webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/j0YJiz/%3F1730407466428&title=Religious%20Liberty%2C%20Volume%205%2C%20Emory%20University%20Studies%20in%20Law%20and%20Religion%20%28EUSLR%29&summary=One%20of%20the%20most%20respected%20and%20influential%20scholars%20of%20religious%20liberty%20in%20our%20time%2C%20Douglas%20Laycock%20has%20argued%20many%20crucial%20religious-liberty%20cases%20in%20the%20United%20States%20Supreme%20Court.%20His%20noteworthy%20scholarly%20and%20popular%20writings%20are%20being%20collected%20i&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/j0YJiz/%3F1730407466428",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=One%20of%20the%20most%20respected%20and%20influential%20scholars%20of%20religious%20liberty%20in%20our%20time%2C%20Douglas%20Laycock%20has%20argued%20many%20crucial%20religious-libert%0Dhttps://textcafe.co/books/j0YJiz/%3F1730407466428&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/j0YJiz/%3F1730407466428&posttype=link&caption=One%20of%20the%20most%20respected%20and%20influential%20scholars%20of%20religious%20liberty%20in%20our%20time%2C%20Douglas%20Laycock%20has%20argued%20many%20crucial%20religious-liberty%20cases%20in%20the%20United%20States%20Supreme%20Court.%20His%20noteworthy%20scholarly%20and%20popular%20writings%20are%20being%20collected%20i",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/j0YJiz/%3F1730407466428&description=One%20of%20the%20most%20respected%20and%20influential%20scholars%20of%20religious%20liberty%20in%20our%20time%2C%20Douglas%20Laycock%20has%20argued%20many%20crucial%20religious-liberty%20cases%20in%20the%20United%20States%20Supreme%20Court.%20His%20noteworthy%20scholarly%20and%20popular%20writings%20are%20being%20collected%20i&media=https://textcafe.co/books/j0YJiz/tc-custom/9781467451376.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781467451376&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=LYDLEAAAQBAJ&amp;rdid=book-LYDLEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467451376').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/j0YJiz/tc-custom/9781467451376.jpg?1730407466428',
        alt: 'Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "006_Contents", "007_Preface", "008_Introduction", "009_Part01", "010_Chapter01a", "010_Chapter01b", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/j0YJiz/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Fm01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_Fm01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_Fm01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Dedication__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Contents__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Preface__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Part01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01a__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_010_Chapter01b__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_010_Chapter01b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_010_Chapter01b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_010_Chapter01c__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_010_Chapter01c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_010_Chapter01c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_011_Chapter02__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_011_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_011_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter03__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_012_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_013_Part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04a__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_014_Chapter04a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_014_Chapter04b__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_014_Chapter04b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_014_Chapter04b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_014_Chapter04c__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_014_Chapter04c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_014_Chapter04c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_014_Chapter04d__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_014_Chapter04d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_014_Chapter04d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_014_Chapter04e__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_014_Chapter04e___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_014_Chapter04e__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_014_Chapter04f__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_014_Chapter04f___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_014_Chapter04f__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_014_Chapter04g__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_014_Chapter04g___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_014_Chapter04g__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_015_Chapter05a__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_015_Chapter05a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_015_Chapter05a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_015_Chapter05b__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_015_Chapter05b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_015_Chapter05b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_015_Chapter05c__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_015_Chapter05c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_015_Chapter05c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_016_Chapter06__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_016_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_016_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_017_Chapter07__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_017_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_017_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_018_BM01__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_018_BM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_018_BM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_last__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_last__);
/*jshint esversion: 6 */




































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/006_Contents",
    "name": "006_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Contents___default.a
  }, {
    "path": "/007_Preface",
    "name": "007_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Preface___default.a
  }, {
    "path": "/008_Introduction",
    "name": "008_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Introduction___default.a
  }, {
    "path": "/009_Part01",
    "name": "009_Part01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Part01___default.a
  }, {
    "path": "/010_Chapter01a",
    "name": "010_Chapter01a",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Chapter01a___default.a
  }, {
    "path": "/010_Chapter01b",
    "name": "010_Chapter01b",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_010_Chapter01b___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_33__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Douglas Laycock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Douglas Laycock")]), _vm._v(" is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the "), _c('I', [_vm._v("New York Times")]), _vm._v(", the "), _c('I', [_vm._v("Washington Post")]), _vm._v(", and numerous other publications. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/j0YJiz/tc-custom/9781467451376.jpg?1730407466428",
      "alt": "This image is the cover for the book Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Religious Liberty, Volume 5, Emory University Studies in Law and Religion (EUSLR)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One of the most respected and influential scholars of religious liberty in our time, Douglas Laycock has argued many crucial religious-liberty cases in the United States Supreme Court. His noteworthy scholarly and popular writings are being collected in five comprehensive volumes under the title "), _c('i', [_vm._v("Religious Liberty.")])]), _c('p', [_vm._v("In this final volume Laycock documents the use of the Constitu­tion’s Free Speech Clause and Establishment Clause in legal briefs, scholarly and popular articles, House testimonies, and written debates. These two clauses have been vitally important in religious-liberty cases concerning religious speech in schools, politics, and the workplace, government funding of religious schools and social services, and the meaning of separation of church and state.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface to Volume 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#fm-2"
    }
  }, [_vm._v("Introduction: The Free Speech and Establishment Clauses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(": F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOM")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PEECH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#ch-1"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech in Public Schools and Universities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#sec2-1"
    }
  }, [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#sec3-1"
    }
  }, [_c('em', [_vm._v("81 Northwestern University Law Review 1 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-2"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Board of Education v. Mergens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-2"
    }
  }, [_c('em', [_vm._v("496 U.S. 226 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-3"
    }
  }, [_vm._v("The Students Won! The Supreme Court Enforces Equal Access Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-3"
    }
  }, [_c('em', [_vm._v("Christian Legal Society Quarterly 147 (Summer 1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-4"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-4"
    }
  }, [_c('em', [_vm._v("515 U.S. 819 (1995)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-5"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Good News Club v. The Milford Central School")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-5"
    }
  }, [_c('em', [_vm._v("533 U.S. 98 (2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-6"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Morse v. Frederick")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-6"
    }
  }, [_c('em', [_vm._v("551 U.S. 393 (2007)")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Value Speech and the Basic Educational Mission of a Public School: Some Preliminary Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Lewis and Clark Law Review 111 (2008)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Christian Legal Society v. Martinez")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("561 U.S. 661 (2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Vanderbilt University "), _c('em', [_vm._v("(Dec. 2, 2011)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Religious Speech in the Political Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom of Speech That Is Both Religious and Political")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("29 University of California Davis Law Review 793 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("People v. Pinkney")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2009 WL 2032030 (Mich. App. 2009)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Repeal the Johnson Amendment, Fix It: Free Speech in the Pulpit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Christian Century 10 (March 15, 2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. Religious Speech in the Workplace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on EEOC Guidelines on Religious Harassment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The Effect of the EEOC’s Proposed Guidelines on Religion in the Workplace: Hearing Before the Senate Subcommittee on Courts and Administrative Practice 37 (June 9, 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Harassment or Free Speech? Few Answers from EEOC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chicago Tribune (June 17, 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion in the Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Employee Rights & Employment Policy Journal 87 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STABLISHMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUSE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech with Government Sponsorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1. Prayers, Ceremonies, and Religious Instruction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Schempp and His Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("38 Journal of Supreme Court History 63 (2013)")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Lee v. Weisman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("505 U.S. 577 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on Religious Equality Amendments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty: Hearings Before the Senate Committee on the Judiciary 66 (Oct. 20, 1995)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Adler v. Duval County School Board")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("206 F.3d 1070 (11th Cir. 2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Santa Fe Independent School District v. Doe, 530 U.S. 290 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief for Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplemental Brief for Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Elk Grove Unified School District v. Newdow, 542 U.S. 1 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motion for Leave to File Amicus Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under God? Pledge of Allegiance Constitutionality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("http://www.pewforum.org/2004/03/19/under-god-pledge-of-allegiance-constitutionality/ (March 19, 2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Teaching Intelligent Design Illegal? A Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Legal Affairs, http://legalaffairs.org/webexclusive/debateclub_id0905.msp (Sept. 26–29, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Voting with Your Feet Is No Substitute for Constitutional Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("32 Harvard Journal of Law and Public Policy 29 (2009)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Town of Greece v. Galloway, 134 S. Ct. 1811 (2014)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief of Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oral Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Passive Displays")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Van Orden v. Perry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("545 U.S. 677 (2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("McCreary County v. American Civil Liberties Union")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("545 U.S. 844 (2005)")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Monumental Decision: High Court Considers Constitutionality of Ten Commandments Displays on Public Property")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("http://www.pewforum.org/2005/02/24/a-monumental-decision-high-court-considers-constitutionality-of-ten-commandments-displays-on-public-property/ (Feb. 24, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Be Religiously Neutral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("28 Legal Times, No. 27 (July 4, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Salazar v. Buono")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("559 U.S. 700 (2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Government-Sponsored Religious Displays: Transparent Rationalizations and Expedient Post-Modernism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("61 Case Western Reserve Law Review 1211 (2011)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Government Funding of Religious Institutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1. Charitable Choice, or the Faith-Based Initiative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debate 2: Should the Government Provide Financial Support for Religious Institutions That Offer Faith-Based Social Services?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1 Rutgers Journal of Law and Religion 5 (1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Faith Based Solutions: What Are the Legal Issues? Hearing Before the Senate Committee on the Judiciary (June 6, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2001 House Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Constitutional Role of Faith-Based Organizations in Competitions for Federal Social Service Funds: Hearing Before the House Subcommittee on the Constitution (June 7, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2010 House Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Faith-Based Initiatives: Recommendations of the President’s Advisory Council on Faith-Based and Community Partnerships and Other Current Issues: Hearing Before the Subcommittee on the Constitution, Civil Rights, and Civil Liberties of the House Committee on the Judiciary (Nov. 18, 2010)")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Funding for Religious Education")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joint Statement of Church-State Scholars on School Vouchers and the Constitution: What the United States Supreme Court Has Settled, What Remains Disputed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pew Forum on Religion & Public Life (2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Testimony on Supreme Court’s School Choice Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The Supreme Court’s School Choice Decision and Congress’ Authority to Enact Choice Programs: Hearing Before the House Subcommittee on the Constitution 5 (Sept. 17, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mistakes in "), _c('em', [_vm._v("Locke v. Davey")]), _vm._v(" and the Future of State Payments for Services Provided by Religious Institutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("40 Tulsa Law Review 227 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why the Supreme Court Changed Its Mind about Government Aid to Religious Institutions: It’s a Lot More Than Just Republican Appointments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2008 Brigham Young University Law Review 275")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. Funding for the Church Itself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Chris Smith and Grace Meng re Disaster Relief for Churches "), _c('em', [_vm._v("(February 12, 2013) Churches, Playgrounds, Government Dollars—and Schools?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("131 Harvard Law Review 133 (2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. The Establishment Clause Attack on Exemptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Board of Education of the Kiryas Joel Village School District v. Grumet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("512 U.S. 687 (1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church-State Game: A Symposium on "), _c('em', [_vm._v("Kiryas Joel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("First Things 36 (Nov. 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Cutter v. Wilkinson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("544 U.S. 709 (2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Mark Kolterman "), _c('em', [_vm._v("(March 15, 2016)")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Oklahoma Legislators "), _c('em', [_vm._v("(April 12, 2018)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Governor Mary Fallin "), _c('em', [_vm._v("(May 10, 2018)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("D. The Many Meanings of Separation of Church and State")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Underlying Unity of Separation and Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("46 Emory Law Journal 43 (1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Many Meanings of Separation: Reviewing Philip Hamburger, Separation of Church and State (2002)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("70 University of Chicago Law Review 1667 (2003)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secularization in the U.S.: Overblown or Underestimated?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sightings, https://divinity.uchicago.edu/sightings/secularization-us-overblown-or-underestimated (Nov. 5, 2015)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Review: Reviewing Thomas E. Buckley’s Establishing Religious Freedom: Jefferson’s Statute in Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("77 Theological Studies 743 (2016)")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('em', [_vm._v("Preface to Volume 5")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("This is the fifth of five volumes that collect my writings on religious liberty. Volume 1, "), _c('em', [_vm._v("Overviews and History")]), _vm._v(", was principally devoted to articles that survey the field and articles on the history of religious liberty in the United States. Volumes 2, 3, and 4 addressed government regulation of religious practice and the legal grounds—constitutional in volume 2, statutory in volumes 3 and 4—for protecting religious practice from burdensome regulation. Volumes 3 and 4 also addressed the culture-wars battles about religious liberty and abortion, contraception, same-sex marriage, and rising numbers of nonbelievers, because those deep moral disagreements are the greatest source of recent threats to freedom to practice one’s religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Government regulation of religious practice is one of the three broad sets of disputes that make up most of the law of religious liberty. The other two broad areas—regulation and sponsorship of religious speech and funding of religious institutions—are the principal topics of this volume. This volume addresses religious free speech, government speech about religion, government funding for religious institutions, and other Establishment Clause issues. The free speech issues include those arising under the Equal Access Act as well as those directly under the Free Speech Clause.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("The free speech issues are inseparably connected to Establishment Clause issues about government sponsorship of religious speech; the focus of litigation is often precisely whether the speech is private, protected by the Free Speech Clause, or government sponsored, prohibited by the Establishment Clause. The briefs and articles about speech without government sponsorship are in ")]), _c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part One")]), _vm._v("; the briefs and articles about government-sponsored speech follow immediately at the beginning of "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(". But in both parts, a recurring issue is where to draw the line between private and governmental.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("Readers might wonder why one of the three great sets of issues, regulation of religious practice, got three separate volumes plus its share of the overviews in volume 1, while the other two sets of issues get only one volume between them, plus their share of the overviews in volume 1. The short answer is that this is just how it worked out when I collected what I had written over forty plus years in the field.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Of course a more serious answer is more complex. Part of it is that, in "), _c('em', [_vm._v("Employment Division v. Smith")]), _vm._v(" (1990), the Supreme Court triggered a huge legal and political battle over regulation of religious practice that has escalated rather than abated over time. Part of it is about specialization. I was actively involved in litigation and in legislative efforts over regulation of religious practice, active but somewhat less so in litigation over religious speech, and mostly uninvolved in litigation over religious funding. My scholarship informed my litigation and legislative testimony, and what I learned from litigation and legislation further informed my scholarship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I mostly stayed out of religious funding cases, in part because there are only so many hours in the day. And I stayed out in part because I moved from strong intuitive opposition to funding in my youth to substantial but qualified support as I matured and actually thought the issues through. There was a lengthy period of ambivalence in the transition, when I avoided writing about funding issues and specialized more and more on the other two sets of issues.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So writings on religious speech, with and without government sponsorship, make up the largest part of this volume. The rest is what I wrote about religious funding issues once I made up my mind, responses to the perverse argument that failure to regulate religion somehow violates the Establishment Clause, and examinations of the disputed meaning of separation of church and state. The entire project is more fully described in the Preface to the Collected Works, in volume 1—except that, when that was written, what are now volumes 3 and 4 were envisioned as a single volume 3.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There are a large number of briefs in this volume, both for parties to litigation and for friends of the court. Briefs necessarily address the facts of particular cases. But I have always tried to put my briefs in a larger frame that makes sense of each clause of the First Amendment and is consistent with protecting the rights of all sides of our religiously diverse population. Briefs test and implement my more academic analyses and often extend the analysis further.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("I am grateful to James Hasson and Jonathan Amgott for research assistance, to my magnificent administrative assistant, Donna-Maria Green, for clerical assistance, and to Jennifer Hoffman at Eerdmans for superb copy editing of all ")]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("five volumes. She was careful and attentive to detail, caught many small errors and the occasional large one, but was generally unintrusive. Editorial conventions have been carried forward from earlier volumes. Legal citation form is explained in Appendix II to volume 1.")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "right1"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUGLAS")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYCOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("Charlottesville")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("July 2018")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Introduction: The Free Speech and Establishment Clauses")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("The Free Speech and Establishment Clauses are presented in a single volume because, with respect to religious speech, they are inseparable. Religious speech by private citizens is constitutionally protected; religious speech by government, or sponsored by government, is constitutionally restricted and sometimes prohibited. Millions of Americans do not like one or the other of these rules, so there is lots of litigation to enforce them and lots of maneuvering to evade them.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Much of that litigation has come to focus on drawing the line between private and government-sponsored speech. Secularists see government sponsorship everywhere; conservative believers see it nowhere. So ")]), _c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part One")]), _vm._v(" of this volume, on freedom of religious speech, and "), _c('span', {
    attrs: {
      "href": "#/014_Chapter04a#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section A of Part Two")]), _vm._v(", on religious speech with government sponsorship, are a package. Think of it as religious speech, with and without government sponsorship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the Establishment Clause addresses much more than just religious speech. In the rest of "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(", there are writings on funding of secular services provided by religious institutions, on Establishment Clause challenges to regulatory exemptions for religious practice, and on the many meanings of separation of church and state.")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-no",
    attrs: {
      "id": "pt-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("PART ONE")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('strong', [_vm._v("Freedom of Religious Speech")])]), _vm._v(" "), _c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("Freedom of religious speech is central to religious liberty. One cannot teach the faith, explain the faith, or even conduct a worship service without speech. This Part addresses issues of religious free speech under the Free Speech Clause and the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Freedom of speech is more important to some faith groups than to others. It looms largest for those religious groups that seek to spread their faith to others and those who seek to orally express their religious beliefs in all the important activities of their lives. Some religions aggressively seek converts; some do not. And those that do are often resented by those that do not. Many targets of these religious appeals are uninterested at best, openly hostile at worst. Many have heard the basic ideas before and made up their mind about those ideas long ago. People who intensely dislike a category of speech often look for ways to restrict it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Religious speech is subject to special restrictions, critics say, because it is subject to the constraints of the Establishment Clause. Religious speech cannot be government sponsored, and maybe it follows that there cannot be even the appearance of government sponsorship. Maybe it follows that it can be excluded from government property, or at least from public schools.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("There are also theories for exclusion from within the Supreme Court’s doctrine on freedom of speech. There is a category of government property known as limited public forums, where government gets to define the scope of the forum and thus define what speech is permitted in the forum. If this sounds fundamentally at odds with the core idea of free speech, that’s because it often is. Government cannot exclude speech from a limited public forum on the basis of viewpoint—it cannot allow Christian speech but exclude Muslim speech, or allow speech hostile to religion but exclude speech supportive of ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("religion. But government can define a limited public forum by subject matter, and governments have often said that the whole topic of religion, pro or con, is an excluded subject matter.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I believe that private religious speech is at the highly protected core of the Free Speech Clause; I also believe that government really cannot sponsor speech that takes a position on religious questions. The challenge is to draw the line between the two. Writings about issues that I would put on the free speech side of the line are in ")]), _c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part One")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "#/010_Chapter01a#ch-1"
    }
  }, [_vm._v("Section A")]), _vm._v(" addresses free speech issues in public schools and universities, "), _c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section B")]), _vm._v(" addresses the political process, and "), _c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section C")]), _vm._v(" addresses the workplace. Writings about issues that I would put on the government-sponsored side of the line are in "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(".")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech in Public Schools and Universities")])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "FirstPara"
  }, [_vm._v("The most intense battles over religious speech have occurred in public schools. Public schools are the most sensitive site for government-sponsored speech; parents do not want their children converted to another faith in a public school. They do not want anyone, whether school employee or fellow student, to make the attempt. Public schools that absorbed and accepted the message of the Establishment Clause—that the school is not to teach the truth claims of any religion—often overreacted and tried to make the school a religion-free zone.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Battles over religious free speech in public schools are fought on multiple and overlapping fronts. Four sources of legal rules figure prominently in this Section.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("First is the Establishment Clause; maybe religious speech is constitutionally prohibited in public schools. The Supreme Court has repeatedly rejected this argument.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second is the law of limited public forums under the Free Speech Clause. Schools can exclude subject matters from their forums, but not viewpoints. The Supreme Court has generally held that religion is a source of viewpoints and not merely an excludable subject matter. This has generally protected religious speech from discriminatory regulation, but there are limits and loopholes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, what if schools suppress student speech in a nondiscriminatory way, closing off opportunities for student speech on any topic, religious or secular? The fight against that sort of rule has mostly been about the meaning of a seminal Supreme Court case, "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(" (1969). I read "), _c('em', [_vm._v("Tinker")]), _vm._v(" as protecting students’ right to speak; school officials and many lower federal courts would confine it to viewpoint discrimination, leaving schools free to suppress all student speech evenhandedly.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Finally, Congress provided strong statutory protection in the Equal Access Act, which protects the right of student organizations to meet in public secondary ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("schools. The principal beneficiaries have been evangelical Christian groups and gay rights clubs. It is no coincidence that these two beneficiaries are on opposite sides of the culture wars. Free speech is for everybody; schools often try to stamp out whatever is controversial.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("The Scholarly …")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Equal Access and Moments of Silence")]), _vm._v(" (1986) is a major article on distinguishing private religious speech from government-sponsored religious speech. It explores the Equal Access Act in depth, and it offers the first, conclusory formulation of what would become my theory of substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("High-Value Speech and the Basic Educational Mission of a Public School")]), _vm._v(" (2008) reacts to an argument, pressed but not resolved in the Supreme Court, that a public school can suppress any speech it deems inconsistent with its “basic educational mission.” Of course that would lead to rampant censorship.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("the Amicus Briefs …")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(" (1990) was the Supreme Court’s encounter with the Equal Access Act. This amicus brief argues that the Act creates a bright-line test to ensure its application and that judicial deference to the discretion of school officials would strip the meaning from the statute. It also argues, more briefly, that the Act is constitutional.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Amicus brief in "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")]), _vm._v(" (1995) argues that if the University funds student publications, it cannot discriminate against student religious publications.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Good News Club v. Milford")]), _vm._v(" (2001) presented the equal access issue in an elementary school, and under the Free Speech Clause rather than the statute. The brief argues that if the school allows the Boy Scouts, Girl Scouts, and 4-H Club to meet, then it must also allow the Good News Club to meet. The Good News Club is an evangelical religious organization.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('em', [_vm._v("Morse v. Frederick")]), _vm._v(" (2007), a high school student was suspended for displaying a banner that said “BONG HiTS 4 JESUS.” The brief argues that this speech could be punished if the Court interpreted it as advocating drug use, but that the school could not suppress any speech that threatened its “basic educational mission.” The 2008 article listed above is a broader and deeper exploration of the issue.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Christian Legal Society v. Martinez")]), _vm._v(" (2010), a public law school excluded a student religious organization because it required a statement of faith for voting membership. The brief argues that this was a simple question of freedom of association; religious organizations cannot exist without religious criteria for membership.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("… and the Short")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("The Students Won!")]), _vm._v(" (1990) is a brief explanation of "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(" (above) written for an audience of Christian lawyers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Letter to Vanderbilt University")]), _vm._v(" (2011) attempts to persuade Vanderbilt not to exclude from campus every religious organization with a statement of faith.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3b"
  }, [_c('strong', [_vm._v("Cross References")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Briefs, articles, and legislative testimony about religious speech with government sponsorship are in ")]), _c('a', {
    attrs: {
      "href": "#/#PT1.1.5.2"
    }
  }, [_vm._v("Section II. A")]), _vm._v(" of this volume and in overview articles cross-referenced there.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The brief in "), _c('em', [_vm._v("Rosenberger")]), _vm._v(" is here because the case presented a free speech issue. But it also presented a funding issue, and my other writings on funding religious institutions are in "), _c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section II. B")]), _vm._v(" of this volume and in overview articles cross-referenced there.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h1', {
    staticClass: "sec3-a",
    attrs: {
      "id": "sec3-1"
    }
  }, [_c('em', [_vm._v("81 Northwestern University Law Review 1 (1986)")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("In")]), _vm._v(" Widmar v. Vincent "), _c('em', [_vm._v("(1981), the Supreme Court upheld the right of student religious organizations to meet on college campuses. But the lower courts generally refused to apply that holding to high schools, and this at a time when constitutional protection for student free speech was considerably stronger than it became later. Religious groups were special, and subject to exclusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Congress responded in 1984 with the Equal Access Act. An early version that protected only religious organizations was denounced as “Son of School Prayer” and clearly could not be passed. A second version that protected all student organizations still drew opposition, but a delicately negotiated bill eventually passed by wide margins. Unfortunately, too many people made too many demands on those negotiations, and the text of the enacted bill was a mess. It didn’t always say what the drafters had intended to say. And whatever it said, critics and school boards immediately claimed that it was unconstitutional.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This article was part of a symposium on")]), _vm._v(" Associational Freedom and Private Discrimination"), _c('em', [_vm._v("—a title that anticipated many later debates—at the Northwestern University Law School. The article defends the constitutionality of the Equal Access Act, and it is foundational to all my later work on religious free speech and establishment of religion.")])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("The article rests on a fundamental distinction between private speech about religion, which is constitutionally protected, and government-sponsored speech taking a position on a religious question, which is constitutionally restricted. This article argues that protection for student religion clubs in public schools is consistent with")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('em', [_vm._v("the most rigorous understanding of the principle that government should not endorse religion. And it argues that opponents of equal access and advocates of school prayer were acting on the identical fallacy—were mirror images of each other. This article contains my first short and conclusory formulation of what I would later develop as the principle of substantive neutrality.")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This piece also carefully explores the Equal Access Act and its legislative history, trying to show how it could be construed to achieve its purpose of protecting student organizations despite the difficulties presented by the text. The final section argues that a properly implemented moment of silence would be constitutional in public schools, but that moments of silence are bad policy and difficult to properly implement.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This article compares and contrasts statutory protection under the Equal Access Act with constitutional protection under the Free Speech Clause. It sets forth a view of")]), _vm._v(" Tinker v. Des Moines Independent Community School District "), _c('em', [_vm._v("(1969), the foundational case on student free speech, as protecting the right of students to speak while they are in a place where they have a right to be. More recently, many lower courts have limited")]), _vm._v(" Tinker "), _c('em', [_vm._v("to simply a rule about viewpoint discrimination, and the Supreme Court has generally declined to review these decisions. The meaning and continued viability of")]), _vm._v(" Tinker "), _c('em', [_vm._v("is a recurring theme in the materials that follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The parts of this article addressing the Equal Access Act have held up well. The parts addressing")]), _vm._v(" Tinker "), _c('em', [_vm._v("and the Free Speech Clause have had a rougher time in the courts, but as of early 2018, the Supreme Court has not yet repudiated them.")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The role of religion in the public schools is one of the most controversial issues of our time. Historically, the public schools openly taught Protestant Christianity, and many opened the day with prayers, Bible readings, or both.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-1",
      "id": "fn1_1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In "), _c('em', [_vm._v("Engel v. Vitale")]), _c('a', {
    attrs: {
      "href": "#/#fn1-2",
      "id": "fn1_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" and "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-3",
      "id": "fn1_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" the Supreme Court held these practices unconstitutional. "), _c('em', [_vm._v("Engel")]), _vm._v(" and "), _c('em', [_vm._v("Schempp")]), _vm._v(" triggered a new round in this long-running debate. A quarter century later, the debate is as intense as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opponents of the Supreme Court’s school prayer decisions have proceeded at two levels. They have denied the legitimacy of the school prayer decisions and the underlying premise that government must be neutral toward religion. "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I hope eventually to defend the requirement of strict government neutrality against the recurring claim that the Establishment Clause")]), _c('a', {
    attrs: {
      "href": "#/#fn1-4",
      "id": "fn1_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" permits nonpreferential support for religion. But that must await a subsequent article."), _c('a', {
    attrs: {
      "href": "#/#fn1-5",
      "id": "fn1_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" This Article will assume that the Supreme Court was right when it said that the Constitution requires the government to be neutral toward religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-6",
      "id": "fn1_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" This Article is about the meaning of “neutrality.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of “neutrality” is central to understanding the second level of response to the school prayer decisions. The Supreme Court’s opponents have sought to encourage or accommodate prayer in public schools in ways that they argued were consistent with neutrality. Their idea has been to attenuate the link between the state and the prayer; they want teachers to encourage students to pray in ways that make it possible to deny that they have done so. Many of these legislative efforts have been clumsy and transparent, and the courts have properly struck them down."), _c('a', {
    attrs: {
      "href": "#/#fn1-7",
      "id": "fn1_7"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("This aspect of the school prayer controversy has come to focus on two more sophisticated statutory proposals: the federal Equal Access Act")]), _c('a', {
    attrs: {
      "href": "#/#fn1-8",
      "id": "fn1_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" and state moment-of-silence laws."), _c('a', {
    attrs: {
      "href": "#/#fn1-9",
      "id": "fn1_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Many supporters of government neutrality toward religion have opposed these statutes, and courts also have been hostile. Undoubtedly such statutes can be implemented in unconstitutional ways. But much of the opposition to these statutes has been misplaced. I will argue that the Constitution "), _c('em', [_vm._v("permits")]), _vm._v(" a properly implemented moment of silence and that it "), _c('em', [_vm._v("requires")]), _vm._v(" a right of equal access for religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In taking these positions, I do not argue that the Establishment Clause permits even a little bit of government support for religion. Properly implemented equal access and moment-of-silence laws are strictly neutral toward religion. Defining neutrality in all the varied interactions between church and state is a major task for Religion Clause scholarship. I do not mean neutrality in the sense of a ban on religious classifications."), _c('a', {
    attrs: {
      "href": "#/#fn1-10",
      "id": "fn1_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" Instead, I mean neutrality in the sense of government conduct that insofar as possible neither encourages nor discourages religious belief or practice. This requires identification of a base line from which to measure encouragement and discouragement. To do that as a general matter is a difficult task beyond the scope of this Article. But in the area of speech, the neutral course seems clear. The government must be neutral both in its own speech and in its treatment of private speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-11",
      "id": "fn1_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" It may not take a position on questions of religion in its own speech, and it must treat religious speech by private speakers exactly like secular speech by private speakers."), _c('a', {
    attrs: {
      "href": "#/#fn1-12",
      "id": "fn1_12"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('strong', [_vm._v("I. The Statutes at Issue")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Equal Access Act")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("The Equal Access Act addresses the rights of student religious groups that seek to meet on school premises before or after school. Typically, such groups want to engage in group prayer, Bible study, or religious discussion. They seek to use school facilities on exactly the same terms as the chess club, the Junior Engineers, or any other student extracurricular group. In the case of religious groups, constitutional questions are minimized if the group is initiated by students and limited to students, and if it neither seeks nor accepts sponsorship from the school or a teacher.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-13",
      "id": "fn1_13"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A case with clear but not unusual facts is "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-14",
      "id": "fn1_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" which the Supreme Court recently decided on standing grounds. The Williamsport schools had a student activity period open to any "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("student club that contributed to the “intellectual, physical or social development of the students.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-15",
      "id": "fn1_15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Students could start their own clubs and meet during the activity period. Only one club had ever been denied permission to meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-16",
      "id": "fn1_16"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" That was Petros, a student group devoted to prayer and other religious activities. Members of Petros sued the school district, alleging violations of the Free Speech"), _c('a', {
    attrs: {
      "href": "#/#fn1-17",
      "id": "fn1_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" and Free Exercise of Religion"), _c('a', {
    attrs: {
      "href": "#/#fn1-18",
      "id": "fn1_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Clauses of the Constitution. Schools that have allowed such groups to meet also have been sued by parents or taxpayers alleging violations of the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-19",
      "id": "fn1_19"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These conflicting claims illustrate two of the three basic positions in the controversy over student religious groups:")]), _vm._v(" "), _c('p', {
    staticClass: "NListSb1"
  }, [_vm._v("(1)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Free Speech or Free Exercise Clause requires schools to treat religious groups just as they treat other groups;")])]), _vm._v(" "), _c('p', {
    staticClass: "NList1"
  }, [_vm._v("(2)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Establishment Clause requires schools to forbid religious groups from meeting on campus, even if other groups are allowed to meet; and")])]), _vm._v(" "), _c('p', {
    staticClass: "NList1"
  }, [_vm._v("(3)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("None of these clauses controls, and the political branches can decide whether to allow religious groups to meet on campus.")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Universities are subject to the first rule; the Supreme Court has held that universities cannot discriminate against student religious groups."), _c('a', {
    attrs: {
      "href": "#/#fn1-20",
      "id": "fn1_20"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" One court of appeals has implied that high schools are subject to either the first or third rule, although it decided that the record before it required affirmance of a preliminary injunction against letting a religious group meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-21",
      "id": "fn1_21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" But two courts of appeals have held,"), _c('a', {
    attrs: {
      "href": "#/#fn1-22",
      "id": "fn1_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("another has strongly suggested,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-23",
      "id": "fn1_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" that high schools are subject to the second rule. These courts of appeals have feared that students would infer school endorsement of prayer groups from the mere presence of such groups on school premises.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In 1984, Congress attempted to settle the debate with the Equal Access Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-24",
      "id": "fn1_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" The Act is not a model of drafting, but its intent is to require high schools to treat student religious groups equally with other extracurricular groups. It thus attempts to overrule the three court of appeals decisions barring religious meetings in high schools. District courts are split over the constitutionality of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-25",
      "id": "fn1_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" The Act is valid under either the first or third rules above, but invalid under the second. The Act’s very existence may influence the answer; the Supreme Court will give more deference to an act of Congress than to a policy of a local school board."), _c('a', {
    attrs: {
      "href": "#/#fn1-26",
      "id": "fn1_26"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Moment-of-Silence Laws")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws are like the Equal Access Act in two ways. First, their political origin is in resistance to the Supreme Court’s ban on school-sponsored prayer. Second, their constitutionality turns on the distinction between government and private speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moment-of-silence laws come in many varieties. What they have in common is that they require teachers to ask students to observe a moment of silence. Students so inclined may use the moment of silence to pray; others may use it to meditate, daydream, plot mischief, or ogle their favorite classmate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Parents and teachers might well be astonished to learn that it is unconstitutional to tell school children to be quiet for a minute. Yet several courts have so held."), _c('a', {
    attrs: {
      "href": "#/#fn1-27",
      "id": "fn1_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Distinguished commentators have been more sympathetic, "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("generally in passing references.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-28",
      "id": "fn1_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" Unfortunately, the facts of the litigated cases indicate that many legislatures and teachers have used these moments of silence to officially encourage prayer. The Alabama moment-of-silence law invalidated in "), _c('em', [_vm._v("Wallace v. Jaffree")]), _c('a', {
    attrs: {
      "href": "#/#fn1-29",
      "id": "fn1_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" is a good example. It is easy to invalidate moment-of-silence laws that are misused in this way. The more interesting question is whether moment-of-silence laws written in wholly neutral and secular terms are facially invalid without any showing of improper implementation. I think that they are not.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b",
    attrs: {
      "id": "PT1.1.5.2"
    }
  }, [_c('strong', [_vm._v("II. A Note on Underlying Assumptions")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("There is a logical difficulty in exploring the meaning of neutrality in a particular case without first establishing that neutrality is required as a general principle. Fortunately, in this case the logical difficulty is not a practical one. It is generally the religious right that demands government support for religion and denies that the Establishment Clause requires neutrality. By “religious right,” I mean to include politically active groups and individuals with generally conservative views on social issues and with generally evangelical or fundamentalist Christian views on religious issues, and the political allies "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("of such groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-30",
      "id": "fn1_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The religious right will happily accept my support of equal access and moments of silence.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opposition to these laws comes from a subset of separationists. I use the term “separationists” even though I think separation of church and state is a misleading metaphor."), _c('a', {
    attrs: {
      "href": "#/#fn1-31",
      "id": "fn1_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" “Separationists” is less awkward than “disestablishmentarians,” and it accurately describes those disestablishmentarians who reason from the separation metaphor. Separationists are of two quite different schools, as Professor Esbeck recently has shown."), _c('a', {
    attrs: {
      "href": "#/#fn1-32",
      "id": "fn1_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" A subgroup that Esbeck calls “secularists” accounts for most of the opposition to equal access laws. The “secularists” tend to think that the need for disestablishment takes precedence over free speech and free exercise rights in substantially all cases of conflict. They occupy the opposite end of the Establishment Clause spectrum from the religious right; it is only fair to call them the secular left.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The secular left includes some groups and individuals who are themselves religious; most notably, Jewish groups have tended to ally themselves with the secular left on Establishment Clause issues. I certainly do not mean to imply that all secularists are personally hostile to religion. Undoubtedly some are, and more are hostile to the fundamentalist and evangelical religions that demand government endorsement. But no separationist openly claims that the Constitution requires the government to share his hostility. Separationists who oppose equal access and moments of silence do so in the name of neutrality. Thus, the people I must persuade traditionally have accepted my premise that the Religion Clauses require the government to be neutral toward religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With respect to government speech, my understanding of neutrality is as rigorous as that of the most orthodox secularist. In my view, the Establishment Clause absolutely disables the government from taking a position for or against religion. The government must treat every religious view with equal respect. “Agnostic” is the label that comes closest to describing the attitude required of the government, but that label is also misleading in an important way. An agnostic has no opinion on whether God exists, and neither should the government. But an agnostic also believes that humans are incapable of knowing whether God exists. If the government believed that, it would prefer agnostics "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("over theists and atheists. Agnostics have no opinion for epistemological reasons; the government must have no opinion for constitutional reasons. The government must have no opinion because it is not the government’s role to have an opinion.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("This principle explains the Supreme Court’s holdings that teachers cannot lead")]), _c('a', {
    attrs: {
      "href": "#/#fn1-33",
      "id": "fn1_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" or encourage"), _c('a', {
    attrs: {
      "href": "#/#fn1-34",
      "id": "fn1_34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" prayer in public schools, or post the Ten Commandments on the bulletin board."), _c('a', {
    attrs: {
      "href": "#/#fn1-35",
      "id": "fn1_35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" The Court should have applied the same principle to its other cases. It should not have held that chaplains can open each meeting of a state legislature with prayer,"), _c('a', {
    attrs: {
      "href": "#/#fn1-36",
      "id": "fn1_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" or that municipalities can erect Christmas displays."), _c('a', {
    attrs: {
      "href": "#/#fn1-37",
      "id": "fn1_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" These decisions are wholly unprincipled and indefensible. A little bit of government support for religion may be only a little bit of establishment, but it is still an establishment. The government should not put “In God We Trust” on coins; it should not open court sessions with “God save the United States and this honorable Court”; and it should not name a city or a naval vessel for the Body of Christ"), _c('a', {
    attrs: {
      "href": "#/#fn1-38",
      "id": "fn1_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" or the Queen of the Angels."), _c('a', {
    attrs: {
      "href": "#/#fn1-39",
      "id": "fn1_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" Perhaps religious minorities "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("should not waste political capital on minor violations such as these. But neither should the Supreme Court legitimate such violations.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-40",
      "id": "fn1_40"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I mention these views to make clear that my support for the Equal Access Act and my tolerance for properly conducted moments of silence do not stem from any view that the religious right’s desire for government support should be modestly indulged. The reason to allow equal access or moments of silence is not that they are acceptably small deviations from neutrality. Rather, they are strictly neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The counterargument is that allowing religious speech on public property, and especially in schools, is a form of government support for religion. Separationists who reason from that starting point wind up actively discriminating against religious speech by excluding it from public fora. Most of them would not take this position with respect to speech on any other subject. But with respect to religious speech, they have been led into error by their fear of establishment and by their fear that the supporters of school prayer will so abuse any concessions that neutrality will never be properly implemented. Some separationists also have been led into error by hostility to the set of political and religious views that they associate with the supporters of school prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The resulting attacks on equal access mistakenly have focused on the location of the speech. That religious speech occurs on public property is incidental and almost entirely irrelevant. Government speech in support of religion is forbidden even if it occurs on private property;"), _c('a', {
    attrs: {
      "href": "#/#fn1-41",
      "id": "fn1_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" private speech in support of religion is protected even if it occurs on public property. What matters is not the location of the speech, but the identity of the speaker."), _c('a', {
    attrs: {
      "href": "#/#fn1-42",
      "id": "fn1_42"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is relevant that the speech occurs in a public school, as distinguished from other public property. But again, there is no magic transformation arising simply from the location of the speech. The school environment is relevant because of the risk that the school may make private speech its own by "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("endorsing or sponsoring it. The central problem is to separate the students’ religious speech from the school’s religious speech, protecting the former and forbidding the latter.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("III. The Argument over Equal Access")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Affirmative Argument:")]), _vm._v(" Widmar v. Vincent")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The basic argument for equal access has been made repeatedly.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-43",
      "id": "fn1_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" It is set out most prominently in "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-44",
      "id": "fn1_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" Cornerstone, an interdenominational group of evangelical Christian students, was one of over one hundred registered student organizations at the University of Missouri at Kansas City. Like all other student organizations, it met in vacant classrooms and at the student center. After Cornerstone had been meeting for four years, the university decided that the group was violating a regulation that barred “religious worship or religious teaching” in the university’s buildings and on its grounds. The university barred Cornerstone from campus, and Cornerstone sued under the Free Speech and Free Exercise Clauses. The district court upheld the university’s rule and dismissed the lawsuit."), _c('a', {
    attrs: {
      "href": "#/#fn1-45",
      "id": "fn1_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" The Eighth Circuit reversed,"), _c('a', {
    attrs: {
      "href": "#/#fn1-46",
      "id": "fn1_46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" and the Supreme Court affirmed the Eighth Circuit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s opinion is short and simple, reasoning from basic principles. Regulation of speech must be content neutral. When the government creates a forum for speech, it cannot pick and choose who can speak or what they can talk about. If students are free to discuss sex, politics, and philosophy, they must be free to discuss religion. The university let Students for a Democratic Society and the Young Socialist Alliance use university facilities."), _c('a', {
    attrs: {
      "href": "#/#fn1-47",
      "id": "fn1_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" It would have let those facilities be used for discussions of agnosticism, Marxism, and other doctrines hostile to religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-48",
      "id": "fn1_48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" There was no doubt that students and faculty enjoyed an open forum in university facilities. The exclusion of religion could not be justified by any policy of neutrality, strict or otherwise. Justice Stevens noted in his concurrence that the university could control its own curriculum, and that a shortage of meeting rooms would require it to "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("choose among voluntary student groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-49",
      "id": "fn1_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" But neither of those legitimate concerns had any relevance to the facts of "), _c('em', [_vm._v("Widmar")]), _vm._v(". Rather, the university openly discriminated against religious speech. The Supreme Court therefore invalidated the regulation, citing its cases on content neutrality"), _c('a', {
    attrs: {
      "href": "#/#fn1-50",
      "id": "fn1_50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" and public fora."), _c('a', {
    attrs: {
      "href": "#/#fn1-51",
      "id": "fn1_51"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The decision seems so self-evident that it is hard to elaborate on the Court’s arguments. Whether one starts with the principle that the Free Speech Clause requires content-neutral regulation of speech, or with the principle that the Religion Clauses require strict neutrality toward religion,"), _c('a', {
    attrs: {
      "href": "#/#fn1-52",
      "id": "fn1_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" one arrives immediately at the result in "), _c('em', [_vm._v("Widmar")]), _vm._v(". Critics have argued that some of the Court’s sweeping statements about the requirement of content neutrality are overbroad,"), _c('a', {
    attrs: {
      "href": "#/#fn1-53",
      "id": "fn1_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" but they have not suggested that the state can suppress a whole category of constitutionally important speech without a substantive reason. There was nothing novel in the Court’s reasoning or in the application of that reasoning to religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Justice White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" argued that religious speech is constitutionally different from all other speech because the Constitution itself distinguishes religious speech from other speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-54",
      "id": "fn1_54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" He cited the school prayer "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("cases.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-55",
      "id": "fn1_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" But this reasoning wholly ignores the difference between government speech and voluntary private speech. That the government cannot express religious opinions does not mean that it can censor religious expression by private speakers. Under the neutrality principle, the government can neither express religious views of its own nor interfere with the expression of religious views by others. The Court had always given religious speech the same constitutional protections as other speech. Indeed, many of the most basic principles of free speech were developed in the Jehovah’s Witness cases."), _c('a', {
    attrs: {
      "href": "#/#fn1-56",
      "id": "fn1_56"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court never had suggested that it mattered whether private religious speech was on public or private property. A series of cases in the 1940s and 1950s upheld the right of Jehovah’s Witnesses to hold services or meetings in public parks."), _c('a', {
    attrs: {
      "href": "#/#fn1-57",
      "id": "fn1_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" The Court treated these cases as ordinary public forum cases. In one of the cases, the state argued that allowing a religious service in a public park would violate the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-58",
      "id": "fn1_58"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" The issue was fully briefed but not properly presented by the facts."), _c('a', {
    attrs: {
      "href": "#/#fn1-59",
      "id": "fn1_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" Although the Establishment Clause issue was not squarely decided, the Court’s apparent assumption in all these cases was that religious groups were entitled to use public fora on the same terms "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("as anyone else. This tacit assumption in the Supreme Court became holding in the courts of appeals: cases in the late 1970s allowed papal masses in public parks.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-60",
      "id": "fn1_60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" conceded that “the right of the religious to nondiscriminatory access to the public forum is well established.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-61",
      "id": "fn1_61"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s most explicit equation of secular and religious speech on public property had come one year before "), _c('em', [_vm._v("Widmar")]), _vm._v(", in "), _c('em', [_vm._v("Heffron v. International Society for Krishna Consciousness, Inc")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-62",
      "id": "fn1_62"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" The Hare Krishnas challenged a rule that required persons wishing to solicit or distribute literature at the Minnesota State Fair to remain in fixed booths."), _c('a', {
    attrs: {
      "href": "#/#fn1-63",
      "id": "fn1_63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The Court upheld the rule as a reasonable response to the number of solicitors and the congestion on the fairgrounds. The Court rejected the Hare Krishnas’ claim that they were entitled to special dispensation because their solicitation was a religious duty. Applying ordinary public forum principles, the Court concluded that all noncommercial solicitors were entitled to equal treatment."), _c('a', {
    attrs: {
      "href": "#/#fn1-64",
      "id": "fn1_64"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" If the rule were struck down for the Hare Krishnas, it would have to be struck down for everyone. This premise was central to the Court’s assessment of the reasonableness of the rule."), _c('a', {
    attrs: {
      "href": "#/#fn1-65",
      "id": "fn1_65"
    }
  }, [_c('sup', [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On their facts, none of the earlier Supreme Court cases squarely controlled "), _c('em', [_vm._v("Widmar")]), _vm._v(". "), _c('em', [_vm._v("Heffron")]), _vm._v(" rejected a claim that religious speech is more protected than other noncommercial speech; the case did not present a claim that religious speech is "), _c('em', [_vm._v("less")]), _vm._v(" protected. There could be some difference between a public forum "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("in a park or fairgrounds and a public forum in a university or high school. But the stated principle of all these cases was content neutrality, and "), _c('em', [_vm._v("Widmar")]), _vm._v(" fell squarely within that principle. That the speech was religious made an a fortiori case. Like political speech, religious speech is at the core of the constitutional right to free expression. It is singled out for special constitutional protection in the Free Exercise Clause. The Religion Clause principle of neutrality toward religion reinforces the Speech Clause principle of content neutrality toward speech. One is tempted to think that there was no case squarely on point because no one ever before had thought the state could discriminate against religious speech. The case for equal access depends less on elaboration of these basic principles than on responding to claims that an exception should be created.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("In commenting on this Article, Dean Stone notes that evenhanded suppression of all religious and antireligious speech is a form of neutrality and that a less compelling justification is required to ban all discussion of a subject matter than to ban expression of only some viewpoints on a subject matter.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-66",
      "id": "fn1_66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" He and I agree that it would be far worse for a school to permit a Christian prayer group while forbidding a Jewish prayer group, or to permit an atheist club while forbidding a prayer club. But suppression of speech is not desirable or constitutional merely because it can be characterized as evenhanded."), _c('a', {
    attrs: {
      "href": "#/#fn1-67",
      "id": "fn1_67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Nor is it evenhanded to suppress all speech on a particular subject matter. A subject-matter ban, though less egregious than a ban against particular viewpoints, is still a content-based restriction on speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-68",
      "id": "fn1_68"
    }
  }, [_c('sup', [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With respect to the government’s own speech, taking no position on religion is the most neutral practice. But with respect to private speech, protecting religious and antireligious speech equally with secular speech is far more neutral than singling out religious and antireligious speech for special treatment. No one would suggest that the government was complying with the First Amendment, or being neutral toward religion, if it uniformly suppressed all religious and antireligious organizations. The argument for such suppression among public school students must turn on some overriding consideration, not on a claim that the suppression is evenhanded. Especially when the subject is "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("religion or politics, with their special First Amendment status, even “neutral” subject-matter bans should require extraordinary justification. To say that religious or political speech can be suppressed in a forum where secular and apolitical speech is protected is to turn the First Amendment on its head.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-69",
      "id": "fn1_69"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" I turn now to the alleged justifications for suppression.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. The Central Issue: Apparent Endorsement")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The argument most often pressed against the Equal Access Act is that allowing religious speech in high schools is an actual or apparent endorsement of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-70",
      "id": "fn1_70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" The claim of actual endorsement is absurd. Perhaps in a totalitarian state the government implicitly endorses all that it does not censor. But no such inference can be drawn in a nation with a constitutional guarantee of free speech. Indeed, the core case for First Amendment protection is speech critical of the government. No governmental unit can interfere with such speech, but it obviously does not follow that the government endorses the critical message. Similarly, the public forum may include Young Democrats and Young Republicans, Socialists and Libertarians, pro-Khomeini refugees and anti-Khomeini refugees, fundamentalists and agnostics. The government obviously does not endorse all these wildly inconsistent positions. Before "), _c('em', [_vm._v("Widmar")]), _vm._v(", my own university censored rallies by the Longhorn Christian Fellowship but allowed Students for Freedom from Religion to hold a “Phooey on Falwell” rally."), _c('a', {
    attrs: {
      "href": "#/#fn1-71",
      "id": "fn1_71"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" No one could ever explain why this was neutral, or why tolerating the one group would be an endorsement if tolerating the other group was not.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whether the speech is on public or private property is wholly irrelevant if the state lacks power to censor. It is almost a given that a public forum will be "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("on public property; very few exist on private property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-72",
      "id": "fn1_72"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Because the state lacks power to exclude views from a public forum on public property, there can be no reasonable inference that it endorses speech in such a forum.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Capacity of High School Students.")]), _vm._v("—Since "), _c('em', [_vm._v("Widmar")]), _vm._v(", the argument has been that even if there is no government endorsement, there will be an improper appearance of endorsement, especially if religious speech is allowed in public high schools. It is said that college students may understand the neutrality of an open public forum but that high school students are too young and impressionable. The argument is most fully developed in Judge Garth’s opinion in "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-73",
      "id": "fn1_73"
    }
  }, [_c('sup', [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument is wrong, both factually and legally. The proposition that government cannot censor speech, and therefore that it does not endorse everything it fails to censor, is not complicated. High school students can understand the proposition if it is explained to them. That is all they need to understand to avoid a mistaken inference of endorsement. Despite Judge Garth’s overblown rhetoric, students do not have to understand all “the subtleties and intricacies of the first amendment about which judges and legislators themselves find reason to pause.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-74",
      "id": "fn1_74"
    }
  }, [_c('sup', [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The proposition that government does not endorse everything it fails to censor is fundamental to our system of government. Grade schools and high schools should teach the values of free expression and open public fora by precept and example."), _c('a', {
    attrs: {
      "href": "#/#fn1-75",
      "id": "fn1_75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Certainly junior high school civics courses should cover free speech. Many students never go on to college, but they too can be good citizens who understand the basic political values of our society."), _c('a', {
    attrs: {
      "href": "#/#fn1-76",
      "id": "fn1_76"
    }
  }, [_c('sup', [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("To the extent that high school students’ ability to understand is an empirical question, we could commission a team of developmental psychologists to do a sample survey.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-77",
      "id": "fn1_77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" But the question is only partly empirical. The constitutional commitment to open public fora should not be lightly undermined because of fears that the audience will misunderstand."), _c('a', {
    attrs: {
      "href": "#/#fn1-78",
      "id": "fn1_78"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" At the very least, a heavy burden of persuasion rests on those who would exclude some views for fear that they mistakenly will be attributed to the state. In the equal access cases, there has been no evidence of the level of high school student understanding and no evidence that the schools tried to explain open fora to the students. The courts simply have assumed that high school students cannot understand.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In closely related contexts, the courts have made the opposite assumption, holding that high school students are not too young or impressionable to be allowed free speech rights. The leading case is "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-79",
      "id": "fn1_79"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" The plaintiffs in "), _c('em', [_vm._v("Tinker")]), _vm._v(" were two high school students and a thirteen-year-old junior high school student. They were suspended from school for wearing black armbands to protest the war in Vietnam."), _c('a', {
    attrs: {
      "href": "#/#fn1-80",
      "id": "fn1_80"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" School officials thought the schools were an inappropriate place for protest, and they feared that the resulting controversy would distract students from their schoolwork."), _c('a', {
    attrs: {
      "href": "#/#fn1-81",
      "id": "fn1_81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" In an apocalyptic dissent, Justice Black noted that the armbands had indeed been controversial among the students and suggested that the officials’ fears had been borne out by events."), _c('a', {
    attrs: {
      "href": "#/#fn1-82",
      "id": "fn1_82"
    }
  }, [_c('sup', [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority sharply disagreed. It reaffirmed that students do not surrender their rights at the schoolhouse door"), _c('a', {
    attrs: {
      "href": "#/#fn1-83",
      "id": "fn1_83"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" and that “[t]he classroom is peculiarly the ‘marketplace of ideas.’”"), _c('a', {
    attrs: {
      "href": "#/#fn1-84",
      "id": "fn1_84"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" It held that high school and junior high school students are constitutionally entitled to express their views, even on controversial subjects, so long as they do so “without ‘materially and substantially interfer[ing] with the requirements of appropriate discipline in the operation of the school’ and without colliding with the rights of others.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-85",
      "id": "fn1_85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" The “discomfort "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("and unpleasantness that always accompany an unpopular viewpoint” were not enough.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-86",
      "id": "fn1_86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" The impossibility of listening to two people at the same time would undoubtedly justify a ban on vocal protest during class. But silent armbands were protected even in class, and so was speech “in the cafeteria, or on the playing field, or on the campus during the authorized hours.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-87",
      "id": "fn1_87"
    }
  }, [_c('sup', [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court also has protected the First Amendment rights of even younger children. Most notably, in "), _c('em', [_vm._v("West Virginia State Board of Education v. Barnette")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-88",
      "id": "fn1_88"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" the Supreme Court held that school children could not be forced to salute the flag. Since "), _c('em', [_vm._v("Tinker")]), _vm._v(", the lower courts have continued to protect the free speech rights of high school students."), _c('a', {
    attrs: {
      "href": "#/#fn1-89",
      "id": "fn1_89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" The Supreme Court recently upheld the power of high school authorities to censor offensive sexual metaphors unnecessary for the expression of ideas,"), _c('a', {
    attrs: {
      "href": "#/#fn1-90",
      "id": "fn1_90"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" but it reaffirmed the “undoubted freedom to advocate unpopular and controversial views in schools and classrooms.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-91",
      "id": "fn1_91"
    }
  }, [_c('sup', [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I am fairly confident that most opponents of the Equal Access Act think that "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" were great decisions. Certainly the American Civil Liberties Union takes that puzzling position."), _c('a', {
    attrs: {
      "href": "#/#fn1-92",
      "id": "fn1_92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" How can it be that students are mature enough to deal with war protests and refusals to salute the flag—in the presence of an entire class—but are not mature enough to deal with a secluded prayer meeting attended only by those who wish to attend?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fear of apparent endorsement is not sufficient to distinguish the cases. No one ever has suggested that students would think that the school opposed the war in Vietnam if it failed to stamp out the armbands in "), _c('em', [_vm._v("Tinker")]), _vm._v(", or that the school was unenthusiastic about flag salutes if it failed to coerce obedience in "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('em', [_vm._v("Barnette")]), _vm._v(". Yet the argument should have been made in those cases if there were anything to it. A showing of confusion about the school’s support for national policy would give rise to a substantial state interest in clarifying the school’s position.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("There are two reasons why the argument of mistaken attribution was not made in those cases. First, it is factually absurd; no one could reasonably attribute the position of a few protesters to the school itself. Second, it is fundamentally at war with the policies of the First Amendment. It depends on the proposition that the school can censor anything with which it disagrees because that is what students expect it to do. The cliché fits here: the remedy for bad speech is more speech.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-93",
      "id": "fn1_93"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" If the school feels a need to clarify its position, it can explicitly state its position. It cannot censor opposing views.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The fear of mistaken attribution in the equal access controversy is as much at war with the First Amendment as it would have been in "), _c('em', [_vm._v("Tinker")]), _vm._v(" or "), _c('em', [_vm._v("Barnette")]), _vm._v(". The inference that the school supports everything it does not censor is just as fallacious. But it is not quite so absurd to assume that some students will draw that inference if they are not told otherwise. Many students will assume from the outset that their school supports flag salutes, American foreign policy, and religion, especially if the religious group involved represents a large portion of the community. When the school tolerates views it is assumed to oppose, there is an immediate tendency to look for some explanation other than endorsement of those views. That tendency will not operate when the school tolerates something that students assume the school supports; tolerating a student religious group may reinforce an unthinking assumption that schools support religion. But we are not dependent on what students assume without reflection or instruction. The school can explain its open forum policy, and there is no reason to believe that high school students are incapable of understanding that explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Ruti Teitel offers a different distinction. She says that "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" involved “absolutely private or individual activities” with insufficient “government involvement” to “create establishment concerns.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-94",
      "id": "fn1_94"
    }
  }, [_c('sup', [_vm._v("94")])]), _vm._v(" But it does not help her to label the speech as “individual.” There was more than one protester in both "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(". Group association for First Amendment purposes is constitutionally protected,"), _c('a', {
    attrs: {
      "href": "#/#fn1-95",
      "id": "fn1_95"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" and it would not have changed the result in "), _c('em', [_vm._v("Tinker")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("or "), _c('em', [_vm._v("Barnette")]), _vm._v(" if the whole student body had worn black armbands or refused to salute the flag.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("It is true that the government had even less “involvement” with the speech in "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Barnette")]), _vm._v(" than it has with a student prayer group. The Tinker children did not have to reserve a room for use at a scheduled time, and thus the school did not have to monitor their use of a room. But this sort of time, place, and manner “involvement” is not an Establishment Clause “concern.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-96",
      "id": "fn1_96"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" Large groups also must reserve time to use parks and auditoriums, but that does not make equal access to parks and auditoriums an establishment of religion. What is forbidden is government support, encouragement, or endorsement. On those criteria, the speech of a self-sustaining student prayer group is just as private as the speech of the Tinker children.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. The Common Fallacy of the Secular Left and the Religious Right.")]), _vm._v("—I wish now to consider the apparent endorsement argument from a different perspective, without regard to the truth of its factual premises. The argument that high school students cannot understand First Amendment rights is untenable even if true. It is untenable because it leads to an insoluble contradiction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the secular left, students cannot understand toleration of religion in the schools. But if students cannot understand toleration of religion in the schools, they are just as incapable of understanding exclusion of religion from the schools."), _c('a', {
    attrs: {
      "href": "#/#fn1-97",
      "id": "fn1_97"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" The secular left’s attack on equal access is indistinguishable from the religious right’s attack on the school prayer cases. The religious right also points to students’ inability to understand; its advocates argue that if schools do not teach about religion, students will interpret that silence as hostility to religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-98",
      "id": "fn1_98"
    }
  }, [_c('sup', [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The secular left and the religious right can both be wrong, but they cannot both be correct. Nor is it possible for one to be correct and the other to be wrong. Both of their propositions depend on the same underlying premise. The premise is that students assume a perfect correspondence between the beliefs of the school administration and the views that it discusses or tolerates—that it endorses everything it approves and censors everything it disapproves. The premise cannot be true for the secular left and false for the religious right, nor vice versa.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In fact, both sides have made the same mistake. Both sides take the position that if the school is not for them, it is against them. Both sides say neutrality will be interpreted as supporting the other side. In short, both sides say that neutrality is impossible. Yet neutrality is what the Constitution requires.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Both sides have been led to the same mistake by similar considerations. Both sides consider it a breach of neutrality if the school does anything that might be understood to support the other side. In effect, each seeks to allocate all risk of uncertainty to the other. Neutrality is seen as support for the other side because it might be misunderstood as support for the other side.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Ruti Teitel’s comment on this Article illustrates the problem.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-99",
      "id": "fn1_99"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" Teitel focuses on the risks of equal access. Some students might misunderstand it; some teachers might improperly implement it; some proselytizers might take unfair advantage of it. The unspoken premise is that the Establishment Clause is entitled to the protection of prophylactic rules so generous that no human deviation from those rules will ever risk violating the clause itself. That premise cannot be defended. When the policies of one clause bump up so directly against the policies of another, neither clause can enjoy a wide margin of safety. Neither side can have all that it wants.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the equal access controversy, a solution in which one side bears all of the risk of student misunderstanding while the other side bears none is not a neutral solution. The risk of misunderstanding must be shared. It is best shared by facially neutral rules in which the government takes no position on religion in its own speech and treats private religious speech exactly like private secular speech. Whatever the risk that some students will perceive an open forum as an endorsement of all groups that participate, that risk is far outweighed by the actual and apparent hostility in a rule that allows students to talk about anything except religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For both sides in this controversy, the risk of misunderstanding can be minimized by explaining what is misunderstood—by teaching students about "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("the values of free speech, public fora, disestablishment, and government neutrality toward religion.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("C. The Supreme Court’s Three-Part Test")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("If the Supreme Court cases had held straightforwardly that the Establishment Clause forbids government support for religion, that the Free Exercise Clause forbids government burdens on religion, and that together the clauses require government to treat religion as neutrally as possible, it would have been almost impossible for any court to conclude that students may talk about anything except religion.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("But neutrality is only part of the Court’s test under the Religion Clauses. It has elaborated a test with three parts—purpose, effect, and entanglement.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-100",
      "id": "fn1_100"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" This much-criticized “test” does not begin to explain the Court’s decisions,"), _c('a', {
    attrs: {
      "href": "#/#fn1-101",
      "id": "fn1_101"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" but the Court continues to invoke it, apparently because no majority can agree on an alternative. Because any program challenged under the Establishment Clause must pass all three parts, the test provides ready ammunition for those who challenge legislation affecting religion.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Ambiguity of Secular Purpose")]), _vm._v(".—The Supreme Court’s first requirement is that state action have a secular purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-102",
      "id": "fn1_102"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" This requirement has been invoked only against transparent endorsements of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-103",
      "id": "fn1_103"
    }
  }, [_c('sup', [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In many of the equal access cases, the school created an open forum for secular speech, and then religious speakers sought equal access to it. There can be no doubt that the purpose of creating the forum was secular. But what is the purpose of granting equal access to religious speakers? I would say the purpose "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("is to avoid discriminating against religion and to comply with the Free Speech and Free Exercise Clauses.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("One could argue that the purpose of admitting religious speakers to the forum is to enhance religious speech. But such an argument has little basis in the policy of the Religion Clauses; it is merely an artifact of the Court’s formulation of the question. State efforts to alleviate discriminatory or state-imposed burdens on religious exercise are consistent with neutrality, even though any such effort, considered in isolation, will appear to aid religion.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-104",
      "id": "fn1_104"
    }
  }, [_c('sup', [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Consider the statutes banning employment discrimination on the basis of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-105",
      "id": "fn1_105"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" A principal purpose of such statutes is to assist religious minorities. Their purpose also can be characterized as restoring religious neutrality to the private labor market. There is no point to metaphysical debate over the religious or secular nature of such a purpose. Whatever we call it, it is a purpose consistent with the Establishment Clause. Barring discrimination against religious speech is equally consistent with the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel offers a different version of the purpose argument."), _c('a', {
    attrs: {
      "href": "#/#fn1-106",
      "id": "fn1_106"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" Teitel notes that the purpose of the primary supporters of the Equal Access Act was to protect religious speech. Many of them also supported school-sponsored prayer, and many of them historically had taken a dim and narrow view of free speech and civil liberties. But then they discovered that the only way to let the student prayer group meet was to protect all kinds of secular student speech as well. Deciding that the benefits of prayer were worth the price of free speech, they voted for the Equal Access Act. Teitel finds this an unconstitutional religious purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-107",
      "id": "fn1_107"
    }
  }, [_c('sup', [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Although Teitel accurately describes the purpose of at least some of the supporters of the Equal Access Act, her legal conclusion does not follow. For one thing, her description begins too late in the process. Congress responded to reports of discriminatory exclusion of religious speech from schools that allowed student speech on other topics; congressional desire to protect religious speech is analogous to the ban on religious discrimination in employment.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("More fundamentally, Teitel’s argument misunderstands the scope of judicial inquiry into legislative motive. If secular and religious speech really do get equal access, it does not matter what motivated Congress. In a wide range of contexts, the Court has held that a bad motive does not invalidate an otherwise permissible statute.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-108",
      "id": "fn1_108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" Inquiries into motive have been reserved for statutes that facially discriminate on a permissible ground but in effect discriminate on a forbidden ground, and then only when the claim is that the permissible facial discrimination is a pretext adopted for the purpose of achieving the forbidden effect."), _c('a', {
    attrs: {
      "href": "#/#fn1-109",
      "id": "fn1_109"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" A statute that is neutral on its face and in effect, such as the Equal Access Act if properly implemented, does not fall within this category.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court’s usual reasons for not inquiring into legislative motive are fully applicable to neutral legislation alleged to have a religious motive."), _c('a', {
    attrs: {
      "href": "#/#fn1-110",
      "id": "fn1_110"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" But there is another reason for not inquiring into religious motive. The usual way of showing the religious motive behind a statute is to show the religious affiliation of the statute’s supporters and to show that some of them expressed religious reasons for supporting the legislation. Teitel provides a detailed description of the religious affiliation of various supporters of the Equal Access Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-111",
      "id": "fn1_111"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" and "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("implies that there is something conspiratorial about their ties.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-112",
      "id": "fn1_112"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" Imagine the reaction if someone assembled a similar list of Jewish affiliations to show that a Zionist conspiracy had pushed through a controversial piece of legislation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If that sort of evidence renders the Equal Access Act constitutionally suspect, then religious citizens are effectively deprived of their right to participate in the political process. Statutes are not unconstitutional just because they coincide with the beliefs of some religious group,"), _c('a', {
    attrs: {
      "href": "#/#fn1-113",
      "id": "fn1_113"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" and the result should not change just because the religious group had the effrontery to express its beliefs. Courts should assess the constitutionality of the statute, not the religious beliefs of its supporters.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Supreme Court’s limited inquiries into purpose under the three-part Establishment Clause test generally have been consistent with its refusal to examine the legislative motive of neutral statutes. With one possible exception,"), _c('a', {
    attrs: {
      "href": "#/#fn1-114",
      "id": "fn1_114"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" statutes invalidated for lack of a secular purpose have openly favored religion and have shown their religious purpose on their face."), _c('a', {
    attrs: {
      "href": "#/#fn1-115",
      "id": "fn1_115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" The Court could have invalidated them for lack of a secular purpose, or it could have dispensed with the purpose test and invalidated them for lack of neutrality. Perhaps the Court has been using “purpose” in the sense of “intended consequence,” while Teitel is using it in the sense of “motivation.” Whatever the Court has in mind, it should not use the purpose test to explore legislative motive for statutes that do not in fact favor religion.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Effects That Neither Advance nor Inhibit Religion.")]), _vm._v("—The second part of the Court’s Establishment Clause test is that the challenged program have a “principal or primary effect … that neither advances nor inhibits religion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-116",
      "id": "fn1_116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" On its face, this is just a statement of the neutrality requirement, and that is how it originated. The phrase is derived from "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-117",
      "id": "fn1_117"
    }
  }, [_c('sup', [_vm._v("117")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("in which it first appeared in a paragraph explicating the “wholesome ‘neutrality’ of which this Court’s cases speak.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-118",
      "id": "fn1_118"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" I already have shown why equal access legislation is neutral.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But two characteristics of the Court’s formulation of the neutrality requirement have let it be put to other uses."), _c('a', {
    attrs: {
      "href": "#/#fn1-119",
      "id": "fn1_119"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" First, the Court has held that a direct religious effect is primary even if the program has more important secular effects."), _c('a', {
    attrs: {
      "href": "#/#fn1-120",
      "id": "fn1_120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" The Court continues to speak of the principal or primary effect,"), _c('a', {
    attrs: {
      "href": "#/#fn1-121",
      "id": "fn1_121"
    }
  }, [_c('sup', [_vm._v("121")])]), _vm._v(" but that is misleading. A more accurate statement of the Court’s test would be that the legislation may have no “substantial” effect that advances or inhibits religion. Litigants can and do argue that almost any effect is substantial.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, the requirement of neutrality is divided into a ban on effects that “advance” and effects that “inhibit.” Those challenging a program can focus only on those effects that arguably advance religion. If those effects are substantial, the program is said to be invalid. Thus, the conclusion of invalidity seemingly follows even when the challenged legislation is the most neutral solution possible.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument against equal access has proceeded in exactly this way. No beneficial effect on religion is too trivial to be offered as damning. Not just the appearance of sponsorship, but free heat and light, free use of classrooms, free supervision by faculty monitors, and convenient access to the potential audience congregated at the public school are all alleged to be substantial effects that advance religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-122",
      "id": "fn1_122"
    }
  }, [_c('sup', [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These arguments are put in context when we recognize that the “effects” test was intended to implement the neutrality requirement. Any serious search for neutrality must compare the available options. If the school encourages religion, or discriminates in favor of religion, the effect is to advance religion. Thus, endorsement or sponsorship is forbidden. If the school discourages religion, or discriminates against religion, the effect is to inhibit religion. Thus, the school cannot have a rule that students may meet to discuss anything except religion. These are the “principal or primary” "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("effects that must be avoided. Compared to these effects, heat, light, classrooms, monitors, and convenient access are merely incidental effects of a neutral policy.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("These incidental effects of neutrality are not new. Free fire and police protection also are provided pursuant to a neutral policy of serving all groups in the community. Even Teitel concedes that church groups may meet in the parks,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-123",
      "id": "fn1_123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" but free use of park land is no different than free use of classrooms. Both park land and classrooms are expensive to acquire, but once in place, the marginal cost of one more use is very low. A student prayer club could meet for years and not cost the school as much as Philadelphia spent on police protection and crowd and traffic control for a papal mass. Those expenditures went unchallenged;"), _c('a', {
    attrs: {
      "href": "#/#fn1-124",
      "id": "fn1_124"
    }
  }, [_c('sup', [_vm._v("124")])]), _vm._v(" they were the incidental consequences of a neutral policy of equal access to the parks."), _c('a', {
    attrs: {
      "href": "#/#fn1-125",
      "id": "fn1_125"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" The expense of monitors is especially irrelevant to the analysis. Monitors are required by the school, not requested by the student prayer group. A group should not be held unconstitutional because of a “benefit” it does not want.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("3. The Misleading Metaphors of Separation and Entanglement")]), _vm._v(".—The third element of the Court’s Establishment Clause test forbids “entanglement” between church and state."), _c('a', {
    attrs: {
      "href": "#/#fn1-126",
      "id": "fn1_126"
    }
  }, [_c('sup', [_vm._v("126")])]), _vm._v(" The Court frequently has invoked Thomas Jefferson’s metaphor that the Religion Clauses erect a “wall of separation” between church and state. Jefferson’s phrase has been enshrined in the public imagination; people talk of “separation of church and state”"), _c('a', {
    attrs: {
      "href": "#/#fn1-127",
      "id": "fn1_127"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" as the fundamental principle of religious liberty in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In the equal access controversy, the metaphors of “separation” and “entanglement” encourage the misguided focus on the location of the speech instead of the identity of the speaker. A private speaker on public property may seem insufficiently separated from the government. If a student religious group meets on school property, there is undoubtedly a contact between religion and the state. Contact is not separation; a contact might even be an entanglement. If a judge’s analytic starting point is separation or entanglement, he is much more likely to convince himself that religion cannot be discussed on public property. "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-128",
      "id": "fn1_128"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" Judge Garth concluded that the religious group’s use of school property and the school’s responsibility for the safety of the students and the building were two separate entanglements; apparently, either entanglement was independently fatal to equal access."), _c('a', {
    attrs: {
      "href": "#/#fn1-129",
      "id": "fn1_129"
    }
  }, [_c('sup', [_vm._v("129")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Judge Garth also found entanglement in Petros’s concession that it would not use the school’s bulletin boards or public address system. He held that distinguishing religious from secular messages for purposes of censoring the bulletin board and public address system would be an excessive entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-130",
      "id": "fn1_130"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" If that were right, it would follow that distinguishing religious from secular messages for purposes of censoring meetings of student groups is also an excessive entanglement. The need to distinguish religious from secular speech results from the court’s commitment to censorship, not from equal access. Access to the school’s open forum should include access to the usual channels of internal communication, as the Supreme Court has held with respect to universities."), _c('a', {
    attrs: {
      "href": "#/#fn1-131",
      "id": "fn1_131"
    }
  }, [_c('sup', [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Bender")]), _vm._v("’s facts aside, the underlying problem is with the metaphors of separation and entanglement. I have argued before that these metaphors do more harm than good."), _c('a', {
    attrs: {
      "href": "#/#fn1-132",
      "id": "fn1_132"
    }
  }, [_c('sup', [_vm._v("132")])]), _vm._v(" The Constitution neither commands separation nor forbids entanglement. Neither word appears there. Some contacts are forbidden; others are not. Most important, the Religion Clauses regulate the state and not the church. The state can neither support nor oppose religion, but churches and religious citizens are as free as anyone else to support or oppose the state.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Like the secular purpose requirement,"), _c('a', {
    attrs: {
      "href": "#/#fn1-133",
      "id": "fn1_133"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" the separation metaphor has been the basis of repeated efforts to censor religiously motivated speech. In the name of separation, Tennessee barred the clergy from running for the "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("state legislature. The Supreme Court invalidated the restriction.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-134",
      "id": "fn1_134"
    }
  }, [_c('sup', [_vm._v("134")])]), _vm._v(" Pro-choice groups built on the metaphor, arguing that restrictions on abortion violated the Establishment Clause because religious groups actively supported them."), _c('a', {
    attrs: {
      "href": "#/#fn1-135",
      "id": "fn1_135"
    }
  }, [_c('sup', [_vm._v("135")])]), _vm._v(" The Supreme Court properly rejected that argument."), _c('a', {
    attrs: {
      "href": "#/#fn1-136",
      "id": "fn1_136"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" When conservative ministers support Ronald Reagan and speak out on their social agenda; when Catholic bishops speak out on abortion, nuclear weapons, economic redistribution, and peace in Central America; or when rabbis speak out on behalf of Israel, someone on the other side of the political issue is sure to charge that these attempts to influence public policy violate separation of church and state. A moment’s reflection on free speech and free exercise reveals the absurdity of that charge; only the metaphor of separation has given it credence. The same confusion appears in the lower court cases rejecting equal access. Once again, the free speech rights of religious citizens are denied in the name of separation of church and state.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In many of the equal access cases, courts have used “entanglement” as a second label for their effects analysis. In "), _c('em', [_vm._v("Bender")]), _vm._v(", for example, Judge Garth suggested that allowing monitors at student meetings would create an appearance of support and also would be an entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-137",
      "id": "fn1_137"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" In this sense, entanglement is simply a synonym for contact and an antonym for separation. If monitors are wholly neutral and their presence neither supports nor interferes with religion, allowing them at student meetings is a neutral practice. Labeling it an entanglement does not make it an Establishment Clause violation. In other contexts, entanglements have involved burdensome state interference with religion. That is where the entanglement doctrine does its greatest mischief: it turns harm to religion into an Establishment Clause violation and thereby gives separationists standing to assert rights that should belong exclusively to churches and believers."), _c('a', {
    attrs: {
      "href": "#/#fn1-138",
      "id": "fn1_138"
    }
  }, [_c('sup', [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These two misleading metaphors are surely responsible for much of the resistance to equal access. Neither metaphor accurately summarizes the Establishment Clause, and neither has much power to explain Supreme "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Court precedent.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-139",
      "id": "fn1_139"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" It would be a great boon to clear thinking if we could banish “separation” and “entanglement” from our vocabulary and speak only of free speech, free exercise, and establishment. The purpose and effects parts of the three-part test can be salvaged if properly understood, but we probably would do better to abandon them as well and to start over from square one.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("D. Miscellaneous Arguments Against Equal Access")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Opponents of equal access have emphasized high school students’ inability to understand tolerance as the primary reason for denying equal access in high schools, and the students’ youth as the primary reason for their inability to understand. They also have made a number of less plausible arguments.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("1. The Tradition of High School Censorship")]), _vm._v(".—One such argument is factually plausible but wholly inconsistent with the policies of the First Amendment. The argument runs that many high schools continue to censor student speech, so that uninstructed students reasonably may infer that their school approves of every student group it tolerates."), _c('a', {
    attrs: {
      "href": "#/#fn1-140",
      "id": "fn1_140"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" But even if that were true, the inference from past school censorship can hardly be a justification for more censorship. If schools that have violated the free speech rights of their students could never change course without violating the Establishment Clause, a constitutional violation would become a constitutional requirement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Equal Access Act offers a far better solution to the problem. It requires schools with non-curriculum-related student groups to stop censoring those groups. Student religious groups are not the only beneficiaries; no student group can be denied permission to meet because of “the religious, political, philosophical, or other content of the speech at such meetings.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-141",
      "id": "fn1_141"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" Thus, the Act does not allow schools to continue to censor so long as they exempt religious groups; schools subject to the Act must run a genuinely open forum for student groups. Under the Act, both left and right wing political groups have the same access as religious groups. The more diverse the participation in the forum, the clearer it will be that the school does not endorse the views of all the participants.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('strong', [_vm._v("2. The Need for Supervision")]), _vm._v(".—Many high schools require that meetings of student groups be monitored by a teacher or other adult.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-142",
      "id": "fn1_142"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" A monitor is a representative of the school who is responsible for keeping order.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Opponents of equal access have worried that the presence of such a monitor will enhance the appearance of school endorsement. In "), _c('em', [_vm._v("Bender")]), _vm._v(", the Third Circuit characterized the role of a monitor in a sentence that is extraordinary for its studied ambiguity and cavalier treatment of the evidence:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("While the students in their affidavits characterized the monitor’s activities as benign and neutral, designed only to maintain order, it is readily apparent that a school teacher or someone associated with the school necessarily must impart the impression to students that the school’s authority and that the school’s endorsement is implicated in the relevant activity, since every monitor must be approved by the school."), _c('a', {
    attrs: {
      "href": "#/#fn1-143",
      "id": "fn1_143"
    }
  }, [_c('sup', [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("This sentence apparently means that the monitor’s presence shows that the school supports religion. If that is what it means, the court ordered summary judgment on the basis of what was “readily apparent,” even though the only evidence on the issue was the students’ contrary affidavits. The court would have reason to be suspicious of conclusory affidavits on such an issue, but the students’ affidavits contained details of the sort that come from witnesses, rather than lawyers."), _c('a', {
    attrs: {
      "href": "#/#fn1-144",
      "id": "fn1_144"
    }
  }, [_c('sup', [_vm._v("144")])]), _vm._v(" Even if doubts about uncontradicted affidavits can justify a trial, such doubts cannot support a summary judgment rejecting the affidavits. Yet that is what the court ordered."), _c('a', {
    attrs: {
      "href": "#/#fn1-145",
      "id": "fn1_145"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" The court apparently held as a matter of law that the students perceived an endorsement that they denied perceiving. Or perhaps it held as a matter of law that some other student, who had not filed an affidavit, would perceive an endorsement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Or perhaps the court did not say any of those things. Note the slippery wording of the final clauses: “[T]he school’s endorsement is implicated in the relevant activity, since every monitor must be approved by the school.” Those clauses might be literally true: the school endorses the monitor, and its endorsement "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("of the monitor is “implicated” in the activity. But it is a long leap from endorsing the monitor to endorsing religion. When the police are sent to preserve order at a demonstration, no one infers that the city endorses the goals of the demonstrators. It is no more reasonable to infer that a monitor sent to protect furnishings and to suppress spitballs endorses the goals of the group he supervises.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is undoubtedly true that for most student groups, the monitor is also the group’s sponsor, and that most student groups find sponsors who endorse their activities. Uninformed students might assume that a monitor at a student religious meeting is also a supportive sponsor. But again, we should not be bound by what the least informed student might assume without benefit of explanation. It is not difficult for the monitor to explain that religion is committed to private choice in our society, that the school cannot take a position on religious questions or participate in the students’ religious activities, and that consequently the monitor is not a sponsor and is present only to keep order. Then, the monitor can read a book or grade papers. Schools concerned about collusion could send a different monitor every week.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Jay Westbrook has asked if these restrictions on the monitor’s role are necessary. He suggests an argument, based on neutrality, that the student religious group is entitled to the assistance of an adult sponsor on the same terms as any other group.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-146",
      "id": "fn1_146"
    }
  }, [_c('sup', [_vm._v("146")])]), _vm._v(" One easily can imagine schools sponsoring and advising competing student political groups without endorsing either group’s position; they could do the same for student religious groups. Why should only the religious group have to make do with juvenile leadership?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The question is more serious than the conventional wisdom would suggest. But I think the conventional wisdom is right on this one. The line between the religious speech protected by the Free Speech and Free Exercise Clauses and the religious speech forbidden by the Establishment Clause is the line between private speech and government speech. That line is conceptually clear, even if in some applications its location is murky and crossing over seems harmless.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The meaning of neutrality must take account of this line. That is why I have offered a two-part formulation: government must be neutral in its own speech as well as in its treatment of private speech. Withholding advisors from student religious groups preserves neutrality in government speech, because the government avoids having its agent take a position on religion. Withholding the advisor is neutral toward private speech because it leaves private speakers free to say whatever they want. It is nonneutral only in the sense that it denies the religious group help that the government gives to other groups.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("If it is nonneutral to deny this help, the refusal to teach religion in the public schools is also nonneutral. Public schools teach the information and skills for all our other social institutions; why is it only religion that has to transmit itself to the next generation without aid from public schools? The answer is that that is the cost of committing religion to private choice and avoiding the dangers associated with governments that take positions on religion. The dangers associated with a public school providing an advisor to a voluntary student religious group are attenuated, but the principle is the same. The meaning of neutrality is that government should take no position on religion, not that it should provide equal assistance to religious and secular groups.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Teitel comes at this issue from another angle. She notes that teachers have free speech rights")]), _c('a', {
    attrs: {
      "href": "#/#fn1-147",
      "id": "fn1_147"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" and suggests that it is inconsistent for the Equal Access Act to forbid teacher participation."), _c('a', {
    attrs: {
      "href": "#/#fn1-148",
      "id": "fn1_148"
    }
  }, [_c('sup', [_vm._v("148")])]), _vm._v(" She tries to discredit equal access by showing that it proves too much.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel is certainly right that teachers have free speech rights. Religious groups made up entirely of teachers are constitutionally entitled to meet on the teachers’ personal time during times that the teachers are entitled to be in the building."), _c('a', {
    attrs: {
      "href": "#/#fn1-149",
      "id": "fn1_149"
    }
  }, [_c('sup', [_vm._v("149")])]), _vm._v(" The sticky issue is whether such a group of teachers, or a single teacher, can meet jointly with a student religious group. The teachers would have to join in their personal capacity and not in their role as teachers; they would have to be ordinary members of the group and not the school’s monitors. And they would have to make these role distinctions clear to students.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teachers probably cannot meet these requirements."), _c('a', {
    attrs: {
      "href": "#/#fn1-150",
      "id": "fn1_150"
    }
  }, [_c('sup', [_vm._v("150")])]), _vm._v(" The Equal Access Act’s ban on teacher participation is a prophylactic rule based on that judgment. "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("It is one thing for students to understand the role of a nonparticipating faculty monitor; his conduct reflects his role. It would be much harder for students to remember that a participating teacher was acting in one capacity at the prayer group and in a different capacity in the classroom half an hour later. It is unlikely that even the teachers could keep their roles straight. There would be no visible evidence of the change in roles. Few, if any, students or teachers have had any experience with teachers joining student organizations in their personal capacity as ordinary members. Lack of precedent would make the role change harder to understand. Lack of precedent also would mean that a religious group’s demand for joint membership is more than merely a demand for equal access.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Fine lines may have to be drawn on occasion, but the principle is clear. The school may monitor the meetings to protect students and property from harm, but the school may not lead, sponsor, encourage, or discourage religious activity.")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('strong', [_vm._v("3. Social Pressure and the Size of High School Campuses")]), _vm._v(".—Judge Garth’s opinion in "), _c('em', [_vm._v("Bender")]), _vm._v(" contains an even more extraordinary attempt to distinguish high schools from colleges. According to Judge Garth, high school campuses are “more confined,”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-151",
      "id": "fn1_151"
    }
  }, [_c('sup', [_vm._v("151")])]), _vm._v(" and their environment is more “structured and controlled.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-152",
      "id": "fn1_152"
    }
  }, [_c('sup', [_vm._v("152")])]), _vm._v(" Consequently,")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("[i]nvoluntary contact between nonparticipating students and religious groups is inevitable. Students of different or conflicting creeds would therefore be less able to overlook the activities of such a group within their school, and by the same token would be more likely to perceive a message of endorsement by school authorities."), _c('a', {
    attrs: {
      "href": "#/#fn1-153",
      "id": "fn1_153"
    }
  }, [_c('sup', [_vm._v("153")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("If Judge Garth meant to say that an open forum on a small campus implies endorsement more strongly than an open forum on a large campus, the argument is silly. Maybe he meant that if impressionable high school students are inclined to mistakenly infer endorsement from toleration, they will have more opportunities to do so on a small campus, because they will be more aware that the religious group is tolerated. But that assertion is wholly dependent on the claim that high school students are inclined to mistake toleration for "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("endorsement; the argument based on the size of high school campuses has no independent force.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Perhaps Judge Garth’s comments were intended to support another argument: that meetings of student religious groups would put social pressure on other students to join the group or change their religious beliefs.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-154",
      "id": "fn1_154"
    }
  }, [_c('sup', [_vm._v("154")])]), _vm._v(" There is some truth to that, but again the distinction between government speech and religious speech is dispositive. The government cannot forbid the exercise of one religion to protect the sensibilities of other religions. Contrary to the bizarre view of the Second Circuit,"), _c('a', {
    attrs: {
      "href": "#/#fn1-155",
      "id": "fn1_155"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" the captain of the football team does not have to conceal his religion lest others be unduly influenced. The right to proselytize is at the core of the First Amendment; the right to attend religious services openly rather than in secret was heretofore unchallenged.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Despite all that, friction between students of different religions is likely to be a problem with or without equal access, and equal access has some tendency to aggravate it. The school must address such frictions by teaching tolerance, not by stamping out religious expression. Unless schools are training students to live in a system of religious apartheid, contact between students of different faiths is a good thing. Students in a pluralistic society must learn to deal constructively with religious differences. To the extent they do, both dominant and minority religions will benefit.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("4. The Remains of "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")])]), _vm._v(".—Judge Garth also relied on the Supreme Court’s first encounters with religion in public schools, the released-time cases. In released-time programs, public schools suspended classes for a period of religious instruction offered by local clergy. In theory, students were not required to attend religious instruction. But they could not leave the school, and secular instruction was suspended. Justice Jackson aptly characterized the programs as providing “a temporary jail for a pupil who will not go to Church.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-156",
      "id": "fn1_156"
    }
  }, [_c('sup', [_vm._v("156")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court struck down these programs in "), _c('em', [_vm._v("Illinois ex rel. McCollum v. Board of Education")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-157",
      "id": "fn1_157"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" It did so for the reason stated by Justice Jackson, although the majority spoke only of compulsory education laws and not of jails. The point was the same: the state’s power to compel school attendance was used to coerce attendance at religious instruction.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There was bitter opposition to "), _c('em', [_vm._v("McCollum")]), _vm._v(", and in "), _c('em', [_vm._v("Zorach v. Clauson")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-158",
      "id": "fn1_158"
    }
  }, [_c('sup', [_vm._v("158")])]), _vm._v(" the Court backed down. "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" were identical in all ways but one. "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("McCollum")]), _vm._v(", the clergy went to the school to provide religious instruction to released students; in "), _c('em', [_vm._v("Zorach")]), _vm._v(", the released students left the school and went to church. That distinction was wholly irrelevant to the coercive use of the compulsory education laws: under both plans, the penalty for not taking religious instruction was detention in a school building where secular instruction had been suspended. But the place of instruction was the only distinction the Court had, so that was the line it drew, holding that released-time programs are constitutional if the religious instruction takes place off campus.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('em', [_vm._v("Zorach")]), _vm._v(" is utterly indefensible. Released-time programs are unconstitutional no matter where the instruction takes place. But "), _c('em', [_vm._v("Zorach")]), _vm._v(" held differently, and neither it nor "), _c('em', [_vm._v("McCollum")]), _vm._v(" has been overruled.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-159",
      "id": "fn1_159"
    }
  }, [_c('sup', [_vm._v("159")])]), _vm._v(" The distinction remains an embarrassment that fools no one,"), _c('a', {
    attrs: {
      "href": "#/#fn1-160",
      "id": "fn1_160"
    }
  }, [_c('sup', [_vm._v("160")])]), _vm._v(" and its reasoning has not been applied in other cases. "), _c('em', [_vm._v("Zorach")]), _vm._v("’s finding that pupils were not coerced is inconsistent with the finding of coercion in the more recent school prayer cases."), _c('a', {
    attrs: {
      "href": "#/#fn1-161",
      "id": "fn1_161"
    }
  }, [_c('sup', [_vm._v("161")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But Judge Garth revived the distinction and found it “critical.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-162",
      "id": "fn1_162"
    }
  }, [_c('sup', [_vm._v("162")])]), _vm._v(" In light of "), _c('em', [_vm._v("Zorach")]), _vm._v(", he thought "), _c('em', [_vm._v("McCollum")]), _vm._v(" held that religious activity in a school building is what made released time unconstitutional. He concluded that it was therefore irrelevant that released time singles out religion for preferential treatment and that equal access does not. He did not even mention that released time is coercive and that equal access is not.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But even if "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" are still good law, Judge Garth’s argument does not follow. On any realistic view of the facts, and certainly in light of the subsequent school prayer cases, "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(" hold that the validity of coerced religious instruction may depend on its location. Neither case says what would happen if the coercive element were wholly removed. "), _c('em', [_vm._v("Zorach")]), _vm._v(" supports the view that the government can trample on the Establishment Clause so long as the coercive element is not more than the Court can stomach. A judge with Garth’s stringent view of the Establishment Clause can argue only that "), _c('em', [_vm._v("Zorach")]), _vm._v(" has been eroded by subsequent decisions. To argue that "), _c('em', [_vm._v("Zorach")]), _vm._v(" supports Judge Garth’s stringent view is simply wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On my view of "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Zorach")]), _vm._v(", equal access would be invalid if schools used the compulsory education laws to encourage attendance at religious meetings. That is not a risk when extracurricular groups meet before or "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("after school. Nonparticipating students are free to leave the campus altogether, so the compulsory education laws are not implicated. Students inclined to join a student religious group may find it easier to do so, but no one who has seen students flee school at the closing bell can think that uninterested students are coerced to remain.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The situation in "), _c('em', [_vm._v("Bender")]), _vm._v(" was a little different. There, the student religious group sought to meet in a student activity period during school hours; students were not free to leave. But there are two crucial differences between "), _c('em', [_vm._v("McCollum")]), _vm._v(" and "), _c('em', [_vm._v("Bender")]), _vm._v(". First, the program in "), _c('em', [_vm._v("McCollum")]), _vm._v(" was sponsored by the school; the student group in "), _c('em', [_vm._v("Bender")]), _vm._v(" was created by students, and the school refrained from any form of endorsement. This is the difference between government speech and private speech. Second, and most important, students in "), _c('em', [_vm._v("McCollum")]), _vm._v(" were required to come to school and then given no attractive alternative to religious instruction. In "), _c('em', [_vm._v("Bender")]), _vm._v(", students had many choices. The student religious group was simply one more option in a preexisting student activity period. A wide variety of other student groups met at the same time. Students could join one of those groups, go to the library, use the computer, go to the placement office and learn about jobs or colleges, or remain in their homeroom. The coercion in "), _c('em', [_vm._v("McCollum")]), _vm._v(" was wholly absent in "), _c('em', [_vm._v("Bender")]), _vm._v(".")]), _c('a', {
    attrs: {
      "href": "#/#fn1-163",
      "id": "fn1_163"
    }
  }, [_c('sup', [_vm._v("163")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel nevertheless thinks that the compulsory school attendance laws create an Establishment Clause problem for the Equal Access Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-164",
      "id": "fn1_164"
    }
  }, [_c('sup', [_vm._v("164")])]), _vm._v(" All groups "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("hoping to speak to a student audience know that they can find lots of students in one place at a school. That religious groups seek the same convenient access is one more incidental consequence of neutrality. If religious proselytizers were forbidden to approach any audience assembled by the government, they would be discriminatorily barred from state fairs, subway stations, and courthouses. Teitel refers to students as a “captive” audience,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-165",
      "id": "fn1_165"
    }
  }, [_c('sup', [_vm._v("165")])]), _vm._v(" but she does not contend that they are forced to attend meetings of student prayer groups or even to read posters announcing that such groups will meet. The most she can possibly mean is that there is a captive audience for announcements of meetings over the school’s public address system. That is a reason to keep such announcements brief and factual, but it is not a reason to ban private religious speech in the school.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("IV. The Implementation of Equal Access")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Existence of an Open or Public Forum")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("I have discussed the constitutional merits of equal access in the context of a school that plainly creates an open forum for student organizations. Such a school is useful for clarifying the basic principle: if there is an open forum for student organizations, student religious organizations cannot be excluded. But the principle may be more difficult to apply in schools with fewer and more restricted student organizations. Student organizations probably have been created informally and haphazardly at many schools; with no articulated policy, schools may try to rationalize their past practice in a way that minimizes their obligation to honor free speech. The resulting ambiguities may be addressed either under the Equal Access Act or the Constitution.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Equal Access Act refers to an “open forum” in public secondary schools,"), _c('a', {
    attrs: {
      "href": "#/#fn1-166",
      "id": "fn1_166"
    }
  }, [_c('sup', [_vm._v("166")])]), _vm._v(" but most of the constitutional cases refer to a “public forum.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-167",
      "id": "fn1_167"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("The terms may be interchangeable, but “open forum” is more precise, and I will generally use it. No one contends that a forum in a school is open to the general public. The issue is whether there is a forum open to students and faculty.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('strong', [_vm._v("1. The Statutory Meaning of “Open Forum.”")]), _vm._v("—The drafters of the Equal Access Act tried to solve the problem by providing a generous, objective definition of “open forum.” The sponsors emphasized that the school’s actual practice was determinative, not its stated policy.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-168",
      "id": "fn1_168"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" Unfortunately, the Act is so badly drafted that it may not achieve its purpose."), _c('a', {
    attrs: {
      "href": "#/#fn1-169",
      "id": "fn1_169"
    }
  }, [_c('sup', [_vm._v("169")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to the Act, a public secondary school that receives federal financial assistance and has a “limited open forum” cannot exclude student groups because of the content of the speech at their meetings—whether religious, political, philosophical, or “other.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-170",
      "id": "fn1_170"
    }
  }, [_c('sup', [_vm._v("170")])]), _vm._v(" The definition of “limited open forum” is in § 4071(b), which states that “[a] public secondary school has a limited open forum whenever such school grants an offering to or opportunity for one or more noncurriculum related student groups to meet on school premises during noninstructional time.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-171",
      "id": "fn1_171"
    }
  }, [_c('sup', [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This definition resembles the constitutional concept of “limited public forum,” but it goes well beyond the Supreme Court’s cases. The statutory “limited open forum” is an artificial construct, and comparisons with the constitutional cases can be misleading. Most notably, government speech does not create a constitutional public forum,"), _c('a', {
    attrs: {
      "href": "#/#fn1-172",
      "id": "fn1_172"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" but a school-sponsored student group that is not curriculum related (if there is such a thing) creates a statutory open forum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Schools seeking to avoid statutory coverage must argue that they do not have even one “noncurriculum related student group.” That key phrase is not defined, and it arguably contains two ambiguities: What is “curriculum related”? And what is a “student group”? The football team is a student group, and it is not curriculum related. On the other hand, it is not an outlet for expression of student views; apart from the statute, a football team would not be relevant to any analysis of open fora or content neutrality. And some schools undoubtedly will argue that the football team is curriculum related, because physical "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("education is part of the curriculum.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-173",
      "id": "fn1_173"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" Indeed, in one of the first cases under the Act, the defendant argued that every group in the school was curriculum related, including the scuba-diving club and a service organization sponsored by the Rotary Club."), _c('a', {
    attrs: {
      "href": "#/#fn1-174",
      "id": "fn1_174"
    }
  }, [_c('sup', [_vm._v("174")])]), _vm._v(" Schools may also argue that the football team is not a student group—that “student group” means student-initiated group and does not include school-sponsored groups.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("a. Legislative History and Statutory Text")])]), _vm._v(".—The legislative history of the Equal Access Act only compounds these ambiguities. The bill was completely rewritten in a series of multilateral negotiations after it was passed by the House and reported out of committee in the Senate. Thus, the committee reports cast no light on the language actually adopted. Senator Hatfield offered the negotiated compromise as a floor amendment in the midst of the Senate’s rush to adjourn for the Fourth of July. He repeatedly emphasized that as many as one thousand people had been involved in the negotiations that produced the compromise version,"), _c('a', {
    attrs: {
      "href": "#/#fn1-175",
      "id": "fn1_175"
    }
  }, [_c('sup', [_vm._v("175")])]), _vm._v(" and that not all the Senators sponsoring the compromise agreed with everything in it."), _c('a', {
    attrs: {
      "href": "#/#fn1-176",
      "id": "fn1_176"
    }
  }, [_c('sup', [_vm._v("176")])]), _vm._v(" Senator Gorton accurately observed that too many cooks had spoiled the broth."), _c('a', {
    attrs: {
      "href": "#/#fn1-177",
      "id": "fn1_177"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" But Hatfield had a large majority committed to his compromise, and he resisted any change that might have caused the deal to fall apart. The Hatfield compromise later passed the House under a special rule that precluded amendments and limited debate to one hour."), _c('a', {
    attrs: {
      "href": "#/#fn1-178",
      "id": "fn1_178"
    }
  }, [_c('sup', [_vm._v("178")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most direct legislative history on the meaning of “limited open forum” is a colloquy between Senators Gorton and Hatfield. Under skillful cross-examination, Hatfield offered just about every possible interpretation in less than two columns of the "), _c('em', [_vm._v("Congressional Record")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-179",
      "id": "fn1_179"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" First, he agreed that the chess club was not curriculum related, so that a school with a chess club had an open forum. He explained that curriculum-related clubs were those that are “really a kind of extension of the classroom.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-180",
      "id": "fn1_180"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" He offered the example "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("of a French club made up of students in a French class, who met to practice speaking French.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-181",
      "id": "fn1_181"
    }
  }, [_c('sup', [_vm._v("181")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Then, in response to a question about the pep club, Hatfield said: “Conceivably, some of your sports activities could grow out of a physical ed curriculum requirement in the school.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-182",
      "id": "fn1_182"
    }
  }, [_c('sup', [_vm._v("182")])]), _vm._v(" Gorton asked about the football team, and “conceivably” became certainly. Hatfield said that the football team “is curriculum-related because that is how they can use tax dollars.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-183",
      "id": "fn1_183"
    }
  }, [_c('sup', [_vm._v("183")])]), _vm._v(" Of course, if the standard is “tax dollars,” everything the school supports is curriculum related. That is a vastly different standard than the “extension of the classroom” standard that Hatfield had just invoked.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Gorton asked if the school district would have full authority to decide what was curriculum related. Hatfield replied, “We in no way seek to limit that discretion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-184",
      "id": "fn1_184"
    }
  }, [_c('sup', [_vm._v("184")])]), _vm._v(" So the school district could decide that the cheerleading squad is curriculum related? “Correct,” said Hatfield."), _c('a', {
    attrs: {
      "href": "#/#fn1-185",
      "id": "fn1_185"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" Could the school district make the same determination with reference to a chess club? “I would not say that no district could, but I cannot readily conceive of a criterion that could be used at this time to establish that as a curriculum-related activity. I am not saying it could not be, because as long as you have lawyers, they can find ways of doing things one way or another.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-186",
      "id": "fn1_186"
    }
  }, [_c('sup', [_vm._v("186")])]), _vm._v(" What about a drama club that puts on a play? Hatfield said that a play was curriculum related and volunteered that the school band and other cultural activities were also curriculum related, because schools offer courses in music and the arts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Gorton said, “It seems to me … that one of the keys to the noncurriculum related student organization is that it is not sponsored by the school.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-187",
      "id": "fn1_187"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" Hatfield replied, “That is correct.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-188",
      "id": "fn1_188"
    }
  }, [_c('sup', [_vm._v("188")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("By this time, Hatfield had gone from only things that are an extension of the classroom, to anything the school spends tax dollars on, to anything the school says is curriculum related (except that the school’s lawyer must be clever enough to state a criterion), to anything that the school sponsors. Another sponsor said that we must judge the school’s actual practice and not its stated policy, lest schools evade application of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-189",
      "id": "fn1_189"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" A House opponent was "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("surely correct when he said that not even the sponsors of the bill knew what it meant.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-190",
      "id": "fn1_190"
    }
  }, [_c('sup', [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It is hard to know what courts should or will do with all this. Hatfield can be quoted to prove anything, which means he proves nothing. It is almost certainly the case that the parties to the compromise had not agreed on the meaning of “curriculum related.” But the committee reports and debate do reflect agreement on a broad legislative purpose. The committees believed that there was widespread discrimination against student religious speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-191",
      "id": "fn1_191"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" The lopsided majorities"), _c('a', {
    attrs: {
      "href": "#/#fn1-192",
      "id": "fn1_192"
    }
  }, [_c('sup', [_vm._v("192")])]), _vm._v(" that voted for the Act plainly wanted to end that discrimination. Such discrimination can be ended either by admitting religious speech to the schools or by excluding much of the speech now allowed in the schools. But any interpretation that largely validates the status quo is not faithful to the legislative purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sponsors clearly believed that the Equal Access Act would make a difference. They clearly believed that many schools have limited open fora. To define “noncurriculum related student group” in a way that results in almost no schools having such fora, or in a way that lets schools evade the Act by cleverly describing existing student groups, is not faithful to the legislative purpose. At the very least, limited open fora exist in schools that entertain student suggestions for the creation of new student groups. Several comments in the floor debate suggest an emphasis on whether the groups are student-initiated as the key to defining whether a limited open forum has been created."), _c('a', {
    attrs: {
      "href": "#/#fn1-193",
      "id": "fn1_193"
    }
  }, [_c('sup', [_vm._v("193")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Yet this interpretation is subject to two serious objections. The first is textual. Both phrases—“noncurriculum related” and “student-initiated”—appear in the text of the statute, and the statute makes sense if we ascribe to the two phrases their quite different ordinary meanings. We must rewrite the statute to conclude that “noncurriculum related” in § 4071(b) means the same thing as “student-initiated” in § 4071(c)(1).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The second objection is that a limitation to student-initiated groups defeats the broader purpose of the statute. A school with many faculty-initiated student groups can largely preempt demand for student-initiated groups. The result "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("could be an open forum for mainstream interests and views, all sponsored by the faculty, with minority views excluded because of faculty hostility or indifference.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-194",
      "id": "fn1_194"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" Such a school would exclude religious groups with the ironclad excuse that the faculty could not sponsor one.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also evidence that the Act’s sponsors thought they had defined “limited open forum” in a way that included virtually all schools. Indeed, some members of Congress thought the existence of a French club would trigger application of the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-195",
      "id": "fn1_195"
    }
  }, [_c('sup', [_vm._v("195")])]), _vm._v(" Senator Gorton, an opponent, thought that athletic teams and cheerleading squads would trigger the Act."), _c('a', {
    attrs: {
      "href": "#/#fn1-196",
      "id": "fn1_196"
    }
  }, [_c('sup', [_vm._v("196")])]), _vm._v(" Senator Dole, a sponsor, said that the open forum included all groups that were not “directly” related to the school’s curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-197",
      "id": "fn1_197"
    }
  }, [_c('sup', [_vm._v("197")])]), _vm._v(" A narrow interpretation of “curriculum related” would maximize coverage, although some schools will always remain exempt unless courts accept Senator Gorton’s view that athletic teams are non-curriculum related student groups.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Maximizing coverage is fully consistent with the views of those who sought to end discrimination by allowing religious speech in the schools. This group includes conservatives who supported religious speech in particular and liberals who supported student free speech in general. Maximizing coverage is undoubtedly the interpretation desired by those most committed to the Act. But the final draft was a compromise; presumably, some of the supporters went along grudgingly, or cared only about ending discrimination and expected that schools would be able to close their limited fora after the Act was passed."), _c('a', {
    attrs: {
      "href": "#/#fn1-198",
      "id": "fn1_198"
    }
  }, [_c('sup', [_vm._v("198")])]), _vm._v(" Representative Pepper thought that the sponsors would be disappointed because most schools did not have open fora."), _c('a', {
    attrs: {
      "href": "#/#fn1-199",
      "id": "fn1_199"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" My best sense "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("of common ground in the legislative history is that closing a limited forum should be possible, but not cost-free.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("More than one interpretation of “curriculum related” is legitimately open to the courts. The best interpretation is the one that Senator Hatfield volunteered before he got entangled in Senator Gorton’s cross-examination: curriculum-related groups are those that are an extension of the classroom. That is what the statutory language seems to say, and that interpretation achieves the purposes of the sponsors and avoids the risk of abuse inherent in distinguishing between student-initiated and faculty-initiated groups. If a group is sponsored by a teacher who teaches a closely related course, and if nearly all the members of the group take that course, then the group is curriculum related, and its existence does not trigger any obligation to recognize other groups.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("b. Some Problematic Cases")])]), _vm._v(".—That still leaves some problematic cases in which an inquiry focusing on relationship to the curriculum will produce results that are counterintuitive to many judges and probably to many of the legislators who voted for the Act. The relationship between athletic teams and the physical education curriculum is tenuous at best, especially when the coach is a history teacher. But athletic teams generally do not engage in speech or expression and do not appear to create limited public fora. Thus, it is defensible in terms of statutory policy to say that all athletic teams are curriculum related.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Activities devoted to expression are more problematic. The debate team, the drama club, the band, and the chorus may or may not be linked to a class in speech, theater, or music. But even if these activities are wholly extracurricular, there is an argument that they are more like athletic teams than like open fora. All are under the direct supervision of a faculty coach or director who has legitimate reasons, unrelated to censorship, for closely controlling student expression in these activities. The play cast, the band, and the chorus must all cooperate to produce a single play or concert; the play and the music are typically selected by the faculty director. Thus, school plays and concerts are plausibly viewed as official expression of the school rather than private expression of students.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-200",
      "id": "fn1_200"
    }
  }, [_c('sup', [_vm._v("200")])]), _vm._v(" A competitive debate team must debate the topic selected by the state’s high school association and take the side assigned by the tournament schedule or coin toss. It is free to create its own arguments for that side, but the expression is so channeled that it is hard to treat the debate team as creating a limited open forum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("That rationale does not fit contestants in an oratory contest who do pick their own topics. That the orator represents the school in an interschool competition does not make his speech an official school speech; many schools probably would deny endorsing the substantive positions taken by their contestants. Still, it is wildly counterintuitive to say that the debate team is curriculum related but the oratory team is not. The sense that all contestants compete on behalf of the school probably has something to do with that intuition. Perhaps a plausible rule is that no forum is established by any school-sponsored entry into a competition sponsored by an association of high schools.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("These suggestions take us increasingly far from the statutory test—whether the group is curriculum related. The purpose of that test is to identify the existence of a limited open forum, and courts can consider that purpose in construing the statute. But “limited open forum” is a defined term; such a forum exists at any school with one or more non-curriculum-related student groups. If courts manipulate “curriculum related” to fit their own concept of limited open forum, they effectively repeal the statutory definition. There is much to be said for asking only whether an activity is related to a course in the curriculum, and for answering that the school play and the football team are not. But I suspect that many courts would instinctively decide that neither the play nor the football team should trigger application of the Act. The reasons for that instinct must be identified so that the Act is not swallowed by exceptions that start with the school play and expand to cover any extracurricular activity that a school is reluctant to abolish.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("The school paper and the yearbook are activities for which a pure “curriculum-related” test works well. These publications are sometimes in-class projects of an art or journalism class, and sometimes extracurricular outlets for student expression. This difference has been treated as an issue of fact in some of the censorship cases litigated under the First Amendment;")]), _c('a', {
    attrs: {
      "href": "#/#fn1-201",
      "id": "fn1_201"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" the same treatment is appropriate under the Equal Access Act. An in-class publication should not trigger the Act; a freestanding publication should.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If we concede that football does not count, student government is probably the most widespread non-curriculum-related activity. Student government is "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("sometimes thought of as a model for teaching students about democracy, but that is not enough to make it curriculum related. If “curriculum related” were watered down to “educational,” nearly all student clubs would qualify. I suspect it is a rare school where student government has any direct relationship to a course in civics or government. Absent such a relationship, student government should trigger application of the Equal Access Act.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-202",
      "id": "fn1_202"
    }
  }, [_c('sup', [_vm._v("202")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_c('em', [_vm._v("c. A Statutory Glitch")])]), _vm._v(".—Senator Gorton’s cross-examination of Senator Hatfield also uncovered another troubling issue. Section 4071(c) sets out five criteria for equal access; a school “shall be deemed to offer a fair opportunity” to meet if it complies with these five criteria."), _c('a', {
    attrs: {
      "href": "#/#fn1-203",
      "id": "fn1_203"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" The five criteria are of two quite different kinds. The first three arise from Establishment Clause restrictions on religious meetings: the meeting must be voluntary and student initiated, there can be no sponsorship by the school, and school employees cannot participate. The other two criteria protect legitimate interests of the school: the meeting may not interfere with education, and nonschool persons may not regularly attend. The school need not be required to impose these last two criteria, but most schools would probably want to impose them on all groups, secular as well as religious.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Act should say that schools must impose the first three criteria on religious groups, and that they may apply any of the criteria to all groups. Unfortunately, the first three criteria and the last two criteria are tacked on to the same introductory clause, even though they are wildly nonparallel. Most troubling, the introductory clause says that the school has offered a fair opportunity to meet if it “uniformly provides” for these five criteria. The restriction on participation by school employees applies by its own terms only to religious meetings. But there is no similar qualifier in the requirement that meetings be student initiated and without school sponsorship. Read literally, the effect is to "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("apply to all meetings two criteria that are essential only to religious meetings. That is, the statute seems to say that Petros has been offered a fair opportunity to meet only if the school “uniformly provides” that non-curriculum-related student meetings are student initiated and without school sponsorship.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Any court interested in avoiding absurd results would recognize this as a statutory glitch.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-204",
      "id": "fn1_204"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" There is no federal interest in forbidding schools to sponsor any group not related to the curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-205",
      "id": "fn1_205"
    }
  }, [_c('sup', [_vm._v("205")])]), _vm._v(" Surely what Congress meant to say is that student religious groups must be student initiated and without school sponsorship, and a group like Petros cannot complain that the lack of school sponsorship denies it a fair opportunity to meet. It is bizarre to provide that school sponsorship of the chess club denies Petros a fair opportunity to meet. “Uniformly” is one of those misleading statutory modifiers—like the misplaced negative in the Communications Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-206",
      "id": "fn1_206"
    }
  }, [_c('sup', [_vm._v("206")])]), _vm._v(" and “otherwise” in the Rehabilitation Act"), _c('a', {
    attrs: {
      "href": "#/#fn1-207",
      "id": "fn1_207"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v("—that even a firmly committed textualist will ignore in the interest of sensible construction."), _c('a', {
    attrs: {
      "href": "#/#fn1-208",
      "id": "fn1_208"
    }
  }, [_c('sup', [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unfortunately, Senator Gorton got Senator Hatfield to say that “uniformly” means exactly what it says."), _c('a', {
    attrs: {
      "href": "#/#fn1-209",
      "id": "fn1_209"
    }
  }, [_c('sup', [_vm._v("209")])]), _vm._v(" Hatfield said that the restrictions in § 4071(c) "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("apply to all groups in the school’s open forum, but not to curriculum-related groups. So the school still can sponsor the football team, but it no longer can sponsor the chess club. Hatfield’s interpretation pulls the chess club into the same net with Petros and other religious organizations. If his interpretation is taken to be authoritative, it creates enormous pressures to hold that every existing student group is curriculum related, lest it lose its faculty sponsors and be left with a nonparticipating monitor. But if all existing groups are curriculum related, there is no open forum, and the Act does not apply. And if there are one or two groups that the school cannot somehow claim as curriculum related, it will be much easier to abolish them to avoid the Act than it would be to abolish ten or twenty non-curriculum-related groups to avoid the Act.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-210",
      "id": "fn1_210"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" No wonder Ruti Teitel reads this provision literally."), _c('a', {
    attrs: {
      "href": "#/#fn1-211",
      "id": "fn1_211"
    }
  }, [_c('sup', [_vm._v("211")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Courts and conscientious school administrators should probably take a deep breath and ignore both Hatfield and the statutory text. Otherwise, the statute completely fails to serve its purpose. A broad spectrum of groups involved in debate over the Act has agreed that “Congress did not intend to prohibit teacher participation in nonreligious student meetings.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-212",
      "id": "fn1_212"
    }
  }, [_c('sup', [_vm._v("212")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("But there is also a technical solution, at least for courts. By following ordinary standing rules, courts can avoid an absurd interpretation of the Act and occasionally apply this provision sensibly. No one has standing to complain that the school is sponsoring the chess club. It is impossible to identify any intended beneficiary of such a prohibition, or anyone who is injured in fact by its violation. But if a school district sponsors the Young Democrats and refuses to sponsor the Young Republicans, the Young Republicans might have a legitimate complaint about this unequal treatment. Section 4071(c) might plausibly be read to address that complaint. The Young Republicans could argue that they were denied a fair opportunity to meet because the school had no uniform policy with respect to sponsorship of non-curriculum-related groups. The only remedy on the face of the statute would be to enjoin sponsorship of the Young Democrats. But if the school began to sponsor both groups, standing would disappear, and the court would have no further reason to interfere.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('strong', [_vm._v("2. The Constitutional Meaning of Open or Public Forum.")]), _vm._v("—Any school that does not have a limited open forum as defined in the Equal Access Act remains vulnerable to a constitutional claim. Perhaps there are some rare configurations of student organizations that give rise to constitutional open fora even though they do not give rise to statutory open fora. Or perhaps some junior high schools have established open fora even though the statute does not apply to them.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-213",
      "id": "fn1_213"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" Much more important, perhaps schools are inherently open fora. That is, the First Amendment may require schools to establish open fora even though they would prefer not to."), _c('a', {
    attrs: {
      "href": "#/#fn1-214",
      "id": "fn1_214"
    }
  }, [_c('sup', [_vm._v("214")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This possibility requires a brief excursion into the Supreme Court’s recent public forum cases. A concept that once was reasonably clear has become obscured by increasingly ill-fitting doctrine. It seems unlikely that the Court will be able to live with the lines it has drawn, because the existing doctrine is inherently unstable. But the three categories of fora reviewed in "), _c('em', [_vm._v("Cornelius v. NAACP Legal Defense & Education Fund")]), _c('a', {
    attrs: {
      "href": "#/#fn1-215",
      "id": "fn1_215"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" provide a starting point.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Traditional public fora” are places devoted to speech and assembly by “long tradition or by government fiat.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-216",
      "id": "fn1_216"
    }
  }, [_c('sup', [_vm._v("216")])]), _vm._v(" The recurring examples are streets and parks. Speakers can be excluded from traditional public fora “only when "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("the exclusion is necessary to serve a compelling state interest and the exclusion is narrowly drawn to achieve that interest.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-217",
      "id": "fn1_217"
    }
  }, [_c('sup', [_vm._v("217")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Limited public fora” are fora designated by the government “for use by the public at large for assembly and speech, for use by certain speakers, or for the discussion of certain subjects.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-218",
      "id": "fn1_218"
    }
  }, [_c('sup', [_vm._v("218")])]), _vm._v(" The existence of a limited public forum is said to depend on the government’s intention to create it, and the designation of a limited public forum is revocable. But while the limited forum exists, only a compelling state interest can justify the exclusion of speakers who fall within the group for whom the forum exists and who wish to address a topic for which the forum exists.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Any other government property or channel of communication is apparently a “nonpublic forum.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-219",
      "id": "fn1_219"
    }
  }, [_c('sup', [_vm._v("219")])]), _vm._v(" The government can exclude speakers from nonpublic fora so long as the restrictions are “reasonable and not an effort to suppress expression merely because public officials oppose the speaker’s view.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-220",
      "id": "fn1_220"
    }
  }, [_c('sup', [_vm._v("220")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most troubling thing about this three-category formulation is that censorship can become self-justifying in the second and third categories. The implication is that the government can convert a limited public forum to a nonpublic forum without any reason whatever, or even because of hostility to speech. The government’s intention to close or limit the forum may be shown by evidence that it has excluded speakers in the past."), _c('a', {
    attrs: {
      "href": "#/#fn1-221",
      "id": "fn1_221"
    }
  }, [_c('sup', [_vm._v("221")])]), _vm._v(" A choice to close the limited public forum is not constrained by a requirement that all speech be treated equally; the government can allow some speakers into a nonpublic forum while excluding others."), _c('a', {
    attrs: {
      "href": "#/#fn1-222",
      "id": "fn1_222"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" Thus, outside the traditional public forum, the only real protection is that exclusion of speech must be reasonable and not motivated by hostility to the views expressed. And the Court’s application of that test has been deferential."), _c('a', {
    attrs: {
      "href": "#/#fn1-223",
      "id": "fn1_223"
    }
  }, [_c('sup', [_vm._v("223")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("It makes little sense to apply the compelling interest test to a category of cases and then let the government opt out of the category at will. The limited public forum category needs to be remodeled in a way that provides more protection for speech. "), _c('em', [_vm._v("Cornelius")]), _vm._v(" did not purport to overrule earlier cases that examined the weight and legitimacy of the government’s need to exclude private speakers from particular public property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-224",
      "id": "fn1_224"
    }
  }, [_c('sup', [_vm._v("224")])]), _vm._v(" If most of those cases are still good law, then the three-category formulation must be revised to explain all the cases.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One such earlier case is "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-225",
      "id": "fn1_225"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" which upheld high school and junior high school students’ right to wear black armbands to protest the Vietnam War. The dissent in "), _c('em', [_vm._v("Cornelius")]), _vm._v(" found the majority’s opinion inconsistent with "), _c('em', [_vm._v("Tinker")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-226",
      "id": "fn1_226"
    }
  }, [_c('sup', [_vm._v("226")])]), _vm._v(" I think that the dissent is wrong; "), _c('em', [_vm._v("Cornelius")]), _vm._v(" is simply inapplicable to "), _c('em', [_vm._v("Tinker")]), _vm._v(". But comparing "), _c('em', [_vm._v("Tinker")]), _vm._v(" to the equal access cases in light of the Court’s three new categories will illuminate the equal access issue and expose some of the problems with the Court’s categories.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Cornelius")]), _vm._v(" is inapplicable to "), _c('em', [_vm._v("Tinker")]), _vm._v(" because "), _c('em', [_vm._v("Tinker")]), _vm._v(" did not involve a question of access to public property. When citizens claim a right to enter government "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("property for the particular purpose of speaking, it is relevant to ask whether other speakers have been allowed the same privilege, or whether the property is especially appropriate for speech. The various versions of the public forum doctrine address these questions. But public forum analysis is irrelevant when access is not at issue. When citizens are going about their business in a place they are entitled to be, they are presumptively entitled to speak.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-227",
      "id": "fn1_227"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" Because students were indisputably entitled to be on the school grounds, the only question in "), _c('em', [_vm._v("Tinker")]), _vm._v(" was whether the school had a constitutionally sufficient reason to suppress their speech. The Court’s requirement that the school show a material and substantial interference with the educational function is addressed to that question.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Tinker")]), _vm._v(" thus protects the right to speak in the halls and on the school grounds—in all the students’ free time when the school is not presenting its own messages. It protects the right to nondisruptive expression such as buttons and armbands, even in class. Religious speech is included in these rights, and these rights have nothing to do with the school’s status as a public forum. "), _c('em', [_vm._v("Tinker")]), _vm._v(" did not hold that the school had created a public forum."), _c('a', {
    attrs: {
      "href": "#/#fn1-228",
      "id": "fn1_228"
    }
  }, [_c('sup', [_vm._v("228")])]), _vm._v(" The decision certainly did not depend on the school’s intention. Rather, "), _c('em', [_vm._v("Tinker")]), _vm._v(" held that the Constitution protected the students’ right to speak, a right that was not contingent on whether the school had allowed others to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Requests to meet in schoolrooms before or after classes do present a question of access to public property. Schools that deny such requests do not suppress speech among students who would have been in the rooms anyway. Rather, they deny the use of the rooms to students who have no reason or desire to be there if they cannot hold a meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If these cases are forced into one of the Court’s three new categories, schools fit only in the relatively unprotected category of nonpublic fora. Schools are not traditional public fora because they are not open to the entire population. The more sensible view is that schools are open fora for students and faculty. In such fora, students and faculty are free to speak on any topic, and the rest of the world can be excluded."), _c('a', {
    attrs: {
      "href": "#/#fn1-229",
      "id": "fn1_229"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" But in the Court’s three new categories, a forum "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("limited to students and faculty can exist only if the government intends to create it.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-230",
      "id": "fn1_230"
    }
  }, [_c('sup', [_vm._v("230")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is an arbitrary mixing of analytic categories here. That the forum is limited to students and faculty has no relationship in logic or policy to whether the forum is permanent or revocable, or to whether the forum exists by constitutional entitlement or by the school’s volition. That the limitation to students and faculty should seem to control these other unrelated issues is an arbitrary and unexamined consequence of the three categories in "), _c('em', [_vm._v("Cornelius")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-231",
      "id": "fn1_231"
    }
  }, [_c('sup', [_vm._v("231")])]), _vm._v(" The consequence is unexamined because it has never actually arisen in a Supreme Court case."), _c('a', {
    attrs: {
      "href": "#/#fn1-232",
      "id": "fn1_232"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" This part of the description of the three categories exists only in dictum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("School authorities who are sued will surely deny that they intended to create a limited public forum, especially now that a Supreme Court opinion appears to make such a self-serving denial so efficacious. Even if a school does have a limited public forum, "), _c('em', [_vm._v("Cornelius")]), _vm._v(" implies that the school can close it at will. But that is inconsistent with the Court’s repeated recognition that schools are especially the marketplace of ideas."), _c('a', {
    attrs: {
      "href": "#/#fn1-233",
      "id": "fn1_233"
    }
  }, [_c('sup', [_vm._v("233")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The "), _c('em', [_vm._v("Cornelius")]), _vm._v(" majority did not mention "), _c('em', [_vm._v("Tinker")]), _vm._v(". It did undertake to explain "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", the university religious speech case. The Court tried to shoehorn "), _c('em', [_vm._v("Widmar")]), _vm._v(" into its limited public forum category; it almost, but not quite, succeeded."), _c('a', {
    attrs: {
      "href": "#/#fn1-234",
      "id": "fn1_234"
    }
  }, [_c('sup', [_vm._v("234")])]), _vm._v(" But the Court’s description of "), _c('em', [_vm._v("Widmar")]), _vm._v(" went further: “Additionally, "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("we noted that a university campus, at least as to its students, possesses many of the characteristics of a traditional public forum.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-235",
      "id": "fn1_235"
    }
  }, [_c('sup', [_vm._v("235")])]), _vm._v(" This formulation gets closer to the essence of "), _c('em', [_vm._v("Widmar")]), _vm._v(" and to the view of the schools espoused in "), _c('em', [_vm._v("Tinker")]), _vm._v(". The essential characteristic of what the Court now calls a traditional public forum is that it is inherently a forum—that is, a place so appropriate for free speech that the government cannot deny access for the purpose of speech. For students and faculty, schools would seem to be such a place. The Court will have a chance to clarify the law of traditional public fora this Term."), _c('a', {
    attrs: {
      "href": "#/#fn1-236",
      "id": "fn1_236"
    }
  }, [_c('sup', [_vm._v("236")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Teitel argues that a high school never can be an open forum, because the educational function requires the school to control so much of the speech that goes on there."), _c('a', {
    attrs: {
      "href": "#/#fn1-237",
      "id": "fn1_237"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" That is equally true in universities. Any educational institution must control the agenda of its classes and other instructional periods. But as the cases hold, that necessity justifies only those restraints on speech that are needed to protect the educational process from disruption."), _c('a', {
    attrs: {
      "href": "#/#fn1-238",
      "id": "fn1_238"
    }
  }, [_c('sup', [_vm._v("238")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Even so, none of the cases finding traditional or inherent open fora involved a right to hold regular meetings that the school would have to monitor."), _c('a', {
    attrs: {
      "href": "#/#fn1-239",
      "id": "fn1_239"
    }
  }, [_c('sup', [_vm._v("239")])]), _vm._v(" Given the disruption and violence in some of our public schools, the Court is unlikely to hold that high school students have a constitutional right to meet on school property without a monitor. And the Court might be reluctant to hold that the First Amendment requires schools to provide monitors for every student organization that requests one. But that is more a prediction about the present Court than a normative judgment. If the Court is serious "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("about the role of schools as a natural site for the free exchange of ideas, then the minor expense of monitors for student meetings should not be sufficient to deny the right to meet. Schools could minimize the expense by having one monitor circulate among adjacent rooms during a scheduled student activity period, or by recruiting parents as volunteer monitors. Just as the expense of cleaning up litter does not justify a ban on leafleting in the streets,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-240",
      "id": "fn1_240"
    }
  }, [_c('sup', [_vm._v("240")])]), _vm._v(" and the expense of police protection does not justify a ban on parades and demonstrations,"), _c('a', {
    attrs: {
      "href": "#/#fn1-241",
      "id": "fn1_241"
    }
  }, [_c('sup', [_vm._v("241")])]), _vm._v(" the expense of supervising students should not justify a ban on student organizations in the public schools. It also has been suggested that the state can charge private groups for the expense of using public facilities, further minimizing the state’s interest in denying a forum."), _c('a', {
    attrs: {
      "href": "#/#fn1-242",
      "id": "fn1_242"
    }
  }, [_c('sup', [_vm._v("242")])]), _vm._v(" In the case of high school students, this could include the cost of monitors.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Court holds that schools are inherently open fora for student organizations, then a wide range of student groups, including student religious groups, could meet at every public school in the land. If the Court holds that there is an open forum for student organizations only at schools that create such a forum, much litigation would be required to identify the schools with open fora under either the statute or the Constitution. The end result would be that some schools have open fora and some do not, and that student religious groups could be excluded from those that do not. The religious right would be unhappy with that result. But so long as the rules were administered without discrimination against religious speech and without distortion by fear that neutrality would be misunderstood as support, the grievance of student religious groups would be no different from that of any other excluded group. In schools that avoided creating an open forum, the loss would be to student speech rights generally, not to religious speech rights in particular.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Junior High and Elementary Schools")])])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The Equal Access Act applies to high schools, and arguably to junior high schools in some states.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-243",
      "id": "fn1_243"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" Therefore, the claims of all or most junior high students and all elementary students must be addressed under the Constitution. Whether the school has created an open forum depends on the constitutional definition of open forum; it is not enough to show the existence of one non-curriculum-related group.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Junior high schools are less likely than high schools to create an open forum, and hardly any elementary schools will have open fora. But when a junior high or elementary school does create an open forum, there is no reason to distinguish it from a high school."), _c('a', {
    attrs: {
      "href": "#/#fn1-244",
      "id": "fn1_244"
    }
  }, [_c('sup', [_vm._v("244")])]), _vm._v(" Exclusion of religious speech is still discriminatory and hostile to religion. The argument for exclusion still depends on the premise that government approves of everything it does not censor. Junior high school students have somewhat less ability than high school students to understand the premises of an open forum, and elementary school students have even less ability. But their ability to understand that exclusion of religion reflects disestablishment rather than hostility is diminished to the same degree. The argument that students cannot understand still leads to the same contradiction and is still soluble by the same facially neutral rules. Student maturity goes to whether the school should create an open forum in the first place. It cannot justify excluding religion from a forum that a school voluntarily creates.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Student maturity is more relevant to claims that junior high and elementary schools are inherently open fora. I am confident that even elementary school students have a right to free speech on their own time—in the halls, cafeterias, and playgrounds. The Supreme Court so held with respect to junior high students in "), _c('em', [_vm._v("Tinker")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-245",
      "id": "fn1_245"
    }
  }, [_c('sup', [_vm._v("245")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, my intuition is that elementary school students certainly, and junior high school students probably, have no constitutional right to an open forum for extracurricular groups with time and space to meet on "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("school property.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-246",
      "id": "fn1_246"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" Two reasons support this distinction between group meetings and individual speech. First, the organizational capacities of students at that level are so limited that an open forum of student-initiated groups is illusory. By contrast, individual student speech is real, and the right to it may be strongly felt. Second, the school’s interest in not supervising extracurricular groups is legitimate, even if the burden is small. But its interest in silencing speech on school grounds is an interest in censorship pure and simple.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this is an aside. Identifying the free speech rights of younger students involves a classic line-drawing problem, and that line is not the subject of this Article. The only proposition to which I am committed is this: Wherever the line is drawn, it must be drawn neutrally with respect to religion. At whatever age the schools or the courts accord students freedom of secular speech, they must accord equal freedom of religious speech.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("C. The Risk of Abuse")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The American Civil Liberties Union opposed early drafts of the Equal Access Act that protected only religious speech. It took no position on the Hatfield compromise, which protected all student speech from content discrimination. The ACLU remained “suspicious” of the enacted legislation,"), _c('a', {
    attrs: {
      "href": "#/#fn1-247",
      "id": "fn1_247"
    }
  }, [_c('sup', [_vm._v("247")])]), _vm._v(" and it began a project with the American Jewish Congress to monitor implementation."), _c('a', {
    attrs: {
      "href": "#/#fn1-248",
      "id": "fn1_248"
    }
  }, [_c('sup', [_vm._v("248")])]), _vm._v(" Subsequently, the ACLU’s biennial conference opposed the Act as “a flagrant violation of the Establishment Clause.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-249",
      "id": "fn1_249"
    }
  }, [_c('sup', [_vm._v("249")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ACLU’s fears of improper implementation should not have produced hostility to a statute that on its face is a great victory for civil liberties. But it is good that someone plans to police implementation. The impetus for the Equal Access Act came from a political sector that traditionally is hostile both to the Establishment Clause and to the Free Speech Clause. The religious right proposed the statute only when its own speech rights were systematically violated. To get statutory relief, it had to protect the speech rights of everyone else as well, and it had to build in safeguards against violations of the Establishment Clause. Now that the benefits of the bargain are embodied in the United States "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Code, it would not be surprising if some in the religious right tried to renege on the consideration. Two kinds of abuse are foreseeable.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('strong', [_vm._v("1. School Sponsorship of Religious Groups.")]), _vm._v("—The first potential abuse is school sponsorship of student religious groups. Schools that never have accepted the ban on school-sponsored prayer might encourage or even coerce participation in student prayer groups. Evidence of precisely this abuse colored "), _c('em', [_vm._v("Lubbock Civil Liberties Union v. Lubbock Independent School District")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-250",
      "id": "fn1_250"
    }
  }, [_c('sup', [_vm._v("250")])]), _vm._v(" the first court of appeals decision against equal access at the high school level. Such sponsorship clearly violates both the Constitution and the Equal Access Act. Ruti Teitel is certainly right when she says that student initiation of religious speech does not justify subsequent government sponsorship."), _c('a', {
    attrs: {
      "href": "#/#fn1-251",
      "id": "fn1_251"
    }
  }, [_c('sup', [_vm._v("251")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But identifying who initiates religious speech may be relevant to determining the remedy. A sufficient remedy for noncoercive endorsement of student-initiated groups would be to enjoin further sponsorship. Any remedy aimed at the student groups themselves would leave such groups vulnerable to school officials, who could render them unconstitutional with unwanted endorsements. But when the school creates the student organization in the first place, or coerces students to attend, the presumptive remedy would be to enjoin the sponsored organization from meeting, just as we decertify sweetheart unions with improper company sponsorship."), _c('a', {
    attrs: {
      "href": "#/#fn1-252",
      "id": "fn1_252"
    }
  }, [_c('sup', [_vm._v("252")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Enforcement will never be perfect; it will not always be easy to discover and prove sponsorship by school officials."), _c('a', {
    attrs: {
      "href": "#/#fn1-253",
      "id": "fn1_253"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" On the other hand, there is little incentive for such abuse. Evangelical students have been quite aggressive about creating their own organizations, and any minister can encourage a devout student to organize a voluntary religious group. The origins of these groups are quite independent of the school administration. Even from the perspective of the religious right, there is no reason to jeopardize the group with school sponsorship when it can function well without it. The religious right will continue its campaign for school-sponsored prayer in the classroom, but potentially "), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("fatal school sponsorship of otherwise legal extracurricular groups is not a likely vehicle.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Exclusion of Unpopular Groups.")]), _vm._v("—The second form of potential abuse is discrimination against other groups applying for access to the school’s open forum. The Lubbock Independent School District may happily recognize the Student Christian Fellowship and refuse to recognize the Students for Nuclear Disarmament or the Student Gay Rights Club. That sort of discrimination presents a straightforward dispute that is easy to police. The excluded group can sue for permission to meet. Such a case is no different from the Williamsport school’s recognition of the student Audubon Society and refusal to recognize Petros.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("There may be some hard issues at the fringes. The congressional debate is full of argument about whether schools would have to tolerate gay rights groups, paramilitary groups, hate groups, unpopular religious groups, or extreme political groups.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-254",
      "id": "fn1_254"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" Senator Hatfield was almost as erratic on this issue as he was on the definition of “curriculum related.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-255",
      "id": "fn1_255"
    }
  }, [_c('sup', [_vm._v("255")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Some of these hard cases will actually arise; many will not. The Ku Klux Klan or the Hare Krishnas cannot send a solicitor to the school and claim protection under the Equal Access Act. A group can invoke the Act only if student members of the group seek to form a student organization; most extreme or deviant groups will have no high school members. When such groups do arise, their right to meet should be protected."), _c('a', {
    attrs: {
      "href": "#/#fn1-256",
      "id": "fn1_256"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" But "), _c('em', [_vm._v("Brandenburg v. Ohio")]), _c('a', {
    attrs: {
      "href": "#/#fn1-257",
      "id": "fn1_257"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" is not the standard in the public high schools. Courts are somewhat less protective of student speech rights than of adult speech rights. The courts of appeals have been dealing with these issues since "), _c('em', [_vm._v("Tinker")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-258",
      "id": "fn1_258"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" and they will not be any more difficult under the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is room for reasonable disagreement here. Excluding a few extremist organizations is not desirable, but neither does it turn the Equal Access Act into "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("a front for religion. The perceived dangers of a Ku Klux Klan chapter in a high school undergoing court-ordered desegregation are different in kind from the perceived dangers of a student religious group in the same high school. A thoroughgoing commitment to free speech would allow both to meet, but there is no inconsistency in deciding that the dangers of violence and race hatred justify censorship while the dangers of mistaken attribution do not.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-259",
      "id": "fn1_259"
    }
  }, [_c('sup', [_vm._v("259")])]), _vm._v(" The fear that students will think the school endorses everything it fails to censor strikes at the heart of the First Amendment. Exclusion of extremists strikes at the margins.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("What schools plainly cannot do is to restrict their open fora to only those groups whose goals they approve. Including the prayer club while excluding the disarmament club would be an abuse by any standard. But it is a highly visible abuse that is easily policed. The solution to such problems is not to exclude religious groups from the open forum, but to police the implementation of equal access.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("3. Religious Worship on School Property.")]), _vm._v("—Some have expressed the view that a worship service is different from other religious speech and that student religious groups should not be permitted to worship even if they are permitted to meet."), _c('a', {
    attrs: {
      "href": "#/#fn1-260",
      "id": "fn1_260"
    }
  }, [_c('sup', [_vm._v("260")])]), _vm._v(" But the distinction is untenable. To let these groups meet and then censor their meetings would be the worst possible result.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument has been explored before. Justice White’s dissent in "), _c('em', [_vm._v("Widmar")]), _vm._v(" insisted that religious worship is a special category of religious speech, completely unprotected by the Free Speech Clause and excludable from a public forum at the government’s option."), _c('a', {
    attrs: {
      "href": "#/#fn1-261",
      "id": "fn1_261"
    }
  }, [_c('sup', [_vm._v("261")])]), _vm._v(" Justice White thought that worship is protected only by the Free Exercise Clause, that the Free Exercise and Establishment Clauses give rise to conflicting arguments about the right to worship in a public forum, and that resolution of that conflict is left to the political branches."), _c('a', {
    attrs: {
      "href": "#/#fn1-262",
      "id": "fn1_262"
    }
  }, [_c('sup', [_vm._v("262")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority responded incredulously to Justice White’s distinction between worship and other religious speech."), _c('a', {
    attrs: {
      "href": "#/#fn1-263",
      "id": "fn1_263"
    }
  }, [_c('sup', [_vm._v("263")])]), _vm._v(" First, they thought the distinction "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("lacked “intelligible content.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-264",
      "id": "fn1_264"
    }
  }, [_c('sup', [_vm._v("264")])]), _vm._v(" They were surely right. The content of worship varies from religion to religion, but a least-common-denominator definition would be that worship is an expression of reverence for, or devotion to, a deity. This suggests that worship is more a state of mind or mode of thought than a category of speech. A sermon, a hymn, a scripture reading, or even a prayer, will sometimes be worship and sometimes not, depending partly on close analysis of its content, partly on the speaker’s mental state, and partly on his theology.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority’s second point had even more force: they argued that even if a distinction between worship and other religious speech could be drawn and administered, the government is constitutionally incompetent to draw it."), _c('a', {
    attrs: {
      "href": "#/#fn1-265",
      "id": "fn1_265"
    }
  }, [_c('sup', [_vm._v("265")])]), _vm._v(" Forbidding worship while allowing other religious speech would require secular officials to categorize all religious speech as either worship or nonworship. But assessing the theological significance of subcategories of religious speech is plainly a religious question properly reserved to religious authorities."), _c('a', {
    attrs: {
      "href": "#/#fn1-266",
      "id": "fn1_266"
    }
  }, [_c('sup', [_vm._v("266")])]), _vm._v(" The Religion Clauses sometimes require courts to make sensitive religious determinations, but doctrines should not be structured in ways that maximize the difficulty."), _c('a', {
    attrs: {
      "href": "#/#fn1-267",
      "id": "fn1_267"
    }
  }, [_c('sup', [_vm._v("267")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority in "), _c('em', [_vm._v("Widmar")]), _vm._v(" had a third response to Justice White’s distinction. Even assuming there was some Establishment Clause value at stake, the majority could see no reason to distinguish religious worship from other religious speech. The majority did not see why worship should be less protected than the proselytizing in "), _c('em', [_vm._v("Heffron")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#fn1-268",
      "id": "fn1_268"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" The majority should have gone further. Both proselytizing and worship go to the essence of evangelical religion; it is hard to distinguish them in terms of religious intensity."), _c('a', {
    attrs: {
      "href": "#/#fn1-269",
      "id": "fn1_269"
    }
  }, [_c('sup', [_vm._v("269")])]), _vm._v(" Proselytizing is much more likely to offend other religious groups. If public (and sometimes offensive) proselytizing is protected, private and inoffensive worship should be protected a fortiori.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Three responses to one bad idea are probably enough, but the majority missed an important one. If religious groups are allowed to meet, any limitation on speech at their meetings would require censorship of the most intrusive and offensive kind. Drawing the line at worship would exacerbate the "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("problem by maximizing the sensitivity and murkiness of the distinction, but the problem is inherent wherever the line is drawn.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-270",
      "id": "fn1_270"
    }
  }, [_c('sup', [_vm._v("270")])]), _vm._v(" Any serious attempt to enforce such a distinction would quickly lead to Orwellian absurdities. For example, before "), _c('em', [_vm._v("Widmar")]), _vm._v(", the University of Texas had a rule that permitted academic discussions of religion but forbade attempts to persuade. When a group called Students for Freedom from Religion demanded enforcement, an assistant dean monitored rallies and pulled the plug on a sound system when a speaker crossed the forbidden line into persuasion."), _c('a', {
    attrs: {
      "href": "#/#fn1-271",
      "id": "fn1_271"
    }
  }, [_c('sup', [_vm._v("271")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Rules that allow schools to monitor the content of religious meetings and break them up when they become “too religious” trample the core of the Free Speech and Free Exercise Clauses. They also violate the Establishment Clause by giving official sanction to those religious meetings that are allowed to continue. If some of the meetings protected by the Equal Access Act include religious worship, there is no abuse, but rather the exercise of a statutory and constitutional right.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("V. Moment-of-Silence Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws require less elaborate analysis. The basic legal analysis is derivative of the analysis of the Equal Access Act. A school that sets aside a moment of silence is creating an open forum for private thought in the midst of the school day. It is not obligated to do so, but it is free to do so. Some students may think religious thoughts, or say a silent prayer. But private religious thought is even less capable of violating the Establishment Clause than private religious speech. Freedom of thought may be the only constitutional right that is absolutely protected.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Even so, most of the cases that have invalidated moments of silence have reached the right result. Neutral moments of silence are harder to implement than equal access. A religious meeting under the Equal Access Act is initiated by students and attended only by volunteers; the faculty monitor need not open his mouth. But inescapably, the teacher must introduce a moment of silence. And he must do so in the presence of the whole class. It requires careful preparation for a teacher to introduce a moment of silence without encouraging or discouraging prayer or appearing to do either. That task does not appear unmanageable in theory, but so far, it has exceeded the capacity of the schools in the litigated "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("cases. Whether through overreaching by the religious right or through sheer incompetence, implementation has largely been disastrous. Even with the best of implementation, moments of silence are more problematic than equal access.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition, legislatures have also found it difficult to draft these statutes in neutral terms. Because we need a properly drafted statute before we can talk about proper implementation, I will consider drafting problems first.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("A. Drafting a Proper Moment-of-Silence Law")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('strong', [_vm._v("1. Finding Neutral Statutory Language.")]), _vm._v("—In "), _c('em', [_vm._v("Wallace v. Jaffree")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-272",
      "id": "fn1_272"
    }
  }, [_c('sup', [_vm._v("272")])]), _vm._v(" the Supreme Court held one of Alabama’s two moment-of-silence statutes facially invalid. One Alabama statute directed teachers to announce that a “period of silence … shall be observed for meditation.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-273",
      "id": "fn1_273"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" A more recent statute authorized teachers to announce that “a period of silence … shall be observed for meditation or voluntary prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-274",
      "id": "fn1_274"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" The plaintiff in "), _c('em', [_vm._v("Wallace")]), _vm._v(" abandoned his challenge to the meditation statute"), _c('a', {
    attrs: {
      "href": "#/#fn1-275",
      "id": "fn1_275"
    }
  }, [_c('sup', [_vm._v("275")])]), _vm._v(" and focused the Court’s attention on the addition of the word “prayer” in the second statute. The Court found that once the meditation statute was on the books, reenacting essentially the same statute to add a reference to prayer could only have been intended to legislatively endorse prayer. In the Court’s view, the legislative history confirmed that purpose. Thus, the Court invalidated the statute under the purpose component of its three-part test for Establishment Clause violations."), _c('a', {
    attrs: {
      "href": "#/#fn1-276",
      "id": "fn1_276"
    }
  }, [_c('sup', [_vm._v("276")])]), _vm._v(" The Court correctly noted that a moment of silence that “merely protect[ed]” each student’s right to pray voluntarily and without state endorsement would be “quite different.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-277",
      "id": "fn1_277"
    }
  }, [_c('sup', [_vm._v("277")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Wallace")]), _vm._v(" was correctly decided, and on the narrowest possible ground. Under the peculiar facts of "), _c('em', [_vm._v("Wallace")]), _vm._v(", it was plausible for the Court to read insertion of the word “prayer” as an endorsement of prayer. But "), _c('em', [_vm._v("Wallace")]), _vm._v(" should not be understood as depending on the use of magic words, with “meditation” statutes permitted and “prayer” statutes invalid. Use of the word “prayer” should not be fatal in a statute that neutrally accommodates each student’s right to private prayer."), _c('a', {
    attrs: {
      "href": "#/#fn1-278",
      "id": "fn1_278"
    }
  }, [_c('sup', [_vm._v("278")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Nor should use of the word “meditation” shield a statute from scrutiny. Meditation can mean contemplation of any subject, but it most often means contemplation of a religious subject. This observation is not based on mere connotation or frequency of usage. Dictionaries offer religious contemplation as a distinct meaning of “meditation.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-279",
      "id": "fn1_279"
    }
  }, [_c('sup', [_vm._v("279")])]), _vm._v(" No modifier is required to make the word specifically and denotatively refer to a religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Alabama legislature probably intended the religious meaning of the word. In any case, millions of citizens will understand the word in its religious meaning. Jaffree unaccountably abandoned his challenge to the meditation statute, but someone else will challenge it sooner or later."), _c('a', {
    attrs: {
      "href": "#/#fn1-280",
      "id": "fn1_280"
    }
  }, [_c('sup', [_vm._v("280")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court did not reach the main problem with the two Alabama statutes. Teachers were authorized to announce that “a period of silence not to exceed one minute in duration shall be observed for meditation or voluntary prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-281",
      "id": "fn1_281"
    }
  }, [_c('sup', [_vm._v("281")])]), _vm._v(" The passive voice and the adjective “voluntary” introduce some ambiguity. But the fairest reading is that this statute authorizes teachers to encourage, and even to command, prayer or religious meditation. It is plain that all students are required to “observe” the moment of silence. And “observe” is modified by the phrase “for meditation or voluntary prayer.” The most apparent meaning is that each student’s observation of the moment must be for the purpose of meditation or prayer. The statutory juxtaposition of “meditation” and “prayer” makes the religious sense of meditation inevitable. Moreover, “meditation” is not modified by “voluntary.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-282",
      "id": "fn1_282"
    }
  }, [_c('sup', [_vm._v("282")])]), _vm._v(" Under this statute, teachers would command students to engage in a religious exercise. The command may be unenforceable, but its mere issuance violates the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Similarly, the earlier Alabama statute required teachers to command students to meditate. The multiple meanings of meditation introduce a slight additional ambiguity, but the essential problem is the same. Many reasonable students would understand this announcement as a state command to engage in a religious exercise. If that is not what the state meant, it should have spoken more clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("One three-judge district court panel has disagreed, upholding a substantially identical Massachusetts statute.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-283",
      "id": "fn1_283"
    }
  }, [_c('sup', [_vm._v("283")])]), _vm._v(" The court held that the statute used “meditation” in its secular sense."), _c('a', {
    attrs: {
      "href": "#/#fn1-284",
      "id": "fn1_284"
    }
  }, [_c('sup', [_vm._v("284")])]), _vm._v(" More precisely, the court said that the statute was “capable of a reasonable construction by which the constitutional difficulties … may be avoided.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-285",
      "id": "fn1_285"
    }
  }, [_c('sup', [_vm._v("285")])]), _vm._v(" But the court’s approach was misguided. The interpretive problem here is not one of construing a statute narrowly to avoid a constitutional question. Legislative endorsements are not filtered through lawyers and state supreme courts. Within limits, the legislature endorses what the public reasonably understands it to endorse."), _c('a', {
    attrs: {
      "href": "#/#fn1-286",
      "id": "fn1_286"
    }
  }, [_c('sup', [_vm._v("286")])]), _vm._v(" If the legislature endorses “meditation,” citizens who understand the legislature to mean “religious meditation” are simply understanding the word in one of its common dictionary senses. They are not making some demonstrable mistake analogous to those who perceive toleration of equal access as endorsement of religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-287",
      "id": "fn1_287"
    }
  }, [_c('sup', [_vm._v("287")])]), _vm._v(" If the legislature cannot speak more clearly, it must at least provide that the teachers who implement the statute speak more clearly. But that was not done in the Massachusetts case."), _c('a', {
    attrs: {
      "href": "#/#fn1-288",
      "id": "fn1_288"
    }
  }, [_c('sup', [_vm._v("288")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Massachusetts court also concluded that the statute required students merely to be quiet and did not require anyone to pray or meditate. This conclusion apparently was drawn from a concession at oral argument;"), _c('a', {
    attrs: {
      "href": "#/#fn1-289",
      "id": "fn1_289"
    }
  }, [_c('sup', [_vm._v("289")])]), _vm._v(" the concession presumably resulted from a careless examination of the statutory language.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Not all moment-of-silence laws follow the Massachusetts and Alabama language. New Mexico did a little better, providing that the moment “may be used for contemplation, meditation, or prayer.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-290",
      "id": "fn1_290"
    }
  }, [_c('sup', [_vm._v("290")])]), _vm._v(" That statute should be upheld if it is properly implemented; it is close enough to neutral to be saved by reasonable explanation. But it is not wholly neutral on its face. “Contemplation” takes on religious coloration from its close association with meditation and prayer, and there is a negative implication that the moment may not be used for anything other than contemplation, meditation, or prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("The New Jersey statute is considerably better. It specifies that the moment of silence is “to be used solely at the discretion of the individual student … for quiet and private contemplation or introspection.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-291",
      "id": "fn1_291"
    }
  }, [_c('sup', [_vm._v("291")])]), _vm._v(" New Jersey’s specification of uses does not explicitly direct students toward religious thought. But the most important difference is the statute’s clear declaration that the use of the moment of silence is in the sole discretion of the individual student. That is the critical point. The New Mexico statute blurred this point, and the Alabama and Massachusetts statute negated it.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Another reasonably well-drafted provision is a West Virginia constitutional amendment that provides:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Public schools shall provide a designated brief time at the beginning of each school day for any student desiring to exercise their [sic] right to personal and private contemplation, meditation, or prayer. No student of a public school may be denied their [sic] right to personal and private contemplation, meditation or prayer nor shall any student be required or encouraged to engage in any given contemplation, meditation or prayer as a part of the school curriculum."), _c('a', {
    attrs: {
      "href": "#/#fn1-292",
      "id": "fn1_292"
    }
  }, [_c('sup', [_vm._v("292")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("The first sentence of this constitutional amendment makes clear that any prayer is the prayer of the individual student and that the school is merely providing a brief time during which students can exercise private rights. The final clause makes it reasonably clear that the school may not encourage any particular use of the moment of silence. The drafting could be tighter, but I would have no difficulty upholding the facial validity of the West Virginia provision.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('strong', [_vm._v("2. Secular Purpose Revisited.")]), _vm._v("—Courts invalidated the New Jersey, West Virginia, and New Mexico provisions despite their apparent neutrality."), _c('a', {
    attrs: {
      "href": "#/#fn1-293",
      "id": "fn1_293"
    }
  }, [_c('sup', [_vm._v("293")])]), _vm._v(" The New Mexico and West Virginia decisions rest in part on findings of improper "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("implementation in particular schools,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-294",
      "id": "fn1_294"
    }
  }, [_c('sup', [_vm._v("294")])]), _vm._v(" but the opinions also appear to facially invalidate the statutes. These decisions rest on the view that even a neutrally worded moment-of-silence statute reflects an impermissible legislative purpose to encourage religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The view that a state moment-of-silence law encourages religion by accommodating silent prayer reflects many of the same fallacious assumptions as the view that the state encourages religion when it permits equal access. But the neutral moment of silence poses the “purpose” issue even more sharply than equal access."), _c('a', {
    attrs: {
      "href": "#/#fn1-295",
      "id": "fn1_295"
    }
  }, [_c('sup', [_vm._v("295")])]), _vm._v(" Equal access builds on a long tradition of open fora for secular speech. There is no such tradition for moments of silence, and no state would mandate a moment of silence for secular thought alone. Rather, the state creates moments of silence for all private thought in order to accommodate religious thought. Even more clearly than in the Equal Access Act, the legislative motivation in moment-of-silence laws is to provide an opportunity for private prayer in the public schools. Courts have not been fooled by the transparently dishonest rationalizations for these laws, such as the claim that they were enacted to help students focus their attention on the day’s work."), _c('a', {
    attrs: {
      "href": "#/#fn1-296",
      "id": "fn1_296"
    }
  }, [_c('sup', [_vm._v("296")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In ordinary usage, a purpose to make it easier for individuals to pray is a religious purpose. This reasoning is most explicit in the court of appeals holding in the New Jersey case. The court found the statute neutral on its face"), _c('a', {
    attrs: {
      "href": "#/#fn1-297",
      "id": "fn1_297"
    }
  }, [_c('sup', [_vm._v("297")])]), _vm._v(" and in effect;"), _c('a', {
    attrs: {
      "href": "#/#fn1-298",
      "id": "fn1_298"
    }
  }, [_c('sup', [_vm._v("298")])]), _vm._v(" it found no improper implementation"), _c('a', {
    attrs: {
      "href": "#/#fn1-299",
      "id": "fn1_299"
    }
  }, [_c('sup', [_vm._v("299")])]), _vm._v(" and no excessive entanglement."), _c('a', {
    attrs: {
      "href": "#/#fn1-300",
      "id": "fn1_300"
    }
  }, [_c('sup', [_vm._v("300")])]), _vm._v(" Nevertheless, the court struck down the statute because two legislators stated a “purpose of permitting prayer by those who want to pray.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-301",
      "id": "fn1_301"
    }
  }, [_c('sup', [_vm._v("301")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("The court of appeals misdirected its inquiry. Whether the statute’s purpose is religious in ordinary usage is irrelevant to the Establishment Clause. First, courts should not inquire into purpose if the statute is neutral on its face and in effect.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-302",
      "id": "fn1_302"
    }
  }, [_c('sup', [_vm._v("302")])]), _vm._v(" Second, a purpose to neutralize a state-imposed burden on religion is constitutionally permissible, even if religion benefits from removal of the burden."), _c('a', {
    attrs: {
      "href": "#/#fn1-303",
      "id": "fn1_303"
    }
  }, [_c('sup', [_vm._v("303")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moment-of-silence laws ease the burden that compulsory education laws impose on some faiths. The compulsory education laws appropriate six or so hours of each student’s time each day. The state devotes those six hours to activities of its choice, and none of its choices can be religious. Students inclined to pray are free to do so on their own time,"), _c('a', {
    attrs: {
      "href": "#/#fn1-304",
      "id": "fn1_304"
    }
  }, [_c('sup', [_vm._v("304")])]), _vm._v(" but there is no assurance that they will get an uninterrupted opportunity. The result is a constraint on the right to pray that would not exist in the absence of compulsory education laws. That constraint generates substantial resentment among certain religious groups. Some believers genuinely feel a need to pray in connection with each of their important activities, of which school is certainly one. Probably a large number are unhappy because they misinterpret the ban on school-sponsored religious activity, viewing it as a hostile exclusion of religion from the public schools.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The state is not required to alleviate this incidental burden, but it does not violate the Establishment Clause if it chooses to do so. A moment of silence accommodates the needs of those who feel a need to pray during the school day. It also helps negate the impression of hostility arising from misunderstanding of the Establishment Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-305",
      "id": "fn1_305"
    }
  }, [_c('sup', [_vm._v("305")])]), _vm._v(" A legislative desire to accommodate prayer in this way should not invalidate a moment-of-silence law that is neutrally drafted and neutrally implemented. Nor does neutral drafting require the legislature to pretend it was not thinking about prayer when it created the moment of silence. Legislators can even say that their purpose is to “return prayer to the public schools,”"), _c('a', {
    attrs: {
      "href": "#/#fn1-306",
      "id": "fn1_306"
    }
  }, [_c('sup', [_vm._v("306")])]), _vm._v(" if the legislature is willing to settle for private prayer, and if both the schools and the legislature refrain from endorsement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Throughout this subsection, I have used the words “accommodate” and “accommodation.” Some in the religious right have almost destroyed the utility of these words by misusing them as code words for government sponsorship. "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("But partisan misuse of the words does not destroy the concepts they embody, and I continue to use the words because no other words express their meaning as well. It should be clear that when I say “accommodate,” I merely mean “provide an opportunity for,” and that I would rigorously exclude government sponsorship or encouragement of any private activity that takes advantage of the opportunity.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-307",
      "id": "fn1_307"
    }
  }, [_c('sup', [_vm._v("307")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Implementing Moments of Silence")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Moment-of-silence laws have posed far more serious implementation problems than drafting problems. A review of the cases is extraordinarily discouraging to those who believe in the rule of law. There is evidence that moments of silence worked well in some schools that were not sued,"), _c('a', {
    attrs: {
      "href": "#/#fn1-308",
      "id": "fn1_308"
    }
  }, [_c('sup', [_vm._v("308")])]), _vm._v(" but in most of the schools that were sued, moments of silence were implemented in unconstitutional ways and became the source of much rancor. There is considerable evidence that teachers encouraged or coerced students to pray"), _c('a', {
    attrs: {
      "href": "#/#fn1-309",
      "id": "fn1_309"
    }
  }, [_c('sup', [_vm._v("309")])]), _vm._v(" and that teachers, students, and the public understood the statutes as requiring students to pray."), _c('a', {
    attrs: {
      "href": "#/#fn1-310",
      "id": "fn1_310"
    }
  }, [_c('sup', [_vm._v("310")])]), _vm._v(" And there is a chilling tale of a praying student harassing a nonpraying student with anti-Semitic epithets."), _c('a', {
    attrs: {
      "href": "#/#fn1-311",
      "id": "fn1_311"
    }
  }, [_c('sup', [_vm._v("311")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These efforts to force students to pray appear to have had very little effect. A study in Las Cruces reported that fewer than twenty percent of students adopted a posture that suggested they were praying."), _c('a', {
    attrs: {
      "href": "#/#fn1-312",
      "id": "fn1_312"
    }
  }, [_c('sup', [_vm._v("312")])]), _vm._v(" Reliance on such a study must allow a wide margin of error; the difficulties of identifying prayer through posture are obvious. Still, the study is suggestive. Some student witnesses have testified that moments of silence were “boring and stupid,”"), _c('a', {
    attrs: {
      "href": "#/#fn1-313",
      "id": "fn1_313"
    }
  }, [_c('sup', [_vm._v("313")])]), _vm._v(" while "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("other witnesses have opposed the moment of silence on the ground that the school atmosphere was not conducive to real prayer and the whole exercise trivialized prayer.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-314",
      "id": "fn1_314"
    }
  }, [_c('sup', [_vm._v("314")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is ample basis in the cases to conclude that moments of silence heighten religious tensions, distract students and faculty from their primary tasks, invite careless, uninformed, or recalcitrant teachers to wittingly or unwittingly violate the Establishment Clause, and succeed in accommodating only the most superficial forms of prayer. As a means of dispelling the impression that schools are hostile to religion, moments of silence are probably less effective than equal access. The facts of the litigated cases suggest that, wholly apart from constitutional questions, moment-of-silence laws are bad public policy. Even so, there is every reason to assume that legislatures will continue to enact them. A neutral way to implement them is needed.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Careful implementation could reduce many of the problems associated with moments of silence. But careful implementation will require a substantial investment of time and effort that the schools could better use in other ways. The facts of the cases make clear that implementation cannot be left to individual teachers, and probably not to individual school boards. The confusion and misinformation about school prayer is too great to expect tolerable results. The only hope is that state boards of education will provide clear guidelines for implementing moments of silence. A well-advised state would give every classroom teacher a little card with a prepared speech for introducing the moment of silence, like the "), _c('em', [_vm._v("Miranda")]), _vm._v(" warning cards that police officers carry. The card should say something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("We will now observe a moment of silence. You are free to think about anything you wish during this moment of silence, but you must remain still and quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("That is a sufficient introduction once the moment of silence has become a customary part of the school day. It is probably sufficient to withstand constitutional attack even if no other explanation is ever offered. But it is also clear from the facts of the cases that widespread confusion and hostility are likely unless students are given a more detailed explanation the first time they are asked to observe a moment of silence. Too many students and parents know that the moment of silence is closely linked to prayer; they draw their own correct and incorrect impressions about the school’s reasons for observing it. "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("The school must dispel those misimpressions to ensure a peaceful moment of silence that is understood to be neutral. And if moments of silence become occasions for the expression of religious intolerance by students, the schools have a duty to respond by teaching tolerance in connection with the moment of silence.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("State boards of education should provide teachers with a more elaborate explanation. I would give teachers a written version that they could take to the classroom to read to their students before the first moment of silence. I would require teachers to reread the more elaborate explanation to their students at regular intervals, and I would also hold faculty meetings in every school to explain it and to review teachers’ experiences in the classrooms. Teachers must understand the law well enough to answer questions from their students. My written version for the classroom would go something like this:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The legislature has asked you to have this moment of silence. One reason for the moment of silence is that some students want a chance to pray. But no one is required to pray during the moment of silence. Whether you pray, and how you pray, and when you pray are entirely up to you and your parents.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteInd"
  }, [_vm._v("We have religious freedom in our country. That means that every family gets to choose its own religion or no religion at all. Some people want to pray at school. Others want to pray only at home or in their church or synagogue. Others don’t want to pray at all. All of these choices are fine with the school. Students who make a different choice than the one you make can still be good students and good Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("It may be that the religious right would rather do without a moment of silence than have teachers say the school does not care whether students pray. But if they take that position, they will prove the claims of those groups that instinctively have opposed moments of silence. The only point of the suggested explanation is to make it clear that the moment of silence is an opportunity for private prayer, and not a state endorsement of prayer. Those who oppose such an explanation must be seeking covert state endorsement, the very thing the Constitution forbids.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nor is it credible to oppose such an explanation on the ground that students cannot understand it. If they cannot understand a neutral moment of silence with an explanation, they certainly cannot understand a neutral moment of silence without an explanation. The explanation may have to be simplified even further in the lower grades. But to argue that students cannot understand the explanation is to argue against a moment of silence altogether.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Even careful attention to implementation will not eliminate all problems. Some teachers will endorse or coerce prayer, and some schools will not correct such violations unless they are sued. Policing implementation in every classroom is a bigger task than facially invalidating statutes in every state. But nothing is more neutral than an open forum for thought. Courts should not invalidate all moment-of-silence laws because of fears that they may be implemented improperly, even if experience so far has been discouraging. Legislatures are free to enact bad public policy, within the limits of the Constitution. A properly drafted and implemented moment-of-silence law is within those limits.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("VI. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Civil libertarians are quick to defend political dissidents, because in those cases the threat to civil liberties comes from only one direction. The state may harass or silence political dissidents, but there is no imminent danger that dissidents will succeed in violating the civil liberties of the rest of us. If the push for the Equal Access Act had come from excluded political groups, the reaction of civil libertarians would have been quite different.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Religious speech poses more complex problems. The risk that the government will sponsor religion is as imminent as the risk that the government will suppress religion. It is hard to rush to the barricades in both directions at the same time. It is harder when you are supposed to be neutral toward people you cannot understand and do not trust, especially when some of those whose speech is being suppressed are simultaneously demanding wholesale violations of the Establishment Clause. Of course, there is nothing unusual about a group loudly defending its own rights while threatening the rights of others. What makes the religious right different is that it is large enough to threaten the rights of others effectively.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever the sins of some evangelicals and fundamentalists on the Establishment Clause front, they are suffering widespread censorship on the free speech and free exercise front. They are not required to remain silent or to confine their religious speech to private places, or to places without children. They are not required to follow the example of the adult bookstores and avoid or warn off listeners who might be offended by their beliefs. We should protect their right to speak as vigilantly as we protect the rights of political groups. Simultaneously, and with equal vigilance, we should fight the government’s efforts to endorse or oppose them or any other religious groups, either openly or subtly.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("I have proposed a simple rule for this two-front war. The government must be absolutely neutral toward religion in its own speech, and it must be absolutely neutral in its treatment of private speech. Under this rule, equal access is constitutionally required. Moment-of-silence laws are not required and are not a good idea, but if neutrally drafted and implemented, they are not unconstitutional.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "ast"
  }, [_vm._v("I am grateful to Dean Kelley, Sanford Levinson, L. A. Powe, David Rabban, Teresa Sullivan, Jay Westbrook, Charles Alan Wright, and Mark Yudof for helpful comments on earlier drafts, and to Fred Garrett for research assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_1",
      "id": "fn1-1"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWRENCE")]), _vm._v(" A. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REMIN")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMMON")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" 66–70 (Columbia Univ. Teachers College 1951); D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IANE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVITCH")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REAT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOL")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARS")]), _vm._v(": N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITY")]), _vm._v(", 1805–1973, at 18–19, 34–35, 47 (Basic Books 1974); 1 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSON")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HELPS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOKES")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATE")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITED")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TATES")]), _vm._v(" 824–27 (Harper Bros. 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_2",
      "id": "fn1-2"
    }
  }, [_vm._v("2.")]), _vm._v(" 370 U.S. 421 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_3",
      "id": "fn1-3"
    }
  }, [_vm._v("3.")]), _vm._v(" 374 U.S. 203 (1963) [in this volume at 282].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_4",
      "id": "fn1-4"
    }
  }, [_vm._v("4.")]), _vm._v(" U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_5",
      "id": "fn1-5"
    }
  }, [_vm._v("5.")]), _vm._v(" For the historical part of that argument, see Douglas Laycock, "), _c('em', [_vm._v("“Non-Preferential” Aid to Religion: A False Claim About Original Intent")]), _vm._v(", 27 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 875 (1986) [in volume 1 at 531].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_6",
      "id": "fn1-6"
    }
  }, [_vm._v("6.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 475 U.S. 534, 554 (1986) (Burger, C.J., dissenting); Grand Rapids Sch. Dist. v. Ball, 473 U.S. 373, 382 (1985); Wallace v. Jaffree, 472 U.S. 38, 53 n.37, 60–61 (1985); Lynch v. Donnelly, 465 U.S. 668, 714 (1983) (Brennan, J., dissenting); Marsh v. Chambers, 463 U.S. 783, 802–03 (1983) (Brennan, J., dissenting); Mueller v. Allen, 463 U.S. 388, 404 (1983) (Marshall, J., dissenting); Thomas v. Review Board, 450 U.S. 707, 717 (1981); McDaniel v. Paty, 435 U.S. 618, 629 (1978) (plurality opinion); "), _c('em', [_vm._v("id")]), _vm._v(". at 636 (Brennan, J., concurring); Maher v. Roe, 432 U.S. 464, 475 n.8 (1977); Roemer v. Board of Pub. Works, 426 U.S. 736, 747 (1976) (plurality opinion); Meek v. Pittenger, 421 U.S. 349, 372 (1975); Committee for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 792–93 (1973); Wisconsin v. Yoder, 406 U.S. 205, 220 (1972); Gillette v. United States, 401 U.S. 437, 449 (1971); "), _c('em', [_vm._v("id")]), _vm._v(". at 469 (Douglas, J., dissenting); Welsh v. United States, 398 U.S. 333, 372 (1970) (White, J., dissenting); Epperson v. Arkansas, 393 U.S. 97, 103–04, 109 (1968); Board of Educ. v. Allen, 392 U.S. 236, 242 (1968); "), _c('em', [_vm._v("id")]), _vm._v(". at 249 (Harlan, J., concurring); Sherbert v. Verner, 374 U.S. 398, 409 (1963); "), _c('em', [_vm._v("id")]), _vm._v(". at 422–23 (Harlan, J., dissenting); Abington Sch. Dist. v. Schempp, 374 U.S. 203, 215–22, 226 (1963); "), _c('em', [_vm._v("id")]), _vm._v(". at 243–45, 295, 299 (Brennan, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 306 (Goldberg, J., concurring); Engel v. Vitale, 370 U.S. 421, 443 (1962) (Douglas, J., concurring); McGowan v. Maryland, 366 U.S. 420, 564 (1961) (Douglas, J., dissenting); Everson v. Board of Educ., 330 U.S. 1, 18 (1947).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("Perhaps the Court’s most frequent formulation of the neutrality requirement is that “the principal or primary effect [of legislation] must be one that neither advances nor inhibits religion.” Lemon v. Kurtzman, 403 U.S. 602, 612 (1971). Two Justices have dissented from the neutrality requirement. See Wallace v. Jaffree, 472 U.S. 38, 83 (1985) (O’Connor, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 99–100, 108 (Rehnquist, J., dissenting). But even they invoke neutrality on occasion. See Bender v. Williamsport Area Sch. Dist., 474 U.S. 534, 554 (1986) (Burger, C.J., dissenting, joined by Rehnquist, J.); Witters v. Wash. Dep’t of Servs. for the Blind, 474 U.S. 481, 493 (1986) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_7",
      "id": "fn1-7"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985) (statutes directed teachers to announce that students “shall observe” period of silence for meditation and authorized them to announce that period was for meditation or prayer); Karen B. v. Treen, 653 F.2d 897 (5th Cir. 1981), "), _c('em', [_vm._v("aff’d mem.")]), _vm._v(", 455 U.S. 913 (1982) (statute authorized teachers to ask if any student wanted to lead class in prayer, and to lead prayer themselves if no student volunteered); "), _c('em', [_vm._v("see also")]), _vm._v(" Stone v. Graham, 449 U.S. 39 (1980) (statute directed schools to permanently post Ten Commandments on bulletin boards, with expenses paid by private contributions).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_8",
      "id": "fn1-8"
    }
  }, [_vm._v("8.")]), _vm._v(" 20 U.S.C. §§ 4071–4074 (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_9",
      "id": "fn1-9"
    }
  }, [_vm._v("9.")]), _vm._v(" These statutes are collected in "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 70 n.1 (O’Connor, J., concurring). They are summarized in tabular form in David Z. Seide, Note, "), _c('em', [_vm._v("Daily Moments of Silence in Public Schools: A Constitutional Analysis")]), _vm._v(", 58 N.Y.U.L. Rev. 364, 407–08 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_10",
      "id": "fn1-10"
    }
  }, [_vm._v("10.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Philip B. Kurland, "), _c('em', [_vm._v("Of Church and State and the Supreme Court")]), _vm._v(", 29 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_11",
      "id": "fn1-11"
    }
  }, [_vm._v("11.")]), _vm._v(" On the distinction between private and government speech, see M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARK")]), _vm._v(" G. Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEN")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVERNMENT")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PEAKS")]), _vm._v(": P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLITICS")]), _vm._v(", L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVERNMENT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICA")]), _vm._v(" (Univ. of California Press 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_12",
      "id": "fn1-12"
    }
  }, [_vm._v("12.")]), _vm._v(" This formulation is arguably implicit in earlier commentary. Judges and commentators have argued that the Free Speech Clause guarantees religious student groups equal access to open fora on school property and that high school students can understand that the school does not endorse every student group. "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Bender v. Williamsport Area Sch. Dist., 475 U.S. 534, 553 (1986) (Burger, C.J., dissenting); Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 561 (3d Cir. 1984) (Adams, J., dissenting), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); S. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EP")]), _vm._v(". No. 357, 98th Cong., 2d Sess. 8–10, 21–24, "), _c('em', [_vm._v("reprinted in")]), _vm._v(" 1984 U.S.C.C.A.N 2348, 2354–56, 2367–70; Arnold H. Loewy, "), _c('em', [_vm._v("School Prayer, Neutrality, and the Open Forum: Why We Don’t Need a Constitutional Amendment")]), _vm._v(", 61 N.C.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 141 (1982); Ira C. Lupu, "), _c('em', [_vm._v("Keeping the Faith: Religion, Equality and Speech in the U.S. Constitution")]), _vm._v(", 18 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 739, 755–61 (1986); John E. Leach, Note, "), _c('em', [_vm._v("Religion in Public Schoolrooms—Striking a Balance Between Freedom of Speech and Establishment of Religion")]), _vm._v(": "), _c('em', [_vm._v("Bender v. Williamsport Area School District")]), _vm._v(", 1984 B.Y.U.L. Rev. 671; Note, Lowell V. Sturgill, Jr. & Nancy S. Oliver, "), _c('em', [_vm._v("Religious Expression in the Public Schools Forum: The High School Student’s Right to Free Speech")]), _vm._v(", 72 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 135 (1983); Scott C. Benjamin, Comment, "), _c('em', [_vm._v("Widmar v. Vincent and the Public Forum Doctrine: Time to Reconsider Public School Prayer")]), _vm._v(", 1984 Wis. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 147; Note, "), _c('em', [_vm._v("The Constitutional Dimensions of Student-Initiated Religious Activity in Public High Schools")]), _vm._v(", 92 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 499 (1983) (hereinafter Note, "), _c('em', [_vm._v("Student-Initiated Religious Activity")]), _vm._v("); "), _c('em', [_vm._v("see also")]), _vm._v(" Keegan v. Univ. of Del., 349 A.2d 14 (Del. 1975); Linda S. Leparulo, Note, "), _c('em', [_vm._v("The Rights of Student Religious Groups Under the First Amendment to Hold Religious Meetings on the Public University Campus")]), _vm._v(", 33 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTGERS")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1008 (1981). For quite different arguments, see Donald L. Drakeman & Robert P. Seawright, "), _c('em', [_vm._v("God and Kids at School: Voluntary Religious Activities in the Public Schools")]), _vm._v(", 14 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETON")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 252 (1984) (balancing Establishment Clause rights against Free Exercise Clause rights and finding free exercise rights weightier); Robert L. Toms & John W. Whitehead, "), _c('em', [_vm._v("The Religious Student in Public Education: Resolving a Constitutional Dilemma")]), _vm._v(", 27 E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MORY")]), _vm._v(" L.J. 3 (1978) (equal access is consistent with “benevolent” or “accommodating” neutrality, in which modest government aid to religion is permitted).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("This Article further develops the principles underlying equal access and responds more thoroughly to arguments against it. The most important new argument in this Article is the attempt to show that arguments against equal access are based on the same fallacy as arguments in favor of school prayer. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 97–99 and accompanying text. This Article also offers a thorough analysis of the Equal Access Act. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 168–212 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_13",
      "id": "fn1-13"
    }
  }, [_vm._v("13.")]), _vm._v(" This would not preclude the school from monitoring meetings for reasons of safety and discipline. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 142–50 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_14",
      "id": "fn1-14"
    }
  }, [_vm._v("14.")]), _vm._v(" 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_15",
      "id": "fn1-15"
    }
  }, [_vm._v("15.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 544 (3d Cir. 1984) (quoting testimony of school principal), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_16",
      "id": "fn1-16"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 543–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_17",
      "id": "fn1-17"
    }
  }, [_vm._v("17.")]), _vm._v(" U.S. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". amend. I.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_18",
      "id": "fn1-18"
    }
  }, [_vm._v("18.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_19",
      "id": "fn1-19"
    }
  }, [_vm._v("19.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_20",
      "id": "fn1-20"
    }
  }, [_vm._v("20.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_21",
      "id": "fn1-21"
    }
  }, [_vm._v("21.")]), _vm._v(" Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646, 649 (11th Cir. 1984) (“The ultimate question, of course, is whether the school district merely accommodates, as opposed to endorses, the [Youth for Christ Club].”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_22",
      "id": "fn1-22"
    }
  }, [_vm._v("22.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982); "), _c('em', [_vm._v("accord")]), _vm._v(", Johnson v. Huntington Beach Union High Sch. Dist., 137 Cal. Rptr. 43 (Ct. App. 1977); "), _c('em', [_vm._v("see also")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985) (applying same rule to junior high school); Mich. State Board of Educ. v. Tri-County Area Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 47 (W.D. Mich. 1984) (applying same rule to elementary school).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_23",
      "id": "fn1-23"
    }
  }, [_vm._v("23.")]), _vm._v(" Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_24",
      "id": "fn1-24"
    }
  }, [_vm._v("24.")]), _vm._v(" 20 U.S.C. §§ 4071 to 4074 (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_25",
      "id": "fn1-25"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('em', [_vm._v("Compare")]), _vm._v(" Mergens v. Board of Educ., 5 Religious Freedom Rep. (Christian Legal Soc’y) 86 (D. Neb. 1985) (denying preliminary injunction to enforce Act and expressing serious doubt about its validity); "), _c('em', [_vm._v("with")]), _vm._v(" Amidei v. Spring Branch Indep. Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 67 (S.D. Tex. 1985) (upholding Act and ordering school board to comply). [The Eighth Circuit reversed in "), _c('em', [_vm._v("Mergens")]), _vm._v(", 867 F.2d 1076 (8th Cir. 1989), and the Supreme Court affirmed the Eighth Circuit. 496 U.S. 226 (1990). My amicus brief in "), _c('em', [_vm._v("Mergens")]), _vm._v(" is in this volume at 81.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_26",
      "id": "fn1-26"
    }
  }, [_vm._v("26.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Walters v. Radiation Survivors, 473 U.S. 305, 319 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_27",
      "id": "fn1-27"
    }
  }, [_vm._v("27.")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); May v. Cooperman, 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom.")]), _vm._v(" Karcher v. May, 479 U.S. 1062 (1987) [this appeal was later dismissed, because the former legislative leaders seeking to appeal no longer held their legislative positions, 484 U.S. 72 (1987)]; Walter v. West Va. State Board of Educ., 610 F. Supp. 1169 (S.D.W. Va. 1985); Duffy v. Las Cruces Pub. Schs., 557 F. Supp. 1013 (D.N.M. 1983); Beck v. McElrath, 548 F. Supp. 1161 (M.D. Tenn. 1982). "), _c('em', [_vm._v("Contra")]), _vm._v(" Gaines v. Anderson, 421 F. Supp. 337 (D. Mass. 1976) (three-judge court); Opinion of the Justices, 307 A.2d 558, 560 (N.H. 1973). The Supreme Court has strongly implied that a properly drafted and implemented moment-of-silence law would be upheld. "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38, 59 (1985); "), _c('em', [_vm._v("id")]), _vm._v(". at 66 (Powell, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 71–75 (O’Connor, J., concurring); "), _c('em', [_vm._v("id")]), _vm._v(". at 91 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_28",
      "id": "fn1-28"
    }
  }, [_vm._v("28.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.,")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AURENCE")]), _vm._v(" H. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIBE")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MERICAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONSTITUTIONAL")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" § 14–6, at 828 (Foundation Press 1978); Jesse H. Choper, "), _c('em', [_vm._v("Religion in the Public Schools: A Proposed Constitutional Standard")]), _vm._v(", 47 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 329, 371 (1963); Paul A. Freund, "), _c('em', [_vm._v("The Legal Issue")]), _vm._v(", in R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHOOLS")]), _vm._v(" 2 (Harvard 1965); Paul G. Kauper, "), _c('em', [_vm._v("Prayer, Public Schools and the Supreme Court")]), _vm._v(", 61 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1031, 1041 (1963); Andrew Woodbridge Hull, Note, "), _c('em', [_vm._v("A Moment of Silence: A Permissible Accommodation Protecting the Capacity to Form Religious Belief")]), _vm._v(", 61 I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ND")]), _vm._v(". L.J. 429 (1986); Donald L. Swanson, Comment, "), _c('em', [_vm._v("Accommodating Religion in the Public Schools")]), _vm._v(", 59 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 425, 450–54 (1980); P. Raymond Bartholomew, Note, "), _c('em', [_vm._v("Religion and the Public Schools")]), _vm._v(", 20 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1078, 1092–93 (1967). "), _c('em', [_vm._v("But see")]), _vm._v(" Donald L. Drakeman, "), _c('em', [_vm._v("Prayer in the Schools: Is New Jersey’s Moment of Silence Law Constitutional?")]), _vm._v(", 35 R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTGERS")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 341 (1983); Kaneaster Hodges, Jr., Comment, "), _c('em', [_vm._v("Constitutional Law—Religious Exercises and the Public Schools")]), _vm._v(", 20 A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RK")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 320, 352–53 (1967); Note, "), _c('em', [_vm._v("The Unconstitutionality of State Statutes Authorizing Moments of Silence in the Public Schools")]), _vm._v(", 96 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1874 (1983) [hereinafter Note, "), _c('em', [_vm._v("State Statutes")]), _vm._v("]; Seide, "), _c('em', [_vm._v("supra")]), _vm._v(" note 9; Robert Tilewick, Note, "), _c('em', [_vm._v("Constitutional Law—Ritual Silence in Public Schools")]), _vm._v(", 57 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMP")]), _vm._v(". L.Q. 95 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_29",
      "id": "fn1-29"
    }
  }, [_vm._v("29.")]), _vm._v(" 472 U.S. 38 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_30",
      "id": "fn1-30"
    }
  }, [_vm._v("30.")]), _vm._v(" Examples drawn from the religious and political leadership of such groups include Rev. Jerry Falwell, Rev. Oral Roberts, Rev. Pat Robertson, Sen. Jesse Helms, and former Sen. Jeremiah Denton.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_31",
      "id": "fn1-31"
    }
  }, [_vm._v("31.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 126–39 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_32",
      "id": "fn1-32"
    }
  }, [_vm._v("32.")]), _vm._v(" Esbeck distinguishes “secularists” from “institutional-separationists.” See Carl H. Esbeck, "), _c('em', [_vm._v("Religion and a Neutral State: Imperative or Impossibility?")]), _vm._v(", 15 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 67, 75–77 (1984). The unfortunately named institutional separationists are typified by the liberal Protestant denominations, which oppose school prayer and financial aid to church schools.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_33",
      "id": "fn1-33"
    }
  }, [_vm._v("33.")]), _vm._v(" Abington School Dist. v. Schempp, 374 U.S. 203 (1963) [in this volume at 282]; Engel v. Vitale, 370 U.S. 421 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_34",
      "id": "fn1-34"
    }
  }, [_vm._v("34.")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); "), _c('em', [_vm._v("see also")]), _vm._v(" Karen B. v. Treen, 653 F.2d 897 (5th Cir. 1981), "), _c('em', [_vm._v("aff’d mem")]), _vm._v("., 455 U.S. 913 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_35",
      "id": "fn1-35"
    }
  }, [_vm._v("35.")]), _vm._v(" Stone v. Graham, 449 U.S. 39 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_36",
      "id": "fn1-36"
    }
  }, [_vm._v("36.")]), _vm._v(" Marsh v. Chambers, 463 U.S. 783 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_37",
      "id": "fn1-37"
    }
  }, [_vm._v("37.")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_38",
      "id": "fn1-38"
    }
  }, [_vm._v("38.")]), _vm._v(" Corpus Christi, the name of a major city in Texas, is a Latin phrase meaning “Body of Christ.” Town boosters refer to residents as Corpus Christians. Numerous religious protesters, including the National Conference of Catholic Bishops, were deeply offended when the Navy named a nuclear submarine the Corpus Christi. President Reagan renamed the ship the "), _c('em', [_vm._v("City of Corpus Christi")]), _vm._v(". For reasons that are wholly unclear, that was considered more acceptable. The controversy is chronicled in Phil Gailey, "), _c('em', [_vm._v("Protester Ends His Fast a Winner and a Loser")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Apr. 29, 1982; "), _c('em', [_vm._v("Church, State, and a Submarine")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Dec. 8, 1981; Robert E. Tomasson, "), _c('em', [_vm._v("Corpus Christi Launched in Groton as 1,000 Protest Sub and Its Name")]), _vm._v(", N.Y. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMES")]), _vm._v(", Apr. 26, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_39",
      "id": "fn1-39"
    }
  }, [_vm._v("39.")]), _vm._v(" The original Spanish name of Los Angeles was "), _c('em', [_vm._v("El Pueblo de Nuestra Senora la Reyna de los Angeles de Porciuncula")]), _vm._v("—“The Town of Our Lady the Queen of the Angels of Porciuncula.” 2 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTURY")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YCLOPEDIA")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" 2513 (1954). Porciuncula apparently is derived from Portiuncula, the first monastery founded by St. Francis of Assisi. J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" J. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELANEY")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AINTS")]), _vm._v(" 234 (Doubleday 1980); "), _c('em', [_vm._v("see also")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RTURO")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UYÁS")]), _vm._v(", A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPLETON")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UYÁS")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v("-S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PANISH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PANISH")]), _vm._v("-E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" 433 (1972) (defining “porciuncula” as a “franciscan jubilee”). The name of the city has since been shortened to "), _c('em', [_vm._v("El Pueblo de la Reyna de los Angeles")]), _vm._v("—“The Town of the Queen of the Angels.” 23 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCYCLOPEDIA")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RITANNICA")]), _vm._v(" 311 (1985). Either version names the city with an honorific title for Mary, a religious figure significant only to Christians. Mary’s role in Christianity is a major point of division between Protestants and Catholics, and only Catholics would refer to her with these honorific titles. [I have been asked if I am now somewhat embarrassed by footnotes 38 and 39 and the paragraph they accompany. I am not. I understood at the time that there would always be a de minimis exception, and I now have a greater appreciation of the need for such an exception. But in principle, which is all I ever claimed, I still believe in this passage.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_40",
      "id": "fn1-40"
    }
  }, [_vm._v("40.")]), _vm._v(" "), _c('em', [_vm._v("Cf.")]), _vm._v(" Korematsu v. United States, 323 U.S. 214, 246 (1944) (Jackson, J., dissenting) (it would have been better for the Court to deny review than to publish opinion that validated principle of racial discrimination in military emergencies).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_41",
      "id": "fn1-41"
    }
  }, [_vm._v("41.")]), _vm._v(" This proposition is far too obvious to have ever been the subject of litigation. "), _c('em', [_vm._v("Cf.")]), _vm._v(" Grand Rapids School Dist. v. Ball, 473 U.S. 373, 388 (1985) (Court concerned that public school teachers might encourage religion while on property of parochial schools). Whatever the defects in the Court’s reasoning, it is plainly correct to hold that an establishment on private property is still an establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_42",
      "id": "fn1-42"
    }
  }, [_vm._v("42.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Toms & Whitehead, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 15–19.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_43",
      "id": "fn1-43"
    }
  }, [_vm._v("43.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" sources cited "), _c('em', [_vm._v("supra")]), _vm._v(" note 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_44",
      "id": "fn1-44"
    }
  }, [_vm._v("44.")]), _vm._v(" 454 U.S. 263, 265–66 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_45",
      "id": "fn1-45"
    }
  }, [_vm._v("45.")]), _vm._v(" Chess v. Widmar, 480 F. Supp. 907 (W.D. Mo. 1979), "), _c('em', [_vm._v("rev’d")]), _vm._v(", 635 F.2d 1310 (8th Cir. 1980), "), _c('em', [_vm._v("aff’d sub nom.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_46",
      "id": "fn1-46"
    }
  }, [_vm._v("46.")]), _vm._v(" "), _c('em', [_vm._v("Chess")]), _vm._v(", 635 F.2d at 1310.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_47",
      "id": "fn1-47"
    }
  }, [_vm._v("47.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 274.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_48",
      "id": "fn1-48"
    }
  }, [_vm._v("48.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 281 (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_49",
      "id": "fn1-49"
    }
  }, [_vm._v("49.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 278–79 (Stevens, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_50",
      "id": "fn1-50"
    }
  }, [_vm._v("50.")]), _vm._v(" Carey v. Brown, 447 U.S. 455 (1980); Healy v. James, 408 U.S. 169 (1972); Police Dep’t v. Mosley, 408 U.S. 92 (1972). "), _c('em', [_vm._v("See generally")]), _vm._v(" Kenneth L. Karst, "), _c('em', [_vm._v("Equality as a Central Principle in the First Amendment")]), _vm._v(", 43 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 20, 20–43 (1975); Geoffrey R. Stone, "), _c('em', [_vm._v("Content Regulation and the First Amendment")]), _vm._v(", 25 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". & M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARY")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 189, 189–94, 233–52 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_51",
      "id": "fn1-51"
    }
  }, [_vm._v("51.")]), _vm._v(" Madison Joint Sch. Dist. v. Wis. Employment Relations Comm’n, 429 U.S. 167 (1976); Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546 (1975). "), _c('em', [_vm._v("See generally")]), _vm._v(" Harry Kalven, Jr., "), _c('em', [_vm._v("The Concept of the Public Forum: Cox v. Louisiana")]), _vm._v(", 1965 Sup. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1; Geoffrey R. Stone, "), _c('em', [_vm._v("Fora Americana: Speech in Public Places")]), _vm._v(", 1974 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UP")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 233.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("More recent scholarship argues that the public forum classification is often conclusory. These scholars suggest a more focused balancing of specific competing interests, with considerable weight given to the interests in speech and content neutrality. "), _c('em', [_vm._v("See")]), _vm._v(" Ronald A. Cass, "), _c('em', [_vm._v("First Amendment Access to Government Facilities")]), _vm._v(", 65 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1287 (1979); Daniel A. Farber & John E. Nowak, "), _c('em', [_vm._v("The Misleading Nature of Public Forum Analysis: Content and Context in First Amendment Adjudication")]), _vm._v(", 70 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1219 (1984); Barbara S. Gaal, Note, "), _c('em', [_vm._v("A Unitary Approach to Claims of First Amendment Access to Publicly Owned Property")]), _vm._v(", 35 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 121 (1982). Structuring the argument in this way does not change the result in "), _c('em', [_vm._v("Widmar")]), _vm._v(", because the ban on religious speech does not help implement the Establishment Clause, the only conceivably relevant governmental goal. "), _c('em', [_vm._v("See")]), _vm._v(" Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(", at 1248–49; "), _c('em', [_vm._v("infra")]), _vm._v(" notes 70–165 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_52",
      "id": "fn1-52"
    }
  }, [_vm._v("52.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" note 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_53",
      "id": "fn1-53"
    }
  }, [_vm._v("53.")]), _vm._v(" Daniel A. Farber, "), _c('em', [_vm._v("Content Regulation and the First Amendment: A Revisionist View")]), _vm._v(", 68 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 727 (1980); Paul B. Stephan III, "), _c('em', [_vm._v("The First Amendment and Content Discrimination")]), _vm._v(", 68 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 203 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_54",
      "id": "fn1-54"
    }
  }, [_vm._v("54.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 284–85 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_55",
      "id": "fn1-55"
    }
  }, [_vm._v("55.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 285.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_56",
      "id": "fn1-56"
    }
  }, [_vm._v("56.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Marsh v. Alabama, 326 U.S. 501 (1946); West Va. State Board of Educ. v. Barnette, 319 U.S. 624 (1943); Murdock v. Pennsylvania, 319 U.S. 105 (1943); Largent v. Texas, 318 U.S. 418 (1943); Jamison v. Texas, 318 U.S. 413 (1943); Cantwell v. Connecticut, 310 U.S. 296 (1940); Lovell v. City of Griffin, 303 U.S. 444 (1938). "), _c('em', [_vm._v("Largent")]), _vm._v(" held that religious speech is protected by both the Free Speech and Free Exercise Clauses. 318 U.S. at 422. That is clearly correct, but the standards are the same under both clauses. Some commentators prefer to protect religious speech under the Free Exercise Clause. "), _c('em', [_vm._v("See, e.g")]), _vm._v("., Drakeman & Seawright, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 273–78. Teitel argues that the Free Exercise Clause is not violated unless the government “effectively foreclose[s] the practice of one’s religion.” Ruti Teitel, "), _c('em', [_vm._v("The Unconstitutionality of Equal Access Policies and Legislation Allowing Organized Student-Initiated Religious Activities in the Public High Schools: A Proposal for a Unitary First Amendment Forum Analysis")]), _vm._v(", 12 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASTINGS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". L.Q. 529, 592 (1985). But Teitel’s standard would allow rampant government hostility to religion, so long as it fell short of a ban on religious practice. Discrimination against religion is the essence of both free speech and free exercise violations in equal access cases. "), _c('em', [_vm._v("See generally")]), _vm._v(" William P. Marshall, "), _c('em', [_vm._v("Solving the Free Exercise Dilemma: Free Exercise as Expression")]), _vm._v(", 67 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 545 (1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_57",
      "id": "fn1-57"
    }
  }, [_vm._v("57.")]), _vm._v(" Poulos v. New Hampshire, 345 U.S. 395 (1953); Fowler v. Rhode Island, 345 U.S. 67 (1953); Niemotko v. Maryland, 340 U.S. 268 (1951); "), _c('em', [_vm._v("see")]), _vm._v(" Kunz v. New York, 340 U.S. 290 (1951); Saia v. New York, 334 U.S. 558 (1948).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_58",
      "id": "fn1-58"
    }
  }, [_vm._v("58.")]), _vm._v(" Niemotko v. Maryland, 340 U.S. 268 (1951).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_59",
      "id": "fn1-59"
    }
  }, [_vm._v("59.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Joint Brief for Appellants at 18–24, "), _c('em', [_vm._v("Niemotko")]), _vm._v("; Joint Brief for Appellees at 17–20. Because the authorities had allowed other religious groups to hold services in the parks, the Court refused to let the state defend the exclusion of Jehovah’s Witnesses on Establishment Clause grounds. "), _c('em', [_vm._v("Niemotko")]), _vm._v(", 340 U.S. at 272–73. The Establishment Clause argument was also raised in Kunz v. New York, 340 U.S. 290, 311 n.10 (1951) (Jackson, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_60",
      "id": "fn1-60"
    }
  }, [_vm._v("60.")]), _vm._v(" O’Hair v. Andrus, 613 F.2d 931 (D.C. Cir. 1979); "), _c('em', [_vm._v("see also")]), _vm._v(" Gilfillan v. City of Philadelphia, 637 F.2d 924 (3d Cir. 1980). "), _c('em', [_vm._v("Gilfillan")]), _vm._v(" held that the city could not pay the cost of building a platform for a papal mass or provide other kinds of assistance that the city had not offered to other groups holding large meetings in the parks. "), _c('em', [_vm._v("Gilfillan")]), _vm._v(", 637 F.2d at 928–33. The plaintiffs conceded that the mass could be held and that the city could spend substantial sums on traffic and crowd control. "), _c('em', [_vm._v("Id")]), _vm._v(". at 928. Similar cases include Jews for Jesus, Inc. v. Board of Airport Comm’rs, 785 F.2d 791 (9th Cir.), "), _c('em', [_vm._v("cert. granted")]), _vm._v(", 479 U.S. 812 (1986) (religious solicitation in airport; establishment issue not raised) [The Court unanimously protected Jews for Jesus’s right to distribute literature, in an opinion written on overbreadth grounds. 482 U.S. 569 (1987).]; Christian Science Reading Room Jointly Maintained v. City of San Francisco, 784 F.2d 1010 (9th Cir. 1986) (church reading room in airport); McCreary v. Stone, 739 F.2d 716 (2d Cir. 1984) (private crèche in public park), "), _c('em', [_vm._v("aff’d by an equally divided Court sub nom")]), _vm._v(". Board of Trustees v. McCreary, 471 U.S. 83 (1985); Jaffe v. Alexis, 659 F.2d 1018 (9th Cir. 1981) (religious solicitation on grounds of Department of Motor Vehicles); Brashich v. Port Auth., 791 F.2d 224 (2d Cir. 1980) (chapels in airport).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_61",
      "id": "fn1-61"
    }
  }, [_vm._v("61.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 287 (White, J., dissenting). White dissented because he thought religious worship was unlike other religious speech. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 261–62 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_62",
      "id": "fn1-62"
    }
  }, [_vm._v("62.")]), _vm._v(" 452 U.S. 640 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_63",
      "id": "fn1-63"
    }
  }, [_vm._v("63.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 643–45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_64",
      "id": "fn1-64"
    }
  }, [_vm._v("64.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 652–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_65",
      "id": "fn1-65"
    }
  }, [_vm._v("65.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 652.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_66",
      "id": "fn1-66"
    }
  }, [_vm._v("66.")]), _vm._v(" Geoffrey R. Stone, "), _c('em', [_vm._v("The Equal Access Controversy: The Religion Clauses and the Meaning of “Neutrality,”")]), _vm._v(" 81 Nw. U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 168 (1986). For a similar argument, see Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 586.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_67",
      "id": "fn1-67"
    }
  }, [_vm._v("67.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Martin H. Redish, "), _c('em', [_vm._v("The Content Distinction in First Amendment Analysis")]), _vm._v(", 34 S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 113 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_68",
      "id": "fn1-68"
    }
  }, [_vm._v("68.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Stone, "), _c('em', [_vm._v("supra")]), _vm._v(" note 50, at 239–42; Geoffrey R. Stone, "), _c('em', [_vm._v("Restriction of Speech Because of Its Content: The Peculiar Case of Subject-Matter Restrictions")]), _vm._v(", 46 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HI")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 81 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_69",
      "id": "fn1-69"
    }
  }, [_vm._v("69.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" Lehman v. City of Shaker Heights, 418 U.S. 298 (1974) (city bus system can sell commercial advertising space and refuse to sell political advertising space).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_70",
      "id": "fn1-70"
    }
  }, [_vm._v("70.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980); Chess v. Widmar, 480 F. Supp. 907 (W.D. Mo. 1979), "), _c('em', [_vm._v("rev’d")]), _vm._v(", 635 F.2d 1310 (8th Cir. 1980), "), _c('em', [_vm._v("aff’d sub nom")]), _vm._v(". Widmar v. Vincent, 454 U.S. 263 (1981); Nadine Strossen, "), _c('em', [_vm._v("A Framework for Evaluating Equal Access Claims by Student Religious Groups: Is There a Window for Free Speech in the Wall Separating Church and State?")]), _vm._v(", 71 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORNELL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 143, 158 (1985); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 566–74. In some cases, courts reasonably found actual endorsement in the implementation of facially neutral equal access policies. "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_71",
      "id": "fn1-71"
    }
  }, [_vm._v("71.")]), _vm._v(" Beyer, "), _c('em', [_vm._v("“Phooey on Falwell” Rally Attracts “The Masses,”")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILY")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXAN")]), _vm._v(", Sept. 30, 1981; Elliot, "), _c('em', [_vm._v("West Mall Religious Rally Ruled Illegal")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AILY")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXAN")]), _vm._v(", Sept. 17, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_72",
      "id": "fn1-72"
    }
  }, [_vm._v("72.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 802–03 (1985). The Court also has held that the streets of company towns are a public forum. Marsh v. Alabama, 326 U.S. 501 (1946). Some states have imposed public forum obligations on the owners of shopping malls, "), _c('em', [_vm._v("see")]), _vm._v(" Robins v. PruneYard Shopping Center, 592 P.2d 341 (Cal. 1979), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 447 U.S. 74 (1980), and private universities, "), _c('em', [_vm._v("see")]), _vm._v(" State v. Schmid, 423 A.2d 615 (N.J. 1980), "), _c('em', [_vm._v("appeal dismissed sub nom")]), _vm._v(". Princeton Univ. v. Schmid, 455 U.S. 100 (1982).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_73",
      "id": "fn1-73"
    }
  }, [_vm._v("73.")]), _vm._v(" 741 F.2d 538, 552 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985); Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 669 F.2d 1038 (5th Cir. 1982); Brandon v. Board of Educ., 635 F.2d 971 (2d Cir. 1980); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 566–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_74",
      "id": "fn1-74"
    }
  }, [_vm._v("74.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 554.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_75",
      "id": "fn1-75"
    }
  }, [_vm._v("75.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Bethel Sch. Dist. No. 403 v. Fraser, 478 U.S. 675, 683–84 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_76",
      "id": "fn1-76"
    }
  }, [_vm._v("76.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Cary v. Board of Educ., 427 F. Supp. 945, 953 (D. Colo. 1977), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 598 F.2d 535 (10th Cir. 1979); Albaum v. Carey, 283 F. Supp. 3, 10–11 (E.D.N.Y. 1968); Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 160–61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_77",
      "id": "fn1-77"
    }
  }, [_vm._v("77.")]), _vm._v(" A student note collects psychological studies suggesting that adolescents resist authority and are capable of independent critical thought. Note, "), _c('em', [_vm._v("Student-Initiated Religious Activity, supra")]), _vm._v(" note 12, at 507–09; "), _c('em', [_vm._v("see also")]), _vm._v(" Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 162.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_78",
      "id": "fn1-78"
    }
  }, [_vm._v("78.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Bigelow v. Virginia, 421 U.S. 809, 827–28 (1975) (state’s interest in “shielding its citizens from information” is entitled to little weight, even in context of commercial advertising).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_79",
      "id": "fn1-79"
    }
  }, [_vm._v("79.")]), _vm._v(" 393 U.S. 503 (1969).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_80",
      "id": "fn1-80"
    }
  }, [_vm._v("80.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 504.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_81",
      "id": "fn1-81"
    }
  }, [_vm._v("81.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 518 (Black, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_82",
      "id": "fn1-82"
    }
  }, [_vm._v("82.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 517–18 (Black, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_83",
      "id": "fn1-83"
    }
  }, [_vm._v("83.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 506.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_84",
      "id": "fn1-84"
    }
  }, [_vm._v("84.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 512 (quoting Keyishian v. Board of Regents, 385 U.S. 589, 603 (1967)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_85",
      "id": "fn1-85"
    }
  }, [_vm._v("85.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 513 (quoting Burnside v. Byars, 363 F.2d 744, 749 (5th Cir. 1966) (internal quotation altered by Court)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_86",
      "id": "fn1-86"
    }
  }, [_vm._v("86.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 509.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_87",
      "id": "fn1-87"
    }
  }, [_vm._v("87.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 512–13.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_88",
      "id": "fn1-88"
    }
  }, [_vm._v("88.")]), _vm._v(" 319 U.S. 624 (1943).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_89",
      "id": "fn1-89"
    }
  }, [_vm._v("89.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471 (9th Cir. 1986) (antidraft advertisements); Gambino v. Fairfax City Sch. Board, 564 F.2d 157 (4th Cir. 1977) (birth control information); Jacobs v. Board of School Comm’rs, 490 F.2d 601 (7th Cir. 1973), "), _c('em', [_vm._v("dismissed as moot,")]), _vm._v(" 420 U.S. 128 (1975) (underground newspaper; profanity); Shanely v. Northeast Indep. Sch. Dist., 462 F.2d 960 (5th Cir. 1972) (challenge to marijuana laws; birth control information); Wilson v. Chancellor, 418 F. Supp. 1358 (D. Or. 1976) (Communist speaker); Bayer v. Kinzler, 383 F. Supp. 1164 (E.D.N.Y. 1974) (birth control and abortion information), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 515 F.2d 504 (2d Cir. 1975). "), _c('em', [_vm._v("See generally")]), _vm._v(" Michael P. Aaron, Note, "), _c('em', [_vm._v("The Equal Access Act: A Haven for High School “Hate Groups”?")]), _vm._v(" 13 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OFSTRA")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 589, 608–11 (1985); Note, "), _c('em', [_vm._v("Administrative Regulation of the High School Press")]), _vm._v(", 83 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 625 (1984) [hereinafter Note, "), _c('em', [_vm._v("Administrative Regulation")]), _vm._v("].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_90",
      "id": "fn1-90"
    }
  }, [_vm._v("90.")]), _vm._v(" Bethel Sch. Dist. No. 403 v. Fraser, 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_91",
      "id": "fn1-91"
    }
  }, [_vm._v("91.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 681 (dictum).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_92",
      "id": "fn1-92"
    }
  }, [_vm._v("92.")]), _vm._v(" The ACLU has denounced the Equal Access Act as a flagrant violation of the Establishment Clause. "), _c('em', [_vm._v("ACLU Debates “Rights in Conflict,”")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Summer 1985, at 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_93",
      "id": "fn1-93"
    }
  }, [_vm._v("93.")]), _vm._v(" Whitney v. California, 274 U.S. 357, 377 (1927) (Brandeis, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_94",
      "id": "fn1-94"
    }
  }, [_vm._v("94.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 588.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_95",
      "id": "fn1-95"
    }
  }, [_vm._v("95.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Democratic Party v. Wisconsin "), _c('em', [_vm._v("ex rel")]), _vm._v(". La Follette, 450 U.S. 107, 121–22 (1981); Buckley v. Valeo, 424 U.S. 1, 15 (1976); NAACP v. Button, 371 U.S. 415, 430–31 (1963); NAACP v. Alabama, 357 U.S. 449, 460 (1958).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_96",
      "id": "fn1-96"
    }
  }, [_vm._v("96.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 126–39 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_97",
      "id": "fn1-97"
    }
  }, [_vm._v("97.")]), _vm._v(" Others have noted that refusing equal access is or may appear to be hostile to religion. "), _c('em', [_vm._v("E.g")]), _vm._v("., Lubbock Civil Liberties Union v. Lubbock Indep. Sch. Dist., 680 F.2d 424, 426 (5th Cir. 1982) (Reavley, J., dissenting from denial of rehearing en banc); Drakeman & Seawright, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 276; Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 163 n.100; Toms & Whitehead, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 9–10; Thomas E. Grossmann, Note, "), _c('em', [_vm._v("The Constitutionality of Student-Initiated Religious Meetings on Public School Grounds")]), _vm._v(", 50 U. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 740, 785 (1981). Contrary to Professor Lupu’s suggestion, the hostility is not mitigated by blaming it on the Constitution instead of the school. "), _c('em', [_vm._v("See")]), _vm._v(" Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 758.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_98",
      "id": "fn1-98"
    }
  }, [_vm._v("98.")]), _vm._v(" "), _c('em', [_vm._v("E.g.")]), _vm._v(", W. H. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERLY")]), _vm._v(", T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RISIS")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(" 55–56 (SCM Press 1949); James Hitchcock, "), _c('em', [_vm._v("Church, State and Moral Values: The Limits of American Pluralism")]), _vm._v(", 44 L. & C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTEMP")]), _vm._v(". P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROBS")]), _vm._v(". 3 (Spring 1981); Hull, "), _c('em', [_vm._v("supra")]), _vm._v(" note 28, at 431–33; "), _c('em', [_vm._v("cf")]), _vm._v(". David G. Leitch, Note, "), _c('em', [_vm._v("The Myth of Religious Neutrality by Separation in Education")]), _vm._v(", 71 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 127 (1985) (true neutrality requires schools to teach values from pluralistic perspectives, including secular philosophy and traditional religions).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_99",
      "id": "fn1-99"
    }
  }, [_vm._v("99.")]), _vm._v(" Ruti Teitel, "), _c('em', [_vm._v("When Separate Is Equal—Why Organized Religious Exercises Unlike Chess, Do Not Belong in the Public Schools")]), _vm._v(", 81 Nw. U.L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 174 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_100",
      "id": "fn1-100"
    }
  }, [_vm._v("100.")]), _vm._v(" “First, the statute must have a secular legislative purpose; second, its principal or primary effect must be one that neither advances nor inhibits religion; finally, the statute must not foster ‘an excessive government entanglement with religion.’” Lemon v. Kurtzman, 403 U.S. 602, 612–13 (1971) (quoting Walz v. Tax Comm’n, 397 U.S. 664, 674 (1970)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_101",
      "id": "fn1-101"
    }
  }, [_vm._v("101.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("A Survey of Religious Liberty in the United States")]), _vm._v(", 47 O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIO")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". L.J. 409, 449–50 (1986) [in volume 1 at 323–24]. For other criticisms of the test, "), _c('em', [_vm._v("see, e.g")]), _vm._v("., Phillip E. Johnson, "), _c('em', [_vm._v("Concepts and Compromise in First Amendment Religious Doctrine")]), _vm._v(", 72 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 817, 825–31 (1984); Philip B. Kurland, "), _c('em', [_vm._v("The Irrelevance of the Constitution: The Religion Clauses of the First Amendment and the Supreme Court")]), _vm._v(", 24 V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 3, 17–20 (1978). For an academic who likes the test, see Norman Redlich, "), _c('em', [_vm._v("Separation of Church and State: The Burger Court’s Tortuous Journey")]), _vm._v(", 60 N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTRE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AME")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1094, 1104 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_102",
      "id": "fn1-102"
    }
  }, [_vm._v("102.")]), _vm._v(" "), _c('em', [_vm._v("Lemon")]), _vm._v(", 403 U.S. at 612.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_103",
      "id": "fn1-103"
    }
  }, [_vm._v("103.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); Stone v. Graham, 449 U.S. 39 (1980); Epperson v. Arkansas, 393 U.S. 97 (1968).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_104",
      "id": "fn1-104"
    }
  }, [_vm._v("104.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Michael W. McConnell, "), _c('em', [_vm._v("Accommodation of Religion")]), _vm._v(", 1985 Sup. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 34–37, 44; Redlich, "), _c('em', [_vm._v("supra")]), _vm._v(" note 101, at 1115; "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 83–84 (O’Connor, J., concurring) (lifting government-imposed burden is accommodation; other government aid to religion is establishment). Although he recognizes the need for accommodation in some contexts, and presumably supports neutrality toward religion, Dean Redlich appears to oppose equal access. "), _c('em', [_vm._v("See")]), _vm._v(" Redlich, "), _c('em', [_vm._v("supra")]), _vm._v(" note 101, at 1116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_105",
      "id": "fn1-105"
    }
  }, [_vm._v("105.")]), _vm._v(" "), _c('em', [_vm._v("E.g.")]), _vm._v(", Title VII of the Civil Rights Act of 1964, 42 U.S.C. § 2000e-2 (1982); "), _c('em', [_vm._v("see also")]), _vm._v(" McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 32–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_106",
      "id": "fn1-106"
    }
  }, [_vm._v("106.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 556–59. Strossen apparently takes a similar view. "), _c('em', [_vm._v("See")]), _vm._v(" Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 170–71, 181. For a contrary view, see Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 759.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_107",
      "id": "fn1-107"
    }
  }, [_vm._v("107.")]), _vm._v(" A divided court struck down New Jersey’s moment-of-silence statute on similar reasoning. "), _c('em', [_vm._v("See")]), _vm._v(" May v. Cooperman, 780 F.2d 240, 252–53 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 (1987) ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 872 (1987)]. "), _c('em', [_vm._v("May")]), _vm._v(" cited Estate of Thornton v. Caldor, Inc., 472 U.S. 703, 708 (1985), as striking down a statute that accommodated religion. But the statute in "), _c('em', [_vm._v("Thornton")]), _vm._v(" was struck down because of its religious effect, not for lack of a secular purpose. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 709–10. The statute in "), _c('em', [_vm._v("Thornton")]), _vm._v(" required the plaintiff’s employer or fellow workers to bear substantial costs resulting from his religious observance. "), _c('em', [_vm._v("Thornton")]), _vm._v(" is correctly decided, but irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_108",
      "id": "fn1-108"
    }
  }, [_vm._v("108.")]), _vm._v(" Palmer v. Thompson, 403 U.S. 217 (1971); United States v. O’Brien, 391 U.S. 367 (1968); United States v. Darby, 312 U.S. 100 (1941); McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 47–48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_109",
      "id": "fn1-109"
    }
  }, [_vm._v("109.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Personnel Adm’r v. Feeney, 442 U.S. 256 (1979) (statute distinguishing military veterans from nonveterans had discriminatory effect on women); Village of Arlington Heights v. Metropolitan Hous. Dev. Corp., 429 U.S. 252 (1977) (zoning ordinance distinguishing single-family housing from multifamily housing had discriminatory effect on blacks); Washington v. Davis, 426 U.S. 229 (1976) (statute distinguishing test-passers from test-failers had discriminatory effect on blacks); "), _c('em', [_vm._v("cf.")]), _vm._v(" Mt. Healthy City Sch. Dist. Board of Educ. v. Doyle, 429 U.S. 274 (1977) (teacher discharged on stated ground of unprofessionalism alleged that real ground was retaliation for protected speech). Similar inquiries are appropriate in religious discrimination cases when a plaintiff is treated worse than his peers and the issue is whether the bad treatment was because of his religion or because of some permissible reason. But some person or group must be treated worse than another to trigger such an inquiry. The motives for an all-inclusive neutrality are irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_110",
      "id": "fn1-110"
    }
  }, [_vm._v("110.")]), _vm._v(" The problems of proving legislative purpose are illustrated in May v. Cooperman, 780 F.2d 240, 252 n.9 (3d Cir. 1985), "), _c('em', [_vm._v("juris postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 (1987) ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 872 (1987)]; "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 262–65 (Becker, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_111",
      "id": "fn1-111"
    }
  }, [_vm._v("111.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 557 n.130.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_112",
      "id": "fn1-112"
    }
  }, [_vm._v("112.")]), _vm._v(" Teitel says that advocates for evangelicals “claim to be” counsel in every equal access case, but that some conceal their identity from the Court by giving a post office box address. "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_113",
      "id": "fn1-113"
    }
  }, [_vm._v("113.")]), _vm._v(" Harris v. McRae, 448 U.S. 297, 319 (1980); McGowan v. Maryland, 366 U.S. 420, 442 (1961).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_114",
      "id": "fn1-114"
    }
  }, [_vm._v("114.")]), _vm._v(" The Court relied on religious purpose when it struck down a statute forbidding the teaching of evolution in the public schools. Epperson v. Arkansas, 393 U.S. 97 (1968). The Constitution prevents the state from teaching religious theories of human origins, so the statute imposed a form of neutrality through silence. But the Court also viewed the statute as nonneutral in its effects, because the statute forbade only the teaching of evolution. "), _c('em', [_vm._v("Id")]), _vm._v(". at 109.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_115",
      "id": "fn1-115"
    }
  }, [_vm._v("115.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38 (1985); Stone v. Graham, 449 U.S. 39 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_116",
      "id": "fn1-116"
    }
  }, [_vm._v("116.")]), _vm._v(" Lemon v. Kurtzman, 403 U.S. 602, 612 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_117",
      "id": "fn1-117"
    }
  }, [_vm._v("117.")]), _vm._v(" 374 U.S. 203, 222 (1963). The phrase is repeated in Board of Educ. v. Allen, 392 U.S. 236, 243 (1968), with a citation to "), _c('em', [_vm._v("Schempp")]), _vm._v(". It is incorporated into the three-part test in "), _c('em', [_vm._v("Lemon")]), _vm._v(", 403 U.S. at 612, with a citation to "), _c('em', [_vm._v("Allen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_118",
      "id": "fn1-118"
    }
  }, [_vm._v("118.")]), _vm._v(" "), _c('em', [_vm._v("Schempp")]), _vm._v(", 374 U.S. at 222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_119",
      "id": "fn1-119"
    }
  }, [_vm._v("119.")]), _vm._v(" This is an excellent example of how the substitution of judicial formulas for constitutional text can change the meaning of constitutional rights. "), _c('em', [_vm._v("See generally")]), _vm._v(" Robert F. Nagel, "), _c('em', [_vm._v("The Formulaic Constitution")]), _vm._v(", 84 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 165 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_120",
      "id": "fn1-120"
    }
  }, [_vm._v("120.")]), _vm._v(" Comm. for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 783–84 n.39 (1973).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_121",
      "id": "fn1-121"
    }
  }, [_vm._v("121.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Witters v. Wash. Dep’t of Servs. for the Blind, 474 U.S. 481, 485 (1986); Grand Rapids Sch. Dist. v. Ball, 473 U.S. 373, 382–83 (1985); Wallace v. Jaffree, 472 U.S. 38, 55 (1985); Lynch v. Donnelly, 465 U.S. 668, 679 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_122",
      "id": "fn1-122"
    }
  }, [_vm._v("122.")]), _vm._v(" Johnson v. Huntington Beach Union High Sch. Dist., 137 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AL")]), _vm._v(". Rptr. 43, 49 (Ct. App.) (1977); Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 562–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_123",
      "id": "fn1-123"
    }
  }, [_vm._v("123.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 582.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_124",
      "id": "fn1-124"
    }
  }, [_vm._v("124.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" note 60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_125",
      "id": "fn1-125"
    }
  }, [_vm._v("125.")]), _vm._v(" Incidental expenses of equal access are analyzed at greater length in Grossmann, "), _c('em', [_vm._v("supra")]), _vm._v(" note 97, at 761–67.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_126",
      "id": "fn1-126"
    }
  }, [_vm._v("126.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Lemon v. Kurtzman, 403 U.S. 602, 613, 619–24 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_127",
      "id": "fn1-127"
    }
  }, [_vm._v("127.")]), _vm._v(" Larkin v. Grendel’s Den, Inc., 459 U.S. 116, 122 (1982); Comm. for Pub. Educ. & Religious Liberty v. Nyquist, 413 U.S. 756, 761 (1973); Everson v. Board of Educ., 330 U.S. 1, 16 (1947); Reynolds v. United States, 98 U.S. 145, 164 (1878).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_128",
      "id": "fn1-128"
    }
  }, [_vm._v("128.")]), _vm._v(" 741 F.2d 538 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also supra")]), _vm._v(" notes 14–18 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_129",
      "id": "fn1-129"
    }
  }, [_vm._v("129.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 556–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_130",
      "id": "fn1-130"
    }
  }, [_vm._v("130.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 556. The superficially similar reasoning in Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646, 649 (11th Cir. 1984), did not relate to announcements of student organizations. The school district in "), _c('em', [_vm._v("Nartowicz")]), _vm._v(" announced off-campus “secular” activities of churches.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_131",
      "id": "fn1-131"
    }
  }, [_vm._v("131.")]), _vm._v(" Healy v. James, 408 U.S. 169, 181–83 (1972); "), _c('em', [_vm._v("cf")]), _vm._v(". Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45–46 (1983). "), _c('em', [_vm._v("Perry")]), _vm._v(" held that teacher mailboxes were not a public forum. But unlike the bulletin boards and intercoms in "), _c('em', [_vm._v("Healy")]), _vm._v(" and "), _c('em', [_vm._v("Bender")]), _vm._v(", the mailboxes in "), _c('em', [_vm._v("Perry")]), _vm._v(" had not been made generally available to a wide range of organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_132",
      "id": "fn1-132"
    }
  }, [_vm._v("132.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Towards a General Theory of the Religion Clauses: The Case of Church Labor Relations and the Right to Church Autonomy")]), _vm._v(", 81 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLUM")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1373, 1378–83, 1392–94 (1981) [in volume 2 at 241–47, 258–60]; "), _c('em', [_vm._v("accord")]), _vm._v(" Arlin M. Adams & William R. Hanlon, "), _c('em', [_vm._v("Jones v. Wolf: Church Autonomy and the Religion Clauses of the First Amendment")]), _vm._v(", 128 U. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1291, 1336–37 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_133",
      "id": "fn1-133"
    }
  }, [_vm._v("133.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–15 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_134",
      "id": "fn1-134"
    }
  }, [_vm._v("134.")]), _vm._v(" McDaniel v. Paty, 435 U.S. 618 (1978).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_135",
      "id": "fn1-135"
    }
  }, [_vm._v("135.")]), _vm._v(" The most sophisticated version of this argument appears in Laurence H. Tribe, "), _c('em', [_vm._v("The Supreme Court, 1972 Term—Foreword: Toward a Model of Roles in the Due Process of Life and Law")]), _vm._v(", 87 H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARV")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 21–25 (1973). Professor Tribe later recanted. See T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIBE")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 28, § 15–10, at 928.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_136",
      "id": "fn1-136"
    }
  }, [_vm._v("136.")]), _vm._v(" Harris v. McRae, 448 U.S. 297, 319 (1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_137",
      "id": "fn1-137"
    }
  }, [_vm._v("137.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 543 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986); "), _c('em', [_vm._v("see also")]), _vm._v(" Brandon v. Board of Educ., 635 F.2d 971, 979 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_138",
      "id": "fn1-138"
    }
  }, [_vm._v("138.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1383 [in volume 2 at 246–47].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_139",
      "id": "fn1-139"
    }
  }, [_vm._v("139.")]), _vm._v(" "), _c('em', [_vm._v("See id")]), _vm._v(". at 1392–94 [in volume 2 at 258–60].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_140",
      "id": "fn1-140"
    }
  }, [_vm._v("140.")]), _vm._v(" "), _c('em', [_vm._v("See Bender")]), _vm._v(", 741 F.2d at 554–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_141",
      "id": "fn1-141"
    }
  }, [_vm._v("141.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_142",
      "id": "fn1-142"
    }
  }, [_vm._v("142.")]), _vm._v(" Monitors apparently are not required by state law in many states. Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 175–76 n.138; Grossmann, "), _c('em', [_vm._v("supra")]), _vm._v(" note 97, at 783–84 (collecting cases).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_143",
      "id": "fn1-143"
    }
  }, [_vm._v("143.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 552, "), _c('em', [_vm._v("quoted with approval in")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 569. Similar concerns were expressed in Brandon v. Board of Educ., 635 F.2d 971, 979 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_144",
      "id": "fn1-144"
    }
  }, [_vm._v("144.")]), _vm._v(" The affidavits stated that the monitor graded papers and took no part in the meetings. "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 544.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_145",
      "id": "fn1-145"
    }
  }, [_vm._v("145.")]), _vm._v(" The trial court granted summary judgment for Petros. The court of appeals agreed that the case was appropriate for summary judgment, "), _c('em', [_vm._v("id")]), _vm._v(". at 542, but reversed, "), _c('em', [_vm._v("id.")]), _vm._v(" at 561. The effect of this reversal was to order summary judgment for the school.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_146",
      "id": "fn1-146"
    }
  }, [_vm._v("146.")]), _vm._v(" Unpublished comment on an early draft of this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_147",
      "id": "fn1-147"
    }
  }, [_vm._v("147.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 571 n.221; "), _c('em', [_vm._v("see, e.g")]), _vm._v("., Tinker v. Des Moines Indep. Community Sch. Dist., 393 U.S. 503, 506 (1969); Pickering v. Board of Educ., 391 U.S. 563 (1968); Shelton v. Tucker, 364 U.S. 479, 487 (1960).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_148",
      "id": "fn1-148"
    }
  }, [_vm._v("148.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 571 n.221.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_149",
      "id": "fn1-149"
    }
  }, [_vm._v("149.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" May v. Evansville-Vanderburgh Sch. Corp., 787 F.2d 1105 (7th Cir. 1986). "), _c('em', [_vm._v("May")]), _vm._v(" held that the school, which allowed no group meetings of teachers, did not have to allow a teacher prayer group to meet. But the teachers were entitled to be in the building and not yet required to be at work. "), _c('em', [_vm._v("Id")]), _vm._v(". at 1107–08. Under those circumstances, a rule forbidding them to meet is facially unconstitutional. "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 227–28 and accompanying text. The court agreed that the teachers’ speech was protected under the circumstances, but it unpersuasively argued that meetings for the purpose of speech were not protected. "), _c('em', [_vm._v("May")]), _vm._v(", 787 F.2d at 1110–12. The court’s arguments all assumed that the teachers were claiming a preferential right to use the school buildings for meetings. "), _c('em', [_vm._v("See id.")]), _vm._v(" In fact, the school was claiming a right to censor private speech in a place that the teachers had a right to be.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_150",
      "id": "fn1-150"
    }
  }, [_vm._v("150.")]), _vm._v(" "), _c('em', [_vm._v("But cf.")]), _vm._v(" James v. Board of Educ., 461 F.2d 566, 574 (2d Cir. 1972) (teacher wore black armband in class; court assumed that students understood it as expression of teacher’s personal views).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_151",
      "id": "fn1-151"
    }
  }, [_vm._v("151.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 552 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_152",
      "id": "fn1-152"
    }
  }, [_vm._v("152.")]), _vm._v(" "), _c('em', [_vm._v("Bender")]), _vm._v(", 741 F.2d at 552.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_153",
      "id": "fn1-153"
    }
  }, [_vm._v("153.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_154",
      "id": "fn1-154"
    }
  }, [_vm._v("154.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at 561; Brandon v. Board of Educ., 635 F.2d 971, 978 (2d Cir. 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_155",
      "id": "fn1-155"
    }
  }, [_vm._v("155.")]), _vm._v(" "), _c('em', [_vm._v("See Brandon")]), _vm._v(", 635 F.2d at 978.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_156",
      "id": "fn1-156"
    }
  }, [_vm._v("156.")]), _vm._v(" Zorach v. Clauson, 343 U.S. 306, 324 (1952) (Jackson, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_157",
      "id": "fn1-157"
    }
  }, [_vm._v("157.")]), _vm._v(" 333 U.S. 203 (1948).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_158",
      "id": "fn1-158"
    }
  }, [_vm._v("158.")]), _vm._v(" 343 U.S. 306 (1952).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_159",
      "id": "fn1-159"
    }
  }, [_vm._v("159.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Lanner v. Wimmer, 662 F.2d 1349, 1354 (10th Cir. 1981) (upholding released time in church building adjacent to school building and wired to hear school’s intercom and bell system).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_160",
      "id": "fn1-160"
    }
  }, [_vm._v("160.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Kurland, "), _c('em', [_vm._v("supra")]), _vm._v(" note 10, at 77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_161",
      "id": "fn1-161"
    }
  }, [_vm._v("161.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Engel v. Vitale, 370 U.S. 421, 430–31 (1962).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_162",
      "id": "fn1-162"
    }
  }, [_vm._v("162.")]), _vm._v(" Bender v. Williamsport Area Sch. Dist., 741 F.2d 538, 553 (3d Cir. 1984), "), _c('em', [_vm._v("vacated on other grounds")]), _vm._v(", 475 U.S. 534 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_163",
      "id": "fn1-163"
    }
  }, [_vm._v("163.")]), _vm._v(" By contrast, there was coercion in Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391 (10th Cir. 1985). The school district had a stated policy of equal access, but only the religious group met between the arrival of school buses and the beginning of class. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 1405. Nonparticipants were required to wait outside, or in the gymnasium during bad weather. "), _c('em', [_vm._v("Id")]), _vm._v(". at 1397 n.4. The court could have invalidated that scheme as coercive.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("The contrast between "), _c('em', [_vm._v("Bender")]), _vm._v(" and "), _c('em', [_vm._v("Bell")]), _vm._v(" illustrates the irrelevance of one distinction offered by some opponents of the Equal Access Act. They argue that the Act applies only to schools where student groups meet before the first class in the morning or after the last class in the afternoon, but not to schools where student groups meet during an activity period between classes. John D. Thompson, Note, "), _c('em', [_vm._v("Student Religious Groups and the Right of Access to Public School Activity Periods")]), _vm._v(", 74 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 205, 208 n.19, 217–18 (1985). But Williamsport had a noncoercive open forum during the school day, and Little Axe coerced students to participate before the first class. The statutory language does not compel this distinction, because a student activity period is “noninstructional time,” 20 U.S.C. § 4071(b) (Supp. 1985), “set aside by the school” before the next period when “actual classroom instruction begins” and after the previous period when “actual classroom instruction ends,” "), _c('em', [_vm._v("id.")]), _vm._v(" § 4072(4). Roughly equal numbers of statements on the floor of Congress go each way on the issue of activity periods during the day. Note, "), _c('em', [_vm._v("supra")]), _vm._v(", at 217 n.83. Teitel concedes that the issue is “unclear.” Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 563–64 n.175.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_164",
      "id": "fn1-164"
    }
  }, [_vm._v("164.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 562–63, 568. For a more modest conclusion drawn from the same premise, see Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 175.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_165",
      "id": "fn1-165"
    }
  }, [_vm._v("165.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 568. She supports this characterization with a reference to Abington School Dist. v. Schempp, 374 U.S. 203, 223 (1963). But there really were captive audiences in "), _c('em', [_vm._v("Schempp")]), _vm._v(" and its companion case. In "), _c('em', [_vm._v("Schempp")]), _vm._v(", Bible verses and the Lord’s Prayer were read over the school’s public address system. Students were asked to stand and repeat the prayer in unison. "), _c('em', [_vm._v("Id")]), _vm._v(". at 207. In "), _c('em', [_vm._v("Schempp")]), _vm._v("’s companion case, the state required schools to open each day with a Bible reading, the Lord’s Prayer, or both. Students could be excused only with a written excuse from a parent. "), _c('em', [_vm._v("Id")]), _vm._v(". at 211–12. For an equally preposterous analogy to "), _c('em', [_vm._v("Schempp")]), _vm._v(", see Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 570.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_166",
      "id": "fn1-166"
    }
  }, [_vm._v("166.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_167",
      "id": "fn1-167"
    }
  }, [_vm._v("167.")]), _vm._v(" Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 800–06 (1985); Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45–49 (1983); Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546, 552 (1975).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_168",
      "id": "fn1-168"
    }
  }, [_vm._v("168.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8341 (daily ed. June 27, 1984) (statement of Sen. Leahy).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_169",
      "id": "fn1-169"
    }
  }, [_vm._v("169.")]), _vm._v(" Lucy B. Mullins, Note, "), _c('em', [_vm._v("Education for Economic Security Acts: The Secular Humanism Ban and Equal Access Act")]), _vm._v(", 43 W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". & L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EE")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 265, 291–93 (1986). Professor Lupu is more optimistic, but his review of the Act is superficial. "), _c('em', [_vm._v("See")]), _vm._v(" Lupu, "), _c('em', [_vm._v("supra")]), _vm._v(" note 12, at 758–61.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_170",
      "id": "fn1-170"
    }
  }, [_vm._v("170.")]), _vm._v(" 20 U.S.C. § 4071(a).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_171",
      "id": "fn1-171"
    }
  }, [_vm._v("171.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". § 4071(3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_172",
      "id": "fn1-172"
    }
  }, [_vm._v("172.")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_173",
      "id": "fn1-173"
    }
  }, [_vm._v("173.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8342 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_174",
      "id": "fn1-174"
    }
  }, [_vm._v("174.")]), _vm._v(" Mergens v. Board of Educ., 5 Religious Freedom Rep. (Christian Legal Soc’y) 86, 87 (D. Neb. 1985) ["), _c('em', [_vm._v("rev’d")]), _vm._v(", 867 F.2d 1076 (8th Cir. 1989), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 496 U.S. 226 (1990)]. Williamsport made a similar claim in "), _c('em', [_vm._v("Bender")]), _vm._v(", and a student commentator has endorsed it. "), _c('em', [_vm._v("See")]), _vm._v(" Thompson, "), _c('em', [_vm._v("supra")]), _vm._v(" note 163, at 208 n.19, 215–17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_175",
      "id": "fn1-175"
    }
  }, [_vm._v("175.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8345 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_176",
      "id": "fn1-176"
    }
  }, [_vm._v("176.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at S8344.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_177",
      "id": "fn1-177"
    }
  }, [_vm._v("177.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8345 (statement of Sen. Gorton).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_178",
      "id": "fn1-178"
    }
  }, [_vm._v("178.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at H7723 (daily ed. July 25, 1984) (motion of Rep. Perkins); "), _c('em', [_vm._v("id")]), _vm._v(". at H7733 (statement of Rep. Oakar); "), _c('em', [_vm._v("id")]), _vm._v(". at H7736 (statement of Rep. Fish).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_179",
      "id": "fn1-179"
    }
  }, [_vm._v("179.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at S8342 (daily ed. June 27, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_180",
      "id": "fn1-180"
    }
  }, [_vm._v("180.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_181",
      "id": "fn1-181"
    }
  }, [_vm._v("181.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_182",
      "id": "fn1-182"
    }
  }, [_vm._v("182.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_183",
      "id": "fn1-183"
    }
  }, [_vm._v("183.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_184",
      "id": "fn1-184"
    }
  }, [_vm._v("184.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_185",
      "id": "fn1-185"
    }
  }, [_vm._v("185.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_186",
      "id": "fn1-186"
    }
  }, [_vm._v("186.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_187",
      "id": "fn1-187"
    }
  }, [_vm._v("187.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_188",
      "id": "fn1-188"
    }
  }, [_vm._v("188.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_189",
      "id": "fn1-189"
    }
  }, [_vm._v("189.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8341 (statement of Sen. Leahy).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_190",
      "id": "fn1-190"
    }
  }, [_vm._v("190.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at H7736 (daily ed. July 25, 1984) (statement of Rep. Fish).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_191",
      "id": "fn1-191"
    }
  }, [_vm._v("191.")]), _vm._v(" S. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EP")]), _vm._v(". No. 98–357 at 10, 11 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_192",
      "id": "fn1-192"
    }
  }, [_vm._v("192.")]), _vm._v(" The vote in the House was 337–77. 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H7740–41 (daily ed. July 25, 1984) (Roll Call No. 313). The vote in the Senate was 88–11. "), _c('em', [_vm._v("Id.")]), _vm._v(" at S8370 (daily ed. June 27, 1984) (vote on Amendment No. 315).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_193",
      "id": "fn1-193"
    }
  }, [_vm._v("193.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8342–43 (daily ed. June 27, 1984) (statement of Sen. Hatfield); "), _c('em', [_vm._v("id")]), _vm._v(". (statement of Sen. Gorton); "), _c('em', [_vm._v("id")]), _vm._v(". at S8355 (statement of Sen. Levin); "), _c('em', [_vm._v("id")]), _vm._v(". at S8356 (statement of Sen. Denton); "), _c('em', [_vm._v("id")]), _vm._v(". at S8357 (statement of Sen. Durenberger); "), _c('em', [_vm._v("id")]), _vm._v(". at S8362 (statement of Sen. Mitchell); "), _c('em', [_vm._v("id")]), _vm._v(". at H7735 (daily ed. July 25, 1984) (statement of Rep. Rogers).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_194",
      "id": "fn1-194"
    }
  }, [_vm._v("194.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Susan Garrison, Comment, "), _c('em', [_vm._v("The Public School as Public Forum")]), _vm._v(", 54 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 90, 116 (1975) (courts should hold that school-sponsored, after-school speakers create open public fora, lest school control supply of outside speakers).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_195",
      "id": "fn1-195"
    }
  }, [_vm._v("195.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8366 (daily ed. June 27, 1984) (statement of Sen. Grassley); "), _c('em', [_vm._v("id")]), _vm._v(". at S8365 (statement of Sen. Baucus); "), _c('em', [_vm._v("id")]), _vm._v(". at H7730 (daily ed. July 25, 1984) (statement of Rep. Clinger).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_196",
      "id": "fn1-196"
    }
  }, [_vm._v("196.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8367 (daily ed. June 27, 1984) (statement of Sen. Gorton).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_197",
      "id": "fn1-197"
    }
  }, [_vm._v("197.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at S8362 (statement of Sen. Dole).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_198",
      "id": "fn1-198"
    }
  }, [_vm._v("198.")]), _vm._v(" "), _c('em', [_vm._v("See id.")]), _vm._v(" at H7739 (daily ed. July 25, 1984) (statement of Rep. Synar); "), _c('em', [_vm._v("id.")]), _vm._v(" at H7736 (statement of Rep. Bonker). Other statements emphasized that schools could choose whether to have an open forum, but did not explicitly state that schools could close existing open fora. "), _c('em', [_vm._v("See id.")]), _vm._v(" at H7740 (statement of Rep. Frenzel); "), _c('em', [_vm._v("id.")]), _vm._v(" at H7732 (statement of Rep. Goodling); "), _c('em', [_vm._v("id")]), _vm._v(". at S8364 (daily ed. June 27, 1984) (statement of Sen. Thurmond); "), _c('em', [_vm._v("id")]), _vm._v(". at S8357 (statement of Sen. Durenberger). The Third Circuit has held that a plaintiff must show that a limited open forum existed after the effective date of the Act. Student Coalition for Peace v. Lower Merion Sch. Dist. Board of Sch. Directors, 776 F.2d 431, 443 (3d Cir. 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_199",
      "id": "fn1-199"
    }
  }, [_vm._v("199.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H7736 (daily ed. July 25, 1984) (statement of Rep. Pepper).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_200",
      "id": "fn1-200"
    }
  }, [_vm._v("200.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Seyfried v. Walton, 668 F.2d 214 (3d Cir. 1981). "), _c('em', [_vm._v("But see")]), _vm._v(" Bowman v. Bethel-Tate Board of Educ., 610 F. Supp. 517 (S.D. Ohio 1985) (school play is extracurricular and not censorable if participation is voluntary).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_201",
      "id": "fn1-201"
    }
  }, [_vm._v("201.")]), _vm._v(" Note, "), _c('em', [_vm._v("Administrative Regulation, supra")]), _vm._v(" note 89, at 632–33. For other distinctions in the student newspaper cases, and incisive criticism of their First Amendment analysis, see Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1306–07, 1350–51. For recent cases see Kuhlmeier v. Hazelwood School Dist., 795 F.2d 1368 (8th Cir. 1986) (holding that school officials were not justified in censoring articles written for in-class student newspaper), "), _c('em', [_vm._v("cert. granted")]), _vm._v(", 479 U.S. 1053 (1987) ["), _c('em', [_vm._v("rev’d")]), _vm._v(", 484 U.S. 260 (1988)]; San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471 (9th Cir. 1986) (invalidating censorship of student newspaper without regard to in-class/out-of-class distinction).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_202",
      "id": "fn1-202"
    }
  }, [_vm._v("202.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Fraser v. Bethel Sch. Dist. No. 403, 755 F.2d 1356, 1364 (9th Cir. 1985) (student government is not part of curriculum), "), _c('em', [_vm._v("rev’d on other grounds")]), _vm._v(", 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_203",
      "id": "fn1-203"
    }
  }, [_vm._v("203.")]), _vm._v(" Section 4071(c) provides:")]), _vm._v(" "), _c('p', {
    staticClass: "foot-left"
  }, [_vm._v("(c)"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Schools shall be deemed to offer a fair opportunity to students who wish to conduct a meeting within its [sic] limited open forum if such school uniformly provides that")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("1."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The meeting is voluntary and student-initiated;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("2."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("there is no sponsorship of the meeting by the school, the government, or its agents or employees;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("3."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("employees or agents of the school or government are present at religious meetings only in a nonparticipatory capacity;")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("4."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("the meeting does not materially and substantially interfere with the orderly conduct of educational activities within the school; and")])]), _vm._v(" "), _c('p', {
    staticClass: "List36"
  }, [_vm._v("5."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("nonschool persons may not direct, conduct, control, or regularly attend activities of student groups.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_204",
      "id": "fn1-204"
    }
  }, [_vm._v("204.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Jay Lawrence Westbrook, "), _c('em', [_vm._v("Glitch: Section 9–402(7) and the U.C.C. Revision Process")]), _vm._v(", 52 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 408, 408 n.1 (1984) (quoting etymology of “glitch” and applying concept to process of statutory drafting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_205",
      "id": "fn1-205"
    }
  }, [_vm._v("205.")]), _vm._v(" There may be a state interest: the school might want to refrain from sponsoring controversial political groups. And there may be some First Amendment right to evenhandedness in sponsorship: a public school should not be allowed to sponsor the Young Republicans and refuse to sponsor the Young Democrats. Neither of these interests supports a federal ban on sponsoring any non-curriculum-related group.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_206",
      "id": "fn1-206"
    }
  }, [_vm._v("206.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" United States v. Finn, 502 F.2d 938, 941–43 (7th Cir. 1974) (construing 47 U.S.C. § 605 (now 47 U.S.C. § 605(a) (1982))). On its face, the Act forbids communications carriers to disclose messages in every circumstance in which Congress meant to authorize disclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_207",
      "id": "fn1-207"
    }
  }, [_vm._v("207.")]), _vm._v(" The Act bars discrimination against “otherwise qualified handicapped individuals.” 29 U.S.C. § 794 (1982). Realizing that a blind bus driver could be otherwise qualified, the implementing agency excised “otherwise” and protected only “qualified handicapped individuals.” 45 C.F.R. § 84.3(k) (1984); "), _c('em', [_vm._v("id")]), _vm._v(". at pt. 84, app. A, § 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_208",
      "id": "fn1-208"
    }
  }, [_vm._v("208.")]), _vm._v(" For my strong commitment to operative legal texts, see Douglas Laycock, "), _c('em', [_vm._v("Taking Constitutions Seriously: A Theory of Judicial Review")]), _vm._v(", 59 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 343 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_209",
      "id": "fn1-209"
    }
  }, [_vm._v("209.")]), _vm._v(" Here are excerpts from the relevant colloquy:")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(".… But those strictures will apply to all noncurriculum-related student activities which may use the open forum?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD.")]), _vm._v(" That is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". This also means that there can be no sponsorship or teacher leadership or significant participation in the operation of the student Young Republican Club or Young Democratic Club, or Young Americans for Freedom, does it not?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". This tightens up the whole area of activity in anything involving student-initiated noncurriculum-related activities, whether they be religious or otherwise. It could be political. All these things can have someone in a custodial role.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON.")]), _vm._v(" The teacher or administration employee participation in the political club can be no greater than its very limited participation in the religious club, can it?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD.")]), _vm._v(" That is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". And going back to my earlier example of the chess club, it can be no greater than its participation in the chess club.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". I believe that is right.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. GORTON")]), _vm._v(". So the question is whether it is curriculum related. If it is not curriculum related, the Senator’s amendment is providing controls over the faculty and administration personnel considerably greater than are many school districts in the United States today, is it not?")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('strong', [_vm._v("Mr. HATFIELD")]), _vm._v(". That is true. What we are trying to get at here, I say to the Senator from Washington, is the question of separation of church and state. It is not involved in a chess club, not involved in a political club, but it is involved in the basic framework of our Constitution. I suppose it is like a net: When you throw the net out, you are going to garner in a few other things, but I do not think to the detriment or [sic] the efficiency of what you are seeking. It will not create a difficult problem.")]), _vm._v(" "), _c('p', {
    staticClass: "f-HPara"
  }, [_vm._v("130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8342–43 (daily ed. June 27, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_210",
      "id": "fn1-210"
    }
  }, [_vm._v("210.")]), _vm._v(" At least some members of Congress assumed that schools with open fora could abolish them, even if their motive in doing so was to avoid equal access. "), _c('em', [_vm._v("See supra")]), _vm._v(" note 198.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_211",
      "id": "fn1-211"
    }
  }, [_vm._v("211.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 565. Later, she concedes that the ban on faculty sponsors for nonreligious groups was “apparently unintended.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 576.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_212",
      "id": "fn1-212"
    }
  }, [_vm._v("212.")]), _vm._v(" This agreement appears in a set of “Equal Access Guidelines” negotiated after passage. Two of the House sponsors inserted these guidelines into the "), _c('em', [_vm._v("Congressional Record")]), _vm._v(", 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". H12, 272 (daily ed. Oct. 11, 1984), but no congressmen participated in their drafting, "), _c('em', [_vm._v("id")]), _vm._v(". at H12, 272–73. They are in no sense legislative history.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_213",
      "id": "fn1-213"
    }
  }, [_vm._v("213.")]), _vm._v(" "), _c('em', [_vm._v("See infra")]), _vm._v(" notes 243–46 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_214",
      "id": "fn1-214"
    }
  }, [_vm._v("214.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_215",
      "id": "fn1-215"
    }
  }, [_vm._v("215.")]), _vm._v(" 473 U.S. 788 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_216",
      "id": "fn1-216"
    }
  }, [_vm._v("216.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 802 (quoting Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 45 (1983)).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_217",
      "id": "fn1-217"
    }
  }, [_vm._v("217.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 800.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_218",
      "id": "fn1-218"
    }
  }, [_vm._v("218.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 802.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_219",
      "id": "fn1-219"
    }
  }, [_vm._v("219.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 800.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_220",
      "id": "fn1-220"
    }
  }, [_vm._v("220.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". (quoting "), _c('em', [_vm._v("Perry")]), _vm._v(", 460 U.S. at 45).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_221",
      "id": "fn1-221"
    }
  }, [_vm._v("221.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 805–06.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_222",
      "id": "fn1-222"
    }
  }, [_vm._v("222.")]), _vm._v(" "), _c('em', [_vm._v("But cf")]), _vm._v(". Larson v. Valente, 456 U.S. 228, 245–46 (1982) (requiring states to treat least favored groups equally with most favored groups provides powerful protection to unfavored groups) (quoting Railway Express Agency v. New York, 336 U.S. 106, 112 (1949) (Jackson, J., concurring)); J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OHN")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LY")]), _vm._v(", D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMOCRACY")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTRUST")]), _vm._v(" 81–87 (Harvard 1980) (same).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_223",
      "id": "fn1-223"
    }
  }, [_vm._v("223.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Perry Educ. Ass’n v. Perry Local Educators’ Ass’n, 460 U.S. 37, 46–49 (1983). The defendant granted one teachers’ union access to the campus mail system and denied access to all others. The Court found no hostility to the views of the competing unions; instead, it found that the restriction served the legitimate goal of “insuring labor peace.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 52. “Insuring labor peace” seems to be a euphemism for suppressing all competition to the exclusive bargaining representative. For further analysis, see Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1253–57.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-Body"
  }, [_vm._v("Fortunately, cases restricting labor speech do not seem to be used as precedent for other kinds of speakers. "), _c('em', [_vm._v("Compare")]), _vm._v(" NAACP v. Claiborne Hardware Co., 458 U.S. 886, 912–15 (1982) (political boycott by black consumers is protected speech) "), _c('em', [_vm._v("with")]), _vm._v(" International Longshoremen’s Ass’n v. Allied Int’l, Inc., 456 U.S. 212, 226 (1982) (political boycott by labor union is not protected speech). For an attempt to reconcile the two cases on the basis of the boycotters’ relative economic power, see Michael C. Harper, "), _c('em', [_vm._v("The Consumer’s Emerging Right to Boycott")]), _vm._v(": "), _c('em', [_vm._v("NAACP v. Claiborne Hardware and Its Implications for American Labor Law")]), _vm._v(", 93 Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(" L.J. 409, 426–29 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_224",
      "id": "fn1-224"
    }
  }, [_vm._v("224.")]), _vm._v(" Southeastern Promotions, Ltd. v. Conrad, 420 U.S. 546, 555–56 (1975); Grayned v. City of Rockford, 408 U.S. 104, 116–17 (1972) (“The crucial question is whether the manner of expression is basically incompatible with the normal activity of a particular place at a particular time.”); "), _c('em', [_vm._v("see")]), _vm._v(" Keith Werhan, "), _c('em', [_vm._v("The Supreme Court’s Public Forum Doctrine and the Return of Formalism")]), _vm._v(", 7 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARDOZO")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 335, 423–26 (1986). Compare Adderly v. Florida, 385 U.S. 39 (1966) (protest on jail grounds not protected) with Brown v. Louisiana, 383 U.S. 131 (1966) (silent protest in public library protected). Language in "), _c('em', [_vm._v("Cornelius")]), _vm._v(" suggests that it is still important to decide whether speech is compatible with the locale: “We will not find that a public forum has been created in the face of clear evidence of a contrary intent, … nor will we infer that the Government intended to create a public forum when the nature of the property is inconsistent with expressive activity.” Cornelius v. NAACP Legal Defense & Educ. Fund, 473 U.S. 788, 803 (1985). Perhaps intention can be objectified into a largely fictional “reasonable intent,” in which the government is presumed to intend to permit speech except when it has strong reasons not to. "), _c('em', [_vm._v("See")]), _vm._v(" Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1305–06 (suggesting that courts have merged the two tests in this way in student newspaper cases).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_225",
      "id": "fn1-225"
    }
  }, [_vm._v("225.")]), _vm._v(" 393 U.S. 503 (1969).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_226",
      "id": "fn1-226"
    }
  }, [_vm._v("226.")]), _vm._v(" "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 823 n.3 (Blackmun, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_227",
      "id": "fn1-227"
    }
  }, [_vm._v("227.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Jamison v. Texas, 318 U.S. 413, 416 (1943); Texas State Teachers Ass’n v. Garland Indep. Sch. Dist., 777 F.2d 1046, 1053–55 (5th Cir. 1985), "), _c('em', [_vm._v("aff’d mem")]), _vm._v("., 479 U.S. 801 (1986); Garrison, "), _c('em', [_vm._v("supra")]), _vm._v(" note 194, at 105–07, 111; "), _c('em', [_vm._v("see also")]), _vm._v(" Cass, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1343–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_228",
      "id": "fn1-228"
    }
  }, [_vm._v("228.")]), _vm._v(" The Court did note that the school’s toleration of other political symbols aggravated the constitutional violation. "), _c('em', [_vm._v("Tinker")]), _vm._v(", 393 U.S. at 510–11. But there was no holding that the school had created a limited public forum.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_229",
      "id": "fn1-229"
    }
  }, [_vm._v("229.")]), _vm._v(" A student commentator’s characterization of "), _c('em', [_vm._v("Tinker")]), _vm._v(" as a public forum case overlooks both the students’ right to be where they were and the noncontingent nature of their rights. "), _c('em', [_vm._v("See")]), _vm._v(" James C. Dever III, Note, "), _c('em', [_vm._v("Tinker Revisited: Fraser v. Bethel School District and Regulation of Speech in the Public Schools")]), _vm._v(", 1985 D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UKE")]), _vm._v(" L.J. 1164, 1174–77. The student’s characterization of "), _c('em', [_vm._v("Tinker")]), _vm._v(" is irrelevant to his thesis that student speech is subject to reasonable time, place, and manner restrictions.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_230",
      "id": "fn1-230"
    }
  }, [_vm._v("230.")]), _vm._v(" "), _c('em', [_vm._v("Cf.")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UDOF")]), _vm._v(", "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 225–27. Yudof argues that so long as normal educational functions are not disrupted, schools should be public fora even for persons other than students and faculty. I do not disagree, but I do not have to defend that proposal to defend the position taken in this Article.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_231",
      "id": "fn1-231"
    }
  }, [_vm._v("231.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Werhan, "), _c('em', [_vm._v("supra")]), _vm._v(" note 224, at 406.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_232",
      "id": "fn1-232"
    }
  }, [_vm._v("232.")]), _vm._v(" Farber and Nowak note that in "), _c('em', [_vm._v("Widmar")]), _vm._v(", the Court finessed this problem of the relationship between the speakers entitled to access to the forum and the state’s right to close the forum. Farber & Nowak, "), _c('em', [_vm._v("supra")]), _vm._v(" note 51, at 1249. They seem to treat the problem as inherent in public forum doctrine, rather than as a glitch in the Court’s formulation of public forum doctrine. One court of appeals sensibly has found that student newspapers are a limited public forum for students; the court did not recognize the difficulties caused by the Supreme Court’s formulation. "), _c('em', [_vm._v("See")]), _vm._v(" San Diego Comm. Against Registration & the Draft v. Governing Board, 790 F.2d 1471, 1476 (9th Cir. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_233",
      "id": "fn1-233"
    }
  }, [_vm._v("233.")]), _vm._v(" Board of Educ. v. Pico, 457 U.S. 853, 864–71 (1982) (plurality opinion); "), _c('em', [_vm._v("id")]), _vm._v(". at 876–77 (Blackmun, J., concurring); Healy v. James, 408 U.S. 169, 180–81 (1972); Tinker v. Des Moines Indep. Community Sch. Dist., 393 U.S. 503, 511–13 (1969); Epperson v. Arkansas, 393 U.S. 97, 104–05 (1968); Keyishian v. Board of Regents, 385 U.S. 589, 603 (1967); Shelton v. Tucker, 364 U.S. 479, 487 (1960).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_234",
      "id": "fn1-234"
    }
  }, [_vm._v("234.")]), _vm._v(" The Court said that the university officials in "), _c('em', [_vm._v("Widmar")]), _vm._v(" intended to create a public forum but mistakenly concluded that the Establishment Clause prevented them from allowing religious groups to participate. That is not entirely accurate, because the defendants also argued that the Missouri constitution barred the university from allowing religious groups to participate. The Court did not characterize the defendants’ view of the state constitution as mistaken; nor did it attribute to the defendants an intention to create a forum in defiance of the state constitution. "), _c('em', [_vm._v("Widmar")]), _vm._v(" found a federal right of access to a university open forum that overrode contrary state law.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_235",
      "id": "fn1-235"
    }
  }, [_vm._v("235.")]), _vm._v(" "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 803 (citing "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 267 n.5).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_236",
      "id": "fn1-236"
    }
  }, [_vm._v("236.")]), _vm._v(" Board of Airport Comm’rs v. Jews for Jesus, Inc., 479 U.S. 812 (1986), "), _c('em', [_vm._v("granting cert. to")]), _vm._v(" 785 F.2d 791 (9th Cir. 1986). [The Court protected Jews for Jesus under overbreadth doctrine, without regard to whether the airport was a public forum. 482 U.S. 569 (1987).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_237",
      "id": "fn1-237"
    }
  }, [_vm._v("237.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 579–90. She proposes a “unitary forum analysis,” in which increasing government control of a site simultaneously erodes its status as a forum and escalates the state’s Establishment Clause responsibility for any religious speech that occurs there. The Establishment Clause half of this analysis merely repeats her earlier arguments about school “involvement” in private religious speech on campus. "), _c('em', [_vm._v("Id")]), _vm._v(". at 586.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_238",
      "id": "fn1-238"
    }
  }, [_vm._v("238.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" cases cited "), _c('em', [_vm._v("supra")]), _vm._v(" note 233.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_239",
      "id": "fn1-239"
    }
  }, [_vm._v("239.")]), _vm._v(" The distinction between meetings and other speech was crucial to May v. Evansville-Vanderburgh School Corp., 787 F.2d 1105 (7th Cir. 1986). But "), _c('em', [_vm._v("May")]), _vm._v(" dealt with meetings of teachers, which required no monitor. For criticism of the case, see "), _c('em', [_vm._v("supra")]), _vm._v(" note 149.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_240",
      "id": "fn1-240"
    }
  }, [_vm._v("240.")]), _vm._v(" Schneider v. New Jersey, 308 U.S. 147, 162–63 (1939).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_241",
      "id": "fn1-241"
    }
  }, [_vm._v("241.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Vince Blasi, "), _c('em', [_vm._v("Prior Restraints on Demonstrations")]), _vm._v(", 68 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1481, 1527–32 (1970); David Goldberger, "), _c('em', [_vm._v("A Reconsideration of Cox v. New Hampshire: Can All Demonstrators Be Required to Pay the Cost of Using America’s Public Forums?")]), _vm._v(", 62 T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EX")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 403 (1983); Eric Neisser, "), _c('em', [_vm._v("Charging for Free Speech: User Fees and Insurance in the Marketplace of Ideas")]), _vm._v(", 74 G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EO")]), _vm._v(". L.J. 257 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_242",
      "id": "fn1-242"
    }
  }, [_vm._v("242.")]), _vm._v(" Cox v. New Hampshire, 312 U.S. 569, 576–77 (1941). For thorough analyses, see Goldberger, "), _c('em', [_vm._v("supra")]), _vm._v(" note 241; Neisser, "), _c('em', [_vm._v("supra")]), _vm._v(" note 241.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_243",
      "id": "fn1-243"
    }
  }, [_vm._v("243.")]), _vm._v(" 20 U.S.C. § 4071(a) (Supp. 1985). The statutory language is “any public secondary schools.” Teitel reports that some state laws use this term to include junior high school. Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 573–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_244",
      "id": "fn1-244"
    }
  }, [_vm._v("244.")]), _vm._v(" "), _c('em', [_vm._v("But see")]), _vm._v(" Bell v. Little Axe Indep. Sch. Dist. No. 70, 766 F.2d 1391, 1402, 1413 (10th Cir. 1985) (holding that elementary school had created limited forum, but Establishment Clause barred “concerted” religious speech from forum); Mich. State Board of Educ. v. Tri-County Area Sch. Dist., 5 Religious Freedom Rep. (Christian Legal Soc’y) 47 (W.D. Mich. 1984) (substantially the same, at preliminary injunction stage).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_245",
      "id": "fn1-245"
    }
  }, [_vm._v("245.")]), _vm._v(" 393 U.S. at 504, 514.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_246",
      "id": "fn1-246"
    }
  }, [_vm._v("246.")]), _vm._v(" "), _c('em', [_vm._v("But cf.")]), _vm._v(" Bowman v. Bethel-Tate Board of Educ., 610 F. Supp. 577 (S.D. Ohio 1985) (enjoining censorship of third-grade play).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_247",
      "id": "fn1-247"
    }
  }, [_vm._v("247.")]), _vm._v(" "), _c('em', [_vm._v("Annual Report, 1983–84: Years of Struggle, Years of Triumph")]), _vm._v(", C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Spring 1985, at 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_248",
      "id": "fn1-248"
    }
  }, [_vm._v("248.")]), _vm._v(" Barry Lynn, "), _c('em', [_vm._v("Religious Speech in Secondary Schools: What Is Equal Access?,")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Fall 1984, at 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_249",
      "id": "fn1-249"
    }
  }, [_vm._v("249.")]), _vm._v(" "), _c('em', [_vm._v("ACLU Debates “Rights in Conflict,”")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IV")]), _vm._v(". L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBERTIES")]), _vm._v(", Summer 1985, at 1, 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_250",
      "id": "fn1-250"
    }
  }, [_vm._v("250.")]), _vm._v(" 669 F.2d 1038 (5th Cir. 1982); "), _c('em', [_vm._v("see also")]), _vm._v(" Nartowicz v. Clayton County Sch. Dist., 736 F.2d 646 (11th Cir. 1984) (court relied on evidence that school sponsored religious activities to support preliminary injunction against on-campus meetings of Youth for Christ Club).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_251",
      "id": "fn1-251"
    }
  }, [_vm._v("251.")]), _vm._v(" Teitel, "), _c('em', [_vm._v("supra")]), _vm._v(" note 56, at 549–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_252",
      "id": "fn1-252"
    }
  }, [_vm._v("252.")]), _vm._v(" NLRB v. Wemyss, 212 F.2d 465 (9th Cir. 1954); "), _c('em', [_vm._v("In re")]), _vm._v(" Carpenter Steel Co., 76 N.L.R.B. 670 (1948); R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OBERT")]), _vm._v(" A. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORMAN")]), _vm._v(", B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASIC")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ON")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABOR")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(", U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIONIZATION")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLLECTIVE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARGAINING")]), _vm._v(" 197 (West 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_253",
      "id": "fn1-253"
    }
  }, [_vm._v("253.")]), _vm._v(" Studies indicating substantial but imperfect compliance with the school prayer decisions are collected in Jesse H. Choper, "), _c('em', [_vm._v("Consequences of Supreme Court Decisions Upholding Individual Constitutional Rights")]), _vm._v(", 83 M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICH")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 1, 79 nn.525–27 (1984).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_254",
      "id": "fn1-254"
    }
  }, [_vm._v("254.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8343–44 (daily ed. June 27, 1984) (colloquy between Sen. Gorton and Sen. Hatfield); "), _c('em', [_vm._v("see")]), _vm._v(" Aaron, "), _c('em', [_vm._v("supra")]), _vm._v(" note 89, at 593–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_255",
      "id": "fn1-255"
    }
  }, [_vm._v("255.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8343–44 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_256",
      "id": "fn1-256"
    }
  }, [_vm._v("256.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Knights of the Ku Klux Klan v. East Baton Rouge Parish Sch. Board, 578 F.2d 1122 (5th Cir. 1978) (Ku Klux Klan had constitutional right of equal access to school gymnasium in evenings; case governed by First Amendment standards for adults).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_257",
      "id": "fn1-257"
    }
  }, [_vm._v("257.")]), _vm._v(" 395 U.S. 444, 448–49 (1969) (advocacy of violence is protected speech unless it amounts to “incitement to imminent lawless action”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_258",
      "id": "fn1-258"
    }
  }, [_vm._v("258.")]), _vm._v(" Aaron, "), _c('em', [_vm._v("supra")]), _vm._v(" note 89, at 597–603, 608–11; Note, "), _c('em', [_vm._v("Administrative Regulation, supra")]), _vm._v(" note 89, at 636–49; Annotation, "), _c('em', [_vm._v("What Oral Statement of Student Is Sufficiently Disruptive So as to Fall Beyond Protection of First Amendment")]), _vm._v(", 76 A.L.R. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ED")]), _vm._v(". 599 (1986); "), _c('em', [_vm._v("see, e.g.")]), _vm._v(", Bethel School Dist. No. 403 v. Fraser, 478 U.S. 675 (1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_259",
      "id": "fn1-259"
    }
  }, [_vm._v("259.")]), _vm._v(" The opposite view is asserted in Strossen, "), _c('em', [_vm._v("supra")]), _vm._v(" note 70, at 171.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_260",
      "id": "fn1-260"
    }
  }, [_vm._v("260.")]), _vm._v(" 130 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONG")]), _vm._v(". R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EC")]), _vm._v(". S8352, 8360 (daily ed. June 27, 1984) (statement of Sen. Hatfield).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_261",
      "id": "fn1-261"
    }
  }, [_vm._v("261.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263, 284–85 (1981) (White, J., dissenting). White thought that if all religious speech were protected by the Free Speech Clause, the Free Exercise Clause would “be emptied of any independent meaning in circumstances in which religious practice took the form of speech.” "), _c('em', [_vm._v("Id")]), _vm._v(". at 284. Losing counsel also thought this was a central defect in the Court’s opinion. Ted D. Ayres, "), _c('em', [_vm._v("Widmar v. Vincent: The Beginning of the End for the Establishment Clause")]), _vm._v(", 8 J.C. & U.L. 511, 514 (1982). The resulting overlap between free speech and free exercise is not troubling, because only the Free Exercise Clause protects the many other forms of religious exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_262",
      "id": "fn1-262"
    }
  }, [_vm._v("262.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 282, 286–89 (White, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_263",
      "id": "fn1-263"
    }
  }, [_vm._v("263.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 269–70 n.6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_264",
      "id": "fn1-264"
    }
  }, [_vm._v("264.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_265",
      "id": "fn1-265"
    }
  }, [_vm._v("265.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_266",
      "id": "fn1-266"
    }
  }, [_vm._v("266.")]), _vm._v(" "), _c('em', [_vm._v("See generally")]), _vm._v(" Serbian E. Orthodox Diocese v. Milivojevich, 426 U.S. 696 (1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_267",
      "id": "fn1-267"
    }
  }, [_vm._v("267.")]), _vm._v(" See Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1411–12 n.286 [in volume 2 at 281]; Douglas Laycock, "), _c('em', [_vm._v("Civil Rights and Civil Liberties")]), _vm._v(", 54 Chi.-Kent. L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 390, 430–32 (1977) [in volume 2 at 357–60].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_268",
      "id": "fn1-268"
    }
  }, [_vm._v("268.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 270 n.6; "), _c('em', [_vm._v("see")]), _vm._v(" Heffron v. Int’l Soc’y for Krishna Consciousness, Inc., 452 U.S. 640 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_269",
      "id": "fn1-269"
    }
  }, [_vm._v("269.")]), _vm._v(" Religious intensity as a basis for valuing Religion Clause interests is examined in Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 132, at 1409–11 [in volume 2 at 278–81].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_270",
      "id": "fn1-270"
    }
  }, [_vm._v("270.")]), _vm._v(" Consider the extraordinary line-drawing difficulties caused by attempts to exclude obscene speech from First Amendment protection.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_271",
      "id": "fn1-271"
    }
  }, [_vm._v("271.")]), _vm._v(" Elliott, "), _c('em', [_vm._v("supra")]), _vm._v(" note 71, at 1, col. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_272",
      "id": "fn1-272"
    }
  }, [_vm._v("272.")]), _vm._v(" 472 U.S. 38 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_273",
      "id": "fn1-273"
    }
  }, [_vm._v("273.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20 (Supp. 1986), "), _c('em', [_vm._v("quoted in Wallace")]), _vm._v(", 472 U.S. at 40 n.1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_274",
      "id": "fn1-274"
    }
  }, [_vm._v("274.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20.1 (Supp. 1986), "), _c('em', [_vm._v("quoted in Wallace")]), _vm._v(", 472 U.S. at 40 n.2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_275",
      "id": "fn1-275"
    }
  }, [_vm._v("275.")]), _vm._v(" "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 40 n.1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_276",
      "id": "fn1-276"
    }
  }, [_vm._v("276.")]), _vm._v(" For the original formulation of this three-part test, see Lemon v. Kurtzman, 403 U.S. 602, 612–13 (1971), quoted "), _c('em', [_vm._v("supra")]), _vm._v(" note 100.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_277",
      "id": "fn1-277"
    }
  }, [_vm._v("277.")]), _vm._v(" "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 59.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_278",
      "id": "fn1-278"
    }
  }, [_vm._v("278.")]), _vm._v(" For an example of a neutral provision that mentions “prayer,” see "), _c('em', [_vm._v("infra")]), _vm._v(" note 292 and accompanying text (West Virginia’s constitutional amendment).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_279",
      "id": "fn1-279"
    }
  }, [_vm._v("279.")]), _vm._v(" The second definition of “meditation” listed in the O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XFORD")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY")]), _vm._v(" 298 (1970) is as follows: “spec. [specifically] in religious use: That kind of private devotional exercise which consists in the continuous application of the mind to the contemplation of some religious truth, mystery, or object of reverence, in order that the soul may increase in love of God and holiness of life.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_280",
      "id": "fn1-280"
    }
  }, [_vm._v("280.")]), _vm._v(" "), _c('em', [_vm._v("See Annual Report, supra")]), _vm._v(" note 247, at 6 (ACLU describes New Jersey law as “legislators trying to hide government-sponsored prayer behind thinly veiled words like ‘contemplation’ and ‘introspection’”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_281",
      "id": "fn1-281"
    }
  }, [_vm._v("281.")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LA")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODE")]), _vm._v(" § 16–1–20.1 (Supp. 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_282",
      "id": "fn1-282"
    }
  }, [_vm._v("282.")]), _vm._v(" Nor is it clear that inserting “voluntary” overcomes the thrust of the statute with respect to prayer. I do not know what it means to direct that students “shall observe” a moment of “voluntary” prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_283",
      "id": "fn1-283"
    }
  }, [_vm._v("283.")]), _vm._v(" Gaines v. Anderson, 421 F. Supp. 337 (D. Mass. 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_284",
      "id": "fn1-284"
    }
  }, [_vm._v("284.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 339, 342. Professor McConnell also finds the statutory text neutral. McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 46–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_285",
      "id": "fn1-285"
    }
  }, [_vm._v("285.")]), _vm._v(" "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 342.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_286",
      "id": "fn1-286"
    }
  }, [_vm._v("286.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Lynch v. Donnelly, 465 U.S. 668, 690 (1984) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_287",
      "id": "fn1-287"
    }
  }, [_vm._v("287.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Seide, "), _c('em', [_vm._v("supra")]), _vm._v(" note 9 (arguing that Establishment Clause forbids any government act perceived as support of religion, apparently without regard to whether perception is accurate, informed, or even reasonable).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_288",
      "id": "fn1-288"
    }
  }, [_vm._v("288.")]), _vm._v(" Teachers were instructed to repeat the words of the legislature, to say that they were doing this to comply with the law, and to refuse to answer questions. "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 340 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_289",
      "id": "fn1-289"
    }
  }, [_vm._v("289.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 344 n.9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_290",
      "id": "fn1-290"
    }
  }, [_vm._v("290.")]), _vm._v(" N.M. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 22–5–4.1 (1978), "), _c('em', [_vm._v("quoted in")]), _vm._v(" Duffy v. Las Cruces Pub. Schs., 557 F. Supp. 1013, 1015 (D.N.M. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_291",
      "id": "fn1-291"
    }
  }, [_vm._v("291.")]), _vm._v(" N.J. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NN")]), _vm._v(". § 18A-26–4 (West 1986), "), _c('em', [_vm._v("quoted in")]), _vm._v(" May v. Cooperman, 572 F. Supp. 1561, 1562 (D.N.J. 1983), "), _c('em', [_vm._v("aff’d")]), _vm._v(", 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 72 (1987)].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_292",
      "id": "fn1-292"
    }
  }, [_vm._v("292.")]), _vm._v(" W. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONST")]), _vm._v(". art. III, § 15-a, "), _c('em', [_vm._v("quoted in")]), _vm._v(" Walter v. West Va. Board of Educ., 610 F. Supp. 1169, 1170 n.1 (S.D.W. Va. 1985); "), _c('em', [_vm._v("cf")]), _vm._v(". N.C. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AWS OF")]), _vm._v(" 1985, ch. 637 (to be codified as N.C. G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EN")]), _vm._v(". S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAT")]), _vm._v(". 115C-4728), "), _c('em', [_vm._v("quoted in")]), _vm._v(" Valerie B. Spalding, Note, "), _c('em', [_vm._v("Constitutional Law—Moment of Silence Statute May Threaten the Wall of Separation Between Church and State—Wallace v. Jaffree")]), _vm._v(", 8 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMPBELL")]), _vm._v(" L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 125, 141 (1985) (“Such period of silence shall be totally unstructured and free of guidance or influence of any kind from any sources.”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_293",
      "id": "fn1-293"
    }
  }, [_vm._v("293.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 241; "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1170 n.1; Duffy v. Las Cruces Pub. Schools, 557 F. Supp. 1013, 1015 (D.N.M. 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_294",
      "id": "fn1-294"
    }
  }, [_vm._v("294.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1172–73. The district court in the New Jersey case also found improper implementation in some districts. "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567–68. But the court of appeals did not rely on these findings, 780 F.2d at 251 & n.8, perhaps because it decided the case on grounds applicable to all districts.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_295",
      "id": "fn1-295"
    }
  }, [_vm._v("295.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–15 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_296",
      "id": "fn1-296"
    }
  }, [_vm._v("296.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1569–73; "), _c('em', [_vm._v("Duffy")]), _vm._v(", 557 F. Supp. at 1015–17. "), _c('em', [_vm._v("But see May")]), _vm._v(", 780 F.2d at 264–65 (Becker, J., dissenting) (arguing that court should accept testimony that moment of silence is a secular teaching device). Martin Nussbaum, an open defender of government support for majoritarian religion, agrees that such rationalizations are “ridiculous.” L. Martin Nussbaum, "), _c('em', [_vm._v("A Garment for the Naked Public Square: Nurturing American Public Theology")]), _vm._v(", 16 C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UMB")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 53, 61–62 (1985).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_297",
      "id": "fn1-297"
    }
  }, [_vm._v("297.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 780 F.2d at 243–46, 251.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_298",
      "id": "fn1-298"
    }
  }, [_vm._v("298.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 247–50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_299",
      "id": "fn1-299"
    }
  }, [_vm._v("299.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 251.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_300",
      "id": "fn1-300"
    }
  }, [_vm._v("300.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 247.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_301",
      "id": "fn1-301"
    }
  }, [_vm._v("301.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 252; "), _c('em', [_vm._v("see id")]), _vm._v(". at 261 (Becker, J., dissenting) (identifying number of legislators). Similar reasoning appears in Note, "), _c('em', [_vm._v("State Statutes, supra")]), _vm._v(" note 28, at 1879–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_302",
      "id": "fn1-302"
    }
  }, [_vm._v("302.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 108–13 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_303",
      "id": "fn1-303"
    }
  }, [_vm._v("303.")]), _vm._v(" "), _c('em', [_vm._v("See supra")]), _vm._v(" notes 102–07 and accompanying text.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_304",
      "id": "fn1-304"
    }
  }, [_vm._v("304.")]), _vm._v(" "), _c('em', [_vm._v("Cf")]), _vm._v(". Wallace v. Jaffree, 472 U.S. 38, 57 n.45 (1985) (no “governmental practice” prevented individual students from praying silently); "), _c('em', [_vm._v("id")]), _vm._v(". at 83 (O’Connor, J., concurring) (no “law” prevented individual students from praying silently).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_305",
      "id": "fn1-305"
    }
  }, [_vm._v("305.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104, at 46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_306",
      "id": "fn1-306"
    }
  }, [_vm._v("306.")]), _vm._v(" The Court incorrectly relied on such statements as evidence of impermissible intent in "), _c('em', [_vm._v("Wallace")]), _vm._v(", 472 U.S. at 56–57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_307",
      "id": "fn1-307"
    }
  }, [_vm._v("307.")]), _vm._v(" For a plea for accommodation that uses the word carefully and tries to develop manageable standards, see McConnell, "), _c('em', [_vm._v("supra")]), _vm._v(" note 104. McConnell and I agree substantially but not totally on the meaning of “accommodation.” In general, I insist on more vigilance against incidental encouragement in the course of accommodation. "), _c('em', [_vm._v("See also")]), _vm._v(" Norman Dorsen & Charles Sims, "), _c('em', [_vm._v("The Nativity Scene Case: An Error of Judgment")]), _vm._v(", 1985 U. I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LL")]), _vm._v(". L. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EV")]), _vm._v(". 837, 862–63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_308",
      "id": "fn1-308"
    }
  }, [_vm._v("308.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" May v. Cooperman, 572 F. Supp. 1561, 1566 (D.N.J. 1983), "), _c('em', [_vm._v("aff’d on other grounds")]), _vm._v(", 780 F.2d 240 (3d Cir. 1985), "), _c('em', [_vm._v("juris. postponed sub nom")]), _vm._v(". Karcher v. May, 479 U.S. 1062 ["), _c('em', [_vm._v("appeal dis’d")]), _vm._v(", 484 U.S. 72 (1987)]; Spalding, "), _c('em', [_vm._v("supra")]), _vm._v(" note 292, at 142 n.141.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_309",
      "id": "fn1-309"
    }
  }, [_vm._v("309.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Walter v. West Va. Board of Educ., 610 F. Supp. 1169, 1173 (S.D.W. Va. 1985); "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567; Gaines v. Anderson, 421 F. Supp. 337, 340 n.4 (D. Mass. 1976). "), _c('em', [_vm._v("May")]), _vm._v(" reports implementation practices in several schools.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_310",
      "id": "fn1-310"
    }
  }, [_vm._v("310.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1567–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_311",
      "id": "fn1-311"
    }
  }, [_vm._v("311.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1172–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_312",
      "id": "fn1-312"
    }
  }, [_vm._v("312.")]), _vm._v(" "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1568.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_313",
      "id": "fn1-313"
    }
  }, [_vm._v("313.")]), _vm._v(" "), _c('em', [_vm._v("Id")]), _vm._v(". at 1567.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_314",
      "id": "fn1-314"
    }
  }, [_vm._v("314.")]), _vm._v(" "), _c('em', [_vm._v("Walter")]), _vm._v(", 610 F. Supp. at 1173; "), _c('em', [_vm._v("May")]), _vm._v(", 572 F. Supp. at 1569, 1574–75; "), _c('em', [_vm._v("Gaines")]), _vm._v(", 421 F. Supp. at 345.")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("Board of Education v. Mergens")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_c('em', [_vm._v("496 U.S. 226 (1990)")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_vm._v("Amicus Brief")]), _vm._v(" "), _c('p', {
    staticClass: "Quote"
  }, [_c('em', [_vm._v("Brief of Baptist Joint Committee on Public Affairs, Christian Legal Society, Church of Jesus Christ of Latter-day Saints, National Association of Evangelicals, National Council of Churches of Christ in the U.S.A., and James E. Andrews as Stated Clerk of the General Assembly of the Presbyterian Church (U.S.A.), as Amici Curiae in Support of Respondents (Oct. 26, 1989)")])]), _vm._v(" "), _c('p', {
    staticClass: "LAuthor"
  }, [_vm._v("With Samuel E. Ericsson, Wilford W. Kirton Jr., Forest D. Montgomery, Carolyn Shain, Oliver S. Thomas, and J. Brent Walker")]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("The Equal Access Act immediately became embroiled in litigation; this was the case that reached the Supreme Court. The school board argued that the Act was unconstitutional and that it was inapplicable. This brief responds to both claims, but especially the latter; it devotes more pages to statutory interpretation than to constitutionality. It argues that Congress enacted an objective test for the Act’s application, a test that left no discretion to resistant school boards, and that this school board’s pervasive resistance to the Act demonstrated the wisdom of that choice. It relies on the distinction between private speech and government speech to show that the Act does not violate the Establishment Clause. And it argues my theory of")]), _vm._v(" Tinker"), _c('em', [_vm._v("—that the students had a free speech right to meet and speak in a place where they were entitled to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Sam Ericsson was director of the Christian Legal Society. Wilford Kirton was a founding partner of Kirton & McConkie in Salt Lake City, which represents the Church of Jesus Christ of Latter-day Saints. Forest Montgomery represented the National Association of Evangelicals. Carolyn Shain was general counsel to the Presbyterian Church (U.S.A.). Buzz Thomas and Brent Walker represented the Baptist Joint Committee on Public Affairs.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Question Presented")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Whether public school officials may prohibit a voluntary, student-initiated, and student-led group of high school students from meeting in empty classrooms before or after school to engage in religious speech, when other student groups are allowed to meet for nonreligious purposes not directly related to the school curriculum.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("This question arises under the Equal Access Act, 20 U.S.C. §§ 4071 to 4074, and in the alternative, under the Speech and Religion Clauses of the First Amendment.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Interest of the Amici Curiae")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The amici joining in this brief represent more than eighty million Americans. These amici are religious organizations that accept this Court’s decisions prohibiting government-sponsored prayer in the public schools. Three of these amici have consistently opposed constitutional amendments that would have permitted school-sponsored prayer. None of these amici have supported such amendments.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Each of these amici support the principles of the Equal Access Act. They saw that the Act was not an attempt to evade this Court’s decisions, but rather an attempt to remove state-imposed obstacles to the speech and religious exercise of students, extending to high schools the sound principles of "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After the Equal Access Act was adopted, all but one of these amici joined in an unusual work of clarification and reconciliation, brought about by the late John Baker, General Counsel of the Baptist Joint Committee. Mr. Baker convened experts from organizations that had favored the Act and from organizations that had opposed it. Together, they negotiated a set of Guidelines for implementation of the Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Because of their long involvement in the enactment and implementation of the Equal Access Act, these amici bring expertise and experience to the case. They have joined in this brief because the positions taken by Westside High School threaten to make the Act a dead letter. A description of the individual amici follows.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Baptist Joint Committee on Public Affairs is composed of representatives from eight national cooperating Baptist conventions and conferences in the United States: American Baptist Churches in the U.S.A.; Baptist General Conference; National Baptist Convention of America; National Baptist Convention, U.S.A.; North American Baptist Convention, Inc.; Seventh Day Baptist General Conference; and Southern Baptist Convention. These constituent bodies have a total membership of approximately thirty million. This brief reflects the traditional Baptist commitment to religious liberty and its political corollary of church-state separation. Because of the congregational autonomy of individual Baptist churches, the Baptist Joint Committee does not purport to speak for all Baptists.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("The Christian Legal Society is a nonprofit, professional association of four thousand judges, attorneys, law professors, and law students, founded in 1961. The Society receives many complaints from high school students who have been denied their rights to religious speech and exercise in the public schools. As a result of such complaints, the Society has been active in the controversy over equal access from the beginning. This brief reflects the Society’s concern for the appropriate accommodation of religion and the protection of the religious speech rights of public high school students.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The Church of Jesus Christ of Latter-day Saints (also known as the Mormon Church) has approximately four million members in the United States. The Church firmly supports the principles of religious freedom embodied in the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The National Association of Evangelicals is a nonprofit association of evangelical Christian organizations, colleges, and universities, as well as some fifty thousand churches from seventy-four denominations. The Association serves a constituency of approximately fifteen million people.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The National Council of Churches of Christ in the U.S.A. is a community of communions composed of thirty-two religious bodies having over forty million constituents in the United States. It is commonly known as the National Council of Churches. Its public positions are based on policies adopted by its Governing Board, composed of about 250 members selected by the member denominations in proportion to their size and support of the Council.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("James E. Andrews, as Stated Clerk of the General Assembly, is the continuing officer of the highest governing body of the Presbyterian Church (U.S.A.). The Presbyterian Church (U.S.A.) is a national Christian denomination with approximately 11,500 congregations organized into 172 presbyteries under the jurisdiction of sixteen synods. This brief does not purport to reflect the views of all Presbyterians. The brief is based on a comprehensive policy statement on religious liberty, adopted by the General Assembly [in volume 1 at 761]. The policy statement specifically opposes any form of government sponsorship for religious observance, and specifically endorses the equal access rights of voluntary student religious clubs.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Through their counsel, the parties have given consent to the filing of this brief.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Summary of Argument")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("This case is one of many similar controversies arising over a period of many years at public schools throughout the nation. The persistent issue arises from ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("widespread misunderstanding of this Court’s decisions forbidding government-sponsored prayer in the public schools. Some educators have come to believe that all religious speech must be extirpated from the schools. Others will permit religious speech by individual students, but forbid students to meet as a group to discuss religion.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("These educators have failed to comprehend the distinction between speech by the school and speech by the students—between government sponsorship of religion and government toleration of religious exercise. In their zeal to enforce the Establishment Clause, they have trampled on the Free Speech and Free Exercise Clauses. They have distinguished away this Court’s clarifying decision in "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981), and they now seek to eviscerate an Act of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If this Court adopts Westside High School’s interpretation of the Equal Access Act, the Act will become a dead letter. WHS proposes judicial deference to such unreviewable administrative discretion that compliance with the Act would for all practical purposes be voluntary.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Of course not all local school officials are hostile to the Equal Access Act. And some who appear hostile are honestly trying to comply with what they understand to be the mandate of this Court’s decisions. But this case shows that at least some local school officials fundamentally reject each and every premise on which Congress acted. This Court should not entrust broad statutory discretion to officials who are so hostile to the statute. Rather, this Court should correct the misunderstanding of its own decisions and vindicate the authority of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Congress enacted an objective statutory test to trigger application of the Equal Access Act. If one noncurriculum related student group is allowed to meet, other groups must be allowed to meet as well. Congress chose this objective test because it feared evasion of the Act. For this objective test to serve its purpose, “noncurriculum related” must be understood in its common and objective sense. Thus the sponsors explained that curriculum related groups are those groups that are directly related to a particular course, such as the French club. WHS would evade the Act by claiming discretion so broad that it could designate any club as curriculum related.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("Enforcing the Equal Access Act at WHS will not violate the Establishment Clause. WHS has artificially created an Establishment Clause issue by insisting that it must sponsor every group that meets in the school, and that it must suppress every group it does not sponsor. This position ignores the facts, the Act, and the case law. The plaintiff students do not seek sponsorship; they seek only the opportunity to meet on a regular basis. The Act expressly provides that WHS cannot sponsor a religious group. And this Court has held that official ")]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("recognition of a student group is not sponsorship, but rather a constitutional entitlement. "), _c('em', [_vm._v("Healy v. James")]), _vm._v(", 408 U.S. 169, 182–84 (1972). If plaintiffs’ club simply meets without sponsorship, as the Act provides, the Establishment Clause issue disappears.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Plaintiffs also have valid constitutional claims, although it is unnecessary to decide them. WHS’s policies violate plaintiffs’ right to speak and to associate for purposes of speech. The school is a traditional forum for its students and faculty. This is something less than a traditional "), _c('em', [_vm._v("public")]), _vm._v(" forum, but a great deal more than a limited public forum in which the right to speak depends on the intent of the school board. Schools are peculiarly the marketplace of ideas, and they are inherently a forum for quiet discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Plaintiffs’ club is entitled to meet even if the school is not characterized as a forum. The students are entitled to be at the school, and they do not surrender their rights at the schoolhouse door. The right to speak individually, or to meet informally and irregularly, is not a substitute for the right to meet as an organized group, guaranteed by the constitutional right of association. This right can be denied only for a substantial educational reason. WHS’s misunderstanding of the Establishment Clause is not such a reason.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, WHS’s policy violates the Free Exercise Clause. Religious speech is a part of free exercise, singled out for the highest level of First Amendment protection. The right of religious groups to meet is also part of the right to free exercise. And WHS’s policy is hostile to religion, violating the duty of neutrality imposed by both Religion Clauses.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Argument")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("I. Westside High School Has a Limited Open Forum as That Term Is Defined in the Equal Access Act. The School’s Contrary Interpretation Would Effectively Repeal the Act.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bia"
  }, [_c('strong', [_c('em', [_vm._v("A. The Congressional Purpose Was to End a Pattern of Content Discrimination Against Student Religious Speech.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The congressional committee that recommended the Equal Access Act found a persistent pattern of discrimination against religious speech by students. The Senate Judiciary Committee found:")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Despite "), _c('em', [_vm._v("Widmar")]), _vm._v(", many school administrators across the country are prohibiting voluntary, student-initiated religious speech as an extracurricular ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("activity. Like the judges of the district court in "), _c('em', [_vm._v("Widmar")]), _vm._v(", they erroneously believe that the Establishment Clause prohibits students from engaging in such speech at all, even when other types of extracurricular student speech are permitted. Generally, those administrators act not from malevolence toward religion but from ignorance of the law and erroneous legal advice. A primary source of their confusion has been the lower Federal courts.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Equal Access Act, Report of the Senate Comm. on the Judiciary on S. 1059")]), _vm._v(", S. Rep. 98–357 at 6 (reprinted in U.S. Code Cong. & Admin. News, 98th Cong., 2d Sess. at 2348 (1984)). The Committee reported many cases of discrimination against student religious speech. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 11–18. The Committee found that many schools prevented religious groups from meeting, and that some schools even tried to prevent individual students from discussing religion in the halls or in the parking lot, or from saying grace over their meal in the cafeteria. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 11–12, 16–18. The House committee made similar but less detailed findings. "), _c('em', [_vm._v("Equal Access Act, Report of the House Comm. on Education and Labor on H.R. 5345")]), _vm._v(", H.R. Rep. No. 98–710, at 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It was this pattern of discrimination by local school boards that made the Equal Access Act necessary. To be sure, the Act is not limited to religious speech. The Act treats the pattern of discrimination against religious speech as a special case of content discrimination. When the Act applies, it protects religious and secular speech alike.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But in deciding when the Act applies, courts must interpret it in a way that solves the problem Congress was trying to solve. “It is the plain duty of the courts, regardless of their views of the wisdom or policy of the Act, to construe this remedial legislation to eliminate, so far as its text permits, the practices it condemns.” "), _c('em', [_vm._v("Wong Yang Sung v. McGrath")]), _vm._v(", 339 U.S. 33, 45 (1950).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The evil to be remedied is clearly identified in the committee reports. Congress found that many school boards, left to choose a course through conflicting legal advice and local pressure groups, would discriminate against religious speech. If local school boards have unlimited discretion to decide whether the Act applies, that discrimination will continue. As the court of appeals correctly held, broad discretion in the school boards would lead to “exactly the result that Congress sought to prohibit.” 867 F.2d at 1078.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("The statutory definition of “limited open forum” must be read in light of the congressional findings and purpose. WHS tries to equate the statutory standard with the constitutional standard, even to the point of falsely claiming that “Congress twice used the term of art ‘limited public forum.’” Pet. Br. 59–60 n.24. This misquotes the statute. Congress avoided the term of art, presumably deliberately, and used its own term with its own definition. Thus, a statutory “limited "), _c('em', [_vm._v("open")]), _vm._v(" forum” is emphatically not the same as a constitutional “limited ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('em', [_vm._v("public")]), _vm._v(" forum.” Rather, the statutory “limited open forum” is expressly defined in 20 U.S.C. § 4071(b):")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("A public secondary school has a limited open forum whenever such school grants an offering to or opportunity for one or more noncurriculum related student groups to meet on school premises during noninstructional time.")]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("This definition makes the existence of a statutory forum depend on an objective standard—one or more noncurriculum related student groups. Unlike this Court’s definition of a constitutional limited forum, a statutory forum does not depend on the intent of the school board. The judicial inquiry under the statute is into the existence of a single noncurriculum related group, not into the school board’s intent.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The statutory definition is sweeping as well as objective. The most striking thing about the definition is the phrase “one or more”—a single noncurriculum related group creates a statutory forum. This part of the definition also goes well beyond this Court’s cases on constitutional limited forums.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This sweeping and objective standard can be understood only as a remedial measure to prevent local school boards from continuing the content discrimination that Congress sought to end. The standard is objective and sweeping because its drafters feared evasion and resistance. Senator Leahy, who together with Senator Hatfield drafted the final language of the bill, explained that the concept of the limited open forum is “the very heart of the bill.” 130 Cong. Rec. S8341 (daily ed. June 27, 1984). He went on to say that the limited open forum “should be triggered by what a school does, not by what it says.” "), _c('em', [_vm._v("Id.")]), _vm._v(" Without the objective standard of a single noncurriculum related group, he feared that schools could avoid the Act with a resolution declaring a closed forum, and then “consider any student group wanting to meet on school premises during noninstructional time on a case-by-case basis.” "), _c('em', [_vm._v("Id.")]), _vm._v(" WHS’s policy fits Leahy’s prediction. WHS says that nothing can meet without school sponsorship and a relationship to the curriculum, and then it decides which groups can meet: service clubs are in, scuba diving is in, religion is out. The remedial purpose of the statute is wholly defeated if courts are too deferential to local school boards on the question of which groups are curriculum related.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The explanations of other sponsoring Senators are fully consistent with the definition’s remedial purpose. Senator Hatfield, the principal Senate sponsor, offered this explanation:")])]), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("[I]n a number of schools, students in a class of Spanish or French will form a French club or a Spanish club where they get together to talk nothing but ")]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("that language, to get conversational proficiency. We are recognizing that as really a kind of extension of the classroom. That is the kind of category of clubs that we are trying to incorporate as curriculum related.")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Id.")]), _vm._v(" at S8342.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The French club is related to the curriculum in the sense that it directly serves a particular course that is offered for credit as part of the ordinary curriculum. That is what Hatfield appears to have meant by “an extension of the classroom.” Pet. Br. 72. Senator Dole, another sponsor, offered the example of “extracurricular field trips taken by a science class” as curriculum related, and he said that the limited open forum included “those student group meetings that are not "), _c('em', [_vm._v("directly")]), _vm._v(" related to the school’s curriculum.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at S8362 (emphasis added). The need for a direct link to curriculum is also suggested by the statutory definition of “meeting”: an activity of a student group that is not “directly related to the school curriculum.” 20 U.S.C. § 4072(3). WHS claims that all its clubs are “an extension of the classroom,” Pet. Br. 72, but it ignores the illustrations that give meaning to the phrase.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The sponsors’ explanations of “curriculum related” fit the common sense understanding of curriculum, the sense in which the word would be used by legislators who are not educational theorists. Their explanations are consistent with the common distinctions among “curricular,” “co-curricular,” and “extra-curricular,” distinctions that WHS would obliterate. Even WHS occasionally slips into more sensible usage, when it says that curriculum is “"), _c('em', [_vm._v("part of")]), _vm._v(" the ‘total learning experience,’” Pet. Br. 20 (emphasis added), and when it distinguishes “the School’s curriculum” from “its overall program.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 15. Of course extra-curricular activities are educational, useful, and related to the total learning experience. But that does not make them part of the curriculum in ordinary speech or in the meaning of the Equal Access Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Following Senator Hatfield’s initial explanation, Senator Gorton skillfully cross-examined him about the meaning of curriculum related. In response to this unfriendly interrogation, Hatfield predicted that school board lawyers would find ways to evade the statute: “I cannot readily conceive of a criterion that could be used at this time to establish [a chess club] as a curriculum related activity. I am not saying it could not be, because as long as you have lawyers, they can find ways of doing things one way or another.” 130 Cong. Rec. at S8342.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS seizes on this prediction about chess clubs, stopping its quotation just before Hatfield’s despairing description of lawyers. Pet. Br. 65. And of course WHS claims what Hatfield could not readily conceive of—that its chess club is curriculum related.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("This same interrogation produced Hatfield’s statement that the statute would not limit school board discretion to define what is curriculum related. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 64. The only meaning of this statement consistent with the purpose of the statute is entirely uncontroversial: the Act does not interfere with local control of curriculum. The Act does not speak to the meaning of “curriculum related” for any purpose other than determining the Act’s applicability. The Act does not control the school board’s theory of curriculum; the board can continue to teach anything it wants, to sponsor any clubs it wants, and to consider them part of the curriculum if it wants.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But WHS cannot apply its infinitely elastic concepts of curriculum to the interpretation of a federal statute. Gorton’s cross-examination attempted to apply Hatfield’s answer about local control to the question of when the statute applies, and this effort led to Hatfield’s statement that chess clubs are not curriculum related but that a clever lawyer might seek to make them so. Gorton was trying to make Hatfield explain the statute in a way that would destroy it. The whole point of the statute was to restrict the discretion of local school boards on one narrow but important issue—the recognition of voluntary student groups.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("One ambiguous answer to a hostile question cannot control unambiguous evidence of congressional purpose. The issue need not depend on speculation about Hatfield’s state of mind, or on any preference for one snippet of floor debate over another. The issue is more reliably resolved by considering the evil the statute was designed to cure, the role of the definition of “limited open forum” in curing that evil, and the meaning of “noncurriculum related” necessary to cure that evil. The entire purpose of the statute depends on a narrow definition of curriculum related, committed in the first instance to local school boards but subject to substantial judicial review in light of the statutory purpose. A sweeping and largely unreviewable discretion, committed to the officials whose behavior Congress was trying to control, would make the statute nugatory.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("After the statute was enacted, a very broad set of interested organizations agreed that “curriculum related” requires a direct relationship to curriculum. In their carefully negotiated Guidelines on the Act, the groups agreed as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("A noncurriculum related student group is a group or club which is interested in a subject matter "), _c('em', [_vm._v("not directly related to the school curriculum.")]), _vm._v(" The math club, the Spanish club, the drama club and athletic teams would normally be curriculum related. A religious club, political club or "), _c('em', [_vm._v("service club")]), _vm._v(" would be considered noncurriculum related.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("130 Cong. Record S14,475 (daily ed. Oct. 11, 1984) (emphasis added).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("Of course these Guidelines are not part of the legislative history. But they were negotiated by the American Association of School Administrators, the National Education Association, the American Civil Liberties Union, and several religious groups, and accepted by the American Federation of Teachers, Americans United for Separation of Church and State, and People for the American Way. All but one of the amici joining in this brief subscribed to these Guidelines, as did many of the amici now supporting WHS. Senator Hatfield inserted these Guidelines into the Congressional Record, explaining that supporters and opponents of the Act had at least been able to agree on what the Act meant.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The broad acceptance of these Guidelines by educational associations indicates the unreasonableness of WHS’s claim that its several service clubs are curriculum related. WHS also claims that its chess club is curriculum related, even though the chess club was one of the most commonly offered congressional examples of a club that is not curriculum related. Similarly, WHS claims that its scuba diving club is curriculum related, even though there is no course in scuba diving and the club is both attended and taught by outsiders who are neither students nor faculty. J.A. 167–68 (Tr. 174); J.A. 175 (Tr. 185–86); J.A. 236–39 (Tr. 282–85).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Act does not apply to WHS, it is hard to imagine a school where the Act would apply. If WHS had political clubs, it would say that they are related to courses in social studies, government, and sociology. There is no club that cannot be related to the curriculum with sufficient imagination. As Senator Hatfield said, “as long as you have lawyers, they can find ways of doing things one way or another.” But that is not an interpretation of the statute; it is a formula for evading the statute.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. WHS Claims Discretion That Is Essentially Unlimited.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("It is revealing to examine the language in which WHS couches its claims of curriculum relatedness. WHS says that each of the clubs was “intended to further "), _c('em', [_vm._v("either")]), _vm._v(" the goals and objectives of specific aspects of the School’s "), _c('em', [_vm._v("curriculum or of its overall program.")]), _vm._v("” Pet. Br. 15 (emphasis added). Several of the clubs are said to be “related with the functioning of the School as an institution.” "), _c('em', [_vm._v("Id.")]), _vm._v(" The curriculum is “part of the ‘total learning experience.’” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 20. Curriculum includes “all the school-related experiences provided for the growth and development of pupils.” "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The clubs are “part of the School’s educational program.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 49. Welcome to Westside is a vehicle “for furthering institutional needs.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 79. “WHS has an interest” in the work of this club, and “it is surely reasonable” to delegate its work to students instead of staff. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 78–79.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("Taken together, these formulations equate “curriculum related” with useful. WHS expands “curriculum related” first to “educational,” then to the “total learning experience,” then to its “overall program,” and finally to “school-related.” “School-related” is not limited to curriculum, or even to “educational” programs; it includes “institutional needs” as well. Indeed, “school-related” is broad enough to include anything in which the school has “an interest,” or anything which is “reasonable.” These are no standards at all, and they are not plausible synonyms for “curriculum related.” These are labels for letting the school do anything it wants.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Dr. Findlay, the school principal, made this claim more directly in his testimony at trial. For him, the question whether a club is curriculum related is wholly tautological. If it is a club, then it is curriculum related:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Curriculum to me includes all of our required courses, our elective courses, all the activities and clubs, [and a number of other things as well,] but definitely I’ve always thought of activities as part of our curriculum.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("J.A. 220 (Tr. 263).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("His response to a question about Cheerleaders was even more tautological:")]), _c('a', {
    attrs: {
      "href": "#/#fn1-315",
      "id": "fn1_315"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "List18Sb"
  }, [_vm._v("Q."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("And what curriculum is it related to?")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Activities and clubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("Q."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("I beg your pardon?")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Activities and clubs.")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("Q."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Is it your testimony that Cheerleaders is curriculum-related because it is part of the clubs and activities at Westside High School?")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("That’s right.")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("Q."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("That’s the reason it is?")])]), _vm._v(" "), _c('p', {
    staticClass: "List18"
  }, [_vm._v("A."), _c('span', {
    staticClass: "pad"
  }, [_vm._v("It’s part of the curriculum. I think the curriculum at Westside High School includes activities.")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("J.A. at 222–23 (Tr. at 266).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This is not the testimony of a school administrator who has considered in good faith how the Equal Access Act applies to his school. Rather, he believes "), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("that it is tautologically impossible for the Equal Access Act ever to apply. If a club exists, it is curriculum related, and no matter how many clubs exist, no new club can be created without his permission. The school licenses group speech, and its discretion is absolutely unfettered. That is the school’s position. Its lawyers have dressed it up a little in the brief, but they claim a discretion broad enough to let the principal adhere to his own theory.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("On most issues of educational policy, WHS does have broad discretion. But on a few issues, where there is an overriding federal policy, the Supremacy Clause requires compliance. This Court has unhesitatingly enforced the law on occasions when Congress directed far greater intrusions into far more central educational decisions. "), _c('em', [_vm._v("See, e.g., Honig v. Doe,")]), _vm._v(" 489 U.S. 305 (1988) (refusing to imply a dangerousness exception into the Education of the Handicapped Act). The Equal Access Act is narrower, but it also declares an overriding federal policy. It restricts the school’s discretion to exclude student speech and association. For purposes of the Act, this Court must interpret “curriculum related” in a way that serves the congressional purpose.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("C. Discretion Cannot Be Entrusted to WHS, Because WHS Rejects Every Important Premise of the Congressional Policy.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("WHS believes that the statute is unconstitutional, wrongheaded, self-contradictory, and bad policy. WHS can hardly be expected to make discretionary judgments that actually implement the statute.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Most obviously, WHS believes that “The Constitution forbids incorporating a religious club into an officially sponsored student activities program.” Pet. Br. 81. This is precisely the belief that Congress found objectionable because it discriminated against religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the school’s rejection of congressional judgment is not limited to this legal conclusion; it extends as well to every related issue of fact, policy, and characterization. WHS believes that its students are incapable of comprehending that the school does not endorse religion when it allows a religious group to meet. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 24, 89. Congress expressly found to the contrary. S. Rep. at 10, 34–36.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("Congress also found that a school could permit a group to meet without thereby sponsoring the group. Congress expressly provided for meetings at which there would be “no sponsorship of the meeting by the school, the government, or its agents or employees.” 20 U.S.C. § 4071(c)(2). WHS believes that such a state of affairs is conceptually impossible—that any group that meets regularly on campus is thereby sponsored by the school. The plaintiff students have asked merely for equal access to a meeting room and to the routine channels ")]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("of communication within the school. WHS equates this request with a demand for sponsorship. Pet. Br. 13, 82–84.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Congress believed that a policy of equal access could be implemented with faculty sponsors for those groups the school was willing and able to sponsor, and without faculty sponsors for those groups the school was unwilling or unable to sponsor. It expressly provided that the school could not sponsor a religious group; “employees or agents of the school or government” can be “present at religious meetings only in a nonparticipatory capacity.” 20 U.S.C. § 4071(c)(3).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS rejects this judgment as well. WHS apparently believes that either it must sponsor all groups or no groups. It claims that if religious clubs can waive a sponsor, so can any other club, including curriculum related clubs, so that its “forum” would be radically restructured. Pet. Br. 54–55.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Amici will respond to some of these arguments later in this brief. The point here is that WHS rejects the congressional view of the First Amendment, it rejects the congressional view of student capacity to understand, it rejects the congressional view of sponsorship, and it rejects the congressional conception of equal treatment. WHS rejects every aspect of the congressional policy. Yet it claims unlimited discretion in implementing that policy. This combination is a sure formula for de facto repeal of the statute. If WHS has its way, content discrimination against student speech will continue unimpeded, in the guise of defining what is curriculum related.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Of course this Court defers to local school boards where appropriate. But this Court also defers to Congress. In the face of such fundamental conflict between the judgments of Congress and the judgments of a local school board, this Court cannot defer to both. But the mandate of the Supremacy Clause is clear: Congress’s resolution of these questions must prevail.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("II. Enforcement of the Equal Access Act at WHS Would Not Violate the Establishment Clause.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("WHS’s Establishment Clause argument depends on two legal errors: its refusal to comply with the sponsorship provisions of the Equal Access Act, and its profound misunderstanding of this Court’s decisions. WHS would create the latent or passive hostility to religion against which this Court has repeatedly warned. "), _c('em', [_vm._v("See, e.g., County of Allegheny v. ACLU")]), _vm._v(", 492 U.S. 573, 610 (1989); "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(", 374 U.S. 203, 225 (1963) [in this volume at 282]; "), _c('em', [_vm._v("id.")]), _vm._v(" at 295 (Brennan, J., concurring).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("It is common ground that WHS cannot sponsor a religion club. To do so would endorse religion in violation of a long line of decisions from this Court. ")]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('em', [_vm._v("See County of Allegheny")]), _vm._v(", 492 U.S. at 589–94. School sponsorship is also objectionable because it would invade the autonomy of the religious club, inevitably influencing choices within the club and changing the religious experience of its members. When government undertakes to direct religious activity, believers as well as nonbelievers are the victims. Thus, amici’s disagreement with WHS is not over the permissibility or the desirability of school sponsorship.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Rather, our disagreement is over the meaning of sponsorship, and more fundamentally, over the role of unsponsored groups in a free society. WHS insists that it "), _c('em', [_vm._v("must")]), _vm._v(" sponsor every group that meets on campus, and therefore, WHS concludes that it "), _c('em', [_vm._v("does")]), _vm._v(" sponsor every group that meets on campus. Because it insists on suppressing everything it does not sponsor, it concludes that mere failure to suppress is sponsorship. Only in this way could WHS repeatedly characterize the plaintiffs’ request for permission to meet and to use the routine channels of school communication as a request for sponsorship. Pet. Br. 31–32, 83–89, 91.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS says that students are free to discuss religion informally, and even to meet informally, "), _c('em', [_vm._v("id.")]), _vm._v(" at 6, 13, 51, so it must be sponsorship that the plaintiffs are seeking. But this claim about informal meetings ignores the significance of a critical undisputed fact. Informal meetings could not be “so regular that they were simply a form of club, without faculty sponsorship.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 13. A club without faculty sponsorship is exactly what plaintiffs want, and exactly what WHS forbids. The school principal “would not allow any group, not even a checkers club, to meet regularly without official sponsorship.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 13.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS’s Establishment Clause argument thus amounts to a self-imposed Catch-22. Plaintiffs do not want school sponsorship, Congress does not want them to have school sponsorship, the Establishment Clause will not permit them to have school sponsorship, but WHS insists that they must have school sponsorship and that school sponsorship makes the students’ meetings unconstitutional. The Establishment Clause issue is manufactured out of nothing by WHS’s insistence that it must sponsor every group that meets on campus.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("WHS’s rule that no group can meet without official sponsorship is precluded by the Equal Access Act. The Act provides that if the school permits one or more noncurriculum related groups on campus, it must permit other groups to meet as well. 20 U.S.C. § 4071(a) and (b). The Act further provides that WHS cannot sponsor or participate in any religious group. § 4071(c)(2) and (c)(3).")]), _c('a', {
    attrs: {
      "href": "#/#fn1-316",
      "id": "fn1_316"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" It is therefore unnecessary to decide whether WHS’s policy of suppressing all "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("it does not sponsor is unconstitutional. WHS can comply with the Act only by permitting plaintiffs’ club to meet without sponsorship. If WHS would simply accept this statutory directive, the Establishment Clause issue would disappear.")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("An unsponsored religion club presents no serious Establishment Clause issue. Such a club would be wholly voluntary, initiated and run by students. Its speech and activities would be the speech and activities of private citizens, not the speech and activities of government.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Private speech is not converted to government speech simply because it takes place on government property, and this Court has long upheld the rights of religious speakers to speak on public property. "), _c('em', [_vm._v("See Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981) (directing state university to allow religious club to meet on campus); "), _c('em', [_vm._v("Board of Airport Commissioners v. Jews for Jesus, Inc.")]), _vm._v(", 482 U.S. 569 (1987) (permitting religious proselytizing in public airport); "), _c('em', [_vm._v("Heffron v. International Society for Krishna Consciousness, Inc.")]), _vm._v(", 452 U.S. 640 (1981) (applying same standards to religious and secular solicitation from booths at state fair); "), _c('em', [_vm._v("Poulos v. New Hampshire")]), _vm._v(", 345 U.S. 395 (1953) (holding that persons desiring to hold church service in public park may be required to obtain license, where licensing authority acts under reasonable and nondiscriminatory standards); "), _c('em', [_vm._v("Niemotko v. Maryland")]), _vm._v(", 340 U.S. 268 (1951) (protecting church service in public park); "), _c('em', [_vm._v("Kunz v. New York")]), _vm._v(", 340 U.S. 290 (1951) (protecting church service in public street).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These cases were not decided in ignorance of the Establishment Clause implications. The Establishment Clause issue was squarely decided in "), _c('em', [_vm._v("Widmar.")]), _vm._v(" It was also briefed in "), _c('em', [_vm._v("Niemotko")]), _vm._v(", see Joint Brief for Appellants at 18–24, Joint Brief for Appellees at 17–20, and it was raised in dissent in "), _c('em', [_vm._v("Kunz")]), _vm._v(", 340 U.S. at 311 n.10 (Jackson, J., dissenting). Opponents of religious speech in the other cases did not find it worthwhile even to argue the Establishment Clause issue.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nor is it sponsorship for government to recognize that religious speech is occurring or to subject it to nondiscriminatory allocation of space. No one suggested that government’s nondiscriminatory allocation of a booth at the state fair in "), _c('em', [_vm._v("Heffron")]), _vm._v(", or of a license to meet in the park in "), _c('em', [_vm._v("Poulos")]), _vm._v(", would be a form of sponsorship that converted private religious speech into a violation of the Establishment Clause. The student request for recognition as a club entitled to use school facilities on an equal basis with other clubs seeks no more. Official recognition is merely a grant of permission to function; it is not sponsorship unless WHS makes it so.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("This Court decided the meaning of sponsorship in the context of student organizations in "), _c('em', [_vm._v("Healy v. James")]), _vm._v(", 408 U.S. 169 (1972). "), _c('em', [_vm._v("Healy")]), _vm._v(" was not decided under the Establishment Clause, and it involved a university instead of a high school. But the arguments actually presented and decided were quite similar to the arguments here. Plaintiffs in "), _c('em', [_vm._v("Healy")]), _vm._v(" sought to have the university officially ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("recognize their chapter of Students for a Democratic Society. As at WHS, official recognition was prerequisite to the right to meet on campus and to use the campus channels of communication. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 176. And like WHS, school officials argued that the students could meet off campus, and even “meet together informally on campus—as individuals, but not as” an organized group. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 182–83. Thus, the school concluded, what the students really sought was the “college’s stamp of approval,” the “administrative seal of official college respectability.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 182. This Court unanimously rejected the argument, holding instead that “the College’s denial of recognition was a form of prior restraint.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 184. The same analysis applies here.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("An unsponsored religion club readily meets the three part test of "), _c('em', [_vm._v("Lemon v. Kurtzman")]), _vm._v(", 403 U.S. 602 (1971). The secular purpose of permitting an unsponsored religion club is to implement the constitutional requirement of neutrality—to avoid discriminating against religious speech, and thus to avoid both the appearance and the reality of hostility to religion. When the school permits a wide range of other clubs and forbids a religion club, it sends an unambiguous message of hostility to religion. Just as discrimination in favor of religion would send an improper message of endorsement, discrimination against religion sends an improper message of hostility. Equal access is not endorsement, but unequal exclusion is repudiation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The primary secular effect of permitting an unsponsored religion club is to implement the secular purpose of neutrality. Because the club would be unsponsored, there would be no religious effect of school endorsement or sponsorship. Interested students would have to seek out the club’s meetings; unlike the school-sponsored religious activities that this Court has properly struck down, uninterested students would not be socially pressured to participate in religious observances or displays in their classrooms. "), _c('em', [_vm._v("Cf. Stone v. Graham")]), _vm._v(", 449 U.S. 39 (1980) (display of Ten Commandments on classroom bulletin board); "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(", 374 U.S. 203 (1963) (teacher-led prayer and Bible reading).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Without a faculty sponsor, there would be no entanglement between state and religion. If the school chooses to send a nonparticipating room monitor on occasion, the monitor’s only role is to preserve order. That role is unrelated to the subject matter of the meeting, and unaffected by it. He must enforce the same disciplinary rules he would enforce if the club did not exist, or if it met to discuss philosophy, social studies, or football. The nonparticipating room monitor is not excessively entangled in religion.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("WHS offers one final objection to equal access, while insisting that the Court need not decide it. This is the claim that high school students will misunderstand and think that the school sponsors the religion club if it fails to ")]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("suppress it. Pet. Br. 24, 89–91. This claim that high school students are too “impressionable” to understand free speech and free exercise is inconsistent with the congressional findings, S. Rep. at 10, 34–36, with the testimony of the expert educational psychologist below, J.A. 379–400 (Tr. 540–61), and with the dominant scholarly understanding of human development. Citations to the scholarly literature are collected in Note, "), _c('em', [_vm._v("The Constitutional Dimensions of Student-Initiated Religious Activity in Public High Schools")]), _vm._v(", 92 Yale L.J. 499, 507–09 (1983).")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The claim that high school students will misunderstand is also inconsistent with this Court’s holding that high school students are mature enough to exercise their rights to free speech in and about the school. "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(", 393 U.S. 503 (1969). This Court’s holdings to the effect that high school students are more impressionable than college students all came in the very different context of government speech. "), _c('em', [_vm._v("See, e.g., Edwards v. Aguillard")]), _vm._v(", 482 U.S. 578, 587 (1987) (teaching of creation science in science courses in public schools); "), _c('em', [_vm._v("Grand Rapids School District v. Ball")]), _vm._v(", 473 U.S. 373, 383, 385 (1985) (public school teachers teaching at public expense in parochial schools). These cases assume that high school students are likely to believe what their teachers say, so that government sponsorship of religion is likely to influence them. These cases are irrelevant to the issue here, which is whether high school students can tell the difference between what their teachers and administrators say and what their classmates say.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But most important, WHS’s claim that high school students cannot understand is self-defeating. If high school students cannot understand that letting a religion club meet is not sponsorship, then they certainly cannot understand that driving a religion club off campus is not hostility. What students at WHS see now is that their school officials will spend large sums of money and years of litigation to keep a religion club off campus. Whatever motivations exist in the minds of WHS officials are far more difficult to understand than the difference between student speech and official school speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The solution to possible student misunderstanding is not to act on the misunderstanding, but to educate those who misunderstand. With appropriate disclaimers and explanations, the school can easily enough make clear that it does not sponsor the religion club. This Court recently held that an explanatory plaque may adequately disclaim government endorsement of religion even when government itself displays religious symbols. "), _c('em', [_vm._v("County of Allegheny v. ACLU")]), _vm._v(", 492 U.S. 573, 619–20 (1989). Some of these amici would not have gone so far. But certainly disclaimers can adequately deal with erroneous attributions to government of private religious speech. WHS would ignore its duty to educate, and instead hold religious speech hostage to the misunderstanding of the least informed or least sophisticated high school student.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("Congress correctly judged that voluntary religious clubs can meet without sponsorship. Because WHS rejects even the possibility of an unsponsored club, it asks this Court to hold the Equal Access Act unconstitutional. But the constitutional problem is in WHS’s rigidity, not in the Act. If the Act is enforced as Congress wrote it, the Establishment Clause issue disappears.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("III. Exclusion of Plaintiffs’ Club Violates Their Rights of Free Speech, Free Exercise, and Association.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Because plaintiffs are plainly entitled to prevail on their statutory claim, there is no need to decide their constitutional claims. But even if there were no Equal Access Act, plaintiffs’ club would be entitled to meet under the First Amendment.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("A. WHS’s Policy Violates Plaintiffs’ Rights to Speech and Association.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec7l"
  }, [_c('strong', [_vm._v("1. A School Is a Traditional Forum for Its Students and Faculty.")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara0"
  }, [_vm._v("A school is not a traditional "), _c('em', [_vm._v("public")]), _vm._v(" forum, because it is not open to the general public. But neither is it a limited public forum or a nonpublic forum, where speech rights depend wholly on the school board’s intention. Rather, a school is a traditional forum for its own students and faculty. As this Court said with respect to university campuses in "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", and again in "), _c('em', [_vm._v("Cornelius v. NAACP Legal Defense & Educational Fund, Inc.")]), _vm._v(", a campus, “at least as to its students, possesses many of the characteristics of a traditional public forum.” "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. 788, 803 (1985), quoting "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. 263, 267 n.5 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Because "), _c('em', [_vm._v("Widmar")]), _vm._v(" involved a university campus, the Court’s characterization of the forum naturally refers to a university campus. But this characterization of the campus as a traditional forum follows from a long line of cases, many of which involved high schools. This Court has repeatedly held that the “classroom is peculiarly the marketplace of ideas.” "), _c('em', [_vm._v("Board of Education v. Pico")]), _vm._v(", 457 U.S. 853, 877 (1982) (Blackmun, J., concurring); "), _c('em', [_vm._v("Tinker v. Des Moines Independent Community School District")]), _vm._v(", 393 U.S. 503, 512 (1969). “The vigilant protection of constitutional freedoms is nowhere more vital than in the community of American schools.” "), _c('em', [_vm._v("Epperson v. Arkansas")]), _vm._v(", 393 U.S. 97, 104–05 (1969); "), _c('em', [_vm._v("Shelton v. Tucker")]), _vm._v(", 364 U.S. 479, 487 (1960). "), _c('em', [_vm._v("See also Hazelwood School District v. Kuhlmeier")]), _vm._v(", 484 U.S. 260, 266 (1988) (high school students “cannot be punished merely for expressing their personal views on the school premises”); "), _c('em', [_vm._v("Pico")]), _vm._v(", 457 U.S. at 864–71 (plurality opinion).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("Schools are one of the traditional places for debate and discussion, just as the streets and parks are one of the traditional places for parades, rallies, and protests. Of course a school is not the same kind of forum as the streets and parks. Rallies and demonstrations that would be entirely appropriate in a park will often be entirely inconsistent with the educational functions of a school. But a school is inherently a forum for the quiet exchange of ideas. That is what is at issue in this case.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The existence of this forum does not depend on the intention of the school officials. School officials can instruct students in the proper means of debate, "), _c('em', [_vm._v("Bethel School District No. 403 v. Fraser")]), _vm._v(", 478 U.S. 675 (1986), and they can control the speech that the school sponsors, such as articles in the official school newspaper, "), _c('em', [_vm._v("Hazelwood School District v. Kuhlmeier")]), _vm._v(", 484 U.S. 260 (1988). But neither of these cases questioned “the undoubted freedom to advocate unpopular and controversial views in schools and classrooms.” "), _c('em', [_vm._v("Bethel")]), _vm._v(", 475 U.S. at 681.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS denies that it has a traditional "), _c('em', [_vm._v("public")]), _vm._v(" forum, relying principally on evidence that the whole public does not have access to the school for purposes of speech. Pet. Br. 33–37. It also cites dictum in "), _c('em', [_vm._v("Hazelwood")]), _vm._v(" for the proposition that a high school is not a traditional public forum. 484 U.S. at 267–68. But "), _c('em', [_vm._v("Hazelwood")]), _vm._v(" is not at all in point. The only forum issue there was “whether "), _c('em', [_vm._v("Spectrum")]), _vm._v(" may appropriately be characterized as a forum for public expression.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 267 (emphasis added). "), _c('em', [_vm._v("Spectrum")]), _vm._v(" of course was an officially sponsored school newspaper produced for academic credit in a journalism class. In the context of that forum, it was entirely appropriate to focus on the school’s intention to create “a supervised learning experience for journalism students.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 569. Here the constitutional forum is the school’s buildings and empty classrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS assumes, and some of the dictum in "), _c('em', [_vm._v("Hazelwood")]), _vm._v(" may be read to assume, that if a school is not a traditional forum for the whole public, then it can be only a limited forum, so that the openness of the forum depends wholly on the school’s intent. But the exclusion of the general public does not entail, either as a matter of logic or policy, that the speech rights of the students and faculty be wholly subjected to the will of the school board. "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 1, at 45–51 [in this volume at 56–62]. Restrictions on the persons who have access to the property is a wholly separate issue from restrictions on the speech rights of those who do not have access. The three categories of forums recognized in "), _c('em', [_vm._v("Cornelius")]), _vm._v(" cannot be understood to have collapsed these two issues into one, because "), _c('em', [_vm._v("Cornelius")]), _vm._v(" itself recognized the possibility of a traditional public forum limited to students. 473 U.S. at 803. Nor can "), _c('em', [_vm._v("Hazelwood")]), _vm._v(" be understood to have overruled all the earlier cases on the speech rights of students and faculty, because the newspaper at issue there was so unambiguously sponsored by the school.")])]), _c('h1', {
    staticClass: "sec7l"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('strong', [_vm._v("2. WHS’s Policy Violates Rights of Free Speech and Association Even If the School Is Not Characterized as a Traditional Forum.")])])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "HPara0"
  }, [_vm._v("The speech and association issues in this case can also be decided without characterizing the school as a forum. The absence of a forum means restrictions on access: on who can come to the property, or who can publish in the official school paper. But it does not follow merely from the absence of a forum that the school can censor the speech of students who are in a place where they have a right to be. The presence of a forum may create speech rights that did not previously exist, but the absence of a forum is not a license to censor everyone who has a right to be there. The Court recognized this distinction and held the issue open in "), _c('em', [_vm._v("Board of Airport Commissioners v. Jews for Jesus, Inc.")]), _vm._v(", 482 U.S. 569, 573 (1987).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The students here seek to meet only when the school is open, when they are entitled to be on campus, and when they are not required to be in class. The school recognizes their right to use empty meeting spaces so long as the use is not regular. Pet. Br. 13. Thus, the students seek to speak and to associate for the purpose of group speech in a place where they have a right to be. They seek to speak “on the campus during the authorized hours.” "), _c('em', [_vm._v("Hazelwood")]), _vm._v(", 484 U.S. at 266, quoting "), _c('em', [_vm._v("Tinker")]), _vm._v(", 393 U.S. at 512–13. The school cannot suppress the exercise of that right except to protect disruption of the educational process, "), _c('em', [_vm._v("Tinker")]), _vm._v(", or to teach a lesson it is entitled to teach, as in "), _c('em', [_vm._v("Bethel")]), _vm._v(" and "), _c('em', [_vm._v("Hazelwood.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS’s suppression of voluntary associations goes much further. School officials claim a monopoly over the initiation of topics for group discussion. No organized group can meet to discuss any topic not sponsored by the school. No organized group can meet to advocate anything. Pet. Br. 11. WHS’s insistence that no group can meet without school sponsorship violates the most basic tenets of a free society. “In our system, students may not be regarded as closed-circuit recipients of only that which the State chooses to communicate.” "), _c('em', [_vm._v("Tinker")]), _vm._v(", 393 U.S. at 511. But that is how WHS regards them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Apparently recognizing that these policies would be wholly indefensible if applied to individual speech, WHS emphasizes that individual students can discuss whatever they want. Pet. Br. 6, 13, 51. But WHS draws the line at an organized group. It is as though speech were a purely individual right, and this Court had never decided a case on freedom of association.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But of course that is not the law. The right to associate for political and religious speech is fundamental. As Professor Tribe has noted, one can imagine a legal system in which only individual speech was protected, and association for group speech was a punishable conspiracy, but that is not our system. Laurence H. Tribe, "), _c('em', [_vm._v("American Constitutional Law")]), _vm._v(" 1014 (2d ed., Foundation Press 1988).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("The mere fact that the students want to meet as a group does not distinguish this case from other high school free speech cases, such as "), _c('em', [_vm._v("Tinker.")]), _vm._v(" As this Court held in "), _c('em', [_vm._v("Healy v. James")]), _vm._v(", 408 U.S. 169, 181–82 (1972), students’ right to association includes the right to meet in campus facilities and use the school’s channels of communication. And if the school makes those rights dependent on official recognition as a student organization, then the right to association includes the right to official recognition. "), _c('em', [_vm._v("Id.")])])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Here there is no claim that the plaintiffs’ club would be disruptive. There is no claim that suppression of plaintiffs’ club teaches any valuable lesson. There are only legal claims that misunderstand the law. WHS relies on the Establishment Clause, but the Establishment Clause will not be violated. It relies on its policy of suppressing every group it does not sponsor, but that is simply a negation of the constitutional right of association. Once these legal claims are rejected, there remains no legitimate educational interest in suppressing the plaintiffs’ club.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. WHS’s Policy Violates Plaintiffs’ Right to Free Exercise of Religion.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Restrictions on religious speech violate the Free Exercise Clause as well as the Free Speech Clause. "), _c('em', [_vm._v("Largent v. Texas")]), _vm._v(", 318 U.S. 418, 422 (1943). This is no mere formalistic redundancy. Religious speech is singled out for special protection in the constitutional text. The Free Exercise Clause makes clear what would otherwise be left to implication: that religious speech is at the very core of the First Amendment, one of the most protected categories of speech. The religious speech at issue here is not minimally protected, like the vulgar speech in "), _c('em', [_vm._v("Bethel.")]), _vm._v(" Rather, it is maximally protected, like the political speech in "), _c('em', [_vm._v("Tinker.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Similarly, religious association is protected by the Free Exercise Clause. “For many individuals, religious activity derives meaning in large measure from participation in a larger religious community.” "), _c('em', [_vm._v("Corporation of the Presiding Bishop v. Amos")]), _vm._v(", 483 U.S. 327, 342 (1983) (Brennan, J., concurring). Simple meetings of religious groups—meeting in a place where each member of the group has a right to be—cannot be suppressed without some substantial reason. WHS’s reasons consist only of its misunderstanding of the Establishment Clause and its unconstitutional desire to sponsor and control every group that meets on campus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("WHS’s policy also violates the Free Exercise Clause because it discriminates against religion. Part of the central message of the Religion Clauses is that government must be neutral toward religion. “Neither sponsorship nor hostility” is permitted. "), _c('em', [_vm._v("Walz v. Tax Commission")]), _vm._v(", 397 U.S. 664, 672 (1970). Discrimination against religion violates the Free Exercise Clause because it evidences hostility. "), _c('em', [_vm._v("Hobbie v. Unemployment Appeals Commission")]), _vm._v(", 480 U.S. 136, 142 n.7 (1986).")])]), _c('h1', {
    staticClass: "sec4bq1"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('strong', [_vm._v("Conclusion")])])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("This Court should affirm the judgment of the court of appeals on statutory grounds. The Equal Access Act applies and is dispositive; WHS’s contrary interpretation would eviscerate the Act.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Act is constitutional. It requires that WHS allow the plaintiffs’ club to meet without sponsorship. Without sponsorship, there is no Establishment Clause issue.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Construing the Act in this way makes it unnecessary to decide plaintiffs’ constitutional claims, but those claims are also sufficient to support the judgment below.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("As more fully explained in the short article that follows, this case ended in a decisive win for student free speech and the Equal Access Act. The Court rejected constitutional challenges to the Act; equally important, it interpreted the Act in a way that would enable it to work. It said that deference to the discretion of school boards would make the Act ineffective, and it required a tight connection in deciding whether a club was related to the curriculum. It was 8–1 on the result, although the majority divided on the constitutional issue and offered three different explanations of how the Act was consistent with the Establishment Clause.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Justice O’Connor’s plurality opinion on the constitutional issue said that “there is a crucial difference between")]), _vm._v(" government "), _c('em', [_vm._v("speech endorsing religion, which the Establishment Clause forbids, and")]), _vm._v(" private "), _c('em', [_vm._v("speech endorsing religion, which the Free Speech and Free Exercise Clauses protect.” This distinction became the focus of much future litigation on religious speech. And she said: “The proposition that schools do not endorse everything they fail to censor is not complicated”—pretty much a direct quote from my Northwestern article, but without attribution. Inexplicably, I had failed to get that sentence into the brief. She did cite the article for several other points.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_315",
      "id": "fn1-315"
    }
  }, [_vm._v("1.")]), _vm._v(" Amici do not claim that Cheerleaders alone would trigger application of the Equal Access Act. It may be that cheerleaders are such official spokespersons for their school that they are not a student group at all for purposes of the Act. "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 Nw. U.L. Rev. 1, 41 (1986) [in this volume at 51] (discussing debate team, school play, and school chorus). The testimony in text is quoted to show Dr. Findlay’s all-inclusive definition of curriculum.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_316",
      "id": "fn1-316"
    }
  }, [_vm._v("2.")]), _vm._v(" It is not seriously disputed that this is what the statute means. Certain syntactical ambiguities in the literal text are analyzed and explained in Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 1, at 42–45 [in this volume at 53–56].")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("The Students Won! The Supreme Court Enforces the Equal Access Act")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('h1', {
    staticClass: "sec3-a",
    attrs: {
      "id": "sec3-3"
    }
  }, [_c('em', [_vm._v("Christian Legal Society Quarterly 17 (Summer 1990)")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("This is a short explanation of the")]), _vm._v(" Mergens "), _c('em', [_vm._v("decision for a publication of the Christian Legal Society. I had no influence on the title.")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Voluntary student religion clubs have finally won the right to meet in public schools. In a June 4, 1990 decision in "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(", the Supreme Court upheld the Equal Access Act, which Congress passed in 1984. Equally important, it interpreted the Act in a way that should make it readily enforceable.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("CLS filed an amicus brief in the case, along with six other religious organizations. Much of Justice O’Connor’s majority opinion tracked the reasoning in the CLS brief and only Justice Stevens dissented.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition to declaring the Act constitutional, the Court addressed the Act’s controversial triggering mechanism, the presence of at least one “noncurriculum related student group.” But Congress left that key phrase undefined. Therefore, Westside High insisted all its clubs were curriculum related, including the chess, scuba diving, and the Rotary-sponsored service clubs.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In its decision, the Court focused on the congressional purpose “to end discrimination by allowing students to meet and discuss religion before and after class.” To achieve this purpose, Congress intended “a low threshold for triggering the Act’s requirements.” Supporting congressional intent, the Court held that to avoid triggering the Act every student group must “directly relate to the body of courses offered by the school.”")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("In our view, a student group directly relates to a school’s curriculum if the subject matter of the group is actually taught, or soon will be taught, in a regularly offered course; if the subject matter of the group concerns the body of courses as a whole; if participation in the group results in academic credit.")])]), _c('p', {
    staticClass: "BodySb"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("This standard seems clear except for groups that concern “the body of courses as a whole.” The Court said this refers to student government, but only “to the extent that it addresses concerns, solicits opinions and formulates proposals pertaining to the body of courses offered by the school.”")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court’s standard is so objective and resistant to rationalization that the Act should clearly apply in most high schools. The Court also clarified the rights that come with equal access; religion clubs cannot have faculty sponsors or school endorsement, but they are entitled to access to the school newspaper, bulletin boards, public address system, and the annual Club Fair.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The majority divided 2–4–2 on the claim that the Act violates the Establishment Clause. Four Justices thought students would understand that letting student religion clubs meet reflects neutrality rather than sponsorship. “The proposition that schools do not endorse everything they fail to censor is not complicated.” Justices Kennedy and Scalia concurred, urging their position that government is free to endorse religion. They thought the key point was that schools could not coerce students to participate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Justices Marshall and Brennan also concurred, but they had more doubts. At least for a while, the Christian club may be the only club not sponsored and endorsed by the school. In that environment, students might reasonably assume that the school sponsors the Christian club just as it sponsors all the other clubs. Marshall and Brennan insisted that the school affirmatively disclaim its sponsorship of the Christian club. Justice O’Connor’s opinion agreed that such a disclaimer would help students understand the school’s relationship to religion, although it stopped short of saying that such disclaimers were required.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In my judgment, the religious community should not resist such disclaimers. Rather, the religious community should help school officials write them; otherwise, the disclaimer may imply hostility instead of neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("An appropriate disclaimer could be a tribute to religious liberty. It would say that schools in America do not sponsor religion clubs because religion in America is left wholly to the private choices of individuals and families. Students of any faith or of no faith are free to form voluntary organizations, and they are free to meet on campus, but the school is not free to sponsor them or interfere with them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever happens in future implementation of the Act, the decisive battle has been won. Six years after the Act’s passage and nearly fifteen years and as many cases after the first litigation on the subject, the principle of equal access for religious speech is finally secure.")])]), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-4"
    }
  }, [_c('em', [_vm._v("515 U.S. 819 (1995)")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_vm._v("Amicus Brief")]), _vm._v(" "), _c('p', {
    staticClass: "Quote"
  }, [_c('em', [_vm._v("Brief Amici Curiae of Christian Legal Society, Christian Life Commission of the Southern Baptist Convention, Family Research Council, Home School Legal Defense Association, and National Association of Evangelicals (December 15, 1994)")])]), _vm._v(" "), _c('p', {
    staticClass: "LAuthor"
  }, [_vm._v("With Steven T. McFarland and Samuel B. Casey")]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("I have always made it a rule not to sue or litigate against my employer; this brief was filed more than fifteen years before I arrived at the University of Virginia. The University subsidized a broad range of student organizations, including student publications, but refused to subsidize publications that were too overtly religious. The funds were administered by a student committee, and the lines it drew were far from clear. The committee denied funding to an evangelical Christian magazine, and the students who edited the magazine sued the University.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The case presented a square conflict between the principle of government neutrality toward religion and the principle of no government funding for religion. This brief takes both principles seriously and offers substantive neutrality as the way to resolve the conflict between them. The University’s discriminatory funding rules skewed the debate on Grounds and pressured religious publications to water down their message to qualify for funding. The neutral course was to fund everybody or nobody. Discriminatory funding was the worst possible policy. (Virginia doesn’t have a campus; it has Grounds.)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The Equal Access Act does not apply to higher education; the claim here was under the Free Speech Clause. Between")]), _vm._v(" Mergens "), _c('em', [_vm._v("and")]), _vm._v(" Rosenberger, "), _c('em', [_vm._v("the Court had unanimously invoked the Free Speech Clause to protect the right of a religious community group to rent a high school auditorium on the same terms as other community groups.")]), _vm._v(" Lamb’s Chapel v. Center Moriches Union Free School District "), _c('em', [_vm._v("(1993). But that case did not involve government money; this case did.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Steve McFarland and Sam Casey were the lawyers for the Christian Legal Society.")])])]), _c('h1', {
    staticClass: "sec4b"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('strong', [_vm._v("Interest of the "), _c('em', [_vm._v("Amici")])])])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The interest of each "), _c('em', [_vm._v("amicus curiae")]), _vm._v(" is set forth in the appendix to this brief. The letters from the parties consenting to the filing of this brief have been filed with the Clerk of the Court.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Statement of the Case")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Amici")]), _vm._v(" adopt the Statement of the Case in the Brief of Petitioners.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Summary of Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("This case lies at the intersection of two familiar principles from the American tradition of religious liberty. Petitioners rely on the neutrality principle; respondents rely on the no-funding principle. These "), _c('em', [_vm._v("amici")]), _vm._v(" attempt to resolve the conflict in a non-arbitrary manner by examining the deeper principles and policies that underlie the positions of the parties.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Substantive neutrality, defined as minimizing government influence on religion, directly serves the ultimate goal of maximizing religious liberty for both believers and nonbelievers. The no-funding principle has often served this goal instrumentally, but on these facts it does not. The policies of the no-funding principle are better served by no funding or by universal funding; the worst possible policy is discriminatory funding, which is the University’s policy.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This brief also examines the principal historical controversies that made the no-funding principle prominent in the American understanding of religious liberty. The general assessment proposal in 1784–85 would have funded only religious activities, thus violating both the neutrality and the no-funding principles. The University’s discriminatory funding of non-religious and anti-religious speech is in some ways the mirror image of the general assessment; neutral funding of all viewpoints would be better than discriminatory funding of either side.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The other great historical precedent is nineteenth-century Catholic complaints about the Protestant establishment in public schools and the corresponding movement to ban funding of Catholic schools. Nativist Protestants convinced themselves that Protestant religious observances in the public schools were neutral, but that Catholic schools were sectarian. The University has committed an analogous fallacy in claiming that its subsidy of non-religious and anti-religious speech is neutral, and that funding "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" would be a forbidden support for religion.")])]), _c('h1', {
    staticClass: "sec4b"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('strong', [_vm._v("Argument")])])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("I. The Conflict Between the Neutrality Principle and the No-Funding Principle Can Be Resolved by Underlying Principles of Religious Liberty and Substantive Neutrality.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The Conflicting Principles.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("This case lies at the intersection of two familiar principles from the American tradition of religious liberty. The neutrality principle directs that government be neutral toward religion,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-317",
      "id": "fn1_317"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" neither “advanc[ing] nor inhibit[ing]” religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-318",
      "id": "fn1_318"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Government may not endorse religion, but neither may it “disapprove” religion"), _c('a', {
    attrs: {
      "href": "#/#fn1-319",
      "id": "fn1_319"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" or endorse the view that religion is wrongheaded or irrelevant.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Because we are here dealing with speech, the neutrality principle of the Religion Clauses is reinforced by the content neutrality and viewpoint neutrality principles of the Free Speech Clause."), _c('a', {
    attrs: {
      "href": "#/#fn1-320",
      "id": "fn1_320"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" has published Christian perspectives on racism, sexuality, eating disorders, economic policy, and other contemporary issues."), _c('a', {
    attrs: {
      "href": "#/#fn1-321",
      "id": "fn1_321"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" These facts thus illustrate once again what the Court unanimously recognized two years ago: religion is not only a subject matter, but also a source of viewpoints on a wide range of contemporary issues."), _c('a', {
    attrs: {
      "href": "#/#fn1-322",
      "id": "fn1_322"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A second principle, equally familiar, is the no-funding principle: government should generally not fund religious functions."), _c('a', {
    attrs: {
      "href": "#/#fn1-323",
      "id": "fn1_323"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Government may sometimes fund secular functions performed by religious organizations,"), _c('a', {
    attrs: {
      "href": "#/#fn1-324",
      "id": "fn1_324"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" but those "), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("cases are no precedent for funding religious functions. There is no dispute that the speech to be funded here is religious and that it falls within the natural scope of the no-funding principle.")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("The neutrality and no-funding principles have generally seemed to be consistent, and the Court has only occasionally been forced to choose between them. When the Court has been forced to choose, the neutrality principle has prevailed. The clearest example is the Court’s unanimous holding that state scholarships for the blind may be applied to the purely religious program of studying for the ministry in a Bible college.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-325",
      "id": "fn1_325"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Somewhat analogously, the Court has held that property committed to religious uses may be exempted from taxation pursuant to a neutral scheme of tax exemption for a wide range of secular and religious organizations."), _c('a', {
    attrs: {
      "href": "#/#fn1-326",
      "id": "fn1_326"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" And no one has ever brought an Establishment Clause challenge to the income-tax deductibility of contributions to religious organizations. These deductions are not mere tax exemptions; they offset tax that would be due on the taxpayer’s salary and investment income. They are therefore like a matching grant to the taxpayer for every contribution. The justification must be that religious contributions are neutrally included in a broad range of contributions to analogous organizations, and that the neutrality principle controls over the no-funding principle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Here the two principles squarely conflict. The University of Virginia funds a class of student publications that naturally includes religious publications. The neutrality principle forbids the discriminatory exclusion of religious publications. But the University argues, and the court of appeals held, that including the religious publications would violate the no-funding principle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ultimate question presented is thus to specify the relationship between these conflicting principles in the context of religious speech. Are the neutrality principles of the Religion and Speech Clauses subordinate to the no-funding principle, as the court of appeals assumed? Or is it the other way around, as this Court has held in other contexts? Or is there some underlying principle that unites these principles and makes their relationship clear?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('strong', [_c('em', [_vm._v("B. Substantive Neutrality: Maximizing Religious Liberty by Minimizing Government Influence.")])])])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("There is such an underlying principle. The ultimate goal of the Religion Clauses is religious liberty for all—for believer and nonbeliever, for Christian and Jew, for Protestant and Catholic, for Western traditions and Eastern, for large faiths and small, for atheist and agnostic, for secular humanist and the religiously indifferent, for every individual human being in the vast mosaic that makes up the American people. The ultimate goal is that every American should be free to hold his own views on religious questions, and to live the life that those views direct, with a minimum of government interference or influence.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The neutrality principle serves this ultimate goal directly. By forbidding government to take positions on religious questions, the neutrality principle minimizes government influence on religious choice, and thus leaves maximum room for private influence and private choice.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The no-funding principle serves this ultimate goal instrumentally. Government money is a powerful source of government influence; government expenditures on religion generally expand government influence in a field where that influence should be minimized. Describing the same point from the private perspective, voluntary funding of religious organizations generally maximizes individual liberty and the influence of private choice. Each individual can decide when, how, and how much to contribute to whom, and whether to contribute at all. Voluntary funding of religious organizations protects individual conscience and keeps government out of religion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These themes of liberty, neutrality, and voluntarism can be integrated into a single standard of substantive neutrality:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("[S]ubstantive neutrality [means] this: the religion clauses require government to minimize the extent to which it either encourages or discourages religious belief or disbelief, practice or nonpractice, observance or nonobservance.… [R]eligion should be left as wholly to private choice as anything can be. It should proceed as unaffected by government as possible.…")])]), _c('p', {
    staticClass: "QuoteInd"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("This elaboration highlights the connections among religious neutrality, religious autonomy, and religious voluntarism. Government must be neutral so that religious belief and practice can be free. The autonomy of religious belief and disbelief is maximized when government encouragement and discouragement is minimized. The same is true of religious practice and refusal to practice. The goal of maximum religious liberty ")]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("can help identify the baseline from which to measure encouragement and discouragement.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-327",
      "id": "fn1_327"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("This elaboration of substantive neutrality synthesizes seemingly separate strands in the American tradition of religious liberty. It attempts to clarify this Court’s traditional emphasis on neutrality, to defend that emphasis against academic critics,"), _c('a', {
    attrs: {
      "href": "#/#fn1-328",
      "id": "fn1_328"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" and to show how neutrality relates to liberty and to voluntarism. This synthesis points the way to a principled resolution here, where each side relies on a different strand from the religious liberty tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This definition of substantive neutrality contrasts with formal neutrality, the mere absence of religious classifications."), _c('a', {
    attrs: {
      "href": "#/#fn1-329",
      "id": "fn1_329"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" The University’s policy obviously violates formal neutrality, because it expressly defines “religious activities” as a basis for adverse treatment. These "), _c('em', [_vm._v("amici")]), _vm._v(" think it more significant that the University’s policy also violates substantive neutrality.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The ultimate goal is to maximize religious liberty for believers and nonbelievers alike. The no-funding principle is instrumental—it serves religious liberty under a familiar range of circumstances. But refusal of funding does not serve religious liberty under present circumstances at the University of Virginia.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("II. Substantive Neutrality Requires Funding for")]), _vm._v(" Wide Awake.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bia"
  }, [_c('strong', [_c('em', [_vm._v("A. Government Speech and Private Speech.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The most basic distinction in this case is between religious speech by private citizens and religious speech by government. “[T]here is a crucial difference between "), _c('em', [_vm._v("government")]), _vm._v(" speech endorsing religion, which the Establishment Clause forbids, and "), _c('em', [_vm._v("private")]), _vm._v(" speech endorsing religion, which the Free Speech and Free Exercise Clauses protect.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-330",
      "id": "fn1_330"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" Private citizens are free to take any position on "), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("religious matters; they are under no obligation to remain neutral. But religious speech by government is forbidden or severely restricted. “The Establishment Clause, at the very least, prohibits government from appearing to take a position on questions of religious belief.…”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-331",
      "id": "fn1_331"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Government must maintain its neutrality toward religion either by silence on the subject, or by carefully balanced comments, as in a course on comparative religion."), _c('a', {
    attrs: {
      "href": "#/#fn1-332",
      "id": "fn1_332"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Both the protections for private speech and the restrictions on government speech follow from the neutrality principle:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("The government must be neutral both in its own speech and in its treatment of private speech. It may not take a position on questions of religion in its own speech, and it must treat religious speech by private speakers exactly like secular speech by private speakers."), _c('a', {
    attrs: {
      "href": "#/#fn1-333",
      "id": "fn1_333"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "BodySb"
  }, [_vm._v("In a mixed economy, the line between government and the private sector is sometimes difficult to discern. But the task cannot be avoided; the distinction between private and governmental practice of religion is fundamental to the Religion Clauses. The line need not be drawn arbitrarily, or on the basis of a sterile debate over definitions. The principle of substantive neutrality—the ultimate goal of maximizing religious liberty and minimizing government influence on religion—can provide a reasoned basis for drawing the line in close cases.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Substantive Neutrality and Student Publications.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The University of Virginia has chosen to enhance private speech by subsidizing student publications. The University is not promulgating any message of its own; indeed, it carefully insists that its funding of student organizations does not mean that it “approves” of the organizations, their activities, or their publications."), _c('a', {
    attrs: {
      "href": "#/#fn1-334",
      "id": "fn1_334"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" These publications are not government speech in pursuit of some legitimate government interest. The only government interest is to neutrally enhance the quantity of serious discussion on the campus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Unfortunately, the University is enhancing private speech in a decidedly non-neutral way. It enhances a wide range of non-religious and anti-religious "), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("speech, but it does not enhance religious speech. It paid to print anti-Christian satires in "), _c('em', [_vm._v("The Yellow Journal")]), _vm._v(",")]), _c('a', {
    attrs: {
      "href": "#/#fn1-335",
      "id": "fn1_335"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" it paid to print a range of views on “Faith and Reason” in "), _c('em', [_vm._v("Thoughtlines")]), _vm._v(","), _c('a', {
    attrs: {
      "href": "#/#fn1-336",
      "id": "fn1_336"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" and it pays to print secular perspectives on a wide range of issues in fifteen different publications."), _c('a', {
    attrs: {
      "href": "#/#fn1-337",
      "id": "fn1_337"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" But it will not pay to print a Christian perspective on many of the same issues in "), _c('em', [_vm._v("Wide Awake")]), _vm._v(". It thus discriminates between different viewpoints about religion; it also discriminates between religious and secular viewpoints on contemporary social issues. There is more non-religious and anti-religious speech on the campus than there would be without the University’s enhancement. The University has interfered with the free flow of debate in the private sector, tilting the balance against religious views.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the University were spending equivalent sums to disseminate its own anti-religious messages, or its own claim that non-religious viewpoints exhaust the range of debate on contemporary social issues, the constitutional violation would be clear. The University’s discriminatory subsidy of private speech is analogous to these clear violations, although it is not identical because the University does not lend its own name and credibility to the private messages that it subsidizes. A closer analogy would be this: Suppose the University spent equivalent sums to publish anti-religious messages, or messages urging students to give thoughtful consideration “to the full range of secular viewpoints” on important issues, but it published this propaganda anonymously. Even though the University’s name was not attached, this commitment of public funds to reduce the influence of religion would surely be unconstitutional. The University cannot itself take positions on religious questions, or work to exclude religious viewpoints from public debate; neither can it do so indirectly by subsidizing some private viewpoints and not others. If the University subsidizes private speech, it must do so without regard to viewpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A fatal inconsistency lies at the heart of the University’s position. The University in effect contends that when it subsidizes non-religious or anti-religious speech, that speech remains private, so that the University has not opposed or marginalized religion. But when it subsidizes religious speech, that speech becomes public, so that the University is supporting religion and violating the Establishment Clause.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("The court of appeals made an equivalent error: “[I]t would be difficult to view awarding … monies to "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" as anything but state sponsorship—and therefore advancement—of religious belief.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-338",
      "id": "fn1_338"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" But if this be true, then it must be equally true that awarding money to "), _c('em', [_vm._v("The Yellow Journal")]), _vm._v(" is state sponsorship of anti-religious belief, and therefore “inhibition” of religion. Neither the court of appeals nor the University can have it both ways.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The University can subsidize the full range of student speech, or it can subsidize no student speech. Or it can subsidize only that student speech that it is willing and legally able to sponsor as an official university publication. Or it can subsidize publications selected on some neutral criterion, such as those publications that serve the largest number of students. But it cannot subsidize private publications selected in whole or in part on the basis of viewpoint. It cannot subsidize only non-religious and anti-religious speech any more than it could subsidize only religious speech.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("III. The Policies of the No-Funding Principle Are Better Served by Universal Funding Than by Discriminatory Funding.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The no-funding principle is not an end in itself; it is a means to the end of religious liberty. In a wide range of circumstances, government funding of religious functions threatens religious liberty. Compliance with the no-funding principle generally reduces government influence on the climate of religious opinion, and thus conduces to compliance with the neutrality principle. Discretionary funding decisions can distort religious missions; religious groups may tailor their message to qualify for funding. Government is more likely to assert improper control over religious functions if it funds them. And many taxpayers object to being forced to support religious opinions involuntarily, and especially to supporting religious opinions with which they disagree.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Under the current rules at the University of Virginia, one of these reasons for the no-funding principle is of little weight, and the rest have actually become arguments for further funding. We will consider each of these reasons in turn, but the general point is this: The University has already breached the no-funding rule and run afoul of all its policies. The University only makes matters worse by trying to fund some private opinions and not others. The only way to achieve the policies of the no-funding rule is to fund nobody or everybody—to abandon the Student Activities Fund entirely, or to abandon the exclusion of religious views.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('strong', [_c('em', [_vm._v("A. Neutrality.")])])])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The University has not refrained from influencing the climate of religious opinion. Rather, as described above, it is directing its money and influence against religion. It is already flouting the neutrality principle. Because it is already funding non-religious and anti-religious speech, funding religious speech as well would bring it back into compliance with the neutrality principle.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Distortion of Religious Messages.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("Similarly, it is the University’s current policy that requires discretionary decisions that distort religious messages. The University’s conception of a “religious activity” is ill-defined, and administered in the first instance by inexperienced undergraduates. The Muslim Students Association, which sponsors speakers and publishes a magazine, is funded.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-339",
      "id": "fn1_339"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" The Jewish Law Students Association, which exists to “encourage Jewish law students to participate in Jewish activities,” is funded."), _c('a', {
    attrs: {
      "href": "#/#fn1-340",
      "id": "fn1_340"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" The C. S. Lewis Society, which promotes discussion of “literary, moral, and philosophical topics, with a particular emphasis on the work of the ‘Oxford Christians,’”"), _c('a', {
    attrs: {
      "href": "#/#fn1-341",
      "id": "fn1_341"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" is funded—because, the University says, it does not proselytize."), _c('a', {
    attrs: {
      "href": "#/#fn1-342",
      "id": "fn1_342"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" Black Voices was funded in 1990–91, when it sang “gospel music as a Black cultural activity,” but not in 1991–92, when it began “evangelizing as a religious group.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-343",
      "id": "fn1_343"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" is not funded, apparently because it takes its Christianity too seriously."), _c('a', {
    attrs: {
      "href": "#/#fn1-344",
      "id": "fn1_344"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("There is a clear message to the Muslim Students, the Jewish Law Students, the C. S. Lewis Society, and any other religious student groups that may need or desire University funding. They may be funded so long as they keep their religious message muted. They may be funded if they claim to discuss religion as a cultural artifact and not as a living belief system. Or perhaps they may be funded if they discuss their religion among themselves and do not try to share it with anyone else. The line is not clear; they had best play it safe. These groups can evolve only on lines acceptable to the University, unless they are able and willing to give up their funding. There is an equally clear message to "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" and Black Voices: if you really need funding, tone down your message, disguise yourselves as cultural, and apply again next year.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("This is exactly the problem the no-funding rule is designed to avoid. The problem is inherent once the University begins to fund a wide range of student groups. The problem would not be avoided by pushing the line back and excluding even more religious speech. That would aggravate the anti-religious discrimination in the system, but it would not relinquish the University’s control over groups that need or desire funding. Some places to draw the line may be clearer than others, but wherever the University draws the line, it will be controlling the student groups that fall near it.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Once the University undertakes the business of subsidizing student speech, the only way to avoid control and to approximate neutrality is to fund all student speech, including religious speech, without regard to viewpoint. If there are not enough funds for all that apply, the selection criteria should be unrelated to viewpoint and as objective and nondiscretionary as possible. Funding some viewpoints but not others maximizes control; on these facts, expanding funding would relinquish control.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("C. Deliberate Assertions of Control.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The distortion of religious messages under the current program is the natural result of the University’s effort to enforce its discriminatory eligibility criteria. Eliminating the discriminatory criteria would largely solve that problem. But a related risk would remain: when government pays the bills, it is more likely to assert control. The University may at some point demand the right to edit or censor funded student publications.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("This is a political risk that may or may not come to pass; it is not an inherent or inevitable consequence. The risk is present for all the groups currently funded, and the University has structured the program to minimize the risk. It has stated that it does not control or approve the activities of any funded group,")]), _c('a', {
    attrs: {
      "href": "#/#fn1-345",
      "id": "fn1_345"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" and so far as this record shows, it has kept its word.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the University succumbed to the temptation to exercise control, it would fundamentally change the nature of the program. The purpose of the Student Activity Fund is not to promulgate the University’s message; its only purpose is to enhance student voices and activities. Thus, the current structure of the program provides substantial political protection against University control.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Moreover, so long as the program is structured in this way, there is legal protection against University control. So long as the University merely subsidizes private speech—that is, until and unless it says that subsidized student "), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("groups genuinely speak for the University and deliver the University’s message—it cannot legally censor their speech.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-346",
      "id": "fn1_346"
    }
  }, [_c('sup', [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the University were to assert sponsorship and control over funded programs, everything about this case would change. Many fewer student groups would be funded; the University could not in good faith adopt as its own all the disparate messages of the 118 groups currently funded. Certainly it could not adopt inconsistent messages as its own. No group would have a free speech right to have its message adopted as the University’s message. The University could not adopt religious messages as its own, but neither could it adopt anti-religious messages as its own. The neutrality principle of the Religion Clauses would continue to bind, but the University would have to comply by taking no position on religious questions. Given the University’s history of discrimination against religious viewpoints, any claim that it had closed the forum and adopted all messages as its own should be closely scrutinized for continued discrimination. But if the University bona fide quit funding any messages other than its own, the neutrality principle and the no-funding principle would then point to the same result.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Thus there is a real and recognizable difference between the University’s own speech and a University subsidy for a wide range of student organizations whose speech retains its constitutionally protected status as private speech. This difference means that the risk that the University will assert control is manageable. Under the current program, there are structural, political, and constitutional safeguards against improper assertions of control. Whatever risk remains is modest, and constitutionally far preferable to the gross departure from neutrality in the current distribution of funding."), _c('a', {
    attrs: {
      "href": "#/#fn1-347",
      "id": "fn1_347"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('strong', [_c('em', [_vm._v("D. Voluntarism.")])])])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("The presumptive no-funding principle also protects religious liberty by implementing the voluntarism principle. One application of the voluntarism principle is that taxpayers should not be forced to pay for religion, and especially other people’s religion, with tax dollars. Here, the taxpayers are students who pay a student activity fee of $14 per semester.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-348",
      "id": "fn1_348"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But the voluntarism principle was breached long ago, and universal funding would make things better instead of worse. Students at the University of Virginia are already forced to support opinions about religion with which they disagree. Christian students are forced to support the "), _c('em', [_vm._v("Yellow Journal")]), _vm._v(", which openly mocks Christianity. Christian, Hindu, Buddhist, and atheist students are forced to support the Muslim and Jewish student organizations, which reject the central tenets of Christianity and other faiths and belief systems on campus. Evangelical Christians are forced to support the C. S. Lewis Society, which emphasizes rather different lessons from Christianity than those emphasized by "), _c('em', [_vm._v("Wide Awake")]), _vm._v(", and the Lesbian and Gay Student Union,"), _c('a', {
    attrs: {
      "href": "#/#fn1-349",
      "id": "fn1_349"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" which promotes a very different view of human sexuality than "), _c('em', [_vm._v("Wide Awake")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nondiscriminatory funding would improve this situation in two related ways. First, it would distribute the burden evenly. As it stands now, students of all faiths and viewpoints must contribute to the fund, but only some faiths and viewpoints can draw from the fund. Nondiscriminatory funding would end that imbalance. Everyone would have to support some things he disagreed with, but it would also be more likely that everyone could find some group that gave him his $14 worth.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, nondiscriminatory funding would provide a neutral and secular rationale for the whole program. Students would no longer be taxed merely to support certain viewpoints; they would no longer be taxed merely to support non-religious and anti-religious speech. Rather, they would be taxed to neutrally enhance the full range of speech. “The provision of benefits to so broad a spectrum of groups is an important index of secular effect.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-350",
      "id": "fn1_350"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Similarly, it “would have a secular purpose and would avoid entanglement with religion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-351",
      "id": "fn1_351"
    }
  }, [_c('sup', [_vm._v("35")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('strong', [_c('em', [_vm._v("IV. The Historical Controversies That Gave Prominence to the No-Funding Principle Yield No Principled Support for the University’s Position.")])])])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "HPara"
  }, [_vm._v("The no-funding principle looms large in the American tradition of religious liberty because of two historical controversies of great importance. These controversies are a source of understanding of the principle’s scope and rationale.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("A. The General Assessment.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Financing of churches was the central church-state issue of the 1780s, and immediate background to the adoption of the Establishment Clause in 1791. The single most famous American statement on disestablishment, James Madison’s "), _c('em', [_vm._v("Memorial and Remonstrance Against Religious Assessments")]), _vm._v(", was written in opposition to the general assessment bill in the Virginia legislature, which would have provided tax support for teachers of the Christian religion.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-352",
      "id": "fn1_352"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" If history settles anything in this area, it is that a general assessment would be unconstitutional.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But this case is not about a general assessment; indeed, nothing like the general assessment has been seriously proposed since repeal of the Massachusetts establishment in 1833. In the typical modern dispute about funding religious organizations, the state claims that it is funding some secular function performed by the church; those who object to funding claim that the function is really religious or that the secular function is insufficiently insulated from religious functions. And whether the function to be funded is religious or secular, modern funding programs always include both secular and religious organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In sharp contrast, the general assessment was a tax solely for the support of clergy in the performance of their religious functions. The assessment was “general” only in the sense that all Christian faiths were included. There were no significant numbers of non-Christians in the polity, so the assessment was effectively neutral among religions then represented in Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("However, it was not neutral as between religion and non-religion. The reason for supporting religious functions was not that they fell within the neutrally-drawn boundaries of some larger category of activities to be supported by the state. Rather, religion was to be singled out for special support because the state deemed it to be of special value.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("The essence of "), _c('em', [_vm._v("Wide Awake")]), _vm._v("’s claim to be included in the Student Activities Fund is to end discrimination between religious and non-religious viewpoints. But the essence of the general assessment was massive discrimination in favor of religious viewpoints: in a time of minimal government, religious viewpoints were to be singled out for a special subsidy. The no-funding principle as applied to the general assessment was fully consistent with the neutrality principle. But the no-funding principle as applied to "), _c('em', [_vm._v("Wide Awake")]), _vm._v(" is fundamentally inconsistent with the neutrality principle. Rejection of the general assessment is no precedent for refusing to fund "), _c('em', [_vm._v("Wide Awake")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Protestant-Catholic Conflict.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("The other great controversy that gave prominence to the no-funding principle was the nineteenth-century dispute over common schools. Over a period of decades, and amidst great controversy, Americans built up the public schools and withdrew funding from religious schools.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-353",
      "id": "fn1_353"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Thirty-two states adopted constitutional provisions expressly prohibiting public funding of religious schools."), _c('a', {
    attrs: {
      "href": "#/#fn1-354",
      "id": "fn1_354"
    }
  }, [_c('sup', [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This controversy, the details of which have been largely forgotten, is the source of the tradition that school funding is an especially important issue in the separation of church and state. And the continuing disputes over that issue are a principal source of the sense that “direct monetary subsidization … is a beast of an entirely different color”"), _c('a', {
    attrs: {
      "href": "#/#fn1-355",
      "id": "fn1_355"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v("—distinguishable from access to facilities and other rights subject to the neutrality principle.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The nineteenth-century resolution of the school-funding controversy arguably represents a political judgment on the constitutional questions raised by such funding. But there are difficulties with relying on that political judgment, even with respect to schools. It is especially dangerous to abstract from that judgment a bright-line rule that applies to all contexts and overrides competing principles of religious neutrality and freedom of speech. It is dangerous "), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("to reason from premises derived from an old dispute without examining the dispute and the premises.")])]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("One difficulty with reasoning from nineteenth-century rejection of funding for religious schools is that that rejection was not part of the background to the First Amendment. And although the movement against funding religious schools amended many state constitutions, it conspicuously failed in its attempt to amend the federal Constitution.")]), _c('a', {
    attrs: {
      "href": "#/#fn1-356",
      "id": "fn1_356"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Perhaps more important, the nineteenth-century movement was based in part on premises that were utterly inconsistent with the First Amendment. Although there were good arguments to be made on both sides, the nineteenth-century opposition to funding religious schools drew heavily on anti-Catholicism. Nativist opposition to Catholic immigration fluctuated after 1825, but it never disappeared. Anti-Catholic secret societies, such as the Know Nothings and the American Protective Association, occasionally grew large enough to influence elections,"), _c('a', {
    attrs: {
      "href": "#/#fn1-357",
      "id": "fn1_357"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" and there was occasional mob violence and burnings of Catholic churches and convents."), _c('a', {
    attrs: {
      "href": "#/#fn1-358",
      "id": "fn1_358"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The movement for a federal constitutional amendment began with President Grant’s 1875 warning against a potential national conflict “between patriotism and intelligence on the one side, and superstition, ambition and ignorance on the other.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-359",
      "id": "fn1_359"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" In context, there is no doubt that the feared source of “superstition, ambition and ignorance” was the Roman Catholic Church, rapidly growing from immigration, with its alleged papal conspiracy to dominate the country. The preventive that the President proposed was to “[e]ncourage free schools and resolve that not one dollar of money appropriated to their support, no matter how raised, shall be appropriated to the support of any sectarian school.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-360",
      "id": "fn1_360"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Catholics argued that Protestant religious practices in the public schools made those schools as sectarian as any private school. Public schools commonly read the King James Bible (“the Protestant Bible”) “without note or "), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("comment.”")]), _c('a', {
    attrs: {
      "href": "#/#fn1-361",
      "id": "fn1_361"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" Catholics noted that “the reading of the Scriptures as a public ceremony is as distinctive to them [Protestants], as the celebration of Mass would be to Catholics.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-362",
      "id": "fn1_362"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Senator James G. Blaine proposed a constitutional amendment to implement the President’s proposal. The Blaine Amendment would have codified the Protestant position by expressly permitting Bible reading in the public schools but forbidding any use of state or federal funds to support religious schools."), _c('a', {
    attrs: {
      "href": "#/#fn1-363",
      "id": "fn1_363"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" This amendment was narrowly defeated by Democrats in the Senate; one of Blaine’s supporters later denounced the Democrats as “the party of Rum, Romanism, and Rebellion.”"), _c('a', {
    attrs: {
      "href": "#/#fn1-364",
      "id": "fn1_364"
    }
  }, [_c('sup', [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whatever the merits of the tradition against state funding for church-affiliated schools, its origin was not a proud moment in our constitutional history. These nineteenth-century debates did not produce a principled resolution to a difficult problem. Badly tainted by anti-Catholicism, they produced instead a Nativist Protestant victory over Catholic immigrants. There was only a pretense of neutrality; the end result sustained a Protestant establishment in the public schools at public expense, with no relief for religious minorities. Major Jewish groups responded with their long effort to secularize the public schools;"), _c('a', {
    attrs: {
      "href": "#/#fn1-365",
      "id": "fn1_365"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" Catholics continued their long effort to build and finance private schools. In modern times, the Court has struggled with the difficult issues raised by the combination of secular and religious functions in church-affiliated schools, and those issues are of course not presented here.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The University’s position is essentially analogous to the position of the nineteenth-century Nativist Protestants. The University is far more inclusive, but it makes the same analytic error with respect to the groups it excludes. The University includes in its funding program non-religious, anti-religious, and even mutedly-religious voices. It excludes other religious voices. And it proclaims the program neutral and takes offense when the excluded voices object to its discrimination. The essential nature of the problem is not changed by whose ox is gored. It is irrelevant that anti-religious voices are now favored "), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("instead of disfavored, or that Protestant voices are now disfavored instead of favored. Discrimination in any direction violates the University’s obligation of substantive neutrality toward religion.")])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In an activist state with a mixed economy, there will arise many different issues concerning neutrality and funding, and different factual contexts will require different solutions. This Court must reason such issues out from first principles; we have tried to assist that process in the first three parts of this brief. The relevance of the nineteenth-century Protestant-Catholic conflict is principally as a warning not to beg questions. The Court should not unwittingly reason from a premise rooted in nineteenth-century anti-Catholicism.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4biq1"
  }, [_c('strong', [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The central command of the Religion Clauses is that government should minimize its influence on religious belief and practice. The University has violated that command. It has spent its funds to enhance private speech in discriminatory ways, distorting private debate in a manner that is hostile to religion in general and to "), _c('em', [_vm._v("Wide Awake")]), _vm._v("’s outspoken style of religion in particular. And it has distributed an entitlement on the basis of religion, thus pressuring students to choose secular activities over religious ones or to conform their religious activities to the University’s preferred mode.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The judgment should be reversed and the case remanded for entry of an order granting the petitioner students’ motion for summary judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("The Court ruled for the students on free speech grounds, and it rejected the University’s Establishment Clause defense, 5–4. The dissent was lengthy and bitter; the opinion of the Court was hedged with qualifications. And while not much has come of those specific qualifications, the opinion was confined to a very narrow scope in a casual footnote in")]), _vm._v(" Locke v. Davey "), _c('em', [_vm._v("(2004), a funding case. Articles addressing")]), _vm._v(" Davey "), _c('em', [_vm._v("are in this volume at 865 and in volume 1 at 126.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_317",
      "id": "fn1-317"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", County of Allegheny v. ACLU, 492 U.S. 573, 592–94 (1989); Roemer v. Board of Pub. Works, 426 U.S. 736, 745–47 (1976) (plurality opinion); Abington School Dist. v. Schempp, 374 U.S. 203, 215, 222, 225–26 (1963) [in this volume at 282]; Everson v. Board of Educ., 330 U.S. 1, 18 (1947).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_318",
      "id": "fn1-318"
    }
  }, [_vm._v("2.")]), _vm._v(" Lemon v. Kurtzman, 403 U.S. 602, 612 (1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_319",
      "id": "fn1-319"
    }
  }, [_vm._v("3.")]), _vm._v(" Wallace v. Jaffree, 472 U.S. 38, 56 n.42 (1985), quoting Lynch v. Donnelly, 465 U.S. 668, 690 (1984) (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_320",
      "id": "fn1-320"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Lamb’s Chapel v. Center Moriches Union Free Sch. Dist., 508 U.S. 384 (1993); Widmar v. Vincent, 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_321",
      "id": "fn1-321"
    }
  }, [_vm._v("5.")]), _vm._v(" Rosenberger v. Rector of the Univ. of Virginia, 18 F.3d 269, 272–73 & n.7 (4th Cir. 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_322",
      "id": "fn1-322"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(", 508 U.S. at 394.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_323",
      "id": "fn1-323"
    }
  }, [_vm._v("7.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Lemon v. Kurtzman, 403 U.S. 602, 619 (1971); Everson v. Board of Educ., 330 U.S. 1, 16 (1947).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_324",
      "id": "fn1-324"
    }
  }, [_vm._v("8.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Bowen v. Kendrick, 487 U.S. 589, 608–09 (1988) (sex education); Comm. for Pub. Educ. & Religious Liberty v. Regan, 444 U.S. 646, 657–59 (1980) (administration of mandatory testing and monitoring of student attendance); Roemer v. Board of Pub. Works, 426 U.S. 736 (1976) (cash grants to colleges and universities); Bradfield v. Roberts, 175 U.S. 291 (1899) (medical care).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_325",
      "id": "fn1-325"
    }
  }, [_vm._v("9.")]), _vm._v(" Witters v. Wash. Dept. of Servs. for the Blind, 474 U.S. 481 (1986). "), _c('em', [_vm._v("See also")]), _vm._v(" Zobrest v. Catalina Foothills Sch. Dist., 509 U.S. 1 (1993) (holding that state-paid sign language interpreter for the deaf may be used at Catholic high school to translate both secular and religious instruction).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_326",
      "id": "fn1-326"
    }
  }, [_vm._v("10.")]), _vm._v(" Walz v. Tax Comm’n, 397 U.S. 664, 672–73 (1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_327",
      "id": "fn1-327"
    }
  }, [_vm._v("11.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Formal, Substantive, and Disaggregated Neutrality Toward Religion")]), _vm._v(", 39 DePaul L. Rev. 993, 1001–02 (1990) [in volume 1 at 13–14].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_328",
      "id": "fn1-328"
    }
  }, [_vm._v("12.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Steven D. Smith, "), _c('em', [_vm._v("Symbols, Perceptions, and Doctrinal Illusions: Establishment Neutrality and the “No Endorsement” Test")]), _vm._v(", 86 Mich. L. Rev. 266 (1987). Professor Smith urged the Court to abandon “the illusion that substantive answers can be deduced from the formal idea of neutrality.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 331–32. Substantive neutrality moves beyond a mere “formal idea”; it defines “neutrality” in terms of the underlying substantive policies of the Religion Clauses.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_329",
      "id": "fn1-329"
    }
  }, [_vm._v("13.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Church of the Lukumi Babalu Aye, Inc. v. City of Hialeah, 508 U.S. 520, 561–63 (1993) (Souter, J., concurring); Laycock, "), _c('em', [_vm._v("supra")]), _vm._v(" note 11, at 999–1006 [in volume 1 at 11–19].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_330",
      "id": "fn1-330"
    }
  }, [_vm._v("14.")]), _vm._v(" Board of Educ. v. Mergens, 496 U.S. 226, 250 (1990) [in this volume at 81].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_331",
      "id": "fn1-331"
    }
  }, [_vm._v("15.")]), _vm._v(" County of Allegheny v. ACLU, 492 U.S. 573, 593–94 (1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_332",
      "id": "fn1-332"
    }
  }, [_vm._v("16.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Wallace v. Jaffree, 472 U.S. 38, 60–61 (1985); Stone v. Graham, 449 U.S. 39, 41–42 (1980); Abington School Dist. v. Schempp, 374 U.S. 203, 225 (1963).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_333",
      "id": "fn1-333"
    }
  }, [_vm._v("17.")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 Nw. U.L. Rev. 1, 3 (1986) [in this volume at 9].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_334",
      "id": "fn1-334"
    }
  }, [_vm._v("18.")]), _vm._v(" "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 18 F.3d at 270–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_335",
      "id": "fn1-335"
    }
  }, [_vm._v("19.")]), _vm._v(" "), _c('em', [_vm._v("See A Christmas Story")]), _vm._v(", 1 Yellow Journal No. 2; Andrew “Schnoogums” Wallace, "), _c('em', [_vm._v("Dick Hickner, Bully for Christ")]), _vm._v(", 1 Yellow Journal No. 3 at 14–15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_336",
      "id": "fn1-336"
    }
  }, [_vm._v("20.")]), _vm._v(" "), _c('em', [_vm._v("See")]), _vm._v(" Symposium on "), _c('em', [_vm._v("Faith and Reason")]), _vm._v(", 16 Thoughtlines No. 2 (Fall 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_337",
      "id": "fn1-337"
    }
  }, [_vm._v("21.")]), _vm._v(" The funding of these publications, including "), _c('em', [_vm._v("Thoughtlines")]), _vm._v(" and "), _c('em', [_vm._v("The Yellow Journal")]), _vm._v(", is in the record. "), _c('em', [_vm._v("See Rosenberger")]), _vm._v(", 18 F.3d at 271 & n.3. The Court can read these publications as it would read any other. For convenience, "), _c('em', [_vm._v("amici")]), _vm._v(" will attempt to have copies of the publications lodged with the Clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_338",
      "id": "fn1-338"
    }
  }, [_vm._v("22.")]), _vm._v(" "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 18 F.3d at 285.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_339",
      "id": "fn1-339"
    }
  }, [_vm._v("23.")]), _vm._v(" Jt. App. 89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_340",
      "id": "fn1-340"
    }
  }, [_vm._v("24.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_341",
      "id": "fn1-341"
    }
  }, [_vm._v("25.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" at 104.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_342",
      "id": "fn1-342"
    }
  }, [_vm._v("26.")]), _vm._v(" See Brief of Appellees in court of appeals at 16 n.7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_343",
      "id": "fn1-343"
    }
  }, [_vm._v("27.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_344",
      "id": "fn1-344"
    }
  }, [_vm._v("28.")]), _vm._v(" "), _c('em', [_vm._v("Id.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_345",
      "id": "fn1-345"
    }
  }, [_vm._v("29.")]), _vm._v(" "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 18 F.3d at 270–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_346",
      "id": "fn1-346"
    }
  }, [_vm._v("30.")]), _vm._v(" "), _c('em', [_vm._v("Compare")]), _vm._v(" FCC v. League of Women Voters, 468 U.S. 364, 399–401 (holding that cash subsidy to public television stations does not empower government to bar editorials on those stations); "), _c('em', [_vm._v("with")]), _vm._v(" Rust v. Sullivan, 500 U.S. 173, 192–200 (1991) (holding that when government pays private contractors to implement a government program, it can define the scope of the program and insist that no government money be diverted to other purposes); Hazelwood Sch. Dist. v. Kuhlmeier, 484 U.S. 260, 267–73 (1988) (holding that school could reasonably control content of school-sponsored newspaper produced in journalism class); "), _c('em', [_vm._v("see also")]), _vm._v(" Tex. Monthly v. Bullock, 489 U.S. 1 (1989) (striking down tax exemption that discriminated between religious and secular publications); Ark. Writers’ Project v. Ragland, 481 U.S. 221, 227–32 (1987) (striking down tax exemption that discriminated on basis of content of magazines). In the lower courts, this Court’s principle that government cannot censor subsidized private speech has been applied to subsidized student organizations. "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", Gay & Lesbian Students Ass’n v. Gohn, 850 F.2d 361 (8th Cir. 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_347",
      "id": "fn1-347"
    }
  }, [_vm._v("31.")]), _vm._v(" The distinction between government speech and subsidized private speech is also the central reason why the government’s support of its own public schools does not oblige it to fund private schools.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_348",
      "id": "fn1-348"
    }
  }, [_vm._v("32.")]), _vm._v(" "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 18 F.3d at 270.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_349",
      "id": "fn1-349"
    }
  }, [_vm._v("33.")]), _vm._v(" Jt. App. 65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_350",
      "id": "fn1-350"
    }
  }, [_vm._v("34.")]), _vm._v(" Widmar v. Vincent, 454 U.S. 263, 274 (1981), quoted with approval in Board of Educ. v. Mergens, 496 U.S. 226, 248 (1990) (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_351",
      "id": "fn1-351"
    }
  }, [_vm._v("35.")]), _vm._v(" "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. at 270–71; "), _c('em', [_vm._v("Mergens")]), _vm._v(", 496 U.S. at 248, 252–53 (plurality opinion).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_352",
      "id": "fn1-352"
    }
  }, [_vm._v("36.")]), _vm._v(" Both the "), _c('em', [_vm._v("Memorial and Remonstrance")]), _vm._v(" and the general assessment bill are reprinted in Everson v. Board of Educ., 330 U.S. 1, 63–74 (1947) (appendix to opinion of Rutledge, J., dissenting).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_353",
      "id": "fn1-353"
    }
  }, [_vm._v("37.")]), _vm._v(" For accounts of these developments and the associated controversies, see Charles Glenn, "), _c('em', [_vm._v("The Myth of the Common School")]), _vm._v(" (Univ. of Mass. Press 1988); James Hennesey, "), _c('em', [_vm._v("American Catholics: A History of the Roman Catholic Community in the United States")]), _vm._v(" 182–83, 185–86 (Oxford 1981); Carl F. Kaestle, "), _c('em', [_vm._v("Pillars of the Republic: Common Schools and American Society 1780–1860")]), _vm._v(" (Hill & Wang 1983); Diane Ravitch, "), _c('em', [_vm._v("The Great School Wars")]), _vm._v(" 3–76 (Basic Books 1974); Anson Phelps Stokes, 2 "), _c('em', [_vm._v("Church and State in the United States")]), _vm._v(" 47–72, 642–54, 681–86, 722–28 (Harper Bros. 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_354",
      "id": "fn1-354"
    }
  }, [_vm._v("38.")]), _vm._v(" For a list, see Carl Zollman, "), _c('em', [_vm._v("American Church Law")]), _vm._v(" §§ 65–66 at 78–80 (2d ed., West 1933). For additional background, see Glenn, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 251–53. For examples, see Cal. Const. art. IX, § 8; N.Y. Const. art. XI, § 3; Tex. Const. art. 7, § 5(a).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_355",
      "id": "fn1-355"
    }
  }, [_vm._v("39.")]), _vm._v(" "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 18 F.3d at 286.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_356",
      "id": "fn1-356"
    }
  }, [_vm._v("40.")]), _vm._v(" See "), _c('em', [_vm._v("infra")]), _vm._v(" at 27 [in this volume at 121].")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_357",
      "id": "fn1-357"
    }
  }, [_vm._v("41.")]), _vm._v(" "), _c('em', [_vm._v("See, e.g.")]), _vm._v(", David H. Bennett, "), _c('em', [_vm._v("The Party of Fear")]), _vm._v(" 105–16, 159–82 (Univ. of N. Carolina Press 1988); Donald L. Kinzer, "), _c('em', [_vm._v("An Episode in Anti-Catholicism: The American Protective Association")]), _vm._v(" 140–80 (Univ. of Washington Press 1964); 1 Stokes, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 825–38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_358",
      "id": "fn1-358"
    }
  }, [_vm._v("42.")]), _vm._v(" Kaestle, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 170; Ravitch, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 36, 66, 75; 1 Stokes, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 817–22, 824, 830–31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_359",
      "id": "fn1-359"
    }
  }, [_vm._v("43.")]), _vm._v(" Speech to the Army of the Tennessee (Sept. 29, 1875) (manuscript and typescript in the Ulysses S. Grant Papers in the Library of Congress; reproduced on reel 5 of the microfilm edition).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_360",
      "id": "fn1-360"
    }
  }, [_vm._v("44.")]), _vm._v(" "), _c('em', [_vm._v("Id.")]), _vm._v(" The President requested a constitutional amendment to this effect in his Annual Message to Congress (Dec. 7 1875), reprinted in James D. Richardson, 7 "), _c('em', [_vm._v("Messages and Papers of the Presidents")]), _vm._v(" 332, 334 (1898).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_361",
      "id": "fn1-361"
    }
  }, [_vm._v("45.")]), _vm._v(" For accounts of the Protestant Bible controversy, see Glenn, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 196–204; Kaestle, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 98–99, 166–71; Ravitch, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 3–76; 1 Stokes, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 825–32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_362",
      "id": "fn1-362"
    }
  }, [_vm._v("46.")]), _vm._v(" "), _c('em', [_vm._v("The President’s Speech at Des Moines")]), _vm._v(", 22 Catholic World 433, 438 (1876).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_363",
      "id": "fn1-363"
    }
  }, [_vm._v("47.")]), _vm._v(" For the text of the amendment with discussion, see Glenn, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 252–53; 2 Stokes, "), _c('em', [_vm._v("supra")]), _vm._v(" note 37, at 68–69, 722–28; Zollman, "), _c('em', [_vm._v("supra")]), _vm._v(" note 38, § 62 at 75–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_364",
      "id": "fn1-364"
    }
  }, [_vm._v("48.")]), _vm._v(" See Arthur Schlesinger, ed., "), _c('em', [_vm._v("History of American Presidential Elections 1789–1968")]), _vm._v(" at 1606 (Chelsea House 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_365",
      "id": "fn1-365"
    }
  }, [_vm._v("49.")]), _vm._v(" See Jonathan D. Sarna, "), _c('em', [_vm._v("American Jews and Church-State Relations")]), _vm._v(" 14–31 (American Jewish Committee 1989).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("The Good News Club v. Milford Central School")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-5"
    }
  }, [_c('em', [_vm._v("533 U.S. 98 (2001)")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_vm._v("Brief of Douglas Laycock as Amicus Curiae in Support of Petitioners")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3"
  }, [_c('em', [_vm._v("November 30, 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("The Good News Club is an evangelical Protestant group that runs programs for young children in public schools. The Equal Access Act generally does not apply to their programs, because they are mostly offered in elementary schools and because they have adult leaders from outside the school. Milford is a small town in New York, between Syracuse and Albany, with kindergarten through twelfth grade in a single building.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("A New York law authorizes school districts to make their facilities available to a very broad range of community groups, but not religious groups. Milford, like many other New York school districts, adopted a policy that tracked this state law. The exclusion of religious groups has given rise to much litigation, including this case and others described in this brief. In the")]), _vm._v(" Lamb’s Chapel "), _c('em', [_vm._v("case in 1993, the Supreme Court unanimously held that New York schools could not exclude religious community groups, but that case involved adults renting space on the weekend.")]), _vm._v(" Milford "), _c('em', [_vm._v("involved young children meeting immediately after school, and defendants and their amici thought that was different.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The Court has developed a body of law on “public forums” to control cases about free speech on government property. For a wide range of government property, government can define access to the forum by subject matter, but not by viewpoint. It therefore became common for public schools to say that religion is an excluded subject matter. But")]), _vm._v(" Lamb’s Chapel "), _c('em', [_vm._v("had held that religion is also a source of viewpoints. Both sides of this argument were repeated in")]), _vm._v(" Rosenberger, "), _c('em', [_vm._v("and again in")]), _vm._v(" Milford.")])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('em', [_vm._v("Milford’s policy was sweeping, offering school facilities to pretty much any nonreligious community group. But the town is small, and there weren’t many community groups that needed a place to meet. Only the Boy Scouts, the Girl Scouts, and the 4-H Club actually met in school facilities. So the forum in practice was not")])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('em', [_vm._v("nearly as broad as the forum in principle. Lawyers for the Good News Club argued that all four organizations—the three that were permitted to meet and the one that was not—were engaged in moral and character development of children. They differed only in their religious or secular viewpoint. That accurately characterized the facts, but at a fairly high level of generality. The Good News Club was interested first in saving souls. Moral and character development was secondary, but it was real, and this brief adopts that characterization.")])])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("In 2000, the year before this case, I successfully represented parents and students who objected to school-sponsored prayer at high school football games. That case was")]), _vm._v(" Santa Fe Independent School District v. Doe, "), _c('em', [_vm._v("in this volume at 390. I thought it gave me a certain credibility in arguing for the Good News Club. So I took the somewhat awkward step of filing on my own behalf.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Interest of the Amicus")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("Amicus Douglas Laycock is Professor of Law at The University of Texas at Austin. I have studied issues of free speech and religious liberty for many years, and I have supported vigorous enforcement of the Establishment Clause as well as the Free Speech and Free Exercise Clauses. Last Term, I represented plaintiffs who objected to school-sponsored prayer at football games in "), _c('em', [_vm._v("Santa Fe Independent School District v. Doe")]), _vm._v(", 530 U.S. 290 (2000).")]), _c('a', {
    attrs: {
      "href": "#/#fn1-366",
      "id": "fn1_366"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In earlier years, I filed the principal amicus brief in support of a family who objected to school-sponsored prayer at graduation in "), _c('em', [_vm._v("Lee v. Weisman")]), _vm._v(", 505 U.S. 577 (1992), and an amicus brief in support of those who objected to a school district drawn on religious lines in "), _c('em', [_vm._v("Board of Education v. Grumet")]), _vm._v(", 512 U.S. 687 (1994). I have also filed amicus briefs on the other side of the long-running battle over prayer and religious meetings in public schools, supporting the rights of religious speakers in "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of the University of Virginia")]), _vm._v(", 515 U.S. 819 (1995), and "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(", 496 U.S. 226 (1990). I have addressed the issues surrounding this case in a scholarly article, Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 Nw. U.L. Rev. 1 (1986), and in testimony opposing any form of school-prayer amendment to the Constitution. Statement, in "), _c('em', [_vm._v("Religious Liberty: Hearings Before")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('em', [_vm._v("the Senate Committee on the Judiciary")]), _vm._v(" 66 (1995). [The article and the hearing testimony, and briefs in all the cases cited in these first two paragraphs, are in this volume.]")])]), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This brief speaks in my own voice and offers expertise from a position of relative neutrality in the so-called culture wars. I attempt to place this case in broader constitutional context, to emphasize why staunch opponents of school-sponsored prayer should support petitioners’ claim to free speech here, and to identify the clear rule that consistently explains this Court’s cases on religious speech in public schools. I also diagnose a weakness or loophole in the Court’s public forum doctrine—a weakness that is facilitating misunderstanding or evasion of the Court’s rules on religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This brief is filed with consent of the parties. Petitioners’ consent is on file with the Court, and respondent’s consent is submitted with the brief.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Summary of Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("This case is controlled by the clear principle to which this Court has adhered for forty years, crystallized in "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(", 496 U.S. 226 (1990): “[T]here is a crucial difference between "), _c('em', [_vm._v("government")]), _vm._v(" speech endorsing religion, which the Establishment Clause forbids, and "), _c('em', [_vm._v("private")]), _vm._v(" speech endorsing religion, which the Free Speech and Free Exercise Clauses protect.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 250 (plurality opinion). If the school controls the speech, arranges for the speech, or gives preferential access to the speech, it is governmental speech. If not, it is private speech. This Court has never found an exception to the part of this rule protecting private speech. This Court has "), _c('em', [_vm._v("never")]), _vm._v(" held, in "), _c('em', [_vm._v("any")]), _vm._v(" context, that government may or must discriminate against a private speaker based on the religious content of his speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This rule has encountered continuing resistance from both sides. Whether from innocent confusion or deliberate evasion, anti-prayer school districts have resisted this Court’s free speech cases as vigorously as pro-prayer school districts have resisted the Establishment Clause cases. Milford’s argument this Term is no better than Santa Fe’s argument last Term. Both sides of the dispute require clear rules that are hard to evade.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Meetings of the Good News Club would be private speech under this Court’s cases. Milford Central School has created a designated forum, open to community groups in general, and actively used by groups teaching morals and character development to children. Milford excludes the Good News Club from that forum because it teaches that morals should be based on Christian faith. This is viewpoint discrimination, pure and simple.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("The attempt to recharacterize this discrimination as a mere subject matter exclusion fails on its own terms. Club meetings are not confined to topics on which there is no secular viewpoint, such as the nature of the Trinity. Instead, they address issues of morals and character development that are also addressed from secular perspectives. The court below did not dispute this. Rather, it held that whatever the Club says about morals and character development is tainted by what it says about faith, and that the whole is therefore excludable. The source of this taint is the Club’s viewpoint—in particular, its view that children’s morals should be based on Christian faith.")])]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("More generally, the distinction between religion as viewpoint and religion as mere subject matter is untenable and subject to abuse. Religion is both, as this Court has repeatedly recognized. For people who believe that religious faith is a principal source of instruction on all the other important decisions in their lives, religion is both a prolific source of viewpoints and a vitally important subject matter. For people who do not share the underlying viewpoint, religion is neither a source of other viewpoints nor a subject matter worth discussing. When viewpoint and subject matter are so closely aligned, constitutional rights cannot be made to depend on the distinction without close judicial scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("It appears that the real operative rule in the Second Circuit is not a distinction between religious viewpoint and religious subject matter, but a per se ban on speech that resembles religious worship—no matter what viewpoints it expresses. This rule violates the ban on viewpoint discrimination. Moreover, a distinction between worship and other religious speech was expressly considered and rejected in "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("More generally still, this case illustrates a weakness or loophole in this Court’s public forum doctrine. Decisions to restrict the subject matters or classes of speakers in a designated forum, or to close the designated forum entirely, appear to be largely immune from judicial review. This leaves important rights of free speech to the unrestricted discretion of government officials. Subject matter exclusions can readily be manipulated to achieve viewpoint results, and inevitably have important viewpoint consequences even without manipulation. Exclusion of a controversial subject matter necessarily insulates the status quo. It is futile for the Court to strictly scrutinize viewpoint discrimination if it gives no scrutiny to subject matter exclusions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This larger doctrinal problem need not be solved to decide this case, but solutions are available. One solution to the larger problem may be found in the concurring opinion in "), _c('em', [_vm._v("International Society for Krishna Consciousness, Inc. v. Lee")]), _vm._v(", 505 U.S. 672, 693–703 (1992) (Kennedy, J., concurring). A more modest solution would be to require some functional justification for limits on, or closures of, designated fora.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("Finally, permitting the Good News Club to participate in the designated forum on an equal basis would not violate the Establishment Clause. That is settled in this Court’s cases, and the elementary school context does not change the result. Milford has offered no evidence that the children cannot understand the difference between a school program and an outside program, and it has made no effort to explain the difference. The difference can be explained in simple terms, appropriate to the age of the children.")])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("More fundamentally, the argument that the children cannot understand proves nothing, because it cuts both ways. Assume the children cannot understand that permitting the Club to meet is not an endorsement. On that assumption, they certainly cannot understand that excluding the Club because of its religious views is not a statement of hostility to religion. Indeed, their perception of censorship would be accurate; their hypothetical perception of endorsement would be mistaken. A reasonable perception of endorsement must be based on some favoritism from the school, subtle or flagrant. There is no favoritism, and no basis for a perception of endorsement, in admitting the Club to a designated forum on equal terms with other programs for children.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Argument")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("I. The Religious Speech at Issue Is Private Speech, Protected by the First Amendment.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("For forty years, litigants have brought to this Court a steady flow of cases concerning religious speech in the public schools. And for forty years, this Court has decided those cases with remarkable consistency. Without a single exception in all that time, this Court’s school cases are explained by the “crucial difference between "), _c('em', [_vm._v("government")]), _vm._v(" speech endorsing religion, which the Establishment Clause forbids, and "), _c('em', [_vm._v("private")]), _vm._v(" speech endorsing religion, which the Free Speech and Free Exercise Clauses protect.” "), _c('em', [_vm._v("Board of Education v. Mergens")]), _vm._v(", 496 U.S. 226, 250 (1990) (plurality opinion).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("This distinction between government speakers and private speakers is at the very core of the First Amendment. The difference between protected free speech and free exercise of religion, on the one hand, and forbidden establishment of religion on the other, is the difference between private action and government action. In our system, religion is left wholly to private choice. Citizens may freely debate, practice, and implement their religious beliefs, but government may not participate. "), _c('em', [_vm._v("Lee v. Weisman")]), _vm._v(", 505 U.S. 577, 589–92 (1992). Government’s duty is to protect both religious and secular speech and to remain ")]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("neutral between the two. In places where government permits expression of a diverse range of views, it has neither the duty nor the authority to exclude religious speakers.")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("By carefully distinguishing government speech from private speech, this Court has adhered to a rule against school-"), _c('em', [_vm._v("sponsored")]), _vm._v(" prayer. But the common phrase to describe these cases in popular speech is simply “school prayer.” The shorter phrase is not harmless, for it omits the critical concept of government sponsorship. And indeed, the more aggressive advocates on each side seem to reject the Court’s focus on school sponsorship. One side would permit schools to sponsor prayer and religious instruction; the other side would prohibit all prayer and religious instruction in or about public schools, no matter how privately organized.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These extreme positions are of course inconsistent with the basic principle in this Court’s cases. So litigants on both sides have taken to offering strained interpretations of the principle. Last Term, supporters of school prayer claimed to see purely private speech in an elaborate scheme to accord exclusive access to a single student who would lead large crowds in prayer; the Court properly found school sponsorship. "), _c('em', [_vm._v("Santa Fe Independent School District v. Doe")]), _vm._v(", 530 U.S. 290 (2000).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this case, opponents of school prayer claim to see government sponsorship in mere equal access. Milford claims that it would be school sponsorship merely to permit a private group to meet after school under the terms of a policy that opens school facilities to a vast range of community groups, and that opening school facilities to secular community groups while excluding religious community groups is neither discrimination nor censorship but merely a neutral definition of the scope of the school’s forum. In sharp contrast to Santa Fe’s single speaker with exclusive access to the public address system, Milford really does have a diverse array of community groups using its designated forum. Milford’s claims are no more plausible than Santa Fe’s. Both school districts—Milford this year and Santa Fe last year—are in fact rejecting the basic principle that has guided this Court’s cases for forty years.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("Whether from innocent confusion or deliberate evasion, there is a similar history of resistance on both sides of the issue. Before the Equal Access Act, 20 U.S.C. § 4071 "), _c('em', [_vm._v("et seq.")]), _vm._v(" (1994), many school districts in New York and elsewhere prohibited religious speech without explanation or out of exaggerated concerns about the Establishment Clause. "), _c('em', [_vm._v("See, e.g., Brandon v. Board of Education")]), _vm._v(", 635 F.2d 971 (2d Cir. 1980). After the Equal Access Act defined open fora in secondary schools in terms of whether the school permitted “one or more noncurriculum related student groups,” 20 U.S.C. § 4071(b) (1994), these schools insisted ")]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("that the Act had no effect, because every secular club is curriculum related but religion clubs are not. This Court rejected that claim in "), _c('em', [_vm._v("Mergens")]), _vm._v(", 496 U.S. 226 (1990). Then these school boards said that in any case outside the scope of the Act, religion would be an excluded subject matter even if the school had created a public forum. This Court rejected that claim, holding that religious speech expresses protected viewpoints. "), _c('em', [_vm._v("Lamb’s Chapel v. Center Moriches Union Free School District")]), _vm._v(", 508 U.S. 384 (1993). These school boards still did not change their behavior; now they seek to exclude some subset of religious speech that assertedly does not express protected viewpoints. This subset is ill-defined but substantial; it seems to include all or substantially all religious speech and to largely nullify "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The schools’ argument and the definition of what is excluded have been repeatedly fine-tuned, but the common theme is the same: some school boards will discriminate against religious speech until this Court adopts unambiguous rules that eliminate all room for misunderstanding or evasion. These anti-religious school boards are every bit as persistent as the pro-religious school boards in cases like "), _c('em', [_vm._v("Santa Fe")]), _vm._v(". The Constitution is equally offended in each case: when a religious majority in Santa Fe imposes its prayers on religious and secular minorities, and when a secular majority in Milford denies a religious minority the right to meet and teach its faith to those who wish to learn it. In each set of cases, the solution is to avoid rules that facilitate misunderstanding or evasion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Identifying government sponsorship is not so difficult as it is made out to be by litigants unhappy with the underlying rule. Justices have disagreed about nuances in the formulation of a test, but all of this Court’s judgments are consistent with the simple rule that if persons are speaking in their private capacities, then government cannot discriminate for them or against them based on the religious content of their speech.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("To elaborate: Religious speech is attributable to the government if government employees select the religious message, "), _c('em', [_vm._v("Engel v. Vitale")]), _vm._v(", 370 U.S. 421 (1962), deliver the religious message, "), _c('em', [_vm._v("Abington School District v. Schempp")]), _vm._v(", 374 U.S. 203 (1963),")]), _c('a', {
    attrs: {
      "href": "#/#fn1-367",
      "id": "fn1_367"
    }
  }, [_vm._v("*")]), _vm._v(" encourage or endorse the religious message, "), _c('em', [_vm._v("Wallace v. Jaffree")]), _vm._v(", 472 U.S. 38 (1985); "), _c('em', [_vm._v("Treen v. Karen B.")]), _vm._v(", 455 U.S. 913 (1982), arrange for the religious message, "), _c('em', [_vm._v("Lee v. Weisman")]), _vm._v(", 505 U.S. 577 (1992), or give an otherwise private speaker preferential access to a school forum, program, audience, or facility, "), _c('em', [_vm._v("Santa Fe Independent School District v. Doe")]), _vm._v(", 530 U.S. 290 (2000); "), _c('em', [_vm._v("Stone v. Graham")]), _vm._v(", 449 "), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("U.S. 39 (1980). This Court has found no exception in a school context to the rules stated in this paragraph since "), _c('em', [_vm._v("Zorach v. Clauson")]), _vm._v(", 343 U.S. 306 (1952).")])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Zorach")]), _vm._v(" is an exception to the rule against government sponsorship, at least as measured by the criteria in the preceding paragraph, because the school provided preferential access to a school audience. The school created a “forum” in which the only choices were religious instruction at a local church or essentially custodial care by the school. The Court upheld the program anyway. There have also been two more recent exceptions outside the school context. "), _c('em', [_vm._v("Lynch v. Donnelly")]), _vm._v(", 465 U.S. 668 (1984) (permitting municipal Christmas display); "), _c('em', [_vm._v("Marsh v. Chambers")]), _vm._v(", 463 U.S. 783 (1983) (permitting legislative prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("These cases permit government to sponsor religious messages in certain limited contexts. With respect, I believe that all three of these cases were wrongly decided, and I do not rely on them here. My position is not that government may support religion a little bit, and certainly not in public schools. Rather, my position is that permitting religious groups to meet on the same terms as other groups is no support at all, and that forbidding them to meet on equal terms is anti-religious censorship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If government has not endorsed religious speech by one of the means just discussed, that speech is private, and constitutionally protected. To elaborate: If a private speaker selects and delivers his own message, if government employees express no opinion about that message, if government employees do not invite or arrange for the message, if government employees give the speaker no preferential access to government fora, programs, audiences, or facilities, and in general, if government employees treat the religious speaker like secular speakers similarly situated, the religious speech is attributable to the private speaker. This is the rule in public schools. "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(", 508 U.S. 384 (1993); "), _c('em', [_vm._v("Mergens")]), _vm._v(", 496 U.S. 226 (1990). It is the rule in higher education. "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")]), _vm._v(", 515 U.S. 819 (1995); "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981). It is the rule on other government property. "), _c('em', [_vm._v("Capitol Square Review and Advisory Board v. Pinette")]), _vm._v(", 515 U.S. 753 (1995); "), _c('em', [_vm._v("Board of Airport Commissioners v. Jews for Jesus")]), _vm._v(", 482 U.S. 569 (1987); "), _c('em', [_vm._v("Poulos v. New Hampshire")]), _vm._v(", 345 U.S. 395 (1953); "), _c('em', [_vm._v("Fowler v. Rhode Island")]), _vm._v(", 345 U.S. 67 (1953); "), _c('em', [_vm._v("Niemotko v. Maryland")]), _vm._v(", 340 U.S. 268 (1951). This Court has "), _c('em', [_vm._v("never")]), _vm._v(" found an exception in "), _c('em', [_vm._v("any")]), _vm._v(" context to the rule stated in this paragraph.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("The point is broader than speech on government property. This Court has never doubted the right to make religious arguments in political debate, "), _c('em', [_vm._v("see Lemon v. Kurtzman")]), _vm._v(", 403 U.S. 602, 612 (1971), and it has upheld the right of clergy to hold political office. "), _c('em', [_vm._v("McDaniel v. Paty")]), _vm._v(", 435 U.S. 618 (1978). "), _c('em', [_vm._v("See generally")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Freedom of Speech That Is Both Religious and Political")]), _vm._v(", 29 U.C. Davis L. Rev. 793 (1996) [in this volume at 210]. This Court has "), _c('em', [_vm._v("never")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("held in "), _c('em', [_vm._v("any")]), _vm._v(" context that government may or must discriminate against a private speaker based on the religious content of his speech. The judgment below is without precedent in this Court.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("II. The Second Circuit Rule, Authorizing Exclusion of Speech on Religious “Subject Matter,” Is Inconsistent With This Court’s Cases and With the Free Speech Clause.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bia"
  }, [_c('strong', [_c('em', [_vm._v("A. Exclusion of the Good News Club Is Viewpoint Discrimination.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Milford has excluded the Good News Club squarely on the basis of its viewpoint. Moral instruction and character development from a secular viewpoint is permitted; moral instruction and character development from a religious viewpoint is forbidden. This is viewpoint discrimination, and not a mere subject matter exclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This Court has twice rejected the argument that religion is just a subject matter and not a source of viewpoints on the whole range of other issues facing society. "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 515 U.S. 819 (1995); "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(", 508 U.S. 384 (1993). The Second Circuit has attempted to distinguish those cases by holding that religion is "), _c('em', [_vm._v("sometimes")]), _vm._v(" a source of viewpoints and "), _c('em', [_vm._v("sometimes")]), _vm._v(" just a subject matter. "), _c('em', [_vm._v("Good News Club v. Milford Central School")]), _vm._v(", 202 F.3d 502 (2d Cir. 2000); "), _c('em', [_vm._v("Bronx Household of Faith v. Community School District No. 10")]), _vm._v(", 127 F.3d 207 (2d Cir. 1997). For reasons to be explained, I believe this distinction is fundamentally flawed. But even taking the distinction on its own terms, it cannot explain the judgment below.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Second Circuit’s distinction between subject matter and viewpoint presupposes a religious discussion that is directed entirely inward, directed to purely religious questions, and expressing no viewpoint on any issue that might also be addressed from a secular viewpoint. An example might be a theological disputation about the nature of the Trinity. A religious discussion directed outward, to issues that could also be addressed from secular viewpoints, is necessarily expressing a religious viewpoint on those other issues.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Good News Club’s discussions are directed outward. The Club addresses issues of morals and character development of children that can also be addressed from secular viewpoints, and that in fact are addressed from secular viewpoints by other organizations in the forum at Milford Central School. To exclude the Club’s religious viewpoint on these issues is viewpoint discrimination, barred by this Court’s cases, even if that expression of viewpoint is only part of the discussion.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("The holding below is not that the Good News Club expressed no viewpoints on matters of secular significance, but rather that its protected expressions of viewpoint on morals and character development are disqualified by related discussions that the court of appeals found too religious. “Though [the Club’s] teachings may involve secular values such as obedience or resisting jealousy, the Christian viewpoint, as espoused by Reverend Fournier, contains "), _c('em', [_vm._v("an additional layer")]), _vm._v(".” "), _c('em', [_vm._v("Milford")]), _vm._v(", 202 F.3d at 509 (emphasis added). “The activities of the Good News Club do not involve "), _c('em', [_vm._v("merely")]), _vm._v(" a religious perspective on the secular subject of morality.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 510 (emphasis added). “[T]he Good News Club goes far "), _c('em', [_vm._v("beyond merely stating its viewpoint")]), _vm._v(".” "), _c('em', [_vm._v("Id.")]), _vm._v(" (emphasis added). This “additional layer” may be barred, allegedly because it is subject matter and not viewpoint.")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This is a holding of taint: that a discussion of Christian faith so taints the discussion of morals and character development that both discussions are disqualified from the forum. "), _c('em', [_vm._v("Rosenberger")]), _vm._v(" rejected this notion of taint; it was not disqualifying there that the disputed magazine was permeated with expressions of evangelical Christian faith. "), _c('em', [_vm._v("See")]), _vm._v(" 515 U.S. at 825–26; "), _c('em', [_vm._v("id.")]), _vm._v(" at 865–67 (Souter, J., dissenting). The magazine drew on that faith to express viewpoints on a wide range of issues facing college students, and that was the dispositive fact. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 828–37 (opinion of the Court). The "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(" opinions say less about the content of the disputed film series in that case, but almost certainly those films contained expressions of Christian faith that would be disqualifying under the decision below. "), _c('em', [_vm._v("See")]), _vm._v(" 508 U.S. at 388–89 n.3, especially paragraph 5. The Second Circuit’s distinction, as applied in this case, in fact distinguishes nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The source of the disqualifying taint is precisely the Club’s viewpoint. The Good News Club believes that children are more likely to adopt sound moral principles, and more likely to live up to those principles, if their moral efforts are supported by Christian faith. That viewpoint links the several parts of a Good News Club meeting and makes the discussion of Christian faith an integral part of the discussion of morals and character development. And in the opinion below, it is the manifestation of that viewpoint that disqualifies the Club from speaking. This is precisely the viewpoint discrimination that this Court’s decisions forbid.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. The Distinction Between Religion As Viewpoint and Religion As Subject Matter Is Untenable and Readily Subject to Abuse.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("However formulated, the distinction between religion as viewpoint and religion as subject matter is untenable. Religion is both viewpoint and subject matter, and it is commonplace for discussions of faith or theology to be integrally ")]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("connected to discussions of morals and other issues that are also addressed from secular viewpoints. Nearly all religious believers think that their faith has implications for their morals and for other issues in their life.")])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The Second Circuit’s original and still principal example of religion as mere subject matter, free of viewpoint, is a worship service. "), _c('em', [_vm._v("Full Gospel Tabernacle v. Community School District 27")]), _vm._v(", 164 F.3d 829 (2d Cir. 1999); "), _c('em', [_vm._v("Bronx Household")]), _vm._v(", 127 F.3d 207 (2d Cir. 1997). Its opinion in this case relies principally on a perceived analogy between certain elements of a Good News Club meeting and certain elements of a worship service. "), _c('em', [_vm._v("Milford")]), _vm._v(", 202 F.3d at 510. Perhaps the true Second Circuit rule is simply that worship services (and any other speech that too closely resembles elements of a worship service) can be excluded.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If this is the rule, it has nothing to do with the distinction between viewpoint and subject matter. It is common for worship services to express viewpoints on moral and other issues, in the sermon or homily, in the scripture readings, or in other ways. The Second Circuit rule appears to be that worship-like speech may be excluded no matter how many viewpoints it expresses on issues that can also be addressed from secular viewpoints. But if that is the Second Circuit rule, it is in the teeth of this Court’s emphatic prohibitions on viewpoint discrimination. It is also in the teeth of "), _c('em', [_vm._v("Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981), which held that on-campus worship services are protected by the Free Speech Clause, "), _c('em', [_vm._v("see id.")]), _vm._v(" at 265 n.2 (describing the disputed meetings), and which expressly rejected any distinction between worship services and other religious speech, "), _c('em', [_vm._v("id.")]), _vm._v(" at 269–70 n.6.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Widmar")]), _vm._v(" rejected any distinction between religious worship and other religious speech for three sound reasons: that the distinction lacks intelligible content; that even if the distinction could be specified, government would be incompetent to administer it; and that there is nothing in First Amendment policy or principle to support it. "), _c('em', [_vm._v("Id.")]), _vm._v(" There is a fourth reason: any attempt at enforcement requires the censor to monitor meetings in the most intrusive way. "), _c('em', [_vm._v("See")]), _vm._v(" Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 Nw. U.L. Rev. 1, 56–57 (1986) [in this volume at 67–69] (elaborating all four points). A clear illustration of the final point comes from The University of Texas, which for a time before "), _c('em', [_vm._v("Widmar")]), _vm._v(" tried to enforce a rule that student meetings and rallies could speak about religion but could not proselytize. An assistant dean of students found himself assigned to monitor daily rallies and pull the plug on the loudspeaker when he thought a group had stepped over the line. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 57. Such Orwellian absurdities are the inevitable outcome of any serious effort to draw fine distinctions between kinds of religious speech.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("Subject matter and viewpoint are so closely linked in the case of religion that it is nearly impossible to distinguish religious speech that expresses viewpoints on matters of secular significance from religious speech that does not. Even if it is possible in a few cases, it is impossible in most cases. For people who believe that religious faith is a principal source of instruction on all the other important decisions in their lives, religion is both a prolific source of viewpoints and a vitally important subject matter. For those who believe that religion is marginal to their lives, or an imaginary construct, or a negative influence in other people’s lives, religion is rarely a source of viewpoints and rarely a relevant subject matter. When subject matter and viewpoint are so closely aligned, it is naive to think that courts or administrators can exclude the subject matter without discriminating against the associated viewpoints. Certainly they have not done so here.")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("This untenable distinction is the key to the judgment below and to similar judgments in a wide range of contexts. The judgment below is in no way based on the fact that this case arises in an elementary school. The judgment is not based on the Establishment Clause, nor on any view that there is no right to a forum in elementary schools. The judgment is based squarely on the Second Circuit’s rule that religious speech with elements of worship is mere excludable subject matter and not a viewpoint. This rule is regularly applied to adults and to contexts unrelated to schools. The rule originated in "), _c('em', [_vm._v("Bronx Household")]), _vm._v(", 127 F.3d 207 (2d Cir. 1997), a case in which a church sought to rent space on the weekend.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Second Circuit’s rule is spreading to other circuits and other facilities. It has been applied to use of school facilities by an adult community group in "), _c('em', [_vm._v("Campbell v. St. Tammany’s School Board")]), _vm._v(", 206 F.3d 482 (5th Cir. 2000). Similar arguments were made in an unsuccessful attempt to exclude a film from a senior citizens’ center, "), _c('em', [_vm._v("Church on the Rock v. City of Albuquerque")]), _vm._v(", 84 F.3d 1273 (10th Cir. 1996), and are at issue in a pending case about use by an adult community group of community meeting rooms in a village hall. "), _c('em', [_vm._v("DeBoer v. Village of Oak Park")]), _vm._v(", 86 F. Supp. 2d 804, 810–11 (N.D. Ill. 1999), "), _c('em', [_vm._v("appeal pending")]), _vm._v(". This Court should squarely consider, and squarely reject, the Second Circuit’s rule authorizing exclusion of religious subject matter from public facilities.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("C. This Court’s Current Formulations of Forum Doctrine Invite Censorship of the Kind at Issue in This Case.")])])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("Milford’s exclusion of religious subject matter is a misunderstanding or evasion of this Court’s decisions in "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(" and "), _c('em', [_vm._v("Rosenberger")]), _vm._v(". But evasion is made possible, perhaps even invited, by weaknesses or loopholes in this Court’s formulation ")]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("of public forum doctrine. It is not necessary to clarify or reform that doctrine to reverse the judgment below. But clarification could avoid similar difficulties in future litigation.")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("It is by now familiar doctrine that this Court’s free speech cases recognize three kind of fora. The first is “property that has traditionally been available for public expression.” "), _c('em', [_vm._v("International Society for Krishna Consciousness, Inc. v. Lee")]), _vm._v(", 505 U.S. 672, 678 (1992). Second is “the designated public forum,” property that is a forum because the government said so. "), _c('em', [_vm._v("Id.")]), _vm._v(" Third is the nonpublic forum on “all remaining public property.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 678–79.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A designated forum may be limited by subject matter or speaker identity. "), _c('em', [_vm._v("Cornelius v. NAACP Legal Defense & Educational Fund, Inc.")]), _vm._v(", 473 U.S. 788, 802 (1985). A nonpublic forum may be open to selected private speakers. "), _c('em', [_vm._v("Id.")]), _vm._v(" Thus in both designated and nonpublic fora, government has substantial power to pick and choose who will be permitted to speak and what they will be permitted to discuss. Of course this power is not unlimited. Viewpoint discrimination is forbidden in any kind of forum. "), _c('em', [_vm._v("ISKCON v. Lee")]), _vm._v(", 505 U.S. at 678–79. And so long as a designated forum remains open, government must have a compelling reason for excluding a speaker who falls within the forum’s designated limits. "), _c('em', [_vm._v("Arkansas Educational Television Commission v. Forbes")]), _vm._v(", 523 U.S. 666, 677 (1998). But government can exclude unwanted speakers by further restricting the designated subject matters or classes of permitted speakers, or by closing the designated forum entirely. And under current doctrine, these forms of restriction are largely exempt from judicial review.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The most troubling thing about the Court’s three-category formulation is that censorship can become self-justifying in the second and third categories. The government’s desire to exclude a speaker may be justified by showing its intent to close or limit the forum, and that intent may be shown by evidence that it has excluded other speakers in the past. A choice to close or limit a designated forum is not constrained by any requirement that all speech or speakers be treated equally, nor by any requirement that there be functional reasons for designating certain subject matters or classes of speakers. Outside the traditional public forum, the only real protection is that exclusion of speech must be reasonable and not based on viewpoint discrimination. "), _c('em', [_vm._v("See generally")]), _vm._v(" Laycock, 81 Nw. U.L. Rev. at 45–50 [in this volume at 56–61].")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("Of course decisions to limit or close a designated forum often do have functional reasons, but the Court’s doctrine does not appear to require such reasons. The Court has been sensitive to the need to preserve government property for its intended functions, and speech that disrupts those functions may be excluded. "), _c('em', [_vm._v("See Forbes")]), _vm._v(", 523 U.S. at 672–76; "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 804. The Court has recognized that if it overrides legitimate functional concerns, ")]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("government may close a forum altogether, resulting in less speech rather than more. "), _c('em', [_vm._v("Forbes")]), _vm._v(", 523 U.S. at 680–82.")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition to avoiding disruption of governmental functions, fora are commonly limited as a means of rationing scarce resources, as in "), _c('em', [_vm._v("Forbes")]), _vm._v(", or to set the agenda for a focused discussion, as in a journal, website, or conference devoted to a particular topic. Fora may be limited to speakers associated with the government institution that operates the forum, as when college campuses operate a forum only for students, faculty, and staff. The Court’s forum doctrine avoids interfering with such functional distinctions, and undoubtedly the Court formulated the doctrine with such functional distinctions in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But as this case illustrates, the current doctrinal formulation invites much more. Even without closing a designated forum, government may manipulate or gerrymander the limits on the forum to exclude undesired speakers. Milford has no functional reason for excluding religious subject matter save its hostility to religion or its mistaken view of the Establishment Clause. There is no claim of a need to ration scarce space—and even if there were, space could not be rationed on a ground so closely allied to viewpoint. "), _c('em', [_vm._v("See Rosenberger")]), _vm._v(", 515 U.S. at 835. There is no claim of a narrow focus to which religion or moral instruction is simply irrelevant; the forum is open to substantially all secular community groups. Milford excludes the subject matter of religion by fiat, without offering any plausible reason. By excluding the subject matter of religion, Milford wholly excludes many religious viewpoints, and severely limits the expression of all religious viewpoints. It is futile for the Court to closely scrutinize viewpoint discrimination if it gives carte blanche to subject matter discrimination and permits subject matter to be defined in ways that closely track viewpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The problem is not confined to religious speech, or even to subject matters that are themselves a prolific source of viewpoints. In at least two frequently recurring ways, subject matter exclusions have powerful viewpoint consequences. First, the exclusion of any controversial subject matter insulates the status quo from criticism. Speakers who would defend the status quo have no need to do so if all speakers who would criticize the status quo have been silenced by a subject matter exclusion. Second, speakers who believe that a particular subject matter is unimportant and unworthy of public comment are unaffected by an exclusion of that subject matter; the effect of the ban falls only on speakers who hold the opposite viewpoint, and think that the subject matter is important.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("To prohibit discussion of race relations, even in the Deep South in 1954, would be a mere subject matter exclusion, requiring no justification in designated fora under this Court’s current doctrine. Similarly today, to prohibit discussion of race relations is to insulate those who are satisfied with the current degree of racial progress and to silence all those who think either that we have ")]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("gone too far or that much more remains to be done. To prohibit discussion of animal rights, or sodomy laws, or estate taxes, or the electoral college, is to prevent any criticism of an entrenched status quo, and to silence a minority that vigorously disagrees with that status quo. To prohibit any discussion of the candidates for school board is to insulate incumbents from criticism and to silence those who want a change. To prohibit all discussion of political issues is a subject matter exclusion that insulates the status quo across the board, on all these more specific topics and many others.")])]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A subject matter exclusion of religion has all these vices. It tends to insulate the religious status quo in the community, whatever that status quo may be. It enacts the viewpoint of those who think religion is a purely private matter, inappropriate for public discussion, and suppresses the viewpoint of those who think religion is a vitally important topic. It suppresses religious viewpoints on every issue before the community. And the history of misunderstanding or evasion of this Court’s rule protecting religious speech illustrates that those who would exclude a viewpoint can adjust or gerrymander definitions of subject matter to achieve their goals.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Court need not solve these problems to decide this case. In this case, it is sufficient to hold that Milford has indeed discriminated on the basis of viewpoint. The solution to the underlying problem lies in refining the rules concerning the three kinds of fora on government property. Subject matter exclusions often serve important functional purposes; I do not propose that they be banned or even that they be equated with viewpoint discrimination. But they must be subject to some degree of judicial review.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In "), _c('em', [_vm._v("ISKCON v. Lee")]), _vm._v(", 505 U.S. 672 (1992), four Justices proposed entirely abandoning the rules that let government designate the status of various fora. "), _c('em', [_vm._v("Id.")]), _vm._v(" at 693–703 (Kennedy, J., concurring). That opinion proposed instead that the Court classify government property as public or nonpublic fora based on functional criteria. The most important criterion would be whether the proposed speech would disrupt the normal functions to which the government property is dedicated.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That concurring opinion recognized the most fundamental defect of existing forum doctrine: that it “grants the government authority to restrict speech by fiat.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 694. The opinion continued:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("[Under the Court’s forum analysis,] the authority of the government to control speech on its property is paramount, for in almost all cases the critical step in the Court’s analysis is a classification of the property that turns on the government’s own definition or decision, unconstrained by an independent duty to respect the speech its citizens can voice there.")])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_137"
    }
  }), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('em', [_vm._v("Id.")]), _vm._v(" at 695. The Court should reconsider the fundamental wisdom of that concurring opinion. In this case, the Good News Club no more interferes with the normal functioning of the school than do the Boy Scouts or any other club.")])]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("There is also a smaller step that would help considerably. The Court could retain the current structure with its three kinds of fora, giving presumptive effect to the government’s designation. But the government’s designation would be reviewable. Limitations imposed on a designated forum, and closures of designated fora, should not be wholly insulated from judicial review. Government should have to give some functional reason for limits on a designated forum. These reasons would "), _c('em', [_vm._v("not")]), _vm._v(" have to rise to the level of a compelling interest. Intermediate scrutiny, or even rational basis scrutiny that is not wholly toothless, would eliminate many arbitrary limitations on the scope of fora. Government should not be able to exclude a subject matter for no better reason than its dislike of viewpoints or controversies associated with that subject matter or its misunderstanding of the law. Direct review of such motives would be unworkable, but requiring some functional reason would do much to solve the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The current formulation of doctrine already provides that restrictions on speech, even in nonpublic fora, must be reasonable. "), _c('em', [_vm._v("Cornelius")]), _vm._v(", 473 U.S. at 806. At the very least, the Court should give meaningful content to that requirement and make clear that it also applies to limitations on the scope of a designated forum. In this case, Milford’s exclusion of religious speech is not reasonable. There is absolutely no reason for the exclusion except hostility to religious viewpoints or a misunderstanding of the Establishment Clause. Neither of these reasons is legally cognizable. One is constitutionally forbidden; the other is an error of law to which courts should not defer. This Court should not continue with a doctrine that authorizes governments to exclude whole subject matters from public places without having to offer any reason.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5b1"
  }, [_c('strong', [_c('em', [_vm._v("III. Permitting the Good News Club to Meet Would Not Violate the Establishment Clause.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Permitting the Good News Club to meet in a designated public forum on equal terms with secular clubs would not establish religion. This Court has repeatedly rejected claims to the contrary. "), _c('em', [_vm._v("Rosenberger")]), _vm._v(", 515 U.S. 819 (1995); "), _c('em', [_vm._v("Pinette")]), _vm._v(", 515 U.S. 753 (1995); "), _c('em', [_vm._v("Lamb’s Chapel")]), _vm._v(", 508 U.S. 384 (1993); "), _c('em', [_vm._v("Mergens")]), _vm._v(", 496 U.S. 226 (1990); "), _c('em', [_vm._v("Widmar")]), _vm._v(", 454 U.S. 263 (1981); "), _c('em', [_vm._v("see generally")]), _vm._v(" Part I of this brief. This principle is of course far more controversial when applied to distribution of government funds, but that controversy is not implicated here.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_138"
    }
  }), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("This case is the Court’s first encounter with a designated forum in an elementary school, but that does not change the principle or the result. The age of the children may be a reason not to create a forum in the first place; certainly it is a reason to require each group participating in the forum to have adult leadership. But the age of the children does not justify viewpoint discrimination.")])]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The conventional argument for excluding religious speech is that children are too young to understand the difference between government speech and private speech, and will mistakenly assume that the school endorses any religious speech that it permits. Let us first put this argument in context. It does not negate the viewpoint discrimination inherent in excluding private religious speech from the designated forum, and it does not claim that government actually endorses religion by any method ever recognized in this Court’s cases. Rather, it is an attempt to justify "), _c('em', [_vm._v("actual")]), _vm._v(" viewpoint discrimination on the basis of fears that students may "), _c('em', [_vm._v("mistakenly")]), _vm._v(" perceive endorsement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The claim of an Establishment Clause violation starts with an empirical claim: that elementary students cannot understand that the Good News Club is independent of the school. This is a dubious proposition empirically, and the school has made no effort to prove it. Nor has it tried to dispel any such confusion by explaining to children that the Good News Club is acting entirely on its own. Viewpoint discrimination requires compelling justification, not a speculative assertion about what some children might misunderstand if no adult explains anything to them.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The proposition to be explained to the children is not difficult. The central point is simply that government does not endorse everything it fails to censor. Even the youngest children can understand that they have to go to school but they do not have to go to any after-school club. The school is supposed to be neutral concerning the Good News Club. Neutrality may be an abstraction, but a teacher can easily convey that abstraction in terms young children can understand: "), _c('em', [_vm._v("I don’t care.")]), _vm._v(" “I don’t care whether you go to the Good News Club or not. That is up to you and your parents.” Or: “Mrs. Fournier doesn’t work for the school. The Good News Club is more like a church. It just borrows a room at the school.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("More fundamentally, the Establishment Clause argument does not depend on the children’s level of understanding. The argument that children cannot understand First Amendment rights would be untenable even if it were empirically true. It is untenable because it leads to an insoluble contradiction.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("If students cannot understand that toleration of the Good News Club is not necessarily an endorsement of religion, then they cannot understand that exclusion of the Club is not necessarily a statement of hostility to religion. Milford defends a rule that on its face permits almost any community group to ")]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("meet at the school so long as it is not religious. This facial viewpoint discrimination conveys a message of hostility that is far more real than any mistaken implication of endorsement that some student might draw from mere equal treatment. Any attempt to explain away that apparent hostility would depend on a First Amendment argument considerably more complicated than the simple proposition that the school does not endorse everything it fails to censor. And on Milford’s hypothesis, the children would be incapable of understanding its explanation that it is not really hostile to religion.")])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The argument that children will think the school endorses religion unless it censors all religious speech on campus is like an argument sometimes heard from the other side of the school-prayer wars—that children will think the school opposes religion unless it teaches religion itself with classroom prayer. Both sides in this long running battle make the same mistake. Both sides say that if the school is not visibly for them, it is against them. Both sides say that neutrality will be interpreted as supporting the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Each side seeks to allocate all risk of uncertainty or misunderstanding to the other. Each side seeks to protect its preferred right—free speech or disestablishment—with prophylactic rules so generous that no human deviation from those prophylactic rules will ever risk violating the constitutional right itself. Neither side can have all that it seeks. When each side’s proposed prophylactic rules invade the substantive content of the other’s constitutional right, neither clause can enjoy a wide margin of safety.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("A solution in which one side forfeits its rights and bears all the risk of student misunderstanding while the other side bears no cost or risk whatever is not a neutral solution. The risk of student misunderstanding can be minimized by explanations, and any residual and unavoidable risk of misunderstanding must be shared. It is best shared by facially neutral rules in which the government takes no position on religion in its own speech and treats private religious speech exactly like private secular speech. The courts can review what government actually does; they cannot review what every observer might misunderstand. Whatever the risk that some students will perceive a designated forum as an endorsement of all groups that participate, that risk is far outweighed by the actual and apparent hostility in a rule that allows students to talk about anything except religion. "), _c('em', [_vm._v("See")]), _vm._v(" Laycock, 81 Nw. U.L. Rev. at 14–20 [in this volume at 22–29].")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("This argument does not depend on the age of the children. Elementary school children may have less capacity to understand the premises of a designated forum, but they have the same lesser capacity to understand that exclusion of religion reflects the school’s idea of disestablishment rather than hostility. The argument that students cannot understand still leads to the same ")]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("contradiction and is still soluble by the same facially neutral rules. "), _c('em', [_vm._v("See id.")]), _vm._v(" at 51–52 [in this volume at 63].")])]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("One branch of this Court’s endorsement test “focuses upon the perceptions of a reasonable, informed observer.” "), _c('em', [_vm._v("Pinette")]), _vm._v(", 515 U.S. at 773 (O’Connor, J., concurring). This observer’s perception must be based on something the government did. When the Court finds a violation of the Establishment Clause, “This is not because of ‘transferred endorsement,’ or mistaken attribution of private speech to the State, but because the State’s own actions … and their relationship to the private speech at issue, "), _c('em', [_vm._v("actually convey")]), _vm._v(" a message of endorsement.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 777 (O’Connor, J., concurring).")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The “State’s own actions” that convey this message may be subtle; in unusual cases, they may even be unintentional. But to plausibly be perceived as endorsement, “"), _c('em', [_vm._v("the State’s own actions")]), _vm._v("” must necessarily include some form of preferential treatment for religious speech—some special privilege, or some manipulation of process to ensure that the religious speaker gets an advantage. The non-mistaken impression of endorsement must be based on some government action, however subtle, that treats religious speech more favorably than other speech. Without that, the perception of endorsement is without basis, and the free speech rights of religious citizens are at the mercy of other peoples’ misperceptions.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this case, there is no ambiguity about what the school has actually done or about what it is being asked to do. What it has actually done is to exclude religious speech, because of its religious content, from a forum open to substantially all secular community groups. That is actual anti-religious discrimination, and it conveys an entirely accurate message of hostility to religious speech. What it is being asked to do is to admit a religious club to a designated forum on the same terms as secular clubs, and to let parents freely choose among clubs that teach morals and character development from either a secular or religious perspective. Such equal participation and parental choice convey no message of endorsement to any reasonable or informed observer. If a child misunderstands, the solution is to give that child an explanation—not to use the child’s mistake as an excuse for immediate resort to flagrant viewpoint discrimination.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Because there is no unequal treatment, there is no reasonable perception of endorsement, and there is no violation of the Establishment Clause.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4biq1"
  }, [_c('strong', [_vm._v("Conclusion")])])]), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("The judgment should be reversed, and the case remanded for entry of an injunction prohibiting further exclusion of religious speech from the designated ")]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("forum at Milford Central School. This Court should disapprove the Second Circuit’s mistaken doctrine that exclusion of religious speech from public fora is often or sometimes a mere subject matter exclusion and not a form of viewpoint discrimination.")])]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("The Court found discrimination against the club’s religious viewpoint, and it found no Establishment Clause violation in allowing the club to meet on a neutral basis. It thus upheld the club’s right to meet on campus. It did nothing to clarify or reform its public forum doctrine. Three Justices dissented, and Justice Breyer urged a remand for inquiries that would probably have ended in a ruling for the school; it was effectively 5–4.")]), _vm._v(" Rosenberger "), _c('em', [_vm._v("was close because there was government money at issue;")]), _vm._v(" Milford "), _c('em', [_vm._v("was close because the children were young, and perhaps also because, to some of the Justices, a meeting that resembled a worship service raised special issues.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_142"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_366",
      "id": "fn1-366"
    }
  }, [_vm._v("1.")]), _vm._v(" I prepared this brief myself, without consulting counsel for any party. No other person made any financial contribution to the preparation or submission of this brief. I file this brief in my personal capacity as a scholar, and of course The University of Texas takes no position on the issues in this case.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_367",
      "id": "fn1-367"
    }
  }, [_vm._v("*")]), _vm._v(" I wrote this without rereading the "), _c('em', [_vm._v("Schempp")]), _vm._v(" opinion. The prayers and Bible reading in "), _c('em', [_vm._v("Schempp")]), _vm._v(" were certainly school sponsored, but the message was actually delivered by students. The basic point is not changed. There is an article about "), _c('em', [_vm._v("Schempp")]), _vm._v(" in this volume at 282.]")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2-br",
    attrs: {
      "id": "sec2-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("Morse v. Frederick")])]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-6"
    }
  }, [_c('em', [_vm._v("551 U.S. 393 (2007)")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_vm._v("Amicus Brief")]), _vm._v(" "), _c('p', {
    staticClass: "Quote"
  }, [_c('em', [_vm._v("Brief of the Liberty Legal Institute as Amicus Curiae in Support of Respondent (February 20, 2007)")])]), _vm._v(" "), _c('p', {
    staticClass: "LAuthor"
  }, [_vm._v("With Robert A. Destro, Hiram S. Sasser III, and Kelly J. Shackelford")]), _vm._v(" "), _c('p', {
    staticClass: "HPara1"
  }, [_c('em', [_vm._v("Joseph Frederick was a student in Juneau, Alaska; Deborah Morse was his high school principal. When the entire high school went to watch the Olympic torch pass through town, Frederick and his friends unfurled a fourteen-foot banner that read “BONG HiTS 4 JESUS.” Morse suspended him for ten days. From this rather silly incident there arose an important Supreme Court case on student free speech.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("Kenneth Starr, then the dean of Pepperdine Law School and usually a defender of religious liberty, represented Morse. He tried to use the case to wipe out the protection for student free speech in")]), _vm._v(" Tinker v. Des Moines Independent Community School District "), _c('em', [_vm._v("(1969). He praised Justice Black’s apocalyptic dissent in")]), _vm._v(" Tinker, "), _c('em', [_vm._v("and he picked up on a phrase from")]), _vm._v(" Bethel School District v. Fraser "), _c('em', [_vm._v("(1986), where the Court said that a school did not have to permit a vulgar speech to a student assembly, a speech that would undermine its “basic educational mission.” In context it was just a statement about vulgarity, but the school officials in")]), _vm._v(" Morse "), _c('em', [_vm._v("read it as a sweeping license to censor any speech they disapproved of.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("This brief defends a robust reading of")]), _vm._v(" Tinker "), _c('em', [_vm._v("as against those who would say that")]), _vm._v(" Tinker "), _c('em', [_vm._v("is just about viewpoint discrimination or is just a public forum case. And it argues that authority to censor speech based on a school’s own definition of its “basic educational mission” would lead to rampant censorship, with religious speech among the first victims. It says that if the suspension were to be upheld, it should be on the very narrow ground that the sign could be understood to advocate the use of illegal drugs. But suppressing political or religious speech or controversies cannot be part of a school’s basic mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_c('em', [_vm._v("The argument is carried further, and explored more deeply, in the scholarly article that follows. There is some repetition of the brief, but the brief does more with the cases, and the article does more conceptually.")])])]), _c('p', {
    staticClass: "Body1"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('em', [_vm._v("Bob Destro is professor of law at Catholic University of America. Kelly Shackelford and Hiram Sasser are the lawyers for the Liberty Legal Institute. They are based in Plano, Texas, and details about Texas cases came from them.")])])]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }), _c('h1', {
    staticClass: "sec4b"
  }, [_c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('strong', [_vm._v("Interest of "), _c('em', [_vm._v("Amicus")]), _vm._v(" Curiae")])]), _c('a', {
    attrs: {
      "href": "#/#fn1-368",
      "id": "fn1_368"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The Liberty Legal Institute is a non-profit law firm dedicated to the preservation of First Amendment rights and religious freedom. In its commitment to the protection of religious liberties of all faiths, the Institute represents religious institutions and individuals across the country. The Institute is gravely concerned that the religious freedom of students in public schools will be damaged if the Court reverses the court of appeals decision in the present case. The Institute and its counsel have been involved in significant litigation nationwide in the area of student religious speech.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Amicus")]), _vm._v(" believes very strongly that the Court’s approach in "), _c('em', [_vm._v("Tinker v. Des Moines Indep. Commun. Sch. Dist.")]), _vm._v(", 393 U.S. 503 (1969), is the best protection for freedom of religious speech. The Court should be very cautious when granting the government broad powers to ban speech. "), _c('em', [_vm._v("Amicus")]), _vm._v(" is unwilling to trade the protections "), _c('em', [_vm._v("Tinker")]), _vm._v(" affords religious speech for some marginal “victory” over the ambiguous message at issue in this case.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Summary of Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("The cryptic message at issue in this case is not cause for diminishing "), _c('em', [_vm._v("Tinker")]), _vm._v(" and derailing almost forty years of jurisprudence protecting the political and religious speech of students. Petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(" propose a dangerous test, seeking to recast "), _c('em', [_vm._v("Tinker")]), _vm._v(" as a subjective test satisfied by a school official’s pronouncement that the school’s “basic educational mission” requires suppression of the student speech at issue. This standardless discretion to censor student speech would destroy the fundamental protections in "), _c('em', [_vm._v("Tinker")]), _vm._v(" and sanction political and religious viewpoint discrimination. The Court cannot assume that other existing doctrines would protect student speech if "), _c('em', [_vm._v("Tinker")]), _vm._v(" were undermined in this way.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("Public schools continue to enact broad, sweeping “neutral” speech policies without any objective evidence to support the necessity of their enactment. Public schools claim "), _c('em', [_vm._v("Tinker")]), _vm._v(" has no application to broad “neutral” speech censorship policies. "), _c('em', [_vm._v("See, e.g., Chalifoux v. New Caney Indep. Sch. Dist.")]), _vm._v(", 976 F. Supp. 659 (S.D. Tex. 1997); "), _c('em', [_vm._v("Morgan v. Plano Indep. Sch. Dist.")]), _vm._v(", 2007 WL 397494 (E.D. Tex. Feb. 1, 2007). If the Court adopts petitioner’s proposed subjective test, religious speech would be censored by public schools seeking to establish “neutrality,” especially given that religious speech is always contrary to the “basic educational mission” because no school may adopt the advancement of religion as its mission.")])]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Court wishes to reverse in this case, it could carve out an explicit exception for advocacy of the use of illegal drugs and add that explicit exception to the sexually explicit speech identified in "), _c('em', [_vm._v("Bethel Sch. Dist. v. Fraser")]), _vm._v(", 478 U.S. 675 (1986). But it must be very clear about the basis for that exception. It is no part of the mission of schools to indoctrinate students on issues that are controversial among American adults. Any power to instill values in students, and any power of censorship derived from such a power to instill values, must be confined to fundamental values necessary to preservation of a democratic system, or to specific skills and behaviors necessary to success in adult life. If schools are given a blank check to define their own missions, and then power to censor any student speech inconsistent with that mission, there will be nothing left of this Court’s cases protecting freedom of speech in the public schools.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4b"
  }, [_c('strong', [_vm._v("Argument")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("I. If the Court Cannot Confidently Divine the Meaning of the Sign at Issue, and If It Thinks That Some Possible Meanings Are Not Constitutionally Protected, the Writ Should Be Dismissed.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Under most of the meanings that might plausibly be attributed to it, the cryptic sign at issue in this case is clearly protected by the Constitution, even in a public school.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("The sign is most plausibly understood as anti-religious, ridiculing or satirizing the basic Christian message, making fun of such commonly displayed signs as “Jesus Saves,” or “John 3:16.” If this is the meaning of the sign, it must be protected. Religious speech is at the very core of the First Amendment, clearly protected in public schools so long as it is not school-sponsored. "), _c('em', [_vm._v("See Good News Club v. Milford Cent. Sch. Dist.")]), _vm._v(", 533 U.S. 98 (2001) [in this volume ")]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("at 123]. If public schools have power to ban anti-religious speech, that same power would extend to bans on positive religious speech.")])]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Alternatively, the sign may have been a nonsense phrase, conveying no intelligible meaning. If the Court understands the sign in this way, it is protected simply because there is no sufficient reason to prohibit or punish it. A meaningless nonsense sign does not convey one of the few messages a school is entitled to prohibit.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, somewhat less plausibly, the sign may be understood as suggesting a position on the existing public debate in Alaska, which has led to repeated referenda and to litigation in the state supreme court, over private use of marijuana. If the Court understands the sign in this way, it is a protected comment on an ongoing political debate.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, the petitioner school principal, and "), _c('em', [_vm._v("dubitante")]), _vm._v(", the court of appeals, Pet. App. 3a, J.A. 25, 439 F.3d 1114, 1117–18 (9th Cir. 2006), understood the sign as promoting drug use among students in violation of the school’s strong policy prohibiting student drug use. If the Court attributes this meaning to the sign, then the argument that the sign is protected in a public school context becomes much closer. Still, it is clear that the school’s undoubted power to prohibit drug use does not include power to prohibit all criticism of that policy. A student presentation to the school board, arguing for a change in the school’s drug policy, would undoubtedly be protected political speech, even if its very purpose was to undermine what the school defined as part of its basic mission. Even in speech addressed to other students, it is hard to imagine that every student remark, however brief, however humorous, however ambiguous, is subject to punishment if it can in any way be construed as criticizing the school’s drug policy. It is far more likely that the respondent student was punished so severely because his sign was the last straw for a principal already irritated by thrown Cokes and snowball fights, J.A. 24, 29, 36, 38, 439 F.3d at 1117, than because the sign had any real tendency to promote drug use.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If the Court thinks that one of the sign’s possible meanings is unprotected, then the broad range of possible meanings suggests that this case turns on a factual issue of no particular importance—the meaning of the sign. That issue plainly does not require resolution in this Court. In the quite likely event that the Court can make no confident judgment about the meaning of the sign, the legal issues are presented only in a hypothetical and alternative way. In that event, the proper course is to dismiss the writ as improvidently granted.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("What "), _c('em', [_vm._v("amicus")]), _vm._v(" fears most is that a loosely worded opinion, holding that students have no First Amendment right to promote drug use, will fatally undermine protection for core religious and political speech in public schools. The vague and deferential standard proposed by petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(" invites this ")]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("consequence. Any holding that respondent’s sign is unprotected must be very carefully stated to avoid sending an unintended signal that would do serious damage to the free speech rights of all students, including religious students.")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("II. The “Basic Educational Mission” of the School Cannot Be to Instill Religious or Political Conformity or to Suppress Speech with Which It Disagrees.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("A. Petitioner’s Proposed Standard Would Confer Essentially Standardless Discretion to Define a School’s Mission and Then Suppress All Speech Inconsistent with That Mission.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("However the Court interprets the particular sign at issue in this case, and however it resolves the dispute over that sign, it is critical that the opinion reaffirm students’ fundamental right to free speech on religious and political issues. The Court must clearly state that that right still has broad reach and effectually protective content as applied to students in public schools. Public school officials plainly doubt the continuing vitality of that protection, and many of them would take a win in this case as a green light to censorship, unless the opinion forcefully reminds them of the yellow and red lights that still control most disputes over school censorship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Petitioner devotes a paragraph to praising Justice Black’s dissent in "), _c('em', [_vm._v("Tinker v. Des Moines Indep. Commun. Sch. Dist.")]), _vm._v(", 393 U.S. 503 (1969). This paragraph reveals the aspiration to a general power of censorship and the hope that this case may be the decisive step in restoring that power.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To that end, petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(" propose a dangerous test that goes well beyond what is necessary to decide this case. Their proposed test, unless clarified, threatens to seriously undermine landmark decisions of this Court, including "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Good News Club v. Milford Cent. Sch. Dist.")]), _vm._v(", 533 U.S. 98 (2001). It is true, as this Court said in "), _c('em', [_vm._v("Bethel Sch. Dist. v. Fraser")]), _vm._v(", 478 U.S. 675, 685 (1986), that a public school need not permit student speech that directly subverts the school’s “basic educational mission.” But it is equally true, as the court of appeals said below, that in the administration of this test, the school “is not entitled to suppress speech that undermines whatever missions it defines for itself.” Pet. App. 12a, 439 F.3d at 1120. That approach would confer on school officials a standardless discretion to censor student speech. "), _c('em', [_vm._v("Cf. Forsyth County v. Nationalist Movement")]), _vm._v(", 505 U.S. 123 (1992).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("Bethel")]), _vm._v(", the Court’s comment about undermining the “basic educational mission” took meaning from the gratuitous sexual content of the student’s ")]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("speech and from the school’s interest in maintaining civility and protecting younger children from offensive and age-inappropriate content. The student reaction to the speech in "), _c('em', [_vm._v("Bethel")]), _vm._v(" demonstrated that the speech had in fact been disruptive. Neither the student reaction nor the school’s disciplinary action in "), _c('em', [_vm._v("Bethel")]), _vm._v(" was based on viewpoint discrimination; the student was using sexual innuendo to attract attention to his candidacy, not to express views on any issue concerning sex. He could easily have promoted his candidacy and expressed any viewpoint relevant to that candidacy without the sexual innuendo. Nothing in the holding or opinion in "), _c('em', [_vm._v("Bethel")]), _vm._v(" suggested any broad power to punish speech simply because the school disagreed with the views expressed.")])]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("But here the school expressly claims power to punish speech it disagrees with. Petitioner insists that the reason for censorship is precisely the communicative impact of the message expressed. She interprets respondent’s sign to promote drug use; she interprets the school’s “basic educational mission” to include prevention of drug use; and therefore, she says, the student can be severely punished for displaying the sign. This is dangerous doctrine, requiring careful confinement if it is to be accepted at all. Petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(" seek to recast "), _c('em', [_vm._v("Tinker")]), _vm._v(" as a subjective test satisfied by a school official’s pronouncement that the school’s “basic educational mission” requires suppression of the student speech at issue.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("Petitioner’s proposed subjective standard is consistent with a recent approach by the European Court of Human Rights, but roundly rejected in American jurisprudence. "), _c('em', [_vm._v("See Leyla Sahin v. Turkey")]), _vm._v(", App. No. 44774/98, Eur. Ct. H.R. 299 ¶¶ 112–21 (29 June 2004), ")]), _c('a', {
    attrs: {
      "href": "http://www.echr.coe.int/ECHR",
      "target": "_blank"
    }
  }, [_vm._v("http://www.echr.coe.int/ECHR")]), _vm._v(" (search by application number under HUDOC) (requiring no evidence that banning students from wearing the traditional Muslim headscarf at a University is necessary to protect a real government interest independent of Turkey’s subjective assertion that banning the scarf was in the best interest of the government). The "), _c('em', [_vm._v("Sahin")]), _vm._v(" case is remarkably similar to the legal proposal of petitioner and her "), _c('em', [_vm._v("amici.")]), _vm._v(" The government, or the school, gets to define its mission on terms of its own choosing, and then to prohibit all expression inconsistent with that self-defined mission.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("With all due respect to the European Court of Human Rights, "), _c('em', [_vm._v("amicus")]), _vm._v(" prefers the American jurisprudence on this issue, which holds government to a heavy burden of justifying suppression of speech. "), _c('em', [_vm._v("See Greater New Orleans Broadcasting Assn., Inc. v. United States")]), _vm._v(", 527 U.S. 173, 183 (1999) (“The Government bears the burden of identifying a substantial interest and justifying the challenged restriction”); "), _c('em', [_vm._v("Reno v. ACLU")]), _vm._v(", 521 U.S. 844, 879 (1997) (“The breadth of this content-based restriction of speech imposes an especially heavy burden on the Government to explain why a less restrictive provision would not "), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("be as effective.…”); "), _c('em', [_vm._v("Edenfield v. Fane")]), _vm._v(", 507 U.S. 761, 770–71 (1993) (“burden is not satisfied by mere speculation or conjecture; rather, a governmental body seeking to sustain a restriction on commercial speech must demonstrate that the harms it recites are real and that its restriction will in fact alleviate them to a material degree”); "), _c('em', [_vm._v("Board of Trustees of State Univ. of N.Y. v. Fox")]), _vm._v(", 492 U.S. 469, 480 (1989) (“The State bears the burden of justifying its restrictions.…”); "), _c('em', [_vm._v("Tinker v. Des Moines Indep. Commun. Sch. Dist.")]), _vm._v(", 393 U.S. 503, 509 (1969) (“In order for the State in the person of school officials to justify prohibition of a particular expression of opinion, it must be able to show that its action was caused by something more than a mere desire to avoid the discomfort and unpleasantness that always accompany an unpopular viewpoint”).")])]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_c('h1', {
    staticClass: "sec6bi"
  }, [_c('strong', [_c('em', [_vm._v("B. Suppression of Speech Inconsistent with a School’s Mission, If Tolerated at All, Must Be Confined to Uncontroversial Parts of the School’s Mission.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("If the Court is willing to accept some version of petitioner’s proposed doctrine with respect to messages thought to promote drugs, then it must be very careful to state what is special about drugs, and to draw clear boundaries between those few student messages that can be suppressed and the student speech that retains constitutional protection. Any viewpoint standard so vague as undermining “the basic educational mission” requires judicial clarification at the inception.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The school’s capacity to adopt a viewpoint as part of its educational mission, and to suppress speech inconsistent with that viewpoint, is necessarily quite narrow. The school cannot suppress a student viewpoint as inconsistent with its educational mission unless the school is free, under our Constitution and under the political norms of a free society, to attempt to indoctrinate students into a viewpoint contrary to the student speech that is suppressed. Parents entrust the public schools with their children for important but particular purposes. Parents may expect the school to teach skills and values conducive to success in later life, and they may expect the schools to teach fundamental democratic values. But they do not expect the schools to indoctrinate their children on current political or religious questions that may be the subject of substantial disagreement among the parents themselves, either locally or nationally. Indoctrination on that sort of question is no part of the school’s “basic educational mission,” and the schools have no power to censor nondisruptive student speech on such questions.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("American political norms certainly, and the Constitution at least with respect to means, prevent the public schools from propagandizing students on controversial political or religious issues. The school cannot prohibit Republican ")]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("speech, or Democratic speech, or anti-war speech, or pro-war speech, or define such speech as inconsistent with the school’s mission. No set of American parents accepts it as part of the public school’s role to indoctrinate their children on controversial political issues, and no set of American taxpayers accepts such partisan indoctrination as a legitimate expenditure of education funds. As this Court has long recognized, neither political nor religious indoctrination is part of any school’s basic educational mission:")])]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('p', {
    staticClass: "QuoteSb"
  }, [_vm._v("Probably no deeper division of our people could proceed from any provocation than from finding it necessary to choose what doctrine and whose program public educational officials shall compel youth to unite in embracing.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("W. Va. State Board of Educ. v. Barnette")]), _vm._v(", 319 U.S. 624, 641 (1943). If the Court is to permit viewpoint-based censorship on the basis of any such amorphous test as inconsistency with the school’s “basic educational mission,” it must emphatically reaffirm "), _c('em', [_vm._v("Barnette")]), _vm._v("’s insight that inducing political conformity cannot be any part of the school’s mission.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The point is more frequently litigated with respect to religion than with respect to politics. This Court has repeatedly held for nearly half a century that it is no part of the mission of public schools to inculcate religion among students. "), _c('em', [_vm._v("See, e.g., Santa Fe Indep. Sch. Dist. v. Doe")]), _vm._v(", 530 U.S. 290 (2000); "), _c('em', [_vm._v("Abington Sch. Dist. v. Schempp")]), _vm._v(", 374 U.S. 203 (1963) [in this volume at 390 and 282]. Because religious instruction is not part of a school’s basic educational mission, speech on religious questions does nothing to undermine a school’s educational mission. Therefore, voluntary religious speech and voluntary anti-religious speech are fully protected in public schools.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Nor can the school prohibit all political speech, or all pro-religious and all anti-religious speech, and claim that even-handed suppression is part of its basic educational mission. It is no part of the school’s basic mission to stamp out student interest in political or religious controversies or to suppress student participation in such controversies. "), _c('em', [_vm._v("Tinker")]), _vm._v(" flatly prohibits such a “neutral” ban. "), _c('em', [_vm._v("Tinker")]), _vm._v(" is expressly not limited to viewpoint discrimination. “If a regulation were adopted by school officials "), _c('em', [_vm._v("forbidding discussion of the Vietnam conflict")]), _vm._v(", OR the expression by any student of opposition to it anywhere on school property except as part of a prescribed classroom exercise, it would be obvious that the regulation would violate the constitutional rights of students, at least if it could not be justified by a showing that the students’ activities would materially and substantially disrupt the work and discipline of the school.” "), _c('em', [_vm._v("Tinker")]), _vm._v(", 393 U.S. at 513 (emphasis added).")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("Petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(" place much reliance on "), _c('em', [_vm._v("Ambach v. Norwich")]), _vm._v(" and its paean to “the importance of public schools in the preparation of individuals ")]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("for participation as citizens, and in the preservation of the values on which our society rests.” 441 U.S. 68, 76 (1979). But of course one of the central roles of citizens in our system is to participate actively and intelligently in political debates. The people are sovereign in our system, and the people are ultimately responsible for the choice of their political leaders and for the policy choices made by those leaders. It is an essential part of a public school’s mission to prepare students for this responsibility. It can never be part of a school’s “basic educational mission” to suppress student interest or participation in political or religious discussion.")])]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Ambach")]), _vm._v(" also describes public schools “as an ‘assimilative force’ by which diverse and conflicting elements in our society are brought together on a broad but common ground,” and “as inculcating fundamental values necessary to the maintenance of a democratic political system.” "), _c('em', [_vm._v("Id.")]), _vm._v(" at 77. Of course, freedom of speech is precisely one of those fundamental values “necessary to the maintenance of a democratic political system.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("More generally, this “assimilative” function of public schools is necessarily confined, as the Court said in "), _c('em', [_vm._v("Ambach")]), _vm._v(", to values that are “fundamental” and “necessary” to a democratic system, and to a “broad … common ground.” Let this “assimilative” function expand to values that are less fundamental, less essential to a democratic system, narrow rather than broad, and the public schools would become an engine for instilling conformity and for suppressing discussion of public issues. Representative government, majority rule (subject to protection for individual and minority rights), nondiscrimination and equal protection of the laws, freedom of speech, religion, and assembly, tolerance of dissenting views and of personal and group differences, due process of law, innocent until proven guilty—these are the kinds of values that may be fairly described as “fundamental” and (the most important of the "), _c('em', [_vm._v("Ambach")]), _vm._v(" criteria, because it provides the most real guidance) as “necessary to the maintenance of a democratic political system.” And these are not values that provoke much disagreement in principle among American adults, however great the disagreements over particular applications. It is indeed part of the “basic educational mission” of public schools to instill these broad values in each succeeding generation. How far a school may go in suppressing student dissent from one or more of these values is a much closer question, but that question is not presented in this case.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("It cannot be part of the school’s mission to go beyond such broad and fundamental principles to instill agreement on, or suppress dissent on, more particular social, political, or religious issues. The school cannot define suppression of dissent as part of its educational mission. It cannot justify suppression of dissent by defining its basic educational mission to include instilling support of ")]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("particular or current government policies or administrations. Nor can it justify suppression of all religious speech, pro and con, because the school’s mission does not involve religious speech of its own. And this Court should say so.")])]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("A school may also seek to instill uncontroversial personal virtues that have the overwhelming support of the American people and that are often as important as academic skills to success in adult life: honesty, diligence, personal responsibility, obedience to law, tolerance for dissenting views. The Court may conclude that avoidance of drugs is such a virtue. That sort of socialization into responsible adulthood is consistent with American political norms. But again, this sort of socialization is no justification for suppressing controversial religious or political speech on contemporary issues, even if both sides are equally suppressed.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("III. The Reasons Why the Court Might Permit Suppression of Speech Promoting Drugs Have Nothing to Do with Suppression of Religious or Political Speech.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("If the Court wishes to reverse in this case, it could carve out an explicit exception for advocacy of the use of illegal drugs and add that explicit exception to the sexually explicit speech identified in "), _c('em', [_vm._v("Bethel Sch. Dist. v. Fraser")]), _vm._v(", 478 U.S. 675 (1986). But it must be very clear about the basis for that exception.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If a school can prohibit the speech at issue in this case, it is because the school has a valid rule prohibiting students from using drugs, and because respondent’s sign might be interpreted as encouraging student violations of the valid rule of conduct. The use of drugs is a criminal offense, and whatever disagreement there may be about the efficacy of the drug laws, or about the need for laws against adult use of the less dangerous illegal drugs, there is overwhelming consensus in the polity that adults should discourage children from using drugs. As a corollary of its power to regulate serious misconduct, the schools may plausibly have power to prohibit student speech urging serious misconduct.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("Of course this corollary does not follow in the adult world. But if the Court thinks the corollary does follow in public schools, it must state clear and objective reasons that confine the decision. The school is engaged in educating children, and it may seek to educate them about the reasons for its conduct rules. Assuming the conduct rules themselves are not politically or religiously controversial, the Court may conclude that the school may seek to persuade students to believe in these rules and to accept them as norms of behavior. And because children are younger and on average have less impulse control than adults, the school may believe that urging violations is more likely to lead to ")]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("violations, and that the speaker who persuades a child to violate a rule bears more responsibility for the resulting violation than a speaker who persuades an adult to violate a rule.")])]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("These are reasons why the Court might conclude that the age of the students and the educational context may justify restrictions on "), _c('em', [_vm._v("advocacy of prohibited conduct")]), _vm._v(" in public schools. But if the Court so rules, it must clearly distinguish this case from "), _c('em', [_vm._v("Tinker")]), _vm._v(" and "), _c('em', [_vm._v("Good News")]), _vm._v(" and from political and religious speech. Nothing in these reasons for restricting advocacy of student misconduct justifies restrictions on advocacy of controversial political or religious views.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The court of appeals said that no government mission is more important than war, so if anti-war speech is protected, pro-drug speech must also be protected. Pet. App. 8a, 439 F.3d at 1118. But that is not the right basis for comparison. If there is a difference between drugs and war, it is that war is not part of the "), _c('em', [_vm._v("school")]), _vm._v("’s mission. The decision to go to war, like most other disputed political decisions, is entrusted to government institutions other than schools. Education of children, and protecting children from self-destructive behavior, is at the core of the mission entrusted to schools. A decision permitting the schools to censor student speech promoting the use of drugs implies nothing about the schools’ power to censor student speech on political issues entrusted to other organs of government, or on religious issues entrusted to churches and synagogues, families, and individual conscience.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("IV.")]), _vm._v(" Tinker "), _c('em', [_vm._v("Is an Essential and Independent Protection for Student Speech; No Other Doctrine Can Safely Substitute.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("Within the confines of "), _c('em', [_vm._v("Tinker")]), _vm._v(", school officials bear the burden of demonstrating that suppression of student speech is necessary to prevent a material and substantial disruption. "), _c('em', [_vm._v("See Tinker v. Des Moines Indep. Commun. Sch. Dist.")]), _vm._v(", 393 U.S. 503, 509 (1969). This is a wise balance, protecting student exchange of ideas as part of their education in a democratic society, but permitting government intervention for conduct and that occasional speech that actually disrupts the school. Petitioner seeks to overturn this burden and eviscerate decades of First Amendment jurisprudence following "), _c('em', [_vm._v("Tinker")]), _vm._v(" by asking this Court to grant unfettered discretion to school officials to ban speech that the school subjectively determines is inconsistent with its educational mission.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("At its heart, petitioner’s proposal is to substitute her basic-educational-mission standard for the substantial-disruption standard of "), _c('em', [_vm._v("Tinker.")]), _vm._v(" For the reasons already stated, the basic-educational-mission standard would, unless carefully confined by this Court, give school officials broad discretion to censor ")]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("student speech. The Court cannot assume that other existing doctrines would protect student speech if "), _c('em', [_vm._v("Tinker")]), _vm._v(" were undermined in this way.")])]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The rules against viewpoint discrimination are no protection against rules that simply seek to eliminate controversy by suppressing all speech on any side of an issue. The infamous resolution banning all “First Amendment activities” in the airport was adopted precisely because of its viewpoint neutrality. "), _c('em', [_vm._v("See Board of Airport Comm’rs v. Jews for Jesus, Inc.")]), _vm._v(", 482 U.S. 569 (1987) (striking down the resolution as overbroad). A rule banning student discussion of politics, or of religion, or of particular political or religious issues, could be viewpoint neutral and not so flagrantly overbroad.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("More fundamentally, petitioner’s proposed rule can only be understood as overriding the rule against viewpoint discrimination. A ban on speech promoting drug use is a ban on a particular viewpoint. Petitioner’s claim is precisely that she can engage in viewpoint discrimination whenever her school rejects a viewpoint in pursuit of its “basic educational mission.”")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("Nor will public forum doctrine fill the gap. Public forum rules are no help in those parts of the school that are not a part of a public forum, and schools fiercely deny that even their student activity periods are a public forum, let alone the rest of the campus and the rest of the school day. Public forum doctrine is no help when schools close their forum to avoid permitting religious speech, as happened in "), _c('em', [_vm._v("Child Evangelism Fellowship, Inc. v. Montgomery County Pub. Schs.")]), _vm._v(", 457 F.3d 376 (4th Cir. 2006).")]), _c('a', {
    attrs: {
      "href": "#/#fn1-369",
      "id": "fn1_369"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" One of the reasons "), _c('em', [_vm._v("Tinker")]), _vm._v(" is so important is that it is not entangled in public forum doctrine:")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteSb"
  }, [_c('em', [_vm._v("Tinker")]), _vm._v(" did not involve a question of access to public property. When citizens claim a right to enter government property for the particular purpose of speaking, it is relevant to ask whether other speakers have been allowed the same privilege, or whether the property is especially appropriate for speech. The various versions of the public forum doctrine address these questions. But public forum analysis is irrelevant when access is not at issue. When citizens are going about their business in a place they are entitled to be, they are presumptively entitled to speak. Because students were indisputably entitled to be on the school grounds, the only question in "), _c('em', [_vm._v("Tinker")]), _vm._v(" was whether the school had a constitutionally sufficient reason to suppress their speech. The Court’s requirement that the school show a material and substantial interference with the educational function is addressed to that question.")]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("Douglas Laycock, "), _c('em', [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")]), _vm._v(", 81 Nw. U.L. Rev. 1, 48 (1987) [in this volume at 58–59]; "), _c('em', [_vm._v("see Jews for Jesus")]), _vm._v(", 482 U.S. at 573 (recognizing that "), _c('em', [_vm._v("Tinker")]), _vm._v(" might apply without regard to property’s status as a public forum).")])]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Petitioner proposes to eviscerate "), _c('em', [_vm._v("Tinker.")]), _vm._v(" If a vague educational-mission test is substituted for the material-disruption test, without firm guidance from this Court about the limited nature of the educational missions intended, student speech will be at the mercy of unrestrained school administrators.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec5bi"
  }, [_c('strong', [_c('em', [_vm._v("V. Public Schools Have Repeatedly Shown That They Will Use Their Discretion to Censor Student Speech.")])])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_vm._v("If the Court weakens "), _c('em', [_vm._v("Tinker")]), _vm._v(" and gives government school officials the power to censor speech “contrary to the educational mission,” schools may define broad missions and enact correspondingly broad prohibitions on speech, inevitably including content-based and viewpoint-based discrimination. This unfettered discretion in the hands of school officials creates two dangers, in addition to controverting any purpose to prepare students to live in a democratic society where the exchange of ideas is the country’s lifeblood. First, broad discretion to enact speech regulations “intimidate[s] parties into censoring their own speech, even if the discretion and power are never actually abused.” "), _c('em', [_vm._v("City of Lakewood v. Plain Dealer Pub’g Co.")]), _vm._v(", 486 U.S. 750, 757 (1988). Second, unfettered discretion permits government officials “to roam essentially at will, dispensing or withholding permission to speak … according to their own opinions regarding the potential effect of the activity in question on the ‘welfare’ of the community.” "), _c('em', [_vm._v("Shuttlesworth v. City of Birmingham")]), _vm._v(", 394 U.S. 147, 153 (1969). A school official accused of viewpoint discrimination will easily avoid judicial scrutiny by claiming that the speech censored was contrary to the educational mission of the school as defined in the context of its local community. Rampant viewpoint discrimination will be the result, and it will occur without any possibility of a remedy.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("Religious speech would be among the first banned as out of compliance with the school’s mission. Schools continue to claim that the Establishment Clause requires or justifies them in censoring religious speech, on grounds derived from their own confused definition of their mission. No school may adopt as part of its mission the advancement of religion. "), _c('em', [_vm._v("See, e.g., Edwards v. Aguillard")]), _vm._v(", 482 U.S. 578 (1987); "), _c('em', [_vm._v("Wallace v. Jaffree")]), _vm._v(", 472 U.S. 38 (1985). That would violate the Establishment Clause. This leads many schools to conclude that any student religious speech is therefore inherently inconsistent with the ")]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("educational mission of the school and should just be done elsewhere. If this Court accepts an “educational mission” standard, without clearly reaffirming the limits on how schools may define that mission, student religious speech will be an immediate target.")])]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The fears expressed in this brief are not hypothetical. We know from experience that if this Court permits censorship based on a broad discretionary standard like that proposed by petitioner and her "), _c('em', [_vm._v("amici")]), _vm._v(", public schools will invoke that standard to censor religious and political speech at the core of the First Amendment.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Many schools have persistently sought to suppress student religious speech in violation of this Court’s decisions. "), _c('em', [_vm._v("See, e.g., Good News Club v. Milford Cent. Sch. Dist.")]), _vm._v(", 533 U.S. 98 (2001) [in this volume at 123]; "), _c('em', [_vm._v("Lamb’s Chapel v. Center Moriches Union Free Sch. Dist.")]), _vm._v(", 508 U.S. 384 (1993); "), _c('em', [_vm._v("Board of Educ. v. Mergens")]), _vm._v(", 496 U.S. 226 (1990) [in this volume at 81]; "), _c('em', [_vm._v("cf. Widmar v. Vincent")]), _vm._v(", 454 U.S. 263 (1981) (same problem at university level). There is a litany of cases in every circuit enforcing these decisions against resistance by public schools.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('em', [_vm._v("Amicus")]), _vm._v(" has handled a legion of cases where schools ban student religious speech under allegedly “neutral” anti-speech policies that can only be stopped by "), _c('em', [_vm._v("Tinker.")]), _vm._v(" Currently pending examples include "), _c('em', [_vm._v("Morgan v. Plano Indep. Sch. Dist.")]), _vm._v(", 2007 WL 397494 (E.D. Tex. Feb. 1, 2007), and "), _c('em', [_vm._v("Pounds v. Katy Indep. Sch. Dist.")]), _vm._v(", 4:06-cv-00527 (S.D. Tex.) [517 F. Supp. 2d 901 (S.D. Tex. 2007)]. In "), _c('em', [_vm._v("Plano")]), _vm._v(", students were told they could not share candy canes with their friends, they could not write “Merry Christmas” in “holiday cards” to military troops serving in Iraq, and they could not share pencils with their friends that bore a religious message. In "), _c('em', [_vm._v("Katy")]), _vm._v(", a student was told she could not talk about Jesus during recess. During a class discussion led by the teacher asking students to say what comes to mind when the teacher says the word “Easter,” students responded with words such as “bunnies,” “eggs” and “jelly beans.” One student responded with the word “Jesus.” The teacher told her that such an answer was inappropriate at school.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("All of these bans were justified under allegedly “neutral” policies banning speech—policies that can best be overcome with "), _c('em', [_vm._v("Tinker")]), _vm._v(", and perhaps only with "), _c('em', [_vm._v("Tinker.")]), _vm._v(" These schools plainly think it part of their “basic educational mission” to preserve a religion-free zone. A deferential standard, permitting censorship on the basis of whatever schools declare to be their mission, would go far to validate such policies. If protecting the mission justifies viewpoint discrimination, it would no longer matter whether these schools can plausibly claim that their policies are neutral.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("Counsel for "), _c('em', [_vm._v("Amicus")]), _vm._v(" also participated extensively in "), _c('em', [_vm._v("Chalifoux v. New Caney Indep. Sch. Dist.")]), _vm._v(", 976 F. Supp. 659 (S.D. Tex. 1997) (discussed favorably ")]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_vm._v("in "), _c('em', [_vm._v("Saxe v. State College Area Sch. Dist.")]), _vm._v(", 240 F.3d 200, 211–12 (3d Cir. 2001) (Alito, J.)). In "), _c('em', [_vm._v("Chalifoux")]), _vm._v(", the school district instituted a policy prohibiting rosary beads. The school district believed rosary beads to be a symbol used to identify gang affiliation. The Catholic plaintiffs in "), _c('em', [_vm._v("Chalifoux")]), _vm._v(" certainly would find no refuge in either viewpoint or public forum jurisprudence, because the ban on rosaries allegedly had nothing to do with their religious significance, and because the plaintiffs possessed their rosaries wherever they went, including in the classroom, which courts are reluctant to describe as a public forum.")])]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Without "), _c('em', [_vm._v("Tinker")]), _vm._v(", the students would have been banned from possessing rosaries. If "), _c('em', [_vm._v("Tinker")]), _vm._v(" were circumscribed to allow schools to censor any speech inconsistent with its educational mission, the school could ban rosaries or any other religious symbols or expression as inherently inconsistent with the school’s secular mission. Only a strong "), _c('em', [_vm._v("Tinker")]), _vm._v(" fully protects religious speech in schools.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Tragically, a federal judge, refusing to apply "), _c('em', [_vm._v("Tinker")]), _vm._v(", recently opined that "), _c('em', [_vm._v("Tinker")]), _vm._v(" is limited to viewpoint discrimination cases, which he defined narrowly, en route to upholding a broad sweeping ban on student religious speech. "), _c('em', [_vm._v("See Morgan v. Plano Indep. Sch. Dist.")]), _vm._v(", 2007 WL 397494 (E.D. Tex. Feb. 1, 2007). Far worse would follow if this Court authorizes school districts to suppress any speech they define as inconsistent with their mission. It is critical that this Court reaffirm that the fundamental right to free speech on religious and political issues still has broad reach and protection.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4biq1"
  }, [_c('strong', [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "HPara"
  }, [_c('em', [_vm._v("Amicus")]), _vm._v(" urges the Court to be very careful and explicit in its decision, which could have enormous implications, intended or not, for religious and political speech. If the Court accepts any form of petitioner’s proposed basic-educational-mission standard, the Court must expressly state the First Amendment limits on a school’s capacity to define its own mission for purposes of censoring speech inconsistent with that purpose. The Court should reaffirm "), _c('em', [_vm._v("Tinker")]), _vm._v(", and any exception to "), _c('em', [_vm._v("Tinker")]), _vm._v(" should be narrowly confined.")])]), _c('p', {
    staticClass: "HPara1"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('em', [_vm._v("As more fully explained in the article that follows, the Court held that of course the school could suppress speech that it understood to advocate the use of illegal drugs. It neither accepted nor rejected Judge Starr’s theory about the basic educational mission of the school. It reaffirmed")]), _vm._v(" Tinker "), _c('em', [_vm._v("in terms consistent with my reading of the case, but without clearly taking a position on")]), _vm._v(" Tinker"), _c('em', [_vm._v("’s reach. Five Justices")])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('em', [_vm._v("in separate opinions, two concurring and three dissenting, took a strong view of student free speech rights, but also without significantly clarifying the debate over")]), _vm._v(" Tinker. "), _c('em', [_vm._v("Justices Alito and Kennedy, concurring, would have explicitly rejected the basic-educational-mission argument, saying that it “strikes at the very heart of the First Amendment.”")])])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "id": "page_158"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fn1_368",
      "id": "fn1-368"
    }
  }, [_vm._v("1.")]), _vm._v(" The parties have consented to the filing of this brief. Their general letters of consent have been filed with the Clerk of this Court. Pursuant to this Court’s Rule 37.6, none of the counsel for the parties authored this brief in whole or in part and no one other than "), _c('em', [_vm._v("amicus")]), _vm._v(" or their counsel contributed money or services to the preparation and submission of this brief.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fn1_369",
      "id": "fn1-369"
    }
  }, [_vm._v("2.")]), _vm._v(" Another example is "), _c('em', [_vm._v("Good News/Good Sports Club v. Sch. Dist.")]), _vm._v(", 28 F.3d 1501 (8th Cir. 1994). Events on remand are not reported, but there the school board succeeded in its strategy of closing the forum.")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467451376',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(145)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(147);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 147 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.0927f4b4ca0ad0114711.js